'use strict';

const options = {
	'ac.loginMethod': {
		'1': ['帳號、密碼驗證', 'Account and password verification', '账号、密码验证'],
		'2': ['AD帳號驗證', 'AD account and password verification', 'AD账号验证']
	},
	'ac.loginMethod.portal': {
		'1': ['帳號、密碼驗證','Account and password verification','帐号、密码验证'],
		'2': ['AD 帳號驗證','AD account verification','AD 帐号验证'],
		'3': ['AD 自動驗證','AD automatic verification','AD 自动验证'],
		'4': ['帳號、密碼驗證(預設密碼)','Account and password verification (Default password)','帐号、密码验证(预设密码)'],
		'5': ['Azure Active Directory 驗證','Azure Active Directory Authentication','Azure Active Directory 驗证']
	},
	'ac.loginMethod.portal._sort': [1, 4, 2, 3, 5],
	'ac.pwd.makeUp': {
		'1': ['前','Before','前'],
		'2': ['後','After','后'],
	},
	'ac.pwd.empDefault': {
		'1': ['員工編號','employee ID','员工编号'],
		'2': ['身分證號(外籍則為外僑統一證號)','Identity card number (for foreign nationals, the unified card number for aliens)','身分证号(外籍则为外侨统一证号)'],
		'9': ['固定字串','Fixed string','固定字串']
	},
	'ac.pwd.nonempDefault': {
		'4': ['使用者帳號','User account','使用者帐号'],
		'5': ['使用者Email','User Email','使用者Email'],
		'9': ['固定字串','Fixed string','固定字串']
	},
	'ac.pwd.nonemp.fixCode': {
		'12345678': ['12345678(建議密碼1)','12345678 (recommended password 1)','12345678(建议密码1)'],
		'00000000': ['00000000(建議密碼2)','00000000 (recommended password 2)','00000000(建议密码2)'],
		'AABBCCDDEE': ['AABBCCDDEE(建議密碼3)','AABBCCDDEE (recommended password 3)','AABBCCDDEE(建议密码3)']
	},
	'ac.pwd.unregRule': {
		'1': ['自動解除綁定','Automatic unbinding','自动解除绑定'],
		'2': ['通知HR處理','Notify HR to handle','通知HR处理'],
		'3': ['寄發驗證函','Send verification letter','寄发验证函']
	},
	'ac.pwd.unregRule._sort': [1, 3, 2],
	'ac.ruleType': {
		'CO': ['公司', 'the company', '公司'],
		'DEPT': ['部門', 'department', '部门'],
		'SNO': ['扣繳單位', 'Withholding units', '扣缴单位'],
		'LABOR_NO': ['勞保統編', 'Labor Union', '劳保统编'],
		'HEALTH_NO': ['健保統編', 'Jianbao editorial', '健保统编'],
		'JOB': ['職位', 'Job', '职位'],
		'GRADE': ['職等', 'Grade', '职等'],
		'LEVEL': ['職等/職級', 'Grade / rank', '职等/职级'],
		'JOB_CAT': ['職務類別', 'Job category', '职务类别'],
		'JOB_STYLE': ['職種', 'Job style', '职种'],
		'IDENTITY': ['身分類別', 'Identity category', '身分类别'],
		'EMP_TYPE': ['直間接別', 'Straight to the other', '直间接别'],
		'RESPOBILITY': ['責任區分', 'Distinction of responsibility', '责任区分'],
		'HEADCOUNT_STATUS': ['編制狀況', 'Prepare the situation', '编制状况'],
		'AREA': ['工作區域', 'Work area', '工作区域'],
		'SITE': ['工作區域/地點', 'Work area / location', '工作区域/地点'],
		'FACTORY': ['廠別', 'Site', '厂别'],
		'SHIFT_TYPE': ['班別屬性', 'Class attribute', '班别属性'],
		'SHIFT': ['班別', 'Class', '班别'],
		'SALARY_TYPE': ['計薪方式', 'Paid way', '计薪方式'],
		'EMP': ['員工', 'Employee', '员工']
	},
	'ac.timeUnit': {
		'hour': ['小時', 'hour', '小时'],
		'minute': ['分', 'minute', '分']
	},
	'ac.user.accountStatus': { //注：順序在 ac.user.accountStatus._sort
		'1': ['未認證', 'not certified', '未认证'],
		'3': ['開啟', 'Open', '开启'],
		'4': ['關閉', 'shut down', '关闭'],
		'2': ['鎖定', 'locking', '锁定']
	},
	'ac.user.accountStatus._sort': [1, 3, 4, 2],
	'ac.user.identity': {
		'0': ['Admin使用者', 'Admin user', 'Admin使用者'],
		'1': ['權限管理者', 'Authority manager', '权限管理者'],
		'2': ['標準使用者', 'Standard users', '标准使用者']
	},
	'ac.user.ipType': {
		'1': ['IPv4', 'IPv4', 'IPv4'],
		'2': ['IPv6', 'IPv6', 'IPv6']
	},
	'ac.user.manageScope': {
		'1': ['全集團', 'Group', '全集团'],
		'2': ['部分公司', 'Some companies', '部分公司']
	},
	'ac.user.senField': [
		{
			id: 'emp',
			name: ['員工', 'Employee', '员工'],
			children: [
				{id: 'EMP_NAME', name: ['員工-中文姓名', 'Employee - Chinese name', '员工-中文姓名']},
				{id: 'EMP_EN_NAME', name: ['員工-英文姓名', 'Employee - English name', '员工-英文姓名']},
				{id: 'EMP_ALIAS_NAME', name: ['員工-別名', 'Employee - alias', '员工-别名']},
				{id: 'EMP_AUTO_NAME', name: ['員工-姓名', 'Employee - Name', '员工-姓名']},
				{id: 'BIRTHDAY', name: ['員工-出生日期', 'Employee - date of birth', '员工-出生日期']},
				{id: 'IDC_NO', name: ['員工-身分證號', 'Employee - identity card number', '员工-身分证号']},
				{id: 'MARITAL_STATUS', name: ['員工-婚姻狀況', 'Employee - Marital status', '员工-婚姻状况']},
				{id: 'CRIPPLES_CLASS', name: ['員工-身障類別', 'Staff - body injury category', '员工-身障类别']},
				{id: 'JOB_ID', name: ['員工-職位', 'Staff - position', '员工-职位']},
				{id: 'LEVEL_ID', name: ['員工-職等/職級', 'Staff - grade / rank', '员工-职等/职级']},
				{id: 'OFFICE_TEL', name: ['員工-公司電話', 'Staff - Company Phone', '员工-公司电话']},
				{id: 'OFFICE_EMAIL', name: ['員工-公司E-mail', 'Staff - Company E-mail', '员工-公司E-mail']},
				{id: 'MOBILE_TEL', name: ['員工-行動電話', 'Staff - mobile phone', '员工-行动电话']},
				{id: 'PERSONAL_EMAIL', name: ['員工-個人e-mail', 'Staff - Personal e-mail', '员工-个人e-mail']},
				{id: 'LIVE_TEL', name: ['員工-戶籍電話', 'Employee - household phone', '员工-户籍电话']},
				{id: 'LIVE_ADDRESS', name: ['員工-戶籍地址', 'Employee - household address', '员工-户籍地址']},
				{id: 'HOME_TEL', name: ['員工-住家電話', 'Staff - communication phone', '员工-通讯电话']},
				{id: 'CONTACT_ADDRESS_TW', name: ['員工-通訊地址', 'Employee - mailing address', '员工-通讯地址']},
				{id: 'CONTACT_ADDRESS_EN', name: ['員工-國外地址', 'Employee - Foreign address', '员工-国外地址']},
				{id: 'SOCIAL_ACCOUNT1', name: ['員工-社群帳號1', 'Employee - community account number 1', '员工-社群帐号1']},
				{id: 'SOCIAL_ACCOUNT2', name: ['員工-社群帳號2', 'Staff - Community account 2', '员工-社群帐号2']},
				{id: 'ALIEN_IDC_NO', name: ['員工-外僑統一證號', 'Staff - alien registration card number', '员工-外侨统一证号']},
				{id: 'PASSPORT_NO', name: ['員工-護照號碼', 'Employee - passport number', '员工-护照号码']},
				{id: 'PASSPORT_NAME', name: ['員工-護照姓名', 'Employee - passport name', '员工-护照姓名']},
			]
		}, {
			id: 'family',
			name: ['親屬', 'Relatives', '亲属'],
			children: [
				{id: 'FAMILY_NAME', name: ['親屬-姓名', 'Relatives - name', '亲属-姓名']},
				{id: 'FAMILY_IDC_NO', name: ['親屬-身分證號', 'Relatives - identity card number', '亲属-身分证号']},
				{id: 'FAMILY_ALIEN_IDC_NO', name: ['親屬-外僑統一證號', 'Relatives - aliens', '亲属-外侨统一证号']},
				{id: 'FAMILY_BIRTHDAY', name: ['親屬-出生日期', 'Relatives - date of birth', '亲属-出生日期']},
			]
		}, {
			id: 'edu',
			name: ['學歷', 'Education', '学历'],
			children: [
				{id: 'SCHOOL_NAME', name: ['學歷-學校名稱', 'Education - School name', '学历-学校名称']},
				{id: 'MAJOR_NAME', name: ['學歷-科系名稱', 'Education - Department name', '学历-科系名称']},
			]
		}, {
			id: 'exp',
			name: ['經歷', 'Experience', '经历'],
			children: [
				{id: 'COMPANY_NAME', name: ['經歷-公司名稱', 'Experience - company name', '经历-公司名称']},
				{id: 'DEPT_NAME', name: ['經歷-部門名稱', 'Experience - department name', '经历-部门名称']},
				{id: 'JOB_TITLE', name: ['經歷-職務名稱', 'Experience - job title', '经历-职务名称']},
				{id: 'JOB_DESC', name: ['經歷-職務內容', 'Experience - job content', '经历-职务内容']},
				{id: 'BOSS_NAME', name: ['經歷-主管姓名', 'Experience - supervisor name', '经历-主管姓名']},
			]
		}, {
			id: 'health',
			name: ['健康', 'Health', '健康'],
			children: [
				{id: 'HEALTH_ID', name: ['健康-異常項目', 'Health - abnormal items', '健康-异常项目']},
				{id: 'HEALTH_DESC', name: ['健康-異常說明', 'Health - Exception Description', '健康-异常说明']},
			]
		}
	],
	'ac.user.senFieldEip': {
		'EMP_PHOTO_FILE': ['個人照', 'Employee - Photo', '個人照'],
		'EMP_NAME': ['中文姓名', 'Employee - Chinese name', '基本资料 - 中文姓名'],
		'EMP_EN_NAME': ['英文姓名', 'Employee - English name', '基本资料 - 英文姓名'],
		'EMP_ALIAS_NAME': ['別名', 'Employee - alias', '基本资料 - 别名'],
		'DEPT1_ID': ['部門1', 'department1', '基本资料 - 部门1'],
		'DEPT1_NAME': ['部門名稱1', 'department1_Name', '基本资料 - 部门名稱1'],
		'JOB_NAME': ['職位(職稱)', 'Staff - position', '基本资料 - 职位（职称）'],
		'LEVEL_NAME': ['職等/職級', 'Staff - grade / rank', '基本资料 - 职等/职级'],
		'HIRE_DATE': ['到職日期', 'HIRE_DATE', '基本资料 - 到职日期'],
		'BIRTHDAY': ['出生日期', 'Employee - date of birth', '基本资料 - 出生日期'],
		'MARITAL_STATUS': ['婚姻狀況', 'Employee - Marital status', '基本资料 - 婚姻状况'],
		'SCHOOL_NAME': ['最高學歷', 'Education - School name', '基本资料 - 最高学历'],
		'COMPANY_NAME': ['最近經歷', 'Experience - company name', '基本资料 - 最近经历'],
		'OFFICE_TEL': ['公司電話', 'Staff - Company Phone', '通讯资料 - 公司电话'],
		'OFFICE_EMAIL': ['公司E-mail', 'Staff - Company E-mail', '通讯资料 - 公司电子邮件'],
		'PERSONAL_EMAIL': ['個人e-mail', 'Staff - Personal e-mail', '通讯资料 - 个人电子邮件'],
		'MOBILE_TEL': ['行動電話', 'Staff - mobile phone', '通讯资料 - 行动电话'],
		'LIVE_TEL': ['戶籍電話', 'Employee - household phone', '通讯资料 - 户籍电话'],
		'LIVE_ADDRESS': ['戶籍地址', 'Employee - household address', '通讯资料 - 户籍地址'],
		'HOME_TEL': ['住家電話', 'Staff - communication phone', '通讯资料 - 住家电话'],
		'CONTACT_ADDRESS_TW': ['通訊地址', 'Employee - mailing address', '通讯资料 - 通讯地址'],
		'CONTACT_ADDRESS_EN': ['國外地址', 'Employee - Foreign address', '通讯资料 - 国外地址'],
		'SOCIAL_ACCOUNT1': ['社群帳號1', 'Employee - community account number 1', '通讯资料 - 社群帐号1'],
		'SOCIAL_ACCOUNT2': ['社群帳號2', 'Staff - Community account 2', '通讯资料 - 社群帐号2'],
		'URGENCY_CONTACT1': ['緊急聯絡人(1)', 'URGENCY_CONTACT1', '通讯资料 - 紧急联络人（1）'],
		'URGENCY_RELATION1': ['緊急聯絡人關係(1)', 'URGENCY_RELATION1', '通讯资料 - 紧急联络人关系（1）'],
		'URGENCY_TEL1': ['電話(1)', 'URGENCY_TEL1', '通讯资料 - 电话（1）'],
		'URGENCY_MOBILE1': ['行動電話(1)', 'URGENCY_MOBILE1', '通讯资料 - 行动电话（1）'],
		'URGENCY_CONTACT2': ['緊急聯絡人(2)', 'URGENCY_CONTACT2', '通讯资料 - 紧急联络人（2）'],
		'URGENCY_RELATION2': ['緊急聯絡人關係(2)', 'URGENCY_RELATION2', '通讯资料 - 紧急联络人关系（2）'],
		'URGENCY_TEL2': ['電話(2)', 'URGENCY_TEL2', '通讯资料 - 电话（2）'],
		'URGENCY_MOBILE2': ['行動電話(2)', 'URGENCY_MOBILE2', '通讯资料 - 行动电话（2）']
	},
	'ac.presetRule.userAccount': {
		'1': ['員工編號','employee ID','员工编号'],
		'2': ['Email','Email','Email'],
		'3': ['身分證號(外國籍則為外僑統一證號)','Identity card number (for foreign nationals, it is the unified alien number)','身分证号(外国籍则为外侨统一证号)'],
		'4': ['Email-用戶名稱','Email-user name','Email-用户名称']
	},
	'ac.presetRule.userAccount._sort': [1, 2, 4, 3],
	'am.parm.yearLeaveType': {
		'0': ['去年','last year','去年'],
		'1': ['當年','this year','当年']
	},
	'am.parm.clDeductOrder': {
		'0': ['補休假截止日','Compensatory Leave Deadline','补休假截止日'],
		'1': ['加班歸屬日/薪資折現參考日','Overtime Attribution Date/Salary Discount Reference Date','加班归属日/薪資折現參考日']
	},
	'am.annual.calYears': {
		'1': ['前一年度年資', 'The previous year\'s seniority', '前一年度年资'],
		'2': ['當年度年資(預給制)', 'When the annual capital (pre-system)', '当年度年资(预给制)']
	},
	'am.annual.calYearsType': {
		'1': ['到職日', 'Duty day', '到职日'],
		'2': ['試用期滿日', 'Trial expiry date', '试用期满日'],
		'3': ['到職滿X月', 'To full employment X months', '到职满X月'],
		'4': ['年資滿X月', 'Year full X months', '年资满X月'],
		'5': ['下次給假起始日', 'Next to the fake start date', '下次给假起始日'],
		'6': ['年資滿一年', 'Year full year', '年资满一年'],
		'7': ['到職滿一年', 'Full year of service', '到职满一年']
	},
	'am.annual.convertType': {
		'1': ['依勞基法設定', 'According to the foundation law set', '依劳基法设定'],
		'2': ['依公司給假標準', 'According to the company to leave the standard', '依公司给假标准']
	},
	'am.annual.genBase': {
		'1': ['週年制', 'Anniversary', '周年制'],
		'2': ['每年固定日', 'Annual fixed day', '每年固定日'],
		'3': ['曆年制 01/01', 'Calendar year system', '历年制']
	},
	'am.annual.genRule': {
		'1': ['依勞基法設定', 'According to the foundation law set', '依劳基法设定'],
		'2': ['依公司自訂規則', 'According to the company custom rules', '依公司自订规则']
	},
	'am.annual.genTable': {
		'1': ['標準對照表', 'Standard comparison table', '标准对照表'],
		'2': ['年資與特休給假日對照表', 'Annual and special holiday to holiday list', '年资与特休给假日对照表']
	},
	'am.annual.genTableCompany': {
		'1': ['標準對照表', 'Standard comparison table', '标准对照表'],
		'2': ['年資與公司給假日對照表', 'Annual and company holiday to holiday list', '年资与公司给假日对照表']
	},
	'am.annual.giveLeaveEndDate': {
		'1': ['下一給假起始日前1日', '1 day before the next holiday start date', '下一给假起始日前1日'],
		'2': ['年度給假起始日前1日', '1 day before the start date of the annual leave', '年度给假起始日前1日']
	},
	'am.annual.giveLeaveTimes': {
		'1': ['於基準日前X日自動產生', 'X days before the base date automatically generated', '于基准日前X日自动产生'],
		'2': ['手動產生', 'Manually generated', '手动产生']
	},
	'am.annual.giveLeaveType': {
		'1': ['一次給假', 'Give a leave', '一次给假'],
		'2': ['一次給假分次設定可休上限', 'Set a holiday limit to fake points once', '一次给假分次设定可休上限'],
		'3': ['分次給假', 'Graded leave', '分次给假']
	},
	'am.annual.intervalYears': {
		'1': ['依年資較高的天數計算', 'Calculated by the number of days of higher years', '依年资较高的天数计算'],
		'2': ['依年資的比例分別計算', 'According to the proportion of annual funding were calculated', '依年资的比例分别计算']
	},
	'am.annual.lessYears': {
		'1': ['依年資比例', 'According to the proportion of years', '依年资比例'],
		'2': ['依在職比例', 'According to the proportion of in-service', '依在职比例']
	},
	'am.annual.source': {
		'1': ['人工輸入', 'Manual input', '人工输入'],
		'2': ['人工匯入', 'Manual import', '人工汇入'],
		'3': ['手動產生特休', 'Manually create a special break', '手动产生特休'],
		'4': ['自動產生特休', 'Automatically generate special breaks', '自动产生特休']
	},
	'am.annual.table.overYears': {
		'0': ['未滿1年', 'Less than 1 year', '未满1年'],
		'1': ['1年', '1 year', '1年'],
		'2': ['2年', '2 years', '2年'],
		'3': ['3年', '3 years', '3年'],
		'4': ['4年', '4 years', '4年'],
		'5': ['5年', '5 years', '5年'],
		'6': ['6年', '6 years', '6年'],
		'7': ['7年', '7 years', '7年'],
		'8': ['8年', '8 years', '8年'],
		'9': ['9年', '9 years', '9年'],
		'10': ['10年', '10 years', '10年'],
		'11': ['11年', '11 years', '11年'],
		'12': ['12年', '12 years', '12年'],
		'13': ['13年', '13 years', '13年'],
		'14': ['14年', '14 years', '14年'],
		'15': ['15年', '15 years', '15年'],
		'16': ['16年', '16 years', '16年'],
		'17': ['17年', '17 years', '17年'],
		'18': ['18年', '18 years', '18年'],
		'19': ['19年', '19 years', '19年'],
		'20': ['20年', '20 years', '20年'],
		'21': ['21年', '21 years', '21年'],
		'22': ['22年', '22 years', '22年'],
		'23': ['23年', '23 years', '23年'],
		'24': ['24年', '24 years', '24年'],
		'25': ['25年', '25 years', '25年'],
		'26': ['26年', '26 years', '26年'],
		'27': ['27年', '27 years', '27年'],
		'28': ['28年', '28 years', '28年'],
		'29': ['29年', '29 years', '29年'],
		'30': ['30年以上', '30 years or more', '30年以上']
	},
	'am.annual.tranDeadline': {
		'1': ['於下一特休假年度均可休', 'In the next special holiday can be closed', '于下一特休假年度均可休'],
		'2': ['於下一特休假年度X天內休完', 'In the next special holiday year X days off', '于下一特休假年度X天内休完'],
		'3': ['於下一特休假年度Y內休完', 'In the next special holiday year Y off', '于下一特休假年度Y内休完']
	},
	'am.annual.useType': {
		'11': ['請假(本期)', 'Leave (this issue)', '请假(本期)'],
		'12': ['銷假(本期)', 'Leave off (this issue)', '销假(本期)'],
		'13': ['折現(本期)', 'Discounted (current issue)', '折现(本期)'],
		'14': ['結轉下一年度(本期)', 'Carry forward the next year (current issue)', '结转下一年度(本期)'],
		'15': ['扣回(本期)', 'Deduction (current period)', '扣回(本期)'],
		'19': ['放棄(本期)', 'Give up (this issue)', '放弃(本期)'],
		'21': ['請假(上期展延)', 'Leave (previous period)', '请假(上期展延)'],
		'22': ['銷假(上期展延)', 'Sales leave (previous period)', '销假(上期展延)'],
		'23': ['折現(上期展延)', 'Discount (previous period)', '折现(上期展延)'],
		'24': ['結轉下一年度(上期展延)', 'Carry forward the next year (previous period)', '结转下一年度(上期展延)'],
		'29': ['放棄(上期展延)', 'Give up (previous)', '放弃(上期展延)'],
		'31': ['請假(本期在途)', 'Leave (in the current period)', '请假（本期在途）'],
		'41': ['請假(上期展延在途)', 'Leave (the last period of the exhibition is on the way)', '请假（上期展延在途）']
	},
	'am.annual.preUseWay': {
		'1': ['給假制', 'Give holiday system', '给假制'],
		'2': ['申請制', 'Application system', '申请制']
	},
	'am.annual.preUseGiveLeaveType1': {
		'1': ['到職即給假', 'Give a leave when you arrive', '到职即给假'],
		'2': ['到職滿', 'Full time', '到职满'],
		'3': ['年資滿', 'Full year', '年资满'],
		'4': ['試用期滿給假', 'Trial expired', '试用期满给假']
	},
	'am.annual.preUseUnit': {
		'1': ['月', 'month', '月'],
		'2': ['日', 'day', '日']
	},
	'am.annual.preUseDayRule1': {
		'1': ['固定天數', 'Fixed days', '固定天数'],
		'2': ['依在職', 'Dependent on duty', '依在职'],
		'3': ['依年資', 'Year by year', '依年资']
	},
	'am.annual.preUseDayRuleUnit': {
		'1': ['天', 'day', '天'],
		'2': ['小時', 'hour', '小时']
	},
	'am.annual.preUseGiveLeaveType2': {
		'1': ['前年度給假起始日', 'Fake start date of the previous year', '前年度给假起始日'],
		'2': ['前年度給假起始日加', 'The previous year gave the fake start date plus', '前年度给假起始日加']
	},
	'am.annual.preUseDayRule2': {
		'1': ['固定天數', 'Fixed days', '固定天数'],
		'2': ['年資給假', 'Annual leave', '年资给假']
	},
	'am.annual.type': {
		'1': ['特休假', 'Special leave', '特休假'],
		'2': ['公司假', 'Company leave', '公司假']
	},
	'am.annual.preUse': {
		'0': ['本期','This period','本期'],
		'1': ['預支','Advance','预支']
	},
	'am.annual.preUseDayOpt': {
		'1': ['依預支年度給假天數預支', 'Advance by the number of false days in advance', '依预支年度给假天数预支'],
		'2': ['不產生預支天數', 'Does not generate advance days', '不产生预支天数']
	},
	'am.leave.flexibleSource': {
		'COVER': ['跨整段班','Span','跨整段班'],
		'CROSS': ['跨天請假','Leave across the sky','跨天请假'],
		'END': ['結束時間','End Time','结束时间'],
		'START': ['開始時間','Starting time','开始时间']
	},
	'am.attend.source': {
		'1': ['資料輸入', 'Data input', '资料输入'],
		'2': ['資料匯入', 'Data import', '资料汇入'],
		'3': ['時數輸入', 'Hours input', '时数输入'],
		'4': ['時數匯入', 'Hours imported', '时数汇入'],
		'5': ['刷卡轉入', 'Swipe in', '刷卡转入'],
		'61': ['電子表單時段', 'Electronic form', '电子表单'],
		'63': ['電子表單時數', 'E-form by hours', '电子表单时数'],
		'7': ['介接', 'Interface', '介接'],
		'8': ['請假資料', 'Leave information', '请假资料'],
		'9': ['打卡結轉', 'Punch carry forward', '打卡结转']
	},
	'am.attend.source._sort': [1,2,3,4,5,61,63,7,9,8],
	'am.attendRule.unit': {
		'hour': ['小時', 'hour', '小时'],
		'minute': ['分鐘', 'minute', '分钟']
	},
	'am.base.dayRange': {
		'1900/01/01': ['前日', 'Previous day', '前日'],
		'1900/01/02': ['當日', 'Current day', '当日'],
		'1900/01/03': ['次日', 'Following day', '次日']
	},
	'am.base.finalTarget': {
		'1': ['結轉下年度天數', 'Carry forward the next few days', '结转下年度天数'],
		'2': ['結轉現金', 'Carry cash', '结转现金'],
		'3': ['放棄', 'give up', '放弃']
	},
	'am.base.shiftType': {
		'1': ['固定班', 'Fixed shifts', '固定班'],
		'2': ['排班(依班別)', 'Rotating shifts (by shift)', '排班(依班别)'],
		'3': ['排班(依時段)', 'Rotating shifts (by period)', '排班(依时段)'],
		'4': ['不需排班(依申請時數)', 'Shift scheduling is not required (requested based on hours)', '不需排班(依申请时数)']
	},
	'am.base.shiftType.api': {	// 因為 APP 要串接時，時薪、時段同時測試，但時段先被隱藏了，API 的 validate 只好先改成這個 (時段要上時可以拿掉，記得 api-wf060.js、api-global.js 那邊也要改)
		'1': ['固定班', 'Fixed shifts', '固定班'],
		'2': ['排班(依班別)', 'Rotating shifts (by shift)', '排班(依班别)'],
		'3': ['排班(依時段)', 'Rotating shifts (by period)', '排班(依时段)'],
		'4': ['不需排班(依申請時數)', 'Shift scheduling is not required (requested based on hours)', '不需排班(依申请时数)']
	},
	'am.emp.partTimeStatus.label': {
		'1': ['全時勞工','',''],
		'2': ['部分工時勞工，有約定比例','',''],
		'3': ['部分工時勞工，有約定工時','','']
	},
	'am.emp.partTimeStatus': {
		'1': ['全時勞工','',''],
		'2': ['部分工時-約定比例','',''],
		'3': ['部分工時-約定工時','','']
	},
	'am.emp.partTimeStatus.form': {
		'1': ['全時勞工','Full time','全时劳工'],
		'2': ['約定比例','Agreed ratio','约定比例'],
		'3': ['約定工時','Agreed working hours','约定工时']
	},
	'am.emp.partTimePeriod': {
		'DAY': ['天','day','天'],
		'WEEK': ['週', 'week', '周'],
	},
	'am.emp.partTimePeriod.form': {
		'DAY': ['每天', 'Every day', '每天'],
		'WEEK': ['每週', 'Every week', '每周'],
	},
	'am.emp.period.form': {
		'every': ['每', 'Every', '每'],
	},
	'am.emp.trnType': {
		'1': ['超過8小時轉加班', 'Working overtime over 8 hours', '超过8小时转加班'],
		'2': ['全部轉出勤時數', 'All transfer attendance hours', '全部转出勤时数'],
	},
	'am.base.tranRule': {
		'1': ['上期本期合併結轉', 'The previous period carried forward this period', '上期本期合并结转'],
		'2': ['上期本期分開結轉', 'The current period carried forward separately', '上期本期分开结转']
	},
	'am.base.tranUnit': {
		'1': ['天', 'day', '天'],
		'2': ['％', '%', '％']
	},
	'am.biz.convertRateType': {
		'1': ['系統匯率', 'System exchange rate', '系统汇率'],
		'2': ['自訂匯率', 'Custom exchange rate', '自订汇率']
	},
	'am.biz.rule': {
		'1': ['每日限額', '', ''],
		'2': ['每次限額', '', ''],
		'3': ['依公里數', '', '']
	},
	'am.biz.source': {
		'1': ['資料輸入', 'Data input', '资料输入'],
		'2': ['資料匯入', 'Data import', '资料汇入'],
		'6': ['電子表單', 'Electronic form', '电子表单'],
		'7': ['介接', 'Interface', '介接']
	},
	'am.biz.type': {
		'1': ['國內出差', 'Domestic business trip', '国内出差'],
		'2': ['國外出差', 'Travel abroad', '国外出差']
	},
	'am.cal.annual.jobMonth': {
		'1': ['當月', 'Current Month', '当月'],
		'2': ['前月', 'Previous Month', '前月']
	},
	'am.cal.annualType': {
		'1': ['上期+本期結算', 'Previous period + current period settlement', '上期+本期结算'],
		'2': ['上期結算', 'Previous settlement', '上期结算'],
		'3': ['本期結算', 'Current settlement', '本期结算']
	},
	'am.cal.attendValue1': {
		'1': ['依出勤時數規則扣除', 'Deducted according to the rules of attendance hours', '依出勤时数规则扣除'],
		'0': ['不扣除', 'not deducted', '不扣除']
	},
	'am.cal.attendValue1._sort': [1, 0],
	'am.cal.attendValue2': {
		'1': ['依照員工出勤規則', 'According to employee attendance rules', '依照员工出勤规则'],
		'2': ['自訂', 'not Customize', '自订']
	},
	'am.cal.attendValue4': {
		'1': ['發放加班費', 'Pay overtime', '发放加班费'],
	},
	'am.cal.autoJob.attendCal': {
		'4': ['依計薪週期(出勤時數週期)', 'Payroll cycle (attendance hours)', '依计薪周期(出勤时数周期)'],
		'3': ['不予結算', 'Not settled', '不予结算']
	},
	'am.cal.autoJob.attendCancelCal': {
		'4': ['依計薪週期(取消出勤時數週期)', 'Payroll cycle (attendance hours)', '依计薪周期(出勤时数周期)'],
		'3': ['不予結算', 'Not settled', '不予结算']
	},
	'am.cal.autoJob.bizCal': {
		'4': ['依計薪週期', 'According to the salary cycle', '依计薪周期'],
		'3': ['不予結算', 'Not settled', '不予结算']
	},
	'am.cal.autoJob.cal': {
		'1': ['依截止日', 'By deadline', '依截止日'],
		'2': ['依截止期間', 'By deadline', '依截止期间'],
		'3': ['不予結算', 'Not settled', '不予结算']
	},
	'am.cal.autoJob.calWay': {
		'1': ['依計薪週期設定', 'Set by pay period', '依计薪周期设定'],
		'2': ['自行設定', 'Set by yourself', '自行设定']
	},
	'am.cal.autoJob.cardMatchCal': {
		'4': ['依計薪週期(刷卡異常結算週期)', 'According to the salary cycle (swipe abnormal settlement period)', '依计薪周期(刷卡异常结算周期)'],
		'3': ['不予結算', 'Not settled', '不予结算']
	},
	'am.cal.autoJob.funType': {
		'10': ['年度結算', 'Annual settlement', '年度结算'],
		'20': ['離職留停結算', 'Resignation and settlement', '离职留停结算'],
		'30': ['出差費用結算', 'Travel expenses settlement', '出差费用结算'],
		'40': ['每月假勤結算', 'Monthly log settlement', '每月假勤结算'],
		'50': ['排班工時結算', 'Scheduled work settlement', '排班工时结算']
	},
	'am.cal.autoJob.holidayRule': {
		'1': ['提前', 'in advance', '提前'],
		'2': ['延後', 'Delayed', '延后']
	},
	'am.cal.autoJob.leaveCal': {
		'4': ['依計薪週期(請假扣款週期)', 'Payable period (death deduction period)', '依计薪周期(请假扣款周期)'],
		'3': ['不予結算', 'Not settled', '不予结算']
	},
	'am.cal.autoJob.leaveCancelCal': {
		'4': ['依計薪週期(銷假扣款週期)', 'Payable period (death deduction period)', '依计薪周期(请假扣款周期)'],
		'3': ['不予結算', 'Not settled', '不予结算']
	},
	'am.cal.autoJob.otCal': {
		'4': ['依計薪週期(加班扣款週期)', 'Payroll cycle (overtime deduction cycle)', '依计薪周期(加班扣款周期)'],
		'3': ['不予結算', 'Not settled', '不予结算']
	},
	'am.cal.autoJob.otCancelCal': {
		'4': ['依計薪週期(取消加班週期)', 'Payroll cycle (overtime deduction cycle)', '依计薪周期(加班扣款周期)'],
		'3': ['不予結算', 'Not settled', '不予结算']
	},
	'am.cal.baseType': {
		'1': ['依截止日','By deadline day','依截止日'],
		'2': ['依離職、留停日','By employee leave date','依离职、留停日']
	},
	'am.cal.cond': {
		'1': ['全體員工', 'All employees', '全体员工'],
		'2': ['特定員工', 'Specific employee', '特定员工'],
		'3': ['特休假可休區間訖日落在X月', 'Special leave break period to sunset in X month', '特休假可休区间讫日落在X月']
	},
	'am.cal.flexibleType': {
		'1': ['上期+本期結算', 'Previous period + current period settlement', '上期+本期结算'],
		'2': ['上期結算', 'Previous settlement', '上期结算'],
		'3': ['本期結算', 'Current settlement', '本期结算']
	},
	'am.cal.status': {
		'0': ['未結算', 'Unsettlement', '未结算'],
		'1': ['結算中', 'In settlement', '结算中'],
		'2': ['已結算', 'Settlement completed', '已结算']
	},
	'am.cal.type': {
		'11': ['特休年度結算','Special holiday annual settlement','特休年度结算'],
		'12': ['公司假年度結算','Company leave year settlement','公司假年度结算'],
		'13': ['補休年度結算','Compensation leave annual settlement','补休年度结算'],
		'14': ['彈性假年度結算','Flexible leave annual settlement','弹性假年度结算'],
		'15': ['一般假勤年度結算','Annual Annual General Settlement','一般假勤年度结算'],
		'21': ['特休離職結算','Special holiday leave settlement','特休离职结算'],
		'22': ['公司假離職結算','Company leave settlement','公司假离职结算'],
		'23': ['補休離職結算','Compensation leave settlement','补休离职结算'],
		'24': ['彈性假離職結算','Flexible leave settlement','弹性假离职结算'],
		'25': ['一般假勤離職結算','General leave and absence settlement','一般假勤离职结算'],
		'31': ['出差預支結算','Travel advance settlement','出差预支结算'],
		'32': ['實際出差費用結算','Settlement of actual travel expenses','实际出差费用结算'],
		'41': ['請假結算','Leave settlement','请假结算'],
		'42': ['加班及誤餐費結算','Settlement of overtime and missed meal fees','加班及误餐费结算'],
		'43': ['出勤時數結算','Attendance hours settlement','出勤时数结算'],
		'44': ['刷卡異常結算','Credit card abnormal settlement','刷卡异常结算'],
		'51': ['排班工時結算','Shift work settlement','排班工时结算']
	},
	'am.card.actionLOG': {
		'1': ['進入', 'enter', '进入'],
		'2': ['打卡', 'Punch', '打卡'],
		'3': ['檢查', 'an examination', '检查'],
		'4': ['寫入', 'Write', '写入']
	},
	'am.card.client': {
		'1': ['電腦', 'computer', '电脑'],
		'2': ['平板', 'flat', '平板'],
		'3': ['手機', 'Cell phone', '手机'],
		'4': ['未知', 'unknown', '未知']
	},
	'am.card.import': {
		'A': ['自動匯入', 'Import automatically', '自动汇入'],
		'P': ['人工匯入', 'Manual import', '人工汇入']
	},
	'am.card.isValid': {
		'1': ['有效', 'effective', '有效'],
		'0': ['無效', 'invalid', '无效']
	},
	'am.card.matchType': {
		'0': ['尚未比對', 'Unprocessed', '尚未比对'],
		'1': ['上班', 'Start Work', '上班'],
		'2': ['下班', 'Got Off Work', '下班'],
		'3': ['加班開始', 'Start Overtime', '加班开始'],
		'4': ['加班結束', 'End Overtime', '加班结束'],
		'5': ['休息外出', 'Start Break', '休息外出'],
		'6': ['休息返回', 'End Break', '休息返回'],
		'7': ['請假外出', 'Start Leave', '请假外出'],
		'8': ['請假返回', 'End Leave', '请假返回'],
		'9': ['非首尾筆', 'Not the beginning and the end.', '非首尾笔'],
	},
	'am.card.source': {
		'1': ['刷卡鐘', 'Card clock', '刷卡钟'],
		'2': ['門禁', 'Access control', '门禁'],
		'3': ['網路打卡', 'Network punch', '网路打卡'],
		'4': ['介接', 'Interface', '介接'],
		'5': ['GPS 打卡', 'GPS punch', 'GPS 打卡'],
		'6': ['表單申請', 'Workflow application', '表单申请'],
		'7': ['Wi-Fi打卡', 'Wi-Fi punch', 'Wi-Fi打卡'],
		'8': ['人工匯入', 'Manual import', '人工汇入'],
		'9': ['人工輸入', 'Manual input', '人工输入'],
		'10': ['GPS 打卡(臨時打卡)', 'GPS 打卡(临时打卡)', 'GPS punch (temporary)'],
		'11': ['Wi-Fi打卡(臨時打卡)', 'Wi-Fi打卡(临时打卡)', 'Wi-Fi punch (temporary)'],
	},
	'am.card.source._sort': [1, 2, 3, 4, 5, 7, 6, 8, 9, 10, 11],
	'am.card.type': {
		'1': ['上班','Go to work','上班'],
		'2': ['下班','Off work','下班'],
		'3': ['加班開始','Overtime start','加班开始'],
		'4': ['加班結束','Overtime','加班结束'],
		'5': ['休息外出','Go out for a break','休息外出'],
		'6': ['休息返回','Rest and return','休息返回'],
		'7': ['請假外出','Leave for vacation','请假外出'],
		'8': ['請假返回','Leave back','请假返回']

	},

	'am.cardMatch.overRemind': {
		'1': ['個人因素', 'personal reason', '个人因素'],
		'2': ['實際加班', 'Actual overtime', '实际加班']
	},
	'am.cardMatch.status': {
		'0': ['未比對', 'Unprocessed', '未比对'],
		'1': ['正常', 'Correct', '正常'],
		'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
		'3': ['遲到', 'Late', '迟到'],
		'4': ['早退', 'Leave Early', '早退'],
		'5': ['曠職', 'Absenteeism', '旷职'],
		'6': ['未打卡', 'No Results', '未打卡'],
		'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		'8': ['刷卡資料不足', 'Insufficient credit card information', '刷卡资料不足'],
	},
	'am.cardMatch.statusforAm40030Search': {
		'0': ['未比對', 'Unprocessed', '未比对'],
		'1': ['正常', 'Correct', '正常'],
		'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
		'3': ['遲到', 'Late', '迟到'],
		'4': ['早退', 'Leave Early', '早退'],
		'5': ['曠職', 'Absenteeism', '旷职'],
		//'6': ['未打卡', 'No Results', '未打卡'],
		'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		'8': ['刷卡資料不足', 'Insufficient credit card information', '刷卡资料不足'],
	},
	'am.cardMatch.unusualAction': {
		'1': ['待處理', 'Pending', '待处理'],
		'2': ['請假', 'Take Leave', '请假'],
		'8': ['異常已結算', 'Exception Settled', '异常已结算'],
		'9': ['忽略', 'Ingored', '忽略'],
	},
	'am.cardMatch.unusualGroup': {
		'1': ['打卡異常','Check in time','打卡异常'],
		'2': ['超時異常','Timeout exception','超时异常']
	},
	'am.overAttend.status': {
		'0': ['未比對', 'Unprocessed', '未比对'],
		'1': ['正常', 'Correct', '正常'],
		'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
		'3': ['超時出勤', 'Work Overtime', '超时出勤'],
	},
	'am.overAttend.action': {
		'1': ['待處理','Pending','待处理'],
		'2': ['加班','Overtime','加班'],
		'7': ['填寫超時出勤原因','Reason for overtime attendance has been filled in','填写超时出勤原因'],
		'9': ['忽略','ignore','忽略']
	},
	'am.cardMatch.gridStatus': {
		'0': ['未比對','Unmatched','未比对'],
		'1': ['正常','normal','正常'],
		'2': ['異常','exception','异常'],
	},
	'am.overAttend.fillType': {
		'EMP': ['員工','Employee','员工'],
		'HR': ['HR','HR','HR']
	},

	'am.cl.Source': {
		'1': ['人工輸入', 'Manual input', '人工输入'],
		'2': ['人工匯入', 'Manual import', '人工汇入'],
		'3': ['加班換補休', 'Overtime change', '加班换补休']
	},
	'am.cl.useType': {
		'11': ['請假', 'Leave', '请假'],
		'12': ['銷假', 'Sales leave', '销假'],
		'13': ['折現', 'Discounted', '折现'],
		'19': ['放棄', 'give up', '放弃'],
		'31': ['請假(在途)', 'Leave (on way)', '请假(在途)']
	},
	'am.cl.tranUnit': {
		'1': ['小時','hour','小时'],
		'2': ['％','%','％']
	},
	'am.clock.colDateStyle1': {
		'1': ['2018/3/14', '2018/3/14', '2018/3/14'],
		'2': ['2018-3-14', '2018-3-14', '2018-3-14'],
		'3': ['2018年3月14日', '2018年3月14日', '2018年3月14日'],
		'4': ['20180314', '20180314', '20180314'],
		'5': ['3/14/2018', '3/14/2018', '3/14/2018'],
		'6': ['3-14-2018', '3-14-2018', '3-14-2018'],
		'7': ['03142018', '03142018', '03142018'],
		'8': ['3/14/18', '3/14/18', '3/14/18'],
		'9': ['3-14-18', '3-14-18', '3-14-18'],
		'10': ['031418', '031418', '031418'],
		'11': ['14-Mar-18', '14-Mar-18', '14-Mar-18'],
		'12': ['180314', '180314', '180314'],
	},
	'am.clock.colDateStyle2': {
		'1': ['107/3/14', '107/3/14', '107/3/14'],
		'2': ['107-3-14', '107-3-14', '107-3-14'],
		'3': ['中華民國107年3月14日', '中華民國107年3月14日', '中華民國107年3月14日'],
		'4': ['民國107年3月14日', '民國107年3月14日', '民國107年3月14日'],
		'5': ['107年3月14日', '107年3月14日', '107年3月14日'],
		'6': ['1070314', '1070314', '1070314'],
		'7': ['3/14/107', '3/14/107', '3/14/107'],
		'8': ['3-14-107', '3-14-107', '3-14-107'],
		'9': ['0314107', '0314107', '0314107'],
		'10': ['130314', '130314', '130314']
	},
	'am.clock.colEmpStyle': {
		'1': ['員工編號', 'employee ID', '员工编号'],
		'2': ['卡號', 'card number', '卡号']
	},
	'am.clock.colTimeStyle': {
		'1': ['下午01:30:55', '下午01:30:55', '下午01:30:55'],
		'10': ['下午 01:30:55', '下午 01:30:55', '下午 01:30:55'],
		'2': ['13:30', '13:30', '13:30'],
		'3': ['1:30PM', '1:30PM', '1:30PM'],
		'4': ['13:30:55', '13:30:55', '13:30:55'],
		'5': ['1:30:55 PM', '1:30:55 PM', '1:30:55 PM'],
		'6': ['13時30分', '13時30分', '13時30分'],
		'7': ['13時30分55秒', '13時30分55秒', '13時30分55秒'],
		'8': ['下午1時30分', '下午1時30分', '下午1時30分'],
		'9': ['下午1時30分55秒', '下午1時30分55秒', '下午1時30分55秒'],
		'11': ['1300', '1300', '1300'],
		'12': ['130055', '130055', '130055'],
	},
	'am.clock.colTimeStyle._sort': [1, 10, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12],
	'am.clock.colTimeZone': {
		'1': ['24小時制', '24Hour', '24小时制'],
		'2': ['12小時制', '12Hour', '12小时制']
	},
	'am.clock.colYearStyle': {
		'1': ['西元', 'West yuan', '西元'],
		'2': ['民國', 'Republic of China', '民国']
	},
	'am.clock.fileDatetimeMerge': {
		'1': ['同一欄位', 'The same field', '同一栏位'],
		'0': ['不同欄位', 'Different fields', '不同栏位']
	},
	'am.clock.fileSplitMark': {
		'1': ['Tab', 'Tab', 'Tab'],
		'2': ['空格', 'Space', '空格'],
		'3': ['冒號(:)', 'Colon(:)', '冒号(:)'],
		'4': ['逗號(,)', 'Comma(,)', '逗号(,)'],
		'5': ['反斜線(\\)', 'Backslash(\\)', '反斜线(\\)'],
		'6': ['連字號(-)', 'Hyphen(-)', '连字号(-)'],
		'7': ['分號(;)', 'semicolon(;)', '分号(;)'],
	},
	'am.clock.fileSplitType': {
		'1': ['分隔符號', 'Separator symbol', '分隔符号'],
		'2': ['固定寬度', 'Fixed width', '固定宽度']
	},
	'am.clock.fileType': {
		'1': ['刷卡資料', 'Credit card information', '刷卡资料'],
		'2': ['門禁資料', 'Access Information', '门禁资料']
	},
	'am.clock.fileCoding': {
		'ANSI': ['ANSI(Big5)','ANSI(Big5)','ANSI(Big5)'],
		'UTF8': ['UTF-8','UTF-8','UTF-8']
	},
	'am.clock.formatType': {
		'1': ['純文字檔(.txt,.csv,.dat,.tab)', '(英文)純文字檔(.txt,.csv,.dat,.tab)', '(簡中)純文字檔(.txt,.csv,.dat,.tab)'],
		'2': ['Office Excel(.xls,.xlsx)', 'Office Excel(.xls,.xlsx)', 'Office Excel(.xls,.xlsx)']
	},
	'am.clock.job.contentField': {
		'1': ['員工編號', 'employee ID', '员工编号'],
		'2': ['卡號', 'card number', '卡号'],
		'3': ['刷卡鐘代碼', 'Card number', '刷卡钟代码'],
		'4': ['刷卡代碼', 'Credit card code', '刷卡代码']
	},
	'am.clock.job.dataType': {
		'1': ['轉入檔名規則', 'Into the file name rules', '转入档名规则'],
		'2': ['檔案內容規則', 'File content rules', '档案内容规则']
	},
	'am.commLeaveRulebase.selOption': {
		'1': ['提醒類', 'Reminder class', '提醒类'],
		'2': ['顯示類', 'Display class', '显示类']
	},
	'am.commLeaveRule.checkRule': {
		'1': ['提醒', 'remind', '提醒'],
		'2': ['允許', 'allow', '允许'],
		'3': ['禁止', 'Prohibited', '禁止']
	},
	'am.commLeaveRule.checkRuleShow': {
		'1': ['顯示', 'display', '显示'],
		'2': ['不顯示', 'Do not show', '不显示']
	},
	'am.commLeaveRule.checkOtTiming': {
		'1': ['申請', 'apply', '申请'],
		'2': ['簽核', 'sign', '签核']
	},
	'am.emp.cardMatch': {
		'1': ['需比對及產生異常', 'Comparison and anomaly generation are required.', '需比对及产生异常'],
		'2': ['需比對不需產生異常', 'Comparison is required and anomaly generation is not needed.', '需比对不须产生异常'],
		'3': ['不需比對', 'Comparison is not required.', '不需比对']
	},
	'am.emp.cardRule': {//注：順序在 am.emp.cardRule._sort
		'1': ['刷卡鐘代碼', 'Credit card bell code', '刷卡钟代码'],
		'2': ['GPS打卡地點', 'GPS check-in location', 'GPS打卡地点'],
		'3': ['網路打卡IP', 'Internet punch card IP', '网路打卡IP'],
		'4': ['Wi-Fi打卡地點', 'Wi-Fi check-in location', 'Wi-Fi打卡地点']
	},
	'am.emp.cardRule._sort': [1,3,2,4],
	'am.emp.clCoefType': {
		'1': ['實際補休倍率', 'Actual fill rate', '实际补休倍率'],
		'2': ['折算現金時補休倍率', 'Compensatory time ratio when converting cash', '折算现金时补休倍率']
	},
	'am.emp.offday.adjType': {
		'1': ['與其它日期對調', 'Reversal with other dates', '与其它日期对调'],
		'2': ['直接調整', 'Direct adjustment', '全部转出勤时数']
	},
	'am.emp.varsItem':{
		'AM_TEMPLATE_ID':['出勤規則範本','Attendance rule template','出勤规则范本'],
		'SHIFT_TYPE':['班別屬性','Class attribute','班别属性'],
		'PARTTIME_STATUS': ['部分工時/全時','',''],
		'PARTTIME_SETTING': ['約定比例/約定工時','',''],
		// 'PARTTIME_RATE': ['約定比例','',''],
		// 'PARTTIME_PERIOD': ['約定工時週期','',''],
		// 'PARTTIME_PERIOD_HOUR': ['約定工時週期值','',''],
		// 'PARTTIME_DAY_HOUR': ['部分工時每天x小時','',''],
		'SHIFT_ID':['班別','Class','班别'],
		'CALENDAR_BASIC_ID':['行事曆','Calendar','行事历'],
		'SECTION_RULE_ID':['時段班別規則','Staff scheduling rules','时段班別规则'],
		// 'SA_RULE_ID':['排班規則','Scheduling rules','排班规则'],
		'ANNUAL_ID':['特休規則','Special rules','特休规则'],
		// 'CO_ANNUAL_IDS':['公司假規則','Corporate fake rules','公司假规则'],
		'FLEXIBLE_IDS': ['彈性假規則','Flexible leave rules','弹性假规则'],
		'ATTEND_RULE_ID':['出勤時數規則','Hour staff rules','出勤时数规则'],
		'TRN_TYPE': ['工作日打卡轉加班','Switch to overtime on weekdays','工作日打卡转加班'],
		'OT_RULE_ID':['加班規則','Overtime rules','加班规则'],
		'OT_WORKHOUR_ID':['工時規則','Working rules','工时规则'],
		'IS_CARD_CLOCK':['允許打卡-刷卡鐘','Allowed to punch - credit card clock','允许打卡 - 刷卡钟'],
		'IS_CARD_NETWORK': ['允許打卡-網路打卡', 'Allowed to punch - online punch', '允许打卡 - 网路打卡'],
		'IS_CARD_GPS': ['允許打卡-GPS打卡', 'Allow punch - GPS punch', '允许打卡-GPS打卡'],
		'IS_CARD_WIFI': ['允許打卡-Wi-Fi打卡', 'Allow punch - Wi-Fi punch', '允许打卡-Wi-Fi打卡'],
		'CARD_MATCH':['刷卡比對','Credit card comparison','刷卡比对'],
	},
	'am.flexible.source': {
		'1': ['人工輸入', 'Manual input', '人工输入'],
		'2': ['人工匯入', 'Manual import', '人工汇入'],
		'3': ['手動產生彈性假', 'Manually generate elasticity false', '手动产生弹性假'],
		'4': ['自動產生彈性假', 'Automatically generate elasticity false', '自动产生弹性假'],
		'5': ['上期結轉', 'Last period carry forward', '上期结转']
	},
	'am.flexible.tranDeadline': {
		'1': ['於下一特彈假年度均可休', 'In the next special bounce year can rest', '于下一特弹假年度均可休'],
		'2': ['於下一特彈假年度X月X日內休完', 'The next special bounce year X month X days off', '于下一特弹假年度X月X日内休完']
	},
	'am.flexible.useType': {
		'11': ['請假', 'Leave', '请假'],
		'12': ['銷假', 'Sales leave', '销假'],
		'13': ['折現', 'Discounted', '折现'],
		'14': ['結轉下一年度', 'Carry over to the next year', '结转下一年度'],
		'15': ['扣回', 'discount', '扣回'],
		'31': ['請假(在途)', 'Leave (on way)', '请假(在途)'],
		'19': ['放棄', 'give up', '放弃']
	},
	'am.holidayRule.cycleType': {
		'1': ['年 ( 農曆 )', 'Year ( lunar calendar )', '年 ( 农历 )'],
		'2': ['年 ( 國曆 )', 'Year ( national calendar )', '年 ( 国历 )'],
		'3': ['月', 'month', '月'],
		'4': ['週', 'week', '周'],
		'5': ['日', 'day', '日'],
		'6': ['特定日期', 'Specific date', '特定日期'],
		'7': ['特定週期', 'Specific period', '特定周期']
	},
	'am.holidayRule.lunarDay': {
		'1': ['農曆除夕', 'Lunar New Year\'s Eve', '农历除夕'],
		'2': ['春節', 'Chinese New Year', '春节'],
		'3': ['清明節', 'Ching Ming Festival', '清明節'],
		'4': ['端午節', 'Dragon boat festival', '端午节'],
		'5': ['中秋節', 'Mid-autumn festival', '中秋节'],
		'6': ['小年夜', 'Lunar New Year\'s Eve Eve', '小年夜'],
	},
	'am.leave.source': {
		'1': ['資料輸入', 'Data input', '资料输入'],
		'2': ['資料匯入', 'Data import', '资料汇入'],
		'3': ['時數輸入', 'Hours input', '时数输入'],
		'4': ['時數匯入', 'Hours imported', '时数汇入'],
		'5': ['刷卡轉入', 'Swipe in', '刷卡转入'],
		'6': ['電子表單', 'Electronic form', '电子表单'],
		'61': ['電子表單時段', 'Electronic form', '电子表单'],
		'63': ['電子表單時數', 'E-form by hours', '电子表单时数'],
		'7': ['介接', 'Intermediate data', '介接'],
		'71': ['介接時段', 'Intermediate data', '介接报价'],
		'73': ['介接時數', 'Interface hours', '介接时数'],
	},
	'am.leave.workSheetStatus': {
		'1': ['簽核中', 'Approving', '签核中'],
		'2': ['已核准', 'Approved', '已核准']
	},
	'am.leaveitem.convertAmountType': {
		'1': ['依在職月份比例折抵現金', 'According to the proportion of working-month discount cash', '依在职月份比例折抵现金'],
		'2': ['依在職天數比例折抵現金', 'According to the ratio of working days discounted cash', '依在职天数比例折抵现金'],
		'3': ['未休時數全數折抵現金', 'The number of unspent hours off all cash', '未休时数全数折抵现金']
	},
	'am.leaveitem.eventDayType': {
		'year': ['年', 'year', '年'],
		'month': ['月', 'month', '月'],
		'day': ['日曆天', 'Calendar day', '日历天'],
		'workday': ['工作天', 'Working day', '工作天']
	},
	'am.leaveitem.halfDaySet': {
		'1': ['依班表上下半天規則', 'According to the table half-day rule', '依班表上下半天规则'],
		'2': ['正負X小時規則', 'Positive and negative X hour rule', '正负X小时规则']
	},
	'am.leaveitem.laws': {
		'SLC03': ['補休假','compensatory time','补休假'],
		'SLC10': ['普通傷病假(無住院)','Ordinary injury (no hospitalization)','普通伤病假(无住院)'],
		'SLC11': ['普通傷病假(住院)','Ordinary injury sickness (hospitalization)','普通伤病假(住院)'],
		'SLC12': ['公傷病假','Male sick leave','公伤病假'],
		'SLC13': ['事假','Leave','事假'],
		'SLC14': ['婚假','Marriage leave','婚假'],
		'SLC15': ['喪假(父母、養父母、繼父母、配偶喪亡)','Funeral leave (parents, adoptive parents, stepparents, spouses)','丧假(父母、养父母、继父母、配偶丧亡)'],
		'SLC16': ['喪假(祖父母、子女、配偶之父母、配偶之養父母或繼父母喪亡)','Funeral leave (grandparents, children, parents of spouses, adoptive parents of spouses or step-parents)','丧假(祖父母、子女、配偶之父母、配偶之养父母或继父母丧亡​​)'],
		'SLC17': ['喪假(曾祖父母、兄弟姊妹、配偶之祖父母喪亡)','Funeral leave (grandparents, brothers and sisters, grandparents of spouses are killed)','丧假(曾祖父母、兄弟姊妹、配偶之祖父母丧亡)'],
		'SLC18': ['公假','Public holiday','公假'],
		'SLC19': ['生理假','Physiological leave','生理假'],
		'SLC20': ['產假-年資未滿6個月','Maternity leave - less than 6 months of seniority','产假-年资未满6个月'],
		'SLC21': ['產假','Maternity leave','产假'],
		'SLC22': ['產假(妊娠3個月以上流產)-年資未滿6個月','Maternity leave (abortion more than 3 months of pregnancy) - less than 6 months of seniority','产假(妊娠3个月以上流产)-年资未满6个月'],
		'SLC23': ['產假(妊娠3個月以上流產)','Maternity leave (abortion more than 3 months of pregnancy)','产假(妊娠3个月以上流产)'],
		'SLC24': ['產假(妊娠2-3個月流產)','Maternity leave (abortion during pregnancy 2-3 months)','产假(妊娠2-3个月流产)'],
		'SLC25': ['產假(妊娠未滿2個月流產)','Maternity leave (missing less than 2 months of pregnancy)','产假(妊娠未满2个月流产)'],
		'SLC26': ['產檢假','Birth leave','产检假'],
		'SLC27': ['陪產假','Accompanying leave','陪产假'],
		'SLC28': ['家庭照顧假','Family care leave','家庭照顾假'],
		'SLC29': ['哺(集)乳時間','Feeding (set) milk time','哺(集)乳时间']
	},
	'am.leaveitem.periodType': {
		'year': ['每年', 'Per year', '每年'],
		'month': ['每月', 'per month', '每月'],
		'day': ['每天', 'every day', '每天'],
		'eventday': ['事件發生日', 'The date of the incident', '事件发生日'],
		'custom': ['自訂期間', 'Custom period', '自订期间'],
		'personal': ['依個人設定', 'According to personal settings', '依个人设定'],
		'ppdate': ['試用期滿日', 'Trial period', '试用期满日'],
		'ppnextmonth': ['試用期次月', 'Trial period', '试用期次月'],
		'ppmonth': ['試用期滿當月', 'The trial period expires', '试用期满当月'],
		// 'annualstart': ['特休年資起始日', 'Special holiday start date', '特休年资起始日'],
		// 'workstart': ['工作年資起始日', 'Working start date', '工作年资起始日'],
		'hiremonth': ['到職日當月', 'The day of arrival', '到职日当月'],
		'hiredate': ['到職日', 'Due date', '到职日'],
		'birthdaymonth': ['生日當月', 'Birthday month', '生日当月'],
		'birthday': ['生日當日', 'Birthday day', '生日当日']
	},
	'am.leaveitem.recoverAmountType': {
		'1': ['依在職月份比例扣回現金', 'Rebate cash according to the proportion of in-service month', '依在职月份比例扣回现金'],
		'2': ['依在職天數比例扣回現金', 'Cash back according to the ratio of working days', '依在职天数比例扣回现金'],
		'3': ['已休時數全數扣回現金', 'The number of hours off all cash back', '已休时数全数扣回现金']
	},
	'am.leaveitem.underYearUnit': {
		'1': ['月份比例', 'Month ratio', '月份比例'],
		'2': ['天數比例', 'The ratio of days', '天数比例']
	},
	'am.leaveitem.unit': {
		'day': ['天', 'day', '天'],
		'hour': ['小時', 'hour', '小时'],
		'minute': ['分鐘', 'minute', '分钟']
	},
	'am.leaveitem.unit1': {
		'day': ['天', 'day', '天'],
		'hour': ['小時', 'hour', '小时'],
		'minute': ['分鐘', 'minute', '分钟'],
		'time': ['次', 'time', '次']
	},
	'am.leaveitem.speciallyTarget': {
		'1': ['生日當月員工', 'Birthday employee', '生日当月员工'],
		'2': ['生日當日員工', 'Birthday employee', '生日当日员工'],
		'3': ['試用期期滿員工', 'Expiration period expires employees', '试用期期满员工']
	},
	'am.match.day': { //注：順序在 am.match.day._sort
		'-30': ['前30日', 'The first 30 days', '前30日'],
		'-29': ['前29日', 'The first 29 days', '前29日'],
		'-28': ['前28日', 'The first 28 days', '前28日'],
		'-27': ['前27日', 'The first 27 days', '前27日'],
		'-26': ['前26日', 'The first 26 days', '前26日'],
		'-25': ['前25日', 'The first 25 days', '前25日'],
		'-24': ['前24日', 'The first 24 days', '前24日'],
		'-23': ['前23日', 'The first 23 days', '前23日'],
		'-22': ['前22日', 'Before the 22nd', '前22日'],
		'-21': ['前21日', 'The first 21 days', '前21日'],
		'-20': ['前20日', 'The first 20 days', '前20日'],
		'-19': ['前19日', 'The first 19 days', '前19日'],
		'-18': ['前18日', 'The first 18 days', '前18日'],
		'-17': ['前17日', 'The first 17 days', '前17日'],
		'-16': ['前16日', 'The first 16 days', '前16日'],
		'-15': ['前15日', 'The first 15 days', '前15日'],
		'-14': ['前14日', 'The first 14 days', '前14日'],
		'-13': ['前13日', 'The first 13 days', '前13日'],
		'-12': ['前12日', 'The first 12 days', '前12日'],
		'-11': ['前11日', 'The first 11 days', '前11日'],
		'-10': ['前10日', 'The first 10 days', '前10日'],
		'-9': ['前9日', 'The first 9 days', '前9日'],
		'-8': ['前8日', 'The first 8 days', '前8日'],
		'-7': ['前7日', 'The first 7 days', '前7日'],
		'-6': ['前6日', 'The first 6 days', '前6日'],
		'-5': ['前5日', 'The first 5 days', '前5日'],
		'-4': ['前4日', 'The first 4 days', '前4日'],
		'-3': ['前3日', 'The first 3 days', '前3日'],
		'-2': ['前2日', 'The first 2 days', '前2日'],
		'-1': ['前1日', 'The first day', '前1日'],
		'0': ['今日', 'today', '今日']
	},
	'am.match.day._sort': [-30, -29, -28, -27, -26, -25, -24, -23, -22, -21, -20, -19, -18, -17, -16, -15, -14, -13, -12, -11, -10, -9, -8, -7, -6, -5, -4, -3, -2, -1, 0],
	'am.match.job.matchRule': {
		'1': ['固定日期', 'Fixed date', '固定日期'],
		'2': ['推算日期', 'Calculate the date', '推算日期'],
		//'3': ['上次結轉日隔日', 'The last day of carryover', '上次结转日隔日']
	},
	'am.match.month': { //注：順序在 am.match.month._sort
		'-3': ['前3個月', 'The first 3 months', '前3个月'],
		'-2': ['前2個月', 'The first two months', '前2个月'],
		'-1': ['前1個月', '1 month before', '前1个月'],
		'0': ['本月', 'this month', '本月']
	},
	'am.match.month._sort': [-3, -2, -1, 0],
	'am.match.trn': {
		'1': ['上次打卡結轉日隔日', 'The last punch card carry day after day', '上次打卡结转日隔日'],
		'2': ['上次假勤結轉日隔日', 'The last day of fake attendance carryover', '上次假勤结转日隔日']
	},
	'am.preOt.workSheetStatus': {
		'1': ['簽核中', 'On the way', '签核中'],
		'2': ['已核准(未拋轉)', 'Approved (Used)', '已核准(未抛转)'],
		'3': ['已核准(已拋轉)', 'Approved (Unused)', '已核准(已抛转)'],
	},
	'am.ot.isTax': {
		'1': ['應稅','Tax','应税'],
		'0': ['免稅','noTax','免税']
	},
	'am.ot.costCenterSelect': {
		'1': ['依員工薪資成本中心', 'According to employee salary cost center', '依员工薪资成本中心'],
		'2': ['自訂成本中心', 'Custom cost center', '自订成本中心']
	},
	'am.ot.payType': {
		'2': ['僅支領加班費', 'Only overtime pay ', '仅支领加班费'],
		'3': ['僅支領補休', 'Only compensatory time ', '仅支领补休'],
		'7': ['同時支領加班費及補休', 'Pay and rest', '同时支领加班费及补休']
	},
	'am.ot.payType4Portal': {
		'2': ['支領加班費', 'Overtime pay', '支领加班费'],
		'3': ['支領補休', 'Compensatory time', '支领补休'],
		'7': ['加班費及補休', 'Overtime pay and compensatory time', '加班费及补休']
	},
	'am.ot.rate.dataType': {
		'1': ['補休時數', 'Compensatory hours', '补休时数'],
		'2': ['加班費時數', 'Overtime hours', '加班费时数']
	},
	'am.otExtend.cal': {
		'1': ['依實際加班時數', 'According to the actual number of overtime hours', '依实际加班时数'],
		'2': ['依實際請領加班費及補休時數', 'Please refer to the actual overtime pay and rest hours', '依实际请领加班费及补休时数']
	},
	'am.otRule.clDeadline': {
		'1': ['無截止期限', 'No deadline', '无截止期限'],
		'2': ['指定截止日期', 'Specify the due date', '指定截止日期'],
		'3': ['指定截止天數', 'Specify the deadline', '指定截止天数'],
		'4': ['指定截止月底', 'Specify the end of the month', '指定截止月底']
	},
	'am.otRule.coefType': {
		'11': ['支領加班費時數區間', 'Support overtime hours', '支领加班费时数区间'],
		'21': ['支領補休時數區間', 'Support compensatory hours interval', '支领补休时数区间'],
		'22': ['補休假倍率區間', 'Make up the leave rate range', '补休假倍率区间'],
		'31': ['加班費折現倍率', 'Overtime discount rate', '加班费折现倍率'],
		'32': ['加班費折現倍率(上班時段)', 'Overtime discount rate (working hours)', '加班费折现倍率(上班时段)'],
		'41': ['補休折現倍率', 'Compensation rest discount rate', '补休折现倍率'],
		'42': ['補休折現倍率 (上班時段)', 'Re-discount discount rate (working hours)', '补休折现倍率 (上班时段)']
	},
	'am.otRule.deadlineBase': {
		'1': ['加班當日起', 'Working overtime day', '加班当日起'],
		'2': ['加班隔日起', 'Overtime from the next day', '加班隔日起'],
		'3': ['加班當月月底起', 'Overtime from the end of the month', '加班当月月底起']
	},
	'am.otRule.deadlineVal4': {
		'1': ['當月底', 'The end of the month', '当月底'],
		'2': ['次月底', 'The end of next month', '次月底'],
		'3': ['當年底', 'When the end', '当年底'],
		'4': ['次年底', 'The end of next year', '次年底'],
		'5': ['員工當年特休截止日', 'Employees special day deadline', '员工当年特休截止日'],
		'6': ['員工次年特休截止日', 'Employees next year special deadline', '员工次年特休截止日']
	},
	'am.otRule.otApply': {
		'1': ['不可申請', 'Can not apply', '不可申请'],
		'2': ['僅能申請加班費', 'Only apply for overtime pay', '仅能申请加班费'],
		'3': ['僅能申請補休', 'Can only apply for rest days', '仅能申请补休'],
		'4': ['擇一申請加班費或補休', 'Choose to apply for overtime or rest days', '择一申请加班费或补休'],
		'5': ['加班費及補休比例計算(依比例規則)', 'Overtime and overtime calculation (in accordance with the rules)', '加班费及补休比例计算(依比例规则)'],
		'6': ['加班費及補休比例計算(員工自行選擇)', 'Overtime and overtime calculation (employees choose)', '加班费及补休比例计算(员工自行选择)'],
		'7': ['同時發放加班費及補休', 'At the same time pay overtime pay and rest days', '同时发放加班费及补休']
	},
	'am.otRule.otBatchApply': {
		'2': ['發放加班費','Only apply for overtime pay','仅能申请加班费'],
		'3': ['發放補休假','Can only apply for rest days','仅能申请补休'],
		'5': ['加班費及補休比例發放','Overtime and overtime calculation (in accordance with the rules)','加班费及补休比例计算(依比例规则)'],
		'7': ['同時發放加班費及補休','At the same time pay overtime pay and rest days','同时发放加班费及补休'],
	},
	'am.otRule.otApplyRateLast': {
		'1': ['剩餘時數歸入加班費', 'The remaining hours are classified as overtime', '剩余时数归入加班费'],
		'2': ['剩餘時數歸入補休', 'Remaining hours rest in compensation', '剩余时数归入补休']
	},
	'am.otRule.otApplyRateRule': {
		'1': ['先折換加班費', 'The first shift overtime pay', '先折换加班费'],
		'2': ['先折換補休', 'The first replacement Hugh', '先折换补休']
	},
	'am.otRule.otCl': {
		'1': ['依實際加班時數', 'According to the actual number of overtime hours', '依实际加班时数'],
		'2': ['依時數區間規則', 'Time interval interval rules', '依时数区间规则'],
		'3': ['依員工當日班別時數', 'According to staff hours of the day classes', '依员工当日班别时数'],
		'4': ['依員工請特休假時數', 'According to employee special leave hours', '依员工请特休假时数']
	},
	'am.otRule.otCoef': {
		'1': ['固定倍率', 'Fixed magnification', '固定倍率'],
		'2': ['區間時數倍率', 'Interval hours multiplier', '区间时数倍率']
	},
	'am.otRule.otCoefPriority': {
		'1': ['加班費', ' overtime pay ', '加班费'],
		'2': ['補休', 'compensatory time ', '补休']
	},
	'am.otRule.otCoefPriorityForHP': {
		'1': ['加班費', 'Overtime pay ', '加班费'],
		'2': ['補休', 'Compensatory time ', '补休']
	},
	'am.otRule.otPay': {
		'1': ['依實際加班時數', 'According to the actual number of overtime hours', '依实际加班时数'],
		'2': ['依時數區間規則', 'Time interval interval rules', '依时数区间规则'],
		'3': ['依員工當日班別時數', 'According to staff hours of the day classes', '依员工当日班别时数'],
		'4': ['依員工請特休假時數', 'According to employee special leave hours', '依员工请特休假时数']
	},
	'am.otRule.unit': {
		'hour': ['小時', 'hour', '小时'],
		'minute': ['分鐘', 'minute', '分钟']
	},
	'am.otRule.unitRound': {
		'1': ['不足最小單位即捨去', 'Less than the smallest unit that is to go', '不足最小单位即舍去'],
		'2': ['不足最小單位即進位', 'Less than the smallest unit that carry', '不足最小单位即进位']
	},
	'am.otType.applyRule': {
		'1': ['僅非工作時段可申請', 'Only non-working hours can apply', '仅非工作时段可申请'],
		'2': ['僅上班時段可申請', 'Only working hours can apply', '仅上班时段可申请'],
		'3': ['僅請特休假時段可申請', 'Please only apply for a special holiday period', '仅请特休假时段可申请'],
		'4': ['上班時段及非工作時段皆可申請', 'Working hours and non-working hours can apply', '上班时段及非工作时段皆可申请']
	},
	'am.otType.calendarParm': {
		'1': ['行事曆別不同加班倍率', 'Calendar different overtime rate', '行事历别不同加班倍率'],
		'2': ['行事曆別相同加班倍率', 'The same calendar overtime rate', '行事历别相同加班倍率']
	},
	'am.otType.openParm': {
		'1': ['不需開放時段即可申請', 'No opening hours to apply', '不需开放时段即可申请'],
		'2': ['需HR開放時段才能申請', 'HR opening hours to apply', '需HR开放时段才能申请']
	},
	'am.otType.workParm': {
		'1': ['上下班不同加班倍率', 'Different working overtime rate', '上下班不同加班倍率'],
		'2': ['上下班相同加班倍率', 'The same work overtime rate', '上下班相同加班倍率']
	},
	'am.otWorkhour.checkRule': {
		'1': ['提醒', 'Reminder', '提醒'],
		'2': ['禁止', 'Prohibition', '禁止'],
		'3': ['關閉', 'shut down', '关闭']
	},
	'am.otWorkhour.day': {
		'1': ['當日', 'Today', '当日'],
		'2': ['隔日', 'Tomorrow', '隔日']
	},
	'am.otWorkhour.fixType': {
		'1': ['固定', '固定', '固定'],
		'2': ['連續', '連續', '連續']
	},
	'am.otWorkhour.period': {
		'1': ['工時週期起始', 'Work cycle starts', '工时周期起始'],
		'2': ['特定期間', 'Specific period', '特定期间']
	},
	'am.otWorkhour.shiftRule': {
		'1': ['依班別時間', '依班別時間', '依班別時間'],
		'2': ['依刷卡時間', '依刷卡時間', '依刷卡時間']
	},
	'am.otWorkhour.startMonth': {
		'0': ['本月', 'this month', '本月'],
		'-1': ['上1個月', 'Last month', '上1个月'],
		'-2': ['上2個月', 'Last 2 months', '上2个月']
	},
	'am.otWorkhour.Type': {
		'1': ['一般工時', 'Standard working hours', '一般工时'],
		'2': ['雙週變形', 'Bi-weekly rotation', '双周变形'],
		'4': ['四週變形', 'Four-week rotation', '四周变形'],
		'8': ['八週變形', 'Eight-week rotation', '八周变形']
	},
	'am.shift.flexibleItem': {
		'1': ['工作時間', 'operating hours', '工作时间'],
		'2': ['上半天時間', 'Half a day', '上半天时间'],
		'4': ['下半天時間', 'The next half-day time', '下半天时间'],
		'8': ['可加班時間', 'Can work overtime', '可加班时间'],
		'16': ['禁止加班時間', 'Overtime is forbidden', '禁止加班时间']
	},
	'am.shift.flexibleLeaveBase': {
		'0': ['依班表時間', 'According to the table time', '依班表时间'],
		'1': ['依彈性時間', 'According to flexible time', '依弹性时间']
	},
	'am.shift.flexibleRule': {
		'1': ['可提前上下班', 'Can work early in advance', '可提前上下班'],
		'2': ['可延後上下班', 'Can be delayed to get off work', '可延后上下班'],
		'3': ['可提前或延後上下班', 'Can be in advance or postponed to get off work', '可提前或延后上下班']
	},
	'am.shift.holidaySetting': {
		'0': ['全部相同', 'All the same', '全部相同'],
		'1': ['分別設定', 'Set separately', '分别设定']
	},
	'am.shift.isClockRange': {
		'0': ['依曆日區間', 'Use Default', '依历日区间'],
		'1': ['自行設定', 'User Setting', '自行设定']
	},
	'am.shift.restRule': {
		'1': ['固定時間', 'Fixed time', '固定时间'],
		'2': ['每工作X小時休息Y分鐘', 'Rest for Y minutes each X hour of work', '每工作X小时休息Y分钟']
	},
	'am.shift.workTimeSetting': {
		'0': ['每日相同', 'same', '每日相同'],
		'1': ['逐日設定', 'Set daily', '逐日设定']
	},
	'am.body.temp.fillRule': {
		'1': ['僅當日第一筆打卡必填 (適用於無排班制的公司)', 'Required only for the first check-in on the day (applicable to companies without shift scheduling)', '仅当日第一笔打卡必填 (适用于无排班制的公司)'],
		'2': ['各班別第一筆打卡必填 (適用於有排班制的公司)', 'The first check-in for each shift is required (applicable to companies with a shift system)', '各班别第一笔打卡必填 (适用于有排班制的公司)']
	},
	'am.temp.unit': {
		'C': ['攝氏', 'Celsius', '摄氏'],
		'F': ['華氏', 'Fahrenheit', '华氏']
	},
	'ed.accredit.contractStatus': {
		'0': ['契约中', 'Contract', '契约中'],
		'1': ['到期', 'maturity', '到期'],
		'2': ['轉為正職', 'Turn to office', '转为正职']
	},
	'ed.bank': {
		'004': ['004 台灣銀行', '', ''],
		'005': ['005 土地銀行', '', ''],
		'006': ['006 合作金庫銀行', '', ''],
		'007': ['007 第一銀行', '', ''],
		'008': ['008 華南銀行', '', ''],
		'009': ['009 彰化銀行', '', ''],
		'011': ['011 上海銀行', '', ''],
		'012': ['012 台北富邦銀行', '', ''],
		'013': ['013 國泰世華銀行', '', ''],
		'016': ['016 高雄銀行', '', ''],
		'017': ['017 兆豐國際商銀', '', ''],
		'018': ['018 農業金庫', '', ''],
		'021': ['021 花旗(台灣)商銀', '', ''],
		'022': ['022 美國銀行台北分行', '', ''],
		'023': ['023 泰國盤谷銀行', '', ''],
		'025': ['025 菲律賓首都銀行', '', ''],
		'039': ['039 澳盛(台灣)商銀', '', ''],
		'040': ['040 中華開發', '', ''],
		'048': ['048 王道銀行', '', ''],
		'050': ['050 台灣企銀', '', ''],
		'052': ['052 渣打國際商銀', '', ''],
		'053': ['053 台中商銀', '', ''],
		'054': ['054 京城商銀', '', ''],
		'072': ['072 德商德意志銀行', '', ''],
		'075': ['075 東亞銀行', '', ''],
		'076': ['076 美商摩根大通銀行', '', ''],
		'081': ['081 匯豐(台灣)商銀', '', ''],
		'082': ['082 法商法國巴黎銀行', '', ''],
		'085': ['085 新僑銀行', '', ''],
		'086': ['086 法商東方匯理銀行', '', ''],
		'092': ['092 瑞士商瑞士銀行', '', ''],
		'101': ['101 瑞興銀行', '', ''],
		'102': ['102 華泰銀行', '', ''],
		'103': ['103 新光商業銀行', '', ''],
		'104': ['104 台北五信', '', ''],
		'108': ['108 陽信銀行', '', ''],
		'114': ['114 基隆一信', '', ''],
		'115': ['115 基隆二信', '', ''],
		'118': ['118 板信銀行', '', ''],
		'119': ['119 淡水一信', '', ''],
		'120': ['120 淡水信合社', '', ''],
		'124': ['124 宜蘭信合社', '', ''],
		'127': ['127 桃園信合社', '', ''],
		'130': ['130 新竹一信', '', ''],
		'132': ['132 新竹三信', '', ''],
		'146': ['146 台中二信', '', ''],
		'147': ['147 三信銀行', '', ''],
		'158': ['158 彰化一信', '', ''],
		'161': ['161 彰化五信', '', ''],
		'162': ['162 彰化六信', '', ''],
		'163': ['163 彰化十信', '', ''],
		'165': ['165 鹿港信合社', '', ''],
		'178': ['178 嘉義三信', '', ''],
		'188': ['188 台南三信', '', ''],
		'204': ['204 高雄三信', '', ''],
		'215': ['215 花蓮一信', '', ''],
		'216': ['216 花蓮二信', '', ''],
		'222': ['222 澎湖一信', '', ''],
		'223': ['223 澎湖二信', '', ''],
		'224': ['224 金門信合社', '', ''],
		'380': ['380 大陸商中國銀行', '', ''],
		'381': ['381 大陸商交通銀行', '', ''],
		'388': ['388 全盈支付', '', ''],
		'512': ['512 雲林漁會', '', ''],
		'515': ['515 嘉義漁會', '', ''],
		'517': ['517 南市區漁會', '', ''],
		'518': ['518 南縣漁會', '', ''],
		'520': ['520 小港漁會', '', ''],
		'521': ['521 高雄縣漁會', '', ''],
		'523': ['523 枋寮區漁會', '', ''],
		'524': ['524 新港漁會', '', ''],
		'525': ['525 澎湖區漁會', '', ''],
		'558': ['558 安定區農會', '', ''],
		'605': ['605 高雄市高雄地區農會', '', ''],
		'606': ['606 農會', '', ''],
		'612': ['612 臺中縣農會', '', ''],
		'613': ['613 名間農會', '', ''],
		'614': ['614 彰化區農會', '', ''],
		'616': ['616 雲林區農會', '', ''],
		'617': ['617 嘉義區農會', '', ''],
		'618': ['618 台南區農會', '', ''],
		'619': ['619 高雄區農會', '', ''],
		'620': ['620 南區農漁會', '', ''],
		'621': ['621 花蓮區農會', '', ''],
		'622': ['622 台東區農會', '', ''],
		'624': ['624 澎湖縣農會', '', ''],
		'625': ['625 台中市農會', '', ''],
		'627': ['627 連江縣農會', '', ''],
		'700': ['700 中華郵政', '', ''],
		'803': ['803 聯邦銀行', '', ''],
		'805': ['805 遠東銀行', '', ''],
		'806': ['806 元大銀行', '', ''],
		'807': ['807 永豐商業銀行', '', ''],
		'808': ['808 玉山銀行', '', ''],
		'809': ['809 凱基商業銀行', '', ''],
		'810': ['810 星展銀行', '', ''],
		'812': ['812 台新銀行', '', ''],
		'814': ['814 大眾銀行', '', ''],
		'815': ['815 日盛銀行', '', ''],
		'816': ['816 安泰銀行', '', ''],
		'822': ['822 中國信託', '', ''],
		'823': ['823 將來銀行', '', ''],
		'824': ['824 連線商業銀行', '', ''],
		'826': ['826 樂天國際商業銀行', '', ''],
		'901': ['901 大里農會', '', ''],
		'903': ['903 汐止農會', '', ''],
		'904': ['904 新莊農會', '', ''],
		'910': ['910 桃竹農漁會', '', ''],
		'912': ['912 冬山農會', '', ''],
		'916': ['916 草屯農會', '', ''],
		'922': ['922 台南市台南地區農會', '', ''],
		'928': ['928 板橋農會', '', ''],
		'951': ['951 北區農漁會', '', ''],
		'952': ['952 農漁會南區中心', '', ''],
		'954': ['954 中區農漁會', '', '']
	},
	'ed.base.areaCode': {
		'10': ['基隆市', 'Keelung City', '基隆市'],
		'11': ['臺北市', 'Taipei City', '台北市'],
		'12': ['新北市', 'New TaipeiCity', '新北市'],
		'13': ['桃園市', 'Taoyuan City', '桃园市'],
		'14': ['新竹市', 'Hsinchu City', '新竹市'],
		'15': ['新竹縣', 'Hsinchu County', '新竹县'],
		'16': ['苗栗縣', 'Miaoli County', '苗栗县'],
		'17': ['臺中市', 'Taichung City', '台中市'],
		'18': ['彰化縣', 'Changhua County', '彰化县'],
		'19': ['南投縣', 'Nantou County', '南投县'],
		'20': ['雲林縣', 'Yunlin County', '云林县'],
		'21': ['嘉義市', 'Chiayi City', '嘉义市'],
		'22': ['嘉義縣', 'Chiayi County', '嘉义县'],
		'23': ['臺南市', 'Tainan City', '台南市'],
		'24': ['高雄市', 'Kaohsiung City', '高雄市'],
		'25': ['屏東縣', 'Pingtung County', '屏东县'],
		'26': ['臺東縣', 'Taitung County', '台东县'],
		'27': ['花蓮縣', 'Hualien County', '花莲县'],
		'28': ['宜蘭縣', 'Yilan County', '宜兰县'],
		'29': ['澎湖縣', 'Penghu County', '澎湖县'],
		'30': ['金門縣', 'Kinmen County', '金门县'],
		'31': ['連江縣', 'Lienchiang County', '连江县'],
		//'32':['南海諸島','South China Sea Islands','南海诸岛']	//併入高雄市
	},
	'ed.base.bloodType': {
		'A': ['A型', 'A blood group', 'A型'],
		'B': ['B型', 'B blood group', 'B型'],
		'AB': ['AB型', 'AB blood group', 'AB型'],
		'O': ['O型', 'O blood group', 'O型'],
	},
	'ed.base.constellation': {
		'1': ['牡羊座', 'Aries', '牡羊座'],
		'2': ['金牛座', 'Taurus', '金牛座'],
		'3': ['雙子座', 'Gemini', '双子座'],
		'4': ['巨蟹座', 'Cancer', '巨蟹座'],
		'5': ['獅子座', 'Leo', '狮子座'],
		'6': ['處女座', 'Virgo', '处女座'],
		'7': ['天秤座', 'Libra', '天秤座'],
		'8': ['天蠍座', 'Scorpio', '天蝎座'],
		'9': ['射手座', 'Sagittarius', '射手座'],
		'10': ['魔羯座', 'Capricorn', '魔羯座'],
		'11': ['水瓶座', 'Aquarius', '水瓶座'],
		'12': ['雙魚座', 'Pisces', '双鱼座']
	},
	'ed.base.country': {
		'TW': ['臺灣，中華民國','Taiwan, Republic of China','台湾，中华民国'],
		'AF': ['阿富汗','Afghanistan','阿富汗'],
		'AX': ['奧蘭群島','Aland Islands','奥兰群岛'],
		'AL': ['阿爾巴尼亞','Albania','阿尔巴尼亚'],
		'DZ': ['阿爾及利亞','Algeria','阿尔及利亚'],
		'AS': ['美屬薩摩亞','American Samoa','美属萨摩亚'],
		'AD': ['安道爾','Andorra','安道尔'],
		'AO': ['安哥拉','Angola','安哥拉'],
		'AI': ['英屬安圭拉','British Anguilla','英属安圭拉'],
		'AQ': ['南極洲','Antarctica','南极洲'],
		'AG': ['安地卡及巴布達','Antigua and Barbuda','安地卡及巴布达'],
		'AR': ['阿根廷','Argentina','阿根廷'],
		'AM': ['亞美尼亞','Armenia','亚美尼亚'],
		'AW': ['阿魯巴','Aruba','阿鲁巴'],
		'AU': ['澳大利亞','Australia','澳大利亚'],
		'AT': ['奧地利','Austria','奥地利'],
		'AZ': ['亞塞拜然','Azerbaijan','亚塞拜然'],
		'BS': ['巴哈馬','Bahamas','巴哈马'],
		'BH': ['巴林','Bahrain','巴林'],
		'BD': ['孟加拉','Bengal','孟加拉'],
		'BB': ['巴貝多','Barbados','巴贝多'],
		'BY': ['白俄羅斯','Belarus','白俄罗斯'],
		'BE': ['比利時','Belgium','比利时'],
		'BZ': ['貝里斯','Belis','贝里斯'],
		'BJ': ['貝南','Benin','贝南'],
		'BM': ['百慕達','Bermuda','百慕达'],
		'BT': ['不丹','Bhutan','不丹'],
		'BO': ['玻利維亞','Bolivia','玻利维亚'],
		'BA': ['波士尼亞','Bosnia','波士尼亚'],
		'BW': ['波札那','Botswana','波札那'],
		'BV': ['波維特島','Povet Island','波维特岛'],
		'BR': ['巴西','Brazil','巴西'],
		'IO': ['英屬印度洋地區','British Indian Ocean','英属印度洋地区'],
		'BN': ['汶萊','Brunei','汶莱'],
		'BG': ['保加利亞','Bulgaria','保加利亚'],
		'BF': ['布吉納法索','Burkina Faso','布吉纳法索'],
		'BI': ['浦隆地','Pulongdi','浦隆地'],
		'KH': ['柬埔寨王國','Kingdom of Cambodia','柬埔寨王国'],
		'CM': ['喀麥隆','Cameroon','喀麦隆'],
		'CA': ['加拿大','Canada','加拿大'],
		'CV': ['維德角島','Cape Verde Island','维德角岛'],
		'KY': ['開曼群島','Cayman Islands','开曼群岛'],
		'CF': ['中非','Central Africa','中非'],
		'TD': ['查德','Chad','查德'],
		'CL': ['智利','Chile','智利'],
		'CN': ['中國大陸','China Mainland','中国大陆'],
		'CX': ['聖誕島','Christmas Island','圣诞岛'],
		'CC': ['可可斯群島','Cocos Islands','可可斯群岛'],
		'CO': ['哥倫比亞','Colombia','哥伦比亚'],
		'KM': ['葛摩','Comor','葛摩'],
		'CG': ['剛果共和國','the republic of Congo','刚果共和国'],
		'CD': ['剛果民主共和國','Democratic Republic of Congo','刚果民主共和国'],
		'CK': ['科克群島','Cork Islands','科克群岛'],
		'CR': ['哥斯大黎加','Costa Rica','哥斯大黎加'],
		'CI': ['象牙海岸','Ivory coast','象牙海岸'],
		'HR': ['克羅埃西亞','Croatia','克罗埃西亚'],
		'CU': ['古巴','Cuba','古巴'],
		'CY': ['賽普勒斯','Cyprus','赛普勒斯'],
		'CZ': ['捷克','Czech Republic','捷克'],
		'DK': ['丹麥','Denmark','丹麦'],
		'DJ': ['吉布地','Djibouti','吉布地'],
		'DM': ['多米尼克','Dominica','多米尼克'],
		'DO': ['多明尼加','Dominican Republic','多明尼加'],
		'TP': ['帝汶','Timor','帝汶'],
		'EC': ['厄瓜多','Ecuador','厄瓜多'],
		'EG': ['埃及','Egypt','埃及'],
		'SV': ['薩爾瓦多','Salvador','萨尔瓦多'],
		'GQ': ['赤道幾內亞','Equatorial Guinea','赤道几内亚'],
		'ER': ['厄利垂亞','Eritrea','厄利垂亚'],
		'EE': ['愛沙尼亞','Estonia','爱沙尼亚'],
		'ET': ['依索比亞','Isopia','依索比亚'],
		'FK': ['福克蘭群島','Falkland Islands','福克兰群岛'],
		'FO': ['法羅群島','Faroe Islands','法罗群岛'],
		'FJ': ['斐濟群島','Fiji Islands','斐济群岛'],
		'FI': ['芬蘭','Finland','芬兰'],
		'FR': ['法國','France','法国'],
		'FX': ['法國本土','French mainland','法国本土'],
		'GF': ['法屬圭亞那','French Guiana','法属圭亚那'],
		'PF': ['法屬玻里尼西亞','French Polynesia','法属玻里尼西亚'],
		'TF': ['法屬南部屬地','French Southern Territory','法属南部属地'],
		'GA': ['加彭','Gabon','加彭'],
		'GM': ['甘比亞','Gambia','甘比亚'],
		'GE': ['喬治亞','Georgia','乔治亚'],
		'DE': ['德國','Germany','德国'],
		'GH': ['迦納','Ghana','迦纳'],
		'GI': ['直布羅陀','Gibraltar','直布罗陀'],
		'GR': ['希臘','Greece','希腊'],
		'GL': ['格陵蘭','Greenland','格陵兰'],
		'GD': ['格瑞那達','Granada','格瑞那达'],
		'GP': ['瓜德魯普島','Guadeloupe','瓜德鲁普岛'],
		'GU': ['關島','Guam','关岛'],
		'GT': ['瓜地馬拉','Guatemala','瓜地马拉'],
		'GG': ['格恩西島','Guernsey','格恩西岛'],
		'GN': ['幾內亞','Guinea','几内亚'],
		'GW': ['幾內亞比索','Guinea Bissau','几内亚比索'],
		'GY': ['蓋亞那','Guyana','盖亚那'],
		'HT': ['海地','Haiti','海地'],
		'HM': ['赫德及麥當勞群島','Heard and McDonald Islands','赫德及麦当劳群岛'],
		'VA': ['教廷','Holy See','教廷'],
		'HN': ['宏都拉斯','Honduras','宏都拉斯'],
		'HK': ['香港','Hong Kong','香港'],
		'HU': ['匈牙利','Hungary','匈牙利'],
		'IS': ['冰島','Iceland','冰岛'],
		'IN': ['印度','India','印度'],
		'ID': ['印尼','Indonesia','印尼'],
		'IR': ['伊朗','Iran','伊朗'],
		'IQ': ['伊拉克','Iraq','伊拉克'],
		'IE': ['愛爾蘭','Ireland','爱尔兰'],
		'IM': ['馬恩島','Isle of Man','马恩岛'],
		'IL': ['以色列','Israel','以色列'],
		'IT': ['義大利','Italy','义大利'],
		'JM': ['牙買加','Jamaica','牙买加'],
		'JP': ['日本','Japan','日本'],
		'JE': ['澤西','Jersey','泽西'],
		'JO': ['約旦','Jordan','约旦'],
		'KZ': ['哈薩克','Kazakhstan','哈萨克'],
		'KE': ['肯亞','Kenya','肯亚'],
		'KI': ['吉里巴斯','Giribas','吉里巴斯'],
		'KP': ['北韓','North Korea','北韩'],
		'KR': ['韓國','Korea','韩国'],
		'KW': ['科威特','Kuwait','科威特'],
		'KG': ['吉爾吉斯','Kyrgyz','吉尔吉斯'],
		'LA': ['寮國','Laos','寮国'],
		'LV': ['拉脫維亞','Latvia','拉脱维亚'],
		'LB': ['黎巴嫩','Lebanon','黎巴嫩'],
		'LS': ['賴索托','Lesotho','赖索托'],
		'LR': ['賴比瑞亞','Liberia','赖比瑞亚'],
		'LY': ['利比亞','Libya','利比亚'],
		'LI': ['列支敦斯登','Liechtenstein','列支敦斯登'],
		'LT': ['立陶宛','Lithuania','立陶宛'],
		'LU': ['盧森堡','Luxembourg','卢森堡'],
		'MO': ['澳門','Macao','澳门'],
		'MK': ['北馬其頓','North Macedonia','北马其顿'],
		'MG': ['馬達加斯加','Madagascar','马达加斯加'],
		'MW': ['馬拉威','Malawi','马拉威'],
		'MY': ['馬來西亞','Malaysia','马来西亚'],
		'MV': ['馬爾地夫','Maldives','马尔地夫'],
		'ML': ['馬利','Marley','马利'],
		'MT': ['馬爾他','Maltese','马尔他'],
		'MH': ['馬紹爾群島','Marshall Islands','马绍尔群岛'],
		'MQ': ['法屬馬丁尼克','Martinique','法属马丁尼克'],
		'MR': ['茅利塔尼亞','Mauritania','茅利塔尼亚'],
		'MU': ['模里西斯','Mauritius','模里西斯'],
		'YT': ['美亞特','Mayat','美亚特'],
		'MX': ['墨西哥','Mexico','墨西哥'],
		'FM': ['密克羅尼西亞','Micronesia','密克罗尼西亚'],
		'MD': ['摩爾多瓦','Moldova','摩尔多瓦'],
		'MC': ['摩納哥','Monaco','摩纳哥'],
		'MN': ['蒙古','Mongolia','蒙古'],
		'ME': ['黑山','Montenegro','黑山'],
		'MS': ['蒙瑟拉特島','Monserrate','蒙瑟拉特岛'],
		'MA': ['摩洛哥','Morocco','摩洛哥'],
		'MZ': ['莫三比克','Mozambique','莫三比克'],
		'MM': ['緬甸','Myanmar','缅甸'],
		'NA': ['納米比亞','Namibia','纳米比亚'],
		'NR': ['諾魯','Noru','诺鲁'],
		'NP': ['尼泊爾','Nepal','尼泊尔'],
		'NL': ['荷蘭','Netherlands','荷兰'],
		'AN': ['荷屬安地列斯','Netherlands Antilles','荷属安地列斯'],
		'XB': ['納維斯','Naves','纳维斯'],
		'NC': ['新喀里多尼亞島','New Caledonia','新喀里多尼亚岛'],
		'NZ': ['紐西蘭','New Zealand','纽西兰'],
		'NI': ['尼加拉瓜','Nicaragua','尼加拉瓜'],
		'NE': ['尼日','Niger','尼日'],
		'NG': ['奈及利亞','Nigeria','奈及利亚'],
		'NU': ['紐威島','Neway Island','纽威岛'],
		'NF': ['諾福克群島','Norfolk Islands','诺福克群岛'],
		'MP': ['北馬里亞納群島','Northern Mariana Islands','北马里亚纳群岛'],
		'NO': ['挪威','Norway','挪威'],
		'OM': ['阿曼','Oman','阿曼'],
		'PK': ['巴基斯坦','Pakistan','巴基斯坦'],
		'PW': ['帛琉群島','Palau Islands','帛琉群岛'],
		'PS': ['巴勒斯坦佔領區','Palestinian occupied territories','巴勒斯坦占领区'],
		'PA': ['巴拿馬','Panama','巴拿马'],
		'PG': ['巴布亞紐幾內亞','Papua New Guinea','巴布亚纽几内亚'],
		'PY': ['巴拉圭','Paraguay','巴拉圭'],
		'PE': ['秘魯','Peru','秘鲁'],
		'PH': ['菲律賓','Philippines','菲律宾'],
		'PN': ['皮特康島','Pitcairn Island','皮特康岛'],
		'PL': ['波蘭','Poland','波兰'],
		'PT': ['葡萄牙','Portugal','葡萄牙'],
		'PR': ['波多黎各','Puerto Rico','波多黎各'],
		'QA': ['卡達','Kada','卡达'],
		'RE': ['留尼旺','Reunion','留尼旺'],
		'RO': ['羅馬尼亞','Romania','罗马尼亚'],
		'RU': ['俄羅斯','Russia','俄罗斯'],
		'RW': ['盧安達','Luanda','卢安达'],
		'BL': ['聖巴泰勒米','Saint Barthélemy','圣巴泰勒米'],
		'XA': ['琉球','Ryukyu','琉球'],
		'SH': ['聖赫勒拿島','St. Helena','圣赫勒拿岛'],
		'KN': ['聖克里斯多福','Saint Christopher','圣克里斯多福'],
		'LC': ['聖露西亞','Saint Lucia','圣露西亚'],
		'MF': ['聖馬丁','Saint Martin','圣马丁'],
		'PM': ['聖匹及密啟倫群島','Saint Peter and the Miquelon Islands','圣匹及密启伦群岛'],
		'VC': ['聖文森','Saint Vincent','圣文森'],
		'WS': ['薩摩亞群島','Samoa','萨摩亚群岛'],
		'SM': ['聖馬利諾','San Marino','圣马利诺'],
		'ST': ['聖多美及普林西比','Sao Tome and Principe','圣多美及普林西比'],
		'SA': ['沙烏地阿拉伯','Saudi Arabia','沙乌地阿拉伯'],
		'SN': ['塞內加爾','Senegal','塞内加尔'],
		'RS': ['塞爾維亞','Serbia','塞尔维亚'],
		'SC': ['塞席爾','Seychelles','塞席尔'],
		'SL': ['獅子山','Lion Rock','狮子山'],
		'SG': ['新加坡','Singapore','新加坡'],
		'SK': ['斯洛伐克','Slovakia','斯洛伐克'],
		'SI': ['斯洛凡尼亞','Slovenia','斯洛凡尼亚'],
		'SB': ['索羅門群島','Solomon Islands','索罗门群岛'],
		'SO': ['索馬利亞','Somalia','索马利亚'],
		'ZA': ['南非','South Africa','南非'],
		'GS': ['南喬治亞及南桑威奇群島','South Georgia and the South Sandwich Islands','南乔治亚及南桑威奇群岛'],
		'ES': ['西班牙','Spain','西班牙'],
		'LK': ['斯里蘭卡','Sri Lanka','斯里兰卡'],
		'SD': ['蘇丹','Sudan','苏丹'],
		'SR': ['蘇利南','Suriname','苏利南'],
		'SJ': ['斯瓦巴及尖棉島','Svalbard and Jianmian Island','斯瓦巴及尖棉岛'],
		'SZ': ['史瓦帝尼','Swadini','史瓦帝尼'],
		'SE': ['瑞典','Sweden','瑞典'],
		'CH': ['瑞士','Switzerland','瑞士'],
		'SY': ['敘利亞','Syria','叙利亚'],
		'XC': ['大溪地','Tahiti','大溪地'],
		'TJ': ['塔吉克','Tajik','塔吉克'],
		'TZ': ['坦尚尼亞','Tanzania','坦尚尼亚'],
		'TH': ['泰國','Thailand','泰国'],
		'TL': ['東帝汶','East Timor','东帝汶'],
		'TG': ['多哥','Togo','多哥'],
		'TK': ['托克勞群島','Tokelau','托克劳群岛'],
		'TO': ['東加','Tonga','东加'],
		'TT': ['千里達','Trinidad','千里达'],
		'TN': ['突尼西亞','Tunisia','突尼西亚'],
		'TR': ['土耳其','Turkey','土耳其'],
		'TM': ['土庫曼','Turkmenistan','土库曼'],
		'TC': ['土克斯及開科斯群島','Turks and Caicos Islands','土克斯及开科斯群岛'],
		'TV': ['吐瓦魯','Tuvalu','吐瓦鲁'],
		'UG': ['烏干達','Uganda','乌干达'],
		'UA': ['烏克蘭','Ukraine','乌克兰'],
		'AE': ['阿拉伯聯合大公國','United Arab Emirates','阿拉伯联合大公国'],
		'GB': ['英國','United Kingdom','英国'],
		'US': ['美國','United States','美国'],
		'UM': ['美屬邊疆群島','U.S. Frontier Islands','美属边疆群岛'],
		'UY': ['烏拉圭','Uruguay','乌拉圭'],
		'UZ': ['烏茲別克','Uzbek','乌兹别克'],
		'VU': ['萬那杜','Vanado','万那杜'],
		'VE': ['委內瑞拉','Venezuela','委内瑞拉'],
		'VN': ['越南','Vietnam','越南'],
		'VG': ['英屬維爾京群島','The British Virgin Islands','英属维尔京群岛'],
		'VI': ['美屬維爾京群島','United States Virgin Islands','美属维尔京群岛'],
		'WF': ['沃里斯與伏塔那島','Voorice and Votana','沃里斯与伏塔那岛'],
		'EH': ['西撒哈拉','Western Sahara','西撒哈拉'],
		'YE': ['葉門','Yemen','叶门'],
		'YU': ['南斯拉夫','Yugoslavia','南斯拉夫'],
		'ZM': ['尚比亞','Zambia','尚比亚'],
		'ZW': ['辛巴威','Zimbabwe','辛巴威'],
		'ZZ': ['其他國家','Other countries','其他国家']
	},
	'ed.base.cripplesClass': {
		'1': ['第一類 神經系統構造及精神、心智功能', 'Category 1: Structure and functions of the nervous system, mental, and cognitive functions.', '第一类 神经系统构造及精神、心智功能'],
		'2': ['第二類 眼、耳及相關構造與感官功能及疼痛', 'Category 2: Structure and functions of the eyes, ears, and related sensory functions and pain.', '第二类 眼、耳及相关构造与感官功能及疼痛'],
		'3': ['第三類 涉及聲音與言語構造及其功能', 'Category 3: Structure and functions related to voice and speech.', '第三类 涉及声音与言语构造及其功能'],
		'4': ['第四類 循環、造血、免疫與呼吸系統構造及其功能', 'Category 4: Structure and functions of the circulatory, hematopoietic, immune, and respiratory systems.', '第四类 循环、造血、免疫与呼吸系统构造及其功能'],
		'5': ['第五類 消化、新陳代謝與內分泌系統相關構造及其功能', 'Category 5: Structure and functions of the digestive, metabolic, and endocrine systems.', '第五类 消化、新陈代谢与内分泌系统相关构造及其功能'],
		'6': ['第六類 泌尿與生殖系統相關構造及其功能', 'Category 6: Structure and functions of the urinary and reproductive systems.', '第六类 泌尿与生殖系统相关构造及其功能'],
		'7': ['第七類 神經、肌肉、骨骼之移動相關構造及其功能', 'Category 7: Structure and functions related to nervous, muscular, and skeletal movement.', '第七类 神经、肌肉、骨骼之移动相关构造及其功能'],
		'8': ['第八類 皮膚與相關構造及其功能', 'Category 8: Structure and functions of the skin and related structures.', '第八类 皮肤与相关构造及其功能']
	},
	'ed.base.cripplesLevel': {
		'1': ['輕度身心障礙', 'Mild', '轻度身心障碍'],
		'2': ['中度身心障礙', 'Moderate', '中度身心障碍'],
		'3': ['重度身心障礙', 'Severe', '重度身心障碍'],
		'4': ['極重度身心障礙', 'Profound', '极重度身心障碍']
	},
	'ed.base.ethnicIdentity': {
		'0': ['一般', 'General', '一般'],
		'1': ['原住民', 'Indigenous people', '原住民'],
		'2': ['華僑', 'Overseas Chinese', '华侨'],
		'3': ['外籍配偶', 'Foreign spouse', '外籍配偶']
	},
	'ed.base.gender': {
		'1': ['男', 'Male', '男'],
		'2': ['女', 'Female', '女']
	},
	'ed.base.marriageStatus': {
		'1': ['未婚', 'Single', '未婚'],
		'2': ['已婚', 'Married', '已婚'],
		'3': ['離異', 'Divorced', '离异']
	},
	'ed.base.militaryStatus': {
		'1': ['役畢', 'Completed military service', '役毕'],
		'2': ['屆退', 'Retired from military service', '届退'],
		'3': ['未役', 'Not yet served', '未役'],
		'4': ['待役', 'Awaiting service', '待役'],
		'5': ['免役', 'Exempted from service', '免役']
	},
	'ed.base.nationality': {
		'2': ['外國', 'Foreigner', '外国'],
		'1': ['本國', 'Nationals', '本国']
	},
	'ed.base.postalCode': {
		'200': ['200 基隆市仁愛區', 'Ren Ai District, Keelung City 200', '200 基隆市仁爱区'],
		'201': ['201 基隆市信義區', 'Xin Yi District, Keelung City 201', '201 基隆市信义区'],
		'202': ['202 基隆市中正區', 'Zhong Zheng District, Keelung City 202', '202 基隆市中正区'],
		'203': ['203 基隆市中山區', 'Zhong Shan District, Keelung City 203', '203 基隆市中山区'],
		'204': ['204 基隆市安樂區', 'An Le District, Keelung City 204', '204 基隆市安乐区'],
		'205': ['205 基隆市暖暖區', 'Nuan Nuan District, Keelung City 205', '205 基隆市暖暖区'],
		'206': ['206 基隆市七堵區', 'Qi Du District, Keelung City 206', '206 基隆市七堵区'],
		'100': ['100 台北市中正區', 'Zhong Zheng District, Taipei City 100', '100 台北市中正区'],
		'103': ['103 台北市大同區', 'Da Tong District, Taipei City 103', '103 台北市大同区'],
		'104': ['104 台北市中山區', 'Zhong Shan District, Taipei City 104', '104 台北市中山区'],
		'105': ['105 台北市松山區', 'Song Shan District, Taipei City 105', '105 台北市松山区'],
		'106': ['106 台北市大安區', 'Da An District, Taipei City 106', '106 台北市大安区'],
		'108': ['108 台北市萬華區', 'Wan Hua District, Taipei City 108', '108 台北市万华区'],
		'110': ['110 台北市信義區', 'Xin Yi District, Taipei City 110', '110 台北市信义区'],
		'111': ['111 台北市士林區', 'Shi Lin District, Taipei City 111', '111 台北市士林区'],
		'112': ['112 台北市北投區', 'Bei Tou District, Taipei City 112', '112 台北市北投区'],
		'114': ['114 台北市內湖區', 'Nei Hu District, Taipei City 114', '114 台北市内湖区'],
		'115': ['115 台北市南港區', 'Nan Gang District, Taipei City 115', '115 台北市南港区'],
		'116': ['116 台北市文山區', 'Wen Shan District, Taipei City 116', '116 台北市文山区'],
		'207': ['207 新北市萬里區', 'Wan Li Village, New Taipei City 207', '207 新北市万里区'],
		'208': ['208 新北市金山區', 'Jin Shan Village, New Taipei City 208', '208 新北市金山区'],
		'220': ['220 新北市板橋區', 'Ban Qiao City, New Taipei City 220', '220 新北市板桥区'],
		'221': ['221 新北市汐止區', 'Xi Zhi City, New Taipei City 221', '221 新北市汐止区'],
		'222': ['222 新北市深坑區', 'Shen Keng Village, New Taipei City 222', '222 新北市深坑区'],
		'223': ['223 新北市石碇區', 'Shi Ding Village, New Taipei City 223', '223 新北市石碇区'],
		'224': ['224 新北市瑞芳區', 'Rui Fang Township, New Taipei City 224', '224 新北市瑞芳区'],
		'226': ['226 新北市平溪區', 'Ping Xi Village, New Taipei City 226', '226 新北市平溪区'],
		'227': ['227 新北市雙溪區', 'Shuang Xi Village, New Taipei City 227', '227 新北市双溪区'],
		'228': ['228 新北市貢寮區', 'Gong Liao Village, New Taipei City 228', '228 新北市贡寮区'],
		'231': ['231 新北市新店區', 'Xin Dian City, New Taipei City 231', '231 新北市新店区'],
		'232': ['232 新北市坪林區', 'Ping Lin Village, New Taipei City 232', '232 新北市坪林区'],
		'233': ['233 新北市烏來區', 'Wu Lai Village, New Taipei City 233', '233 新北市乌来区'],
		'234': ['234 新北市永和區', 'Yong He City, New Taipei City 234', '234 新北市永和区'],
		'235': ['235 新北市中和區', 'Zhong He City, New Taipei City 235', '235 新北市中和区'],
		'236': ['236 新北市土城區', 'Tu Chen City, New Taipei City 236', '236 新北市土城区'],
		'237': ['237 新北市三峽區', 'San Xia Township, New Taipei City 237', '237 新北市三峡区'],
		'238': ['238 新北市樹林區', 'Shu Lin City, New Taipei City 238', '238 新北市树林区'],
		'239': ['239 新北市鶯歌區', 'Ying Ge Township, New Taipei City 239', '239 新北市莺歌区'],
		'241': ['241 新北市三重區', 'San Zhong City, New Taipei City 241', '241 新北市三重区'],
		'242': ['242 新北市新莊區', 'Xin Zhuang City, New Taipei City 242', '242 新北市新庄区'],
		'243': ['243 新北市泰山區', 'Tai Shan Village, New Taipei City 243', '243 新北市泰山区'],
		'244': ['244 新北市林口區', 'Lin Kou Village, New Taipei City 244', '244 新北市林口区'],
		'247': ['247 新北市蘆洲區', 'Lu Zhou City, New Taipei City 247', '247 新北市芦洲区'],
		'248': ['248 新北市五股區', 'Wu Gu Village, New Taipei City 248', '248 新北市五股区'],
		'249': ['249 新北市八里區', 'Ba Li Village, New Taipei City 249', '249 新北市八里区'],
		'251': ['251 新北市淡水區', 'Tamshui Township, New Taipei City 251', '251 新北市淡水区'],
		'252': ['252 新北市三芝區', 'San Zhi Village, New Taipei City 252', '252 新北市三芝区'],
		'253': ['253 新北市石門區', 'Shi Men Village, New Taipei City 253', '253 新北市石门区'],
		'320': ['320 桃園市中壢區', 'Zhong Li City, Taoyuan County 320', '320 桃园市中坜区'],
		'324': ['324 桃園市平鎮區', 'Ping Zhen City, Taoyuan County 324', '324 桃园市平镇区'],
		'325': ['325 桃園市龍潭區', 'Long Tan Village, Taoyuan County 325', '325 桃园市龙潭区'],
		'326': ['326 桃園市楊梅區', 'Yang Mei Township, Taoyuan County 326', '326 桃园市杨梅区'],
		'327': ['327 桃園市新屋區', 'Xin Wu Village, Taoyuan County 327', '327 桃园市新屋区'],
		'328': ['328 桃園市觀音區', 'Guan Yin Village, Taoyuan County 328', '328 桃园市观音区'],
		'330': ['330 桃園市桃園區', 'Taoyuan City, Taoyuan County 330', '330 桃园市桃园区'],
		'333': ['333 桃園市龜山區', 'Gui Shan Village, Taoyuan County 333', '333 桃园市龟山区'],
		'334': ['334 桃園市八德區', 'Ba Teh City, Taoyuan County 334', '334 桃园市八德区'],
		'335': ['335 桃園市大溪區', 'Da Xi Township, Taoyuan County 335', '335 桃园市大溪区'],
		'336': ['336 桃園市復興區', 'Fu Xing Village, Taoyuan County 336', '336 桃园市复兴区'],
		'337': ['337 桃園市大園區', 'Da Yuan Village, Taoyuan County 337', '337 桃园市大园区'],
		'338': ['338 桃園市蘆竹區', 'Lu Zhu Village, Taoyuan County 338', '338 桃园市芦竹区'],
		'300': ['300 新竹市', 'Hsinchu City 300', '300 新竹市'],
		'302': ['302 新竹縣竹北市', 'Zhubei City, Hsinchu County 302', '302 新竹县竹北市'],
		'303': ['303 新竹縣湖口鄉', 'Hu Kou Village, Hsinchu County 303', '303 新竹县湖口乡'],
		'304': ['304 新竹縣新豐鄉', 'Xin Feng Village, Hsinchu County 304', '304 新竹县新丰乡'],
		'305': ['305 新竹縣新埔鎮', 'Xin Bu Township, Hsinchu County 305', '305 新竹县新埔镇'],
		'306': ['306 新竹縣關西鎮', 'Guan Xi Township, Hsinchu County 306', '306 新竹县关西镇'],
		'307': ['307 新竹縣芎林鄉', 'Qiong Lin Village, Hsinchu County 307', '307 新竹县芎林乡'],
		'308': ['308 新竹縣寶山鄉', 'Bao Shan Village, Hsinchu County 308', '308 新竹县宝山乡'],
		'310': ['310 新竹縣竹東鎮', 'Zhu Dong Township, Hsinchu County 310', '310 新竹县竹东镇'],
		'311': ['311 新竹縣五峰鄉', 'Wu Feng Village, Hsinchu County 311', '311 新竹县五峰乡'],
		'312': ['312 新竹縣橫山鄉', 'Heng Shan Village, Hsinchu County 312', '312 新竹县横山乡'],
		'313': ['313 新竹縣尖石鄉', 'Jian Shi Village, Hsinchu County 313', '313 新竹县尖石乡'],
		'314': ['314 新竹縣北埔鄉', 'Bei Bu Village, Hsinchu County 314', '314 新竹县北埔乡'],
		'315': ['315 新竹縣峨眉鄉', 'E Mei Village, Hsinchu County 315', '315 新竹县峨眉乡'],
		'350': ['350 苗栗縣竹南鎮', 'Zhu Nan Township, Miaoli County 350', '350 苗栗县竹南镇'],
		'351': ['351 苗栗縣頭份市', 'Tou Fen City, Miaoli County 351', '351 苗栗县头份市'],
		'352': ['352 苗栗縣三灣鄉', 'San Wan Village, Miaoli County 352', '352 苗栗县三湾乡'],
		'353': ['353 苗栗縣南庄鄉', 'Nan Zhuang Village, Miaoli County 353', '353 苗栗县南庄乡'],
		'354': ['354 苗栗縣獅潭鄉', 'Shi Tan Village, Miaoli County 354', '354 苗栗县狮潭乡'],
		'356': ['356 苗栗縣後龍鎮', 'Hou Long Township, Miaoli County 356', '356 苗栗县后龙镇'],
		'357': ['357 苗栗縣通霄鎮', 'Tong Xiao Township, Miaoli County 357', '357 苗栗县通霄镇'],
		'358': ['358 苗栗縣苑裡鎮', 'Yuan Li Township, Miaoli County 358', '358 苗栗县苑里镇'],
		'360': ['360 苗栗縣苗栗市', 'Miaoli City, Miaoli County 360', '360 苗栗县苗栗市'],
		'361': ['361 苗栗縣造橋鄉', 'Zao Qiao Village, Miaoli County 361', '361 苗栗县造桥乡'],
		'362': ['362 苗栗縣頭屋鄉', 'Tou Wu Village, Miaoli County 362', '362 苗栗县头屋乡'],
		'363': ['363 苗栗縣公館鄉', 'Gong Guan Village, Miaoli County 363', '363 苗栗县公馆乡'],
		'364': ['364 苗栗縣大湖鄉', 'Da Hu Village, Miaoli County 364', '364 苗栗县大湖乡'],
		'365': ['365 苗栗縣泰安鄉', 'Tai An Village, Miaoli County 365', '365 苗栗县泰安乡'],
		'366': ['366 苗栗縣銅鑼鄉', 'Tong Luo Village, Miaoli County 366', '366 苗栗县铜锣乡'],
		'367': ['367 苗栗縣三義鄉', 'San Yi Village, Miaoli County 367', '367 苗栗县三义乡'],
		'368': ['368 苗栗縣西湖鄉', 'Xi Hu Village, Miaoli County 368', '368 苗栗县西湖乡'],
		'369': ['369 苗栗縣卓蘭鎮', 'Zhuo Lan Township, Miaoli County 369', '369 苗栗县卓兰镇'],
		'400': ['400 台中市中區', 'Central District, Taichung City 400', '400 台中市中区'],
		'401': ['401 台中市東區', 'East District, Taichung City 401', '401 台中市东区'],
		'402': ['402 台中市南區', 'South District, Taichung City 402', '402 台中市南区'],
		'403': ['403 台中市西區', 'West District, Taichung City 403', '403 台中市西区'],
		'404': ['404 台中市北區', 'North District, Taichung City 404', '404 台中市北区'],
		'406': ['406 台中市北屯區', 'Bei Tun District, Taichung City 406', '406 台中市北屯区'],
		'407': ['407 台中市西屯區', 'Xi Tun District, Taichung City 407', '407 台中市西屯区'],
		'408': ['408 台中市南屯區', 'Nan Tun District, Taichung City 408', '408 台中市南屯区'],
		'411': ['411 台中市太平區', 'Tai Ping District, Taichung City 411', '411 台中市太平區'],
		'412': ['412 台中市大里區', 'Da Li District, Taichung City 412', '412 台中市大里区'],
		'413': ['413 台中市霧峰區', 'Wu Feng District, Taichung City 413', '413 台中市雾峰区'],
		'414': ['414 台中市烏日區', 'Wu Ri District, Taichung City 414', '414 台中市乌日区'],
		'420': ['420 台中市豐原區', 'Feng Yuan District, Taichung City 420', '420 台中市丰原区'],
		'421': ['421 台中市后里區', 'Hou Li District, Taichung City 421', '421 台中市后里区'],
		'422': ['422 台中市石岡區', 'Shi Gang District, Taichung City 422', '422 台中市石冈区'],
		'423': ['423 台中市東勢區', 'Dong Shi District, Taichung City 423', '423 台中市东势区'],
		'424': ['424 台中市和平區', 'He Ping District, Taichung City 424', '424 台中市和平区'],
		'426': ['426 台中市新社區', 'Xin She District, Taichung City 426', '426 台中市新社区'],
		'427': ['427 台中市潭子區', 'Tan Zi District, Taichung City 427', '427 台中市潭子区'],
		'428': ['428 台中市大雅區', 'Da Ya District, Taichung City 428', '428 台中市大雅区'],
		'429': ['429 台中市神岡區', 'Shen Gang District, Taichung City 429', '429 台中市神冈区'],
		'432': ['432 台中市大肚區', 'Da Du District, Taichung City 432', '432 台中市大肚区'],
		'433': ['433 台中市沙鹿區', 'Sha Lu District, Taichung City 433', '433 台中市沙鹿区'],
		'434': ['434 台中市龍井區', 'Long Jing District, Taichung City 434', '434 台中市龙井区'],
		'435': ['435 台中市梧棲區', 'Wu Qi District, Taichung City 435', '435 台中市梧栖区'],
		'436': ['436 台中市清水區', 'Qing Shui District, Taichung City 436', '436 台中市清水区'],
		'437': ['437 台中市大甲區', 'Da Jia District, Taichung City 437', '437 台中市大甲区'],
		'438': ['438 台中市外埔區', 'Wai Bu District, Taichung City 438', '438 台中市外埔区'],
		'439': ['439 台中市大安區', 'Da An District, Taichung City 439', '439 台中市大安区'],
		'500': ['500 彰化縣彰化市', 'Changhua City, Changhua County 500', '500 彰化县彰化市'],
		'502': ['502 彰化縣芬園鄉', 'Fen Yuan Village, Changhua County 502', '502 彰化县芬园乡'],
		'503': ['503 彰化縣花壇鄉', 'Hua Tan Village, Changhua County 503', '503 彰化县花坛乡'],
		'504': ['504 彰化縣秀水鄉', 'Xiu Shui Village, Changhua County 504', '504 彰化县秀水乡'],
		'505': ['505 彰化縣鹿港鎮', 'Lu Gang Township, Changhua County 505', '505 彰化县鹿港镇'],
		'506': ['506 彰化縣福興鄉', 'Fu Xing Village, Changhua County 506', '506 彰化县福兴乡'],
		'507': ['507 彰化縣線西鄉', 'Xian Xi Village, Changhua County 507', '507 彰化县线西乡'],
		'508': ['508 彰化縣和美鎮', 'He Mei Township, Changhua County 508', '508 彰化县和美镇'],
		'509': ['509 彰化縣伸港鄉', 'Shen Gang Village, Changhua County 509', '509 彰化县伸港乡'],
		'510': ['510 彰化縣員林市', 'Yuan Lin City, Changhua County 510', '510 彰化县员林市'],
		'511': ['511 彰化縣社頭鄉', 'She Tou Village, Changhua County 511', '511 彰化县社头乡'],
		'512': ['512 彰化縣永靖鄉', 'Yong Jing Village, Changhua County 512', '512 彰化县永靖乡'],
		'513': ['513 彰化縣埔心鄉', 'Bu Xin Village, Changhua County 513', '513 彰化县埔心乡'],
		'514': ['514 彰化縣溪湖鎮', 'Xi Hu Township, Changhua County 514', '514 彰化县溪湖镇'],
		'515': ['515 彰化縣大村鄉', 'Da Cun Village, Changhua County 515', '515 彰化县大村乡'],
		'516': ['516 彰化縣埔鹽鄉', 'Bu Yan Village, Changhua County 516', '516 彰化县埔盐乡'],
		'520': ['520 彰化縣田中鎮', 'Tian Zhong Township, Changhua County 520', '520 彰化县田中镇'],
		'521': ['521 彰化縣北斗鎮', 'Bei Dou Township, Changhua County 521', '521 彰化县北斗镇'],
		'522': ['522 彰化縣田尾鄉', 'Tian Wei Village, Changhua County 522', '522 彰化县田尾乡'],
		'523': ['523 彰化縣埤頭鄉', 'Bi Tou Village, Changhua County 523', '523 彰化县埤头乡'],
		'524': ['524 彰化縣溪州鄉', 'Xi Zhou Village, Changhua County 524', '524 彰化县溪州乡'],
		'525': ['525 彰化縣竹塘鄉', 'Zhu Tang Village, Changhua County 525', '525 彰化县竹塘乡'],
		'526': ['526 彰化縣二林鎮', 'Er Lin Township, Changhua County 526', '526 彰化县二林镇'],
		'527': ['527 彰化縣大城鄉', 'Da Cheng Village, Changhua County 527', '527 彰化县大城乡'],
		'528': ['528 彰化縣芳苑鄉', 'Fang Yuan Village, Changhua County 528', '528 彰化县芳苑乡'],
		'530': ['530 彰化縣二水鄉', 'Er Shui Village, Changhua County 530', '530 彰化县二水乡'],
		'540': ['540 南投縣南投市', 'Nantou City, Nantou County 540', '540 南投县南投市'],
		'541': ['541 南投縣中寮鄉', 'Zhong Liao Village, Nantou County 541', '541 南投县中寮乡'],
		'542': ['542 南投縣草屯鎮', 'Cao Tun Township, Nantou County 542', '542 南投县草屯镇'],
		'544': ['544 南投縣國姓鄉', 'Guo Xing Village, Nantou County 544', '544 南投县国姓乡'],
		'545': ['545 南投縣埔里鎮', 'Bu Li Township, Nantou County 545', '545 南投县埔里镇'],
		'546': ['546 南投縣仁愛鄉', 'Ren Ai Village, Nantou County 546', '546 南投县仁爱乡'],
		'551': ['551 南投縣名間鄉', 'Ming Jian Village, Nantou County 551', '551 南投县名间乡'],
		'552': ['552 南投縣集集鎮', 'Ji Ji Township, Nantou County 552', '552 南投县集集镇'],
		'553': ['553 南投縣水里鄉', 'Shui Li Village, Nantou County 553', '553 南投县水里乡'],
		'555': ['555 南投縣魚池鄉', 'Yu Chi Village, Nantou County 555', '555 南投县鱼池乡'],
		'556': ['556 南投縣信義鄉', 'Xin Yi Village, Nantou County 556', '556 南投县信义乡'],
		'557': ['557 南投縣竹山鎮', 'Zhu Shan Township, Nantou County 557', '557 南投县竹山镇'],
		'558': ['558 南投縣鹿谷鄉', 'Lu Gu Village, Nantou County 558', '558 南投县鹿谷乡'],
		'630': ['630 雲林縣斗南鎮', 'Dou Nan Township, Yunlin County 630', '630 云林县斗南镇'],
		'631': ['631 雲林縣大埤鄉', 'Da Bi Village, Yunlin County 631', '631 云林县大埤乡'],
		'632': ['632 雲林縣虎尾鎮', 'Hu Wei Township, Yunlin County 632', '632 云林县虎尾镇'],
		'633': ['633 雲林縣土庫鎮', 'Tu Ku Township, Yunlin County 633', '633 云林县土库镇'],
		'634': ['634 雲林縣褒忠鄉', 'Bao Zhong Village, Yunlin County 634', '634 云林县褒忠乡'],
		'635': ['635 雲林縣東勢鄉', 'Dong Shi Village, Yunlin County 635', '635 云林县东势乡'],
		'636': ['636 雲林縣臺西鄉', 'Tai Xi Village, Yunlin County 636', '636 云林县台西乡'],
		'637': ['637 雲林縣崙背鄉', 'Lun Bei Village, Yunlin County 637', '637 云林县仑背乡'],
		'638': ['638 雲林縣麥寮鄉', 'Mai Liao Village, Yunlin County 638', '638 云林县麦寮乡'],
		'640': ['640 雲林縣斗六市', 'Dou Liu City, Yunlin County 640', '640 云林县斗六市'],
		'643': ['643 雲林縣林內鄉', 'Lin Nei Village, Yunlin County 643', '643 云林县林内乡'],
		'646': ['646 雲林縣古坑鄉', 'Gu Keng Village, Yunlin County 646', '646 云林县古坑乡'],
		'647': ['647 雲林縣莿桐鄉', 'Ci Tong Village, Yunlin County 647', '647 云林县莿桐乡'],
		'648': ['648 雲林縣西螺鎮', 'Xi Luo Township, Yunlin County 648', '648 云林县西螺镇'],
		'649': ['649 雲林縣二崙鄉', 'Er Lun Village, Yunlin County 649', '649 云林县二仑乡'],
		'651': ['651 雲林縣北港鎮', 'Bei Gang Township, Yunlin County 651', '651 云林县北港镇'],
		'652': ['652 雲林縣水林鄉', 'Shui Lin Village, Yunlin County 652', '652 云林县水林乡'],
		'653': ['653 雲林縣口湖鄉', 'Kou Hu Village, Yunlin County 653', '653 云林县口湖乡'],
		'654': ['654 雲林縣四湖鄉', 'Si Hu Village, Yunlin County 654', '654 云林县四湖乡'],
		'655': ['655 雲林縣元長鄉', 'Yuan Chang Village, Yunlin County 655', '655 云林县元长乡'],
		'600': ['600 嘉義市', 'Chiayi City 600', '600 嘉义市'],
		'602': ['602 嘉義縣番路鄉', 'Fan Lu Village, Chiayi County 602', '602 嘉义县番路乡'],
		'603': ['603 嘉義縣梅山鄉', 'Mei Shan Village, Chiayi County 603', '603 嘉义县梅山乡'],
		'604': ['604 嘉義縣竹崎鄉', 'Zhu Qi Village, Chiayi County 604', '604 嘉义县竹崎乡'],
		'605': ['605 嘉義縣阿里山鄉', 'The Chiayi County A Li Shan Village 605', '605 嘉义县阿里山乡'],
		'606': ['606 嘉義縣中埔鄉', 'Zhong Bu Village, Chiayi County 606', '606 嘉义县中埔乡'],
		'607': ['607 嘉義縣大埔鄉', 'Da Bu Village, Chiayi County 607', '607 嘉义县大埔乡'],
		'608': ['608 嘉義縣水上鄉', 'Shui Shang Village, Chiayi County 608', '608 嘉义县水上乡'],
		'611': ['611 嘉義縣鹿草鄉', 'Lu Cao Village, Chiayi County 611', '611 嘉义县鹿草乡'],
		'612': ['612 嘉義縣太保市', 'Tai Bao City, Chiayi County 612', '612 嘉义县太保市'],
		'613': ['613 嘉義縣朴子市', 'Pu Zi City, Chiayi County 613', '613 嘉义县朴子市'],
		'614': ['614 嘉義縣東石鄉', 'Dong Shi Village, Chiayi County 614', '614 嘉义县东石乡'],
		'615': ['615 嘉義縣六腳鄉', 'Liu Jiao Village, Chiayi County 615', '615 嘉义县六脚乡'],
		'616': ['616 嘉義縣新港鄉', 'Xin Gang Village, Chiayi County 616', '616 嘉义县新港乡'],
		'621': ['621 嘉義縣民雄鄉', 'Min Xiong Village, Chiayi County 621', '621 嘉义县民雄乡'],
		'622': ['622 嘉義縣大林鎮', 'Da Lin Township, Chiayi County 622', '622 嘉义县大林镇'],
		'623': ['623 嘉義縣溪口鄉', 'Xi Kou Village, Chiayi County 623', '623 嘉义县溪口乡'],
		'624': ['624 嘉義縣義竹鄉', 'Yi Zhu Village, Chiayi County 624', '624 嘉义县义竹乡'],
		'625': ['625 嘉義縣布袋鎮', 'Bu Dai Township, Chiayi County 625', '625 嘉义县布袋镇'],
		'700': ['700 台南市中西區', 'Zhong Xi District, Tainan City 700', '700 台南市中西区'],
		'701': ['701 台南市東區', 'East District, Tainan City 701', '701 台南市东区'],
		'702': ['702 台南市南區', 'South District, Tainan City 702', '702 台南市南区'],
		'704': ['704 台南市北區', 'North District, Tainan City 704', '704 台南市北区'],
		'708': ['708 台南市安平區', 'An Ping District, Tainan City 708', '708 台南市安平区'],
		'709': ['709 台南市安南區', 'An Nan District, Tainan City 709', '709 台南市安南区'],
		'710': ['710 台南市永康區', 'Yong Kang District, Tainan City 710', '710 台南市永康区'],
		'711': ['711 台南市歸仁區', 'Gui Ren District, Tainan City 711', '711 台南市归仁区'],
		'712': ['712 台南市新化區', 'Xin Hua District, Tainan City 712', '712 台南市新化区'],
		'713': ['713 台南市左鎮區', 'Zuo Zhen District, Tainan City 713', '713 台南市左镇区'],
		'714': ['714 台南市玉井區', 'Yu Jing District, Tainan City 714', '714 台南市玉井区'],
		'715': ['715 台南市楠西區', 'Nan Xi District, Tainan City 715', '715 台南市楠西区'],
		'716': ['716 台南市南化區', 'Nan Hua District, Tainan City 716', '716 台南市南化区'],
		'717': ['717 台南市仁德區', 'Ren Teh District, Tainan City 717', '717 台南市仁德区'],
		'718': ['718 台南市關廟區', 'Guan Miao District, Tainan City 718', '718 台南市关庙区'],
		'719': ['719 台南市龍崎區', 'Long Qi District, Tainan City 719', '719 台南市龙崎区'],
		'720': ['720 台南市官田區', 'Guan Tian District, Tainan City 720', '720 台南市官田区'],
		'721': ['721 台南市麻豆區', 'Ma Dou District, Tainan City 721', '721 台南市麻豆区'],
		'722': ['722 台南市佳里區', 'Jia Li District, Tainan City 722', '722 台南市佳里区'],
		'723': ['723 台南市西港區', 'Xi Gang District, Tainan City 723', '723 台南市西港区'],
		'724': ['724 台南市七股區', 'Qi Gu District, Tainan City 724', '724 台南市七股区'],
		'725': ['725 台南市將軍區', 'Jiang Jun District, Tainan City 725', '725 台南市将军区'],
		'726': ['726 台南市學甲區', 'Xue Jia District, Tainan City 726', '726 台南市学甲区'],
		'727': ['727 台南市北門區', 'Bei Men District, Tainan City 727', '727 台南市北门区'],
		'730': ['730 台南市新營區', 'Xin Ying District, Tainan City 730', '730 台南市新营区'],
		'731': ['731 台南市後壁區', 'Hou Bi District, Tainan City 731', '731 台南市后壁区'],
		'732': ['732 台南市白河區', 'Bai He District, Tainan City 732', '732 台南市白河区'],
		'733': ['733 台南市東山區', 'Dong Shan District, Tainan City 733', '733 台南市东山区'],
		'734': ['734 台南市六甲區', 'Liu Jia District, Tainan City 734', '734 台南市六甲区'],
		'735': ['735 台南市下營區', 'Xia Ying District, Tainan City 735', '735 台南市下营区'],
		'736': ['736 台南市柳營區', 'Liu Ying District, Tainan City 736', '736 台南市柳营区'],
		'737': ['737 台南市鹽水區', 'Yan Shui District, Tainan City 737', '737 台南市盐水区'],
		'741': ['741 台南市善化區', 'Shan Hua District, Tainan City 741', '741 台南市善化区'],
		'742': ['742 台南市大內區', 'Da Nei District, Tainan City 742', '742 台南市大内区'],
		'743': ['743 台南市山上區', 'Shan Shang District, Tainan City 743', '743 台南市山上区'],
		'744': ['744 台南市新市區', 'Xin Shi District, Tainan City 744', '744 台南市新市区'],
		'745': ['745 台南市安定區', 'An Ding District, Tainan City 745', '745 台南市安定区'],
		'800': ['800 高雄市新興區', 'Xin Xing District, Kaohsiung City 800', '800 高雄市新兴区'],
		'801': ['801 高雄市前金區', 'Qian Jin District, Kaohsiung City 801', '801 高雄市前金区'],
		'802': ['802 高雄市苓雅區', 'Ling Ya District, Kaohsiung City 802', '802 高雄市苓雅区'],
		'803': ['803 高雄市鹽埕區', 'Yan Cheng District, Kaohsiung City 803', '803 高雄市盐埕区'],
		'804': ['804 高雄市鼓山區', 'Gu Shan District, Kaohsiung City 804', '804 高雄市鼓山区'],
		'805': ['805 高雄市旗津區', 'Qi Jin District, Kaohsiung City 805', '805 高雄市旗津区'],
		'806': ['806 高雄市前鎮區', 'Qianzhen District, Kaohsiung City 806', '806 高雄市前镇区'],
		'807': ['807 高雄市三民區', 'San Min District, Kaohsiung City 807', '807 高雄市三民区'],
		'811': ['811 高雄市楠梓區', 'Nan Zi District, Kaohsiung City 811', '811 高雄市楠梓区'],
		'812': ['812 高雄市小港區', 'Xiao Gang District, Kaohsiung City 812', '812 高雄市小港区'],
		'813': ['813 高雄市左營區', 'Zuo Ying District, Kaohsiung City 813', '813 高雄市左营区'],
		'814': ['814 高雄市仁武區', 'Ren Wu District, Kaohsiung City 814', '814 高雄市仁武区'],
		'815': ['815 高雄市大社區', 'Da She District, Kaohsiung City 815', '815 高雄市大社区'],
		'820': ['820 高雄市岡山區', 'Gang Shan District, Kaohsiung City 820', '820 高雄市冈山区'],
		'821': ['821 高雄市路竹區', 'Lu Zhu District, Kaohsiung City 821', '821 高雄市路竹区'],
		'822': ['822 高雄市阿蓮區', 'A Lian District, Kaohsiung City 822', '822 高雄市阿莲区'],
		'823': ['823 高雄市田寮區', 'Tian Liao District, Kaohsiung City 823', '823 高雄市田寮区'],
		'824': ['824 高雄市燕巢區', 'Yan Chao District, Kaohsiung City 824', '824 高雄市燕巢区'],
		'825': ['825 高雄市橋頭區', 'Qiao Tou District, Kaohsiung City 825', '825 高雄市桥头区'],
		'826': ['826 高雄市梓官區', 'Zi Guan District, Kaohsiung City 826', '826 高雄市梓官区'],
		'827': ['827 高雄市彌陀區', 'Mi Tuo District, Kaohsiung City 827', '827 高雄市弥陀区'],
		'828': ['828 高雄市永安區', 'Yong An District, Kaohsiung City 828', '828 高雄市永安区'],
		'829': ['829 高雄市湖內區', 'Hu Nei District, Kaohsiung City 829', '829 高雄市湖内区'],
		'830': ['830 高雄市鳳山區', 'Feng Shan City, Kaohsiung City 830', '830 高雄市凤山区'],
		'831': ['831 高雄市大寮區', 'Da Liao District, Kaohsiung City 831', '831 高雄市大寮区'],
		'832': ['832 高雄市林園區', 'Lin Yuan District, Kaohsiung City 832', '832 高雄市林园区'],
		'833': ['833 高雄市鳥松區', 'Niao Song District, Kaohsiung City 833', '833 高雄市鸟松区'],
		'840': ['840 高雄市大樹區', 'Da Shu District, Kaohsiung City 840', '840 高雄市大树区'],
		'842': ['842 高雄市旗山區', 'Qi Shan District, Kaohsiung City 842', '842 高雄市旗山区'],
		'843': ['843 高雄市美濃區', 'Mei Nong District, Kaohsiung City 843', '843 高雄市美浓区'],
		'844': ['844 高雄市六龜區', 'Liu Gui District, Kaohsiung City 844', '844 高雄市六龟区'],
		'845': ['845 高雄市內門區', 'Nei Men District, Kaohsiung City 845', '845 高雄市内门区'],
		'846': ['846 高雄市杉林區', 'Shan Lin District, Kaohsiung City 846', '846 高雄市杉林区'],
		'847': ['847 高雄市甲仙區', 'Jia Xian District, Kaohsiung City 847', '847 高雄市甲仙区'],
		'848': ['848 高雄市桃源區', 'Tao Yuan District, Kaohsiung City 848', '848 高雄市桃源区'],
		'849': ['849 高雄市那瑪夏區', 'San Min District, Kaohsiung City 849', '849 高雄市那玛夏区'],
		'851': ['851 高雄市茂林區', 'Mao Lin District, Kaohsiung City 851', '851 高雄市茂林区'],
		'852': ['852 高雄市茄萣區', 'Jia Ding District, Kaohsiung City 852', '852 高雄市茄萣区'],
		'900': ['900 屏東縣屏東市', 'Pingtung City, Pingtung County 900', '900 屏东县屏东市'],
		'901': ['901 屏東縣三地門鄉', 'Pingtung County San Di Men Village 901', '901 屏东县三地门乡'],
		'902': ['902 屏東縣霧臺鄉', 'Wu Tai Village, Pingtung County 902', '902 屏东县雾台乡'],
		'903': ['903 屏東縣瑪家鄉', 'Ma Jia Village, Pingtung County 903', '903 屏东县玛家乡'],
		'904': ['904 屏東縣九如鄉', 'Jiu Ru Village, Pingtung County 904', '904 屏东县九如乡'],
		'905': ['905 屏東縣里港鄉', 'Li Gang Village, Pingtung County 905', '905 屏东县里港乡'],
		'906': ['906 屏東縣高樹鄉', 'Gao Shu Village, Pingtung County 906', '906 屏东县高树乡'],
		'907': ['907 屏東縣鹽埔鄉', 'Yan Bu Village, Pingtung County 907', '907 屏东县盐埔乡'],
		'908': ['908 屏東縣長治鄉', 'Chang Zhi Village, Pingtung County 908', '908 屏东县长治乡'],
		'909': ['909 屏東縣麟洛鄉', 'Lin Luo Village, Pingtung County 909', '909 屏东县麟洛乡'],
		'911': ['911 屏東縣竹田鄉', 'Zhu Tian Village, Pingtung County 911', '911 屏东县竹田乡'],
		'912': ['912 屏東縣內埔鄉', 'Nei Bu Village, Pingtung County 912', '912 屏东县内埔乡'],
		'913': ['913 屏東縣萬丹鄉', 'Wan Dan Village, Pingtung County 913', '913 屏东县万丹乡'],
		'920': ['920 屏東縣潮州鎮', 'Chao Zhou Township, Pingtung County 920', '920 屏东县潮州镇'],
		'921': ['921 屏東縣泰武鄉', 'Tai Wu Village, Pingtung County 921', '921 屏东县泰武乡'],
		'922': ['922 屏東縣來義鄉', 'Lai Yi Village, Pingtung County 922', '922 屏东县来义乡'],
		'923': ['923 屏東縣萬巒鄉', 'Wan Luan Village, Pingtung County 923', '923 屏东县万峦乡'],
		'924': ['924 屏東縣崁頂鄉', 'Kan Ding Village, Pingtung County 924', '924 屏东县崁顶乡'],
		'925': ['925 屏東縣新埤鄉', 'Xin Bi Village, Pingtung County 925', '925 屏东县新埤乡'],
		'926': ['926 屏東縣南州鄉', 'Nan Zhou Village, Pingtung County 926', '926 屏东县南州乡'],
		'927': ['927 屏東縣林邊鄉', 'Lin Bian Village, Pingtung County 927', '927 屏东县林边乡'],
		'928': ['928 屏東縣東港鎮', 'Dong Gang Township, Pingtung County 928', '928 屏东县东港镇'],
		'929': ['929 屏東縣琉球鄉', 'Liu Qiu Village, Pingtung County 929', '929 屏东县琉球乡'],
		'931': ['931 屏東縣佳冬鄉', 'Jia Dong Village, Pingtung County 931', '931 屏东县佳冬乡'],
		'932': ['932 屏東縣新園鄉', 'Xin Yuan Village, Pingtung County 932', '932 屏东县新园乡'],
		'940': ['940 屏東縣枋寮鄉', 'Fang Liao Village, Pingtung County 940', '940 屏东县枋寮乡'],
		'941': ['941 屏東縣枋山鄉', 'Fang Shan Village, Pingtung County 941', '941 屏东县枋山乡'],
		'942': ['942 屏東縣春日鄉', 'Chun Ri Village, Pingtung County 942', '942 屏东县春日乡'],
		'943': ['943 屏東縣獅子鄉', 'Shi Zi Village, Pingtung County 943', '943 屏东县狮子乡'],
		'944': ['944 屏東縣車城鄉', 'Che Cheng Village, Pingtung County 944', '944 屏东县车城乡'],
		'945': ['945 屏東縣牡丹鄉', 'Mu Dan Village, Pingtung County 945', '945 屏东县牡丹乡'],
		'946': ['946 屏東縣恆春鎮', 'Heng Chun Township, Pingtung County 946', '946 屏东县恒春镇'],
		'947': ['947 屏東縣滿洲鄉', 'Man Zhou Village, Pingtung County 947', '947 屏东县满洲乡'],
		'950': ['950 台東縣臺東市', 'Taitung City, Taitung County 950', '950 台东县台东市'],
		'951': ['951 台東縣綠島鄉', 'Lyu Dao Village, Taitung County 951', '951 台东县绿岛乡'],
		'952': ['952 台東縣蘭嶼鄉', 'Lan Yu Village, Taitung County 952', '952 台东县兰屿乡'],
		'953': ['953 台東縣延平鄉', 'Yan Ping Village, Taitung County 953', '953 台东县延平乡'],
		'954': ['954 台東縣卑南鄉', 'Bei Nan Village, Taitung County 954', '954 台东县卑南乡'],
		'955': ['955 台東縣鹿野鄉', 'Lu Ye Village, Taitung County 955', '955 台东县鹿野乡'],
		'956': ['956 台東縣關山鎮', 'Guan Shan Township, Taitung County 956', '956 台东县关山镇'],
		'957': ['957 台東縣海端鄉', 'Hai Duan Village, Taitung County 957', '957 台东县海端乡'],
		'958': ['958 台東縣池上鄉', 'Chi Shang Village, Taitung County 958', '958 台东县池上乡'],
		'959': ['959 台東縣東河鄉', 'Dong He Village, Taitung County 959', '959 台东县东河乡'],
		'961': ['961 台東縣成功鎮', 'Cheng Gong Township, Taitung County 961', '961 台东县成功镇'],
		'962': ['962 台東縣長濱鄉', 'Chang Bin Village, Taitung County 962', '962 台东县长滨乡'],
		'963': ['963 台東縣太麻里鄉', 'The Taitung County Tai Ma Li Village 963', '963 台东县太麻里乡'],
		'964': ['964 台東縣金峰鄉', 'Jin Feng Village, Taitung County 964', '964 台东县金峰乡'],
		'965': ['965 台東縣大武鄉', 'Da Wu Village, Taitung County 965', '965 台东县大武乡'],
		'966': ['966 台東縣達仁鄉', 'Da Ren Village, Taitung County 966', '966 台东县达仁乡'],
		'970': ['970 花蓮縣花蓮市', 'Hualien City, Hualien County 970', '970 花莲县花莲市'],
		'971': ['971 花蓮縣新城鄉', 'Xin Cheng Village, Hualien County 971', '971 花莲县新城乡'],
		'972': ['972 花蓮縣秀林鄉', 'Xiu Lin Village, Hualien County 972', '972 花莲县秀林乡'],
		'973': ['973 花蓮縣吉安鄉', 'Ji An Village, Hualien County 973', '973 花莲县吉安乡'],
		'974': ['974 花蓮縣壽豐鄉', 'Shou Feng Village, Hualien County 974', '974 花莲县寿丰乡'],
		'975': ['975 花蓮縣鳳林鎮', 'Feng Lin Township, Hualien County 975', '975 花莲县凤林镇'],
		'976': ['976 花蓮縣光復鄉', 'Guang Fu Village, Hualien County 976', '976 花莲县光复乡'],
		'977': ['977 花蓮縣豐濱鄉', 'Feng Bin Village, Hualien County 977', '977 花莲县丰滨乡'],
		'978': ['978 花蓮縣瑞穗鄉', 'Rui Sui Village, Hualien County 978', '978 花莲县瑞穗乡'],
		'979': ['979 花蓮縣萬榮鄉', 'Wan Rong Village, Hualien County 979', '979 花莲县万荣乡'],
		'981': ['981 花蓮縣玉里鎮', 'Yu Li Township, Hualien County 981', '981 花莲县玉里镇'],
		'982': ['982 花蓮縣卓溪鄉', 'Zhuo Xi Village, Hualien County 982', '982 花莲县卓溪乡'],
		'983': ['983 花蓮縣富里鄉', 'Fu Li Village, Hualien County 983', '983 花莲县富里乡'],
		'260': ['260 宜蘭縣宜蘭市', 'Yilan City, Yilan County 260', '260 宜兰县宜兰市'],
		'261': ['261 宜蘭縣頭城鎮', 'Tou Cheng Township, Yilan County 261', '261 宜兰县头城镇'],
		'262': ['262 宜蘭縣礁溪鄉', 'Jiao Xi Village, Yilan County 262', '262 宜兰县礁溪乡'],
		'263': ['263 宜蘭縣壯圍鄉', 'Zhuang Wei Village, Yilan County 263', '263 宜兰县壮围乡'],
		'264': ['264 宜蘭縣員山鄉', 'Yuan Shan Village, Yilan County 264', '264 宜兰县员山乡'],
		'265': ['265 宜蘭縣羅東鎮', 'Luo Dong Township, Yilan County 265', '265 宜兰县罗东镇'],
		'266': ['266 宜蘭縣三星鄉', 'San Xing Village, Yilan County 266', '266 宜兰县三星乡'],
		'267': ['267 宜蘭縣大同鄉', 'Da Tong Village, Yilan County 267', '267 宜兰县大同乡'],
		'268': ['268 宜蘭縣五結鄉', 'Wu Jie Village, Yilan County 268', '268 宜兰县五结乡'],
		'269': ['269 宜蘭縣冬山鄉', 'Dong Shan Village, Yilan County 269', '269 宜兰县冬山乡'],
		'270': ['270 宜蘭縣蘇澳鎮', 'Su Ao Township, Yilan County 270', '270 宜兰县苏澳镇'],
		'272': ['272 宜蘭縣南澳鄉', 'Nan Ao Village, Yilan County 272', '272 宜兰县南澳乡'],
		'880': ['880 澎湖縣馬公市', 'Ma Gong City, Peng Hu County 880', '880 澎湖县马公市'],
		'881': ['881 澎湖縣西嶼鄉', 'Xi Yu Village, Peng Hu County 881', '881 澎湖县西屿乡'],
		'882': ['882 澎湖縣望安鄉', 'Wang An Village, Peng Hu County 882', '882 澎湖县望安乡'],
		'883': ['883 澎湖縣七美鄉', 'Qi Mei Village, Peng Hu County 883', '883 澎湖县七美乡'],
		'884': ['884 澎湖縣白沙鄉', 'Bai Sha Village, Peng Hu County 884', '884 澎湖县白沙乡'],
		'885': ['885 澎湖縣湖西鄉', 'Hu Xi Village, Peng Hu County 885', '885 澎湖县湖西乡'],
		'890': ['890 金門縣金沙鎮', 'Jin Sha Township, Jin Men County 890', '890 金门县 金沙镇'],
		'891': ['891 金門縣金湖鎮', 'Jin Hu Township, Jin Men County 891', '891 金门县 金湖镇'],
		'892': ['892 金門縣金寧鄉', 'Jin Ning Village, Jin Men County 892', '892 金门县 金宁乡'],
		'893': ['893 金門縣金城鎮', 'Jin Cheng Township, Jin Men County 893', '893 金门县 金城镇'],
		'894': ['894 金門縣烈嶼鄉', 'Lie Yu Village, Jin Men County 894', '894 金门县 烈屿乡'],
		'896': ['896 金門縣烏坵鄉', 'Wu Qiu Village, Jin Men County 896', '896 金门县 乌丘乡'],
		'209': ['209 連江縣南竿鄉', 'Nan Gan Village, Lian Jiang County 209', '209 连江县南竿乡'],
		'210': ['210 連江縣北竿鄉', 'Bei Gan Village, Lian Jiang County 210', '210 连江县北竿乡'],
		'211': ['211 連江縣莒光鄉', 'Ju Guang Village, Lian Jiang County 211', '211 连江县莒光乡'],
		'212': ['212 連江縣東引鄉', 'Dong Yin Village, Lian Jiang County 212', '212 连江县东引乡'],
		'817': ['817 高雄市東沙群島', 'Dongsha Islands, Nanhai Islands, Kaohsiung City 817', '817 高雄市东沙群岛'],
		'819': ['819 高雄市南沙群島', 'Nansha Islands, Nanhai Islands, Kaohsiung City 819', '819 高雄市南沙群岛']
	},
	'ed.base.zodiac': {
		'1': ['鼠', 'mouse', '鼠'],
		'2': ['牛', 'Cattle', '牛'],
		'3': ['虎', 'tiger', '虎'],
		'4': ['兔', 'rabbit', '兔'],
		'5': ['龍', 'Dragon', '龙'],
		'6': ['蛇', 'snake', '蛇'],
		'7': ['馬', 'horse', '马'],
		'8': ['羊', 'sheep', '羊'],
		'9': ['猴', 'monkey', '猴'],
		'10': ['雞', 'chicken', '鸡'],
		'11': ['狗', 'dog', '狗'],
		'12': ['豬', 'pig', '猪']
	},
	'ed.cooperation.workStatus': {
		'7': ['在廠', 'In the factory', '在厂'],
		'8': ['返校', 'Back to school', '返校']
	},
	'ed.cutyear.dataSource': {
		'1': ['自行輸入', 'Input by yourself', '自己输入'],
		'2': ['復職作業', 'Employee return', '复职作业']
	},
	'ed.edu.education': {
		1: ['博士', `Doctorate`, '博士'],
		2: ['碩士', `Master's degree`, '硕士'],
		4: ['大學', `Bachelor's degree`, '大学'],
		8: ['四技', `Four-year technical college`, '四技'],
		16: ['二技', `Two-year technical college`, '二技'],
		32: ['二專', `Two-year junior college`, '二专'],
		64: ['三專', `Three-year junior college`, '三专'],
		128: ['五專', `Five-year junior college`, '五专'],
		256: ['高中', `High school`, '高中'],
		512: ['高職', `Vocational high school`, '高职'],
		1024: ['國中(含)以下', `Junior high school (and below)`, '国中(含)以下']
	},
	'ed.edu.gradStatus': {
		'1': ['畢業', `Graduated`, '毕业'],
		'2': ['肄業', `Incomplete (attended but did not graduate)`, '肄业'],
		'3': ['就學中', `Currently studying`, '就学中']
	},
	'ed.edu.schoolArea': {
		'0': ['國內', 'internal', '国内'],
		'1': ['國外', 'oversea', '国外']
	},
	'ed.emp.choose.ruleType': {
		'100': ['工作年資', 'Working years', '工作年资'],
		'110': ['任現職位年資', 'Current position', '任现职位年资'],
		'120': ['任現職等年資', 'Any grade', '任现职等年资'],
		'130': ['學校名稱', 'School Name', '学校名称'],
		'140': ['學歷', 'Education', '学历'],
		'150': ['經歷', 'experience', '经历'],
		'160': ['績效等級', 'Performance level', '绩效等级'],
		'170': ['績效分數', 'Performance score', '绩效分数'],
		'180': ['獎懲點數', 'Reward and punishment points', '奖惩点数'],
		'190': ['獎懲項目', 'Rewards and punishments', '奖惩项目'],
		'200': ['教育訓練', 'Education Training', '教育训练'],
		'210': ['證照', 'License', '证照'],
		'220': ['語言', 'Language', '语言'],
		'230': ['方言', 'dialect', '方言'],
		'240': ['擅長工具', 'Good at tools', '擅长工具'],
		'250': ['工作技能', 'working ability', '工作技能'],
		'260': ['職能', 'Function', '职能']
	},
	'ed.emp.return.YearAppType': {
		'1': ['立即承認', 'now', '立即承认'],
		'2': ['到某日承認', 'wait one day', '到某日承认']
	},
	'ed.emp.return.YearCalType': {
		'1': ['重新計算', 'recalculate', '重新计算'],
		'2': ['承認先前年資', 'Recognition of previous years', '承认先前年资']
	},
	'ed.emp.stopInsStatus': {
		'1': ['轉出', 'Withdraw', '转出'],
		'2': ['續保', 'Continue', '续保']
	},
	'ed.empDeal.status': {
		'0': ['契约中', 'Contracting', '契约中'],
		'1': ['到期', 'Expire', '到期'],
		'2': ['中止', 'Suspend', '中止']
	},
	'ed.empHistory.dataInput': {
		'1': ['代碼選單', 'Code menu', '代码选单'],
		'2': ['文字選單', 'Text menu', '文字选单']
	},
	'ed.empLanguage.Level': {
		'1': ['不會', 'Not proficient', '不会'],
		'2': ['略懂', 'Beginner', '略懂'],
		'3': ['中等', 'Intermediate', '中等'],
		'4': ['精通', 'Proficient', '精通']
	},
	'ed.empLanguage.local': {
		'1': ['台語', 'Taiwanese', '台语'],
		'2': ['客家語', 'Hakka language', '客家语'],
		'3': ['粵語', 'Cantonese', '粤语'],
		'4': ['上海話', 'Shanghainese', '上海话'],
		'5': ['原住民語', 'Aboriginal language', '原住民语']
	},
	'ed.empLanguage.national': {
		'1': ['英文', 'English', '英文'],
		'2': ['日文', 'Japanese', '日文'],
		'3': ['法文', 'French', '法文'],
		'4': ['德文', 'German', '德文'],
		'5': ['西班牙文', 'Spanish', '西班牙文'],
		'9': ['越文', 'Vietnamese', '越文'],
		'10': ['泰文', 'Thai', '泰文'],
		'11': ['馬來文', 'Malay', '马来文'],
		'12': ['印尼文', 'Indonesian', '印尼文'],
		'13': ['韓文', 'Korean', '韩文'],
		'14': ['俄文', 'Russian', '俄文'],
		'15': ['義大利文', 'Italian', '义大利文'],
		'16': ['葡萄牙文', 'Portuguese', '葡萄牙文'],
		'17': ['阿拉伯文', 'Arabic', '阿拉伯文'],
		'18': ['中文', 'Chinese', '中文'],
		'19': ['菲律賓文', 'Filipino', '菲律宾文']
	},
	'ed.empTaxFreeCal': {
		'0': ['自動計算', 'Automatic calculation', '自动计算'],
		'1': ['人工輸入', 'Manual input', '人工输入']
	},
	'ed.family.isLife': {
		'1': ['存', 'Alive', '存'],
		'0': ['歿', 'Dead', '殁']
	},
	'ed.family.relation': {
		'1': ['配偶', 'Spouse', '配偶'],
		'2': ['父母', 'Parents', '父母'],
		'3': ['子女', 'Children', '子女'],
		'4': ['祖父母', 'Grandparents', '祖父母'],
		'5': ['孫子女', 'Grandchildren', '孙子女'],
		'6': ['外祖父母', 'Maternal grandparents', '外祖父母'],
		'7': ['外孫子女', 'Maternal grandchildren', '外孙子女'],
		'8': ['曾祖父母', 'Great-grandparents', '曾祖父母'],
		'9': ['外曾祖父母', 'Maternal great-grandparents', '外曾祖父母'],
		'p': ['受監護人', 'Ward', '受监护人'],
		'Z1': ['兄弟姊妹', 'Siblings', '兄弟姊妹'],
		'Z2': ['配偶之父母', 'Parents-in-law', '配偶之父母'],
		'Z3': ['其他', 'Others', '其他']
	},
	'ed.job.empType': {
		'1': ['直接員工', 'Direct employee', '直接员工'],
		'2': ['間接員工', 'Indirect employee', '间接员工']
	},
	'ed.job.headCount': {
		'1': ['編制內員工', 'In-system employee', '编制内员工'],
		'2': ['編制外員工', 'Out-of-system employee', '编制外员工']
	},
	'ed.job.isManage': {
		'0': ['非管理職', `Non-managerial position`, '非管理职'],
		'1': ['管理職', `Managerial position`, '管理职']
	},
	'ed.job.isPassProbation': {
		'1': ['已試用期滿', 'Expired trial', '已试用期满'],
		'2': ['未試用期滿', 'Not trial expired', '未试用期满'],
		'3': ['無試用期', 'No trial period', '无试用期']
	},
	'ed.job.responsibility': {
		'1': ['責任制', 'Exempt employee', '责任制'],
		'2': ['非責任制', 'Non-exempt employee', '非责任制']
	},
	'ed.job.workStatus': {
		'0': ['錄取待報到', 'Admission is reported', '录取待报到'],
		'1': ['在職', 'On duty', '在职'],
		'2': ['留職停薪', 'Leave the job', '留职停薪'],
		'3': ['離職', 'Leave', '离职']
	},
	'ed.job.workYearSetting': {
		'1': ['結清', 'Clear', '结清'],
		'2': ['未結清', 'Unclear', '未结清']
	},
	'ed.perf.dataSource': {
		'0': ['資料建立', 'from data establishment', '资料建立'],
		'1': ['資料匯入', 'from data import', '资料汇入'],
		'2': ['績效管理系統轉入', 'from performance management system', '绩效管理系统转入']
	},
	'ed.perf.pass': {
		'1': ['通過', 'pass', '通过'],
		'0': ['未通過', 'not pass', '未通过']
	},
	'ed.probation.dataSource': {
		'1': ['員工新進', 'New recruit', '员工新进'],
		'2': ['延長試用', 'Extension of probation', '延长试用']
	},
	'ed.probation.pass': {
		'3': ['未評核', 'Unevaluated', '未评核'],
		'1': ['合格', 'qualified', '合格'],
		'0': ['不合格', 'Unqualified', '不合格'],
		'2': ['未評核(展延中)', 'Extension', '未评核(展延中)']
	},
	'ed.returnyear.dataSource': {
		'1': ['員工資料寫入', 'from employee information', '员工资料写入'],
		'2': ['由復職作業寫入', 'from employee return', '由复职作业写入']
	},
	'ed.reward.type': {
		'1': ['獎勵', 'reward', '奖励'],
		'2': ['懲罰', 'punishment', '惩罚']
	},
	'ed.training.courseExec': {
		'1': ['實體課程', 'Classroom', '实体课程'],
		'2': ['線上課程', 'Online', '线上课程']
	},
	'ed.training.courseRequire': {
		'1': ['主管指派', 'Assigned by supervisor', '主管指派'],
		'2': ['個人需求', 'Personal demand', '个人需求']
	},
	'ed.training.testResult': {
		'1': ['合格', 'Passed', '合格'],
		'0': ['不合格', 'Failed', '不合格']
	},
	'ed.training.testResult._sort': [1, 0],
	'ed.training.type': {
		'1': ['內訓', 'Internal training', '内训'],
		'2': ['外訓', 'External training', '外训']
	},
	'ed.training.source': {
		'1': ['人工輸入','Manual input','人工输入'],
		'2': ['人工匯入','Manual import','人工汇入'],
		'3': ['介接','Interface','介接']
	},
	'ed.vars.dataSrc': {
		'1': ['單筆新增','Single ','单笔新增'],
		'2': ['批次新增','Batch','批次新增'],
		'3': ['匯入','Import','汇入'],
		'4': ['復職作業','Employee return','复职作业'],
		'5': ['晉升作業','Promotion','晋升作业'],
		'6': ['電子表單','Electronic form','电子表单'],
		'7': ['介接','Interface','介接'],
		'8': ['薪資基本資料輸入','Basic salary data input','薪资基本资料输入']
	},
	'ed.vars.item': {
		'SNO_ID': ['扣繳單位', 'Withholding units', '扣缴单位'],
		'DEPT1_ID': ['組織類別1', 'org1', '组织类别1'],
		'DEPT2_ID': ['組織類別2', 'org2', '组织类别2'],
		'DEPT3_ID': ['組織類別3', 'org3', '组织类别3'],
		'DEPT4_ID': ['組織類別4', 'org4', '组织类别4'],
		'DEPT5_ID': ['組織類別5', 'org5', '组织类别5'],
		'JOB_ID': ['職位', 'Job', '职位'],
		'GRADE_ID': ['職等', 'Grade', '职等'],
		'LEVEL_ID': ['職級', 'Level', '职级'],
		'JOB_CAT_ID': ['職務類別', 'Job category', '职务类别'],
		'JOB_STYLE_ID': ['職種', 'Job style', '职种'],
		'JOB_DESC_ID': ['職務說明書', 'Job description', '职务说明书'],
		'JOB_BIZ_ID': ['名片職務', 'Business card job', '名片职务'],
		'IDENTITY_ID': ['身分類別', 'Identity category', '身分类别'],
		'EMPLOYEE_TYPE': ['直間接別', 'Straight to the other', '直间接别'],
		'RESPOBILITY': ['責任區分', 'Distinction of responsibility', '责任区分'],
		'HEADCOUNT_STATUS': ['編制狀況', 'Prepare the situation', '编制状况'],
		'AREA_ID': ['工作區域', 'Work area', '工作区域'],
		'SITE_ID': ['工作地點', 'Work location', '工作地点'],
		'FACTORY_ID': ['廠別', 'Site', '厂别'],
		'EMP_NO': ['員工編號', 'Employee', '员工']
	},
	'ed.emp.cause': {
		'16': ['一般留停', 'General unpaid leave', '一般留停'],
		'32': ['育嬰留停', 'Parental leave', '育婴留停'],
		'64': ['自願離職', 'Voluntary separation', '自愿离职'],
		'128': ['資遣(須預告)', 'Disbursement (pre-announcement)', '资遣(须预告)'],
		'256': ['解雇(不須預告)', 'Dismissal (no notice required)', '解雇(不须预告)'],
		'512': ['退休', 'retirement', '退休']
	},
	'ed.emp.stopCause': {
		'16': ['一般留停', 'General unpaid leave', '一般留停'],
		'32': ['育嬰留停', 'Parental leave', '育婴留停']
	},
	'ed.emp.quitCause': {
		'64': ['自願離職', 'Voluntary separation', '自愿离职'],
		'128': ['資遣(須預告)', 'Disbursement (pre-announcement)', '资遣(须预告)'],
		'256': ['解雇(不須預告)', 'Dismissal (no notice required)', '解雇(不须预告)'],
		'512': ['退休', 'retirement', '退休']
	},
	'ed.emp.returnCause': {
		'1': ['留停復職', 'Responsible for reinstatement', '留停复职'],
		'2': ['離職復職', 'Resignation', '离职复职']
	},
	'ed.emp.childCareType': {
		'1': ['依日申請', 'Less than 30 days', '按日申请'],
		'2': ['未滿 6 個月', 'Less than 6 months', '未满 6 个月'],
		'3': ['6 個月以上', 'More than 6 months', '6 个月以上'],
	},
	'ed.emp.childCareCase': {
		'1': ['原則', 'Principle', '原则'],
		'2': ['突發', 'Emergency', '突发'],
	},
	'ed.biz.trans': {
		'1': ['台灣高速鐵路', 'Taiwan High-Speed Rail', '台湾高铁'],
		'2': ['臺北捷運', 'Taipei Metro', '臺北地铁'],
		'3': ['桃園捷運', 'Taoyuan Metro', '桃园地铁'],
		'4': ['臺中捷運', 'Taichung Metro', '臺中地铁']
	},
	'ce.trans.highSpeedRail': {
		178: ['南港', 'Nangang', '南港'],
		179: ['台北', 'Taipei', '台北'],
		180: ['板橋', 'Banqiao', '板桥'],
		181: ['桃園', 'Taoyuan', '桃园'],
		182: ['新竹', 'Hsinchu', '新竹'],
		183: ['苗栗', 'Miaoli', '苗栗'],
		184: ['台中', 'Taichung', '台中'],
		185: ['彰化', 'Changhua', '彰化'],
		186: ['雲林', 'Yunlin', '云林'],
		187: ['嘉義', 'Chiayi', '嘉义'],
		188: ['台南', 'Tainan', '台南'],
		189: ['左營', 'Zuoying', '左营']
	},
	'ce.trans.taipeiMetro': [
		{
			id: 'wenhu',
			name: ['文湖線', 'Wenhu Line', '文湖线'],
			children: [
				{ id: 1, name: ['動物園', 'Taipei Zoo', '动物园'] },
				{ id: 2, name: ['木柵', 'Muzha', '木栅'] },
				{ id: 3, name: ['萬芳社區', 'Wanfang Community', '万芳社区'] },
				{ id: 4, name: ['萬芳醫院', 'Wanfang Hospital', '万芳医院'] },
				{ id: 5, name: ['辛亥', 'Xinhai', '辛亥'] },
				{ id: 6, name: ['麟光', 'Linguang', '麟光'] },
				{ id: 7, name: ['六張犁', 'Liuzhangli', '六张犁'] },
				{ id: 8, name: ['科技大樓', 'Technology Building', '科技大楼'] },
				{ id: 9, name: ['大安', 'Daan', '大安'] },
				{ id: 10, name: ['忠孝復興', 'Zhongxiao Fuxing', '忠孝复兴'] },
				{ id: 11, name: ['南京復興', 'Nanjing Fuxing', '南京复兴'] },
				{ id: 12, name: ['中山國中', 'Zhongshan Junior High School', '中山国中'] },
				{ id: 13, name: ['松山機場', 'Songshan Airport', '松山机场'] },
				{ id: 14, name: ['大直', 'Dazhi', '大直'] },
				{ id: 15, name: ['劍南路', 'Jiannan Rd.', '剑南路'] },
				{ id: 16, name: ['西湖', 'Xihu', '西湖'] },
				{ id: 17, name: ['港墘', 'Gangqian', '港墘'] },
				{ id: 18, name: ['文德', 'Wende', '文德'] },
				{ id: 19, name: ['內湖', 'Neihu', '内湖'] },
				{ id: 20, name: ['大湖公園', 'Dahu Park', '大湖公园'] },
				{ id: 21, name: ['葫洲', 'Huzhou', '葫洲'] },
				{ id: 22, name: ['東湖', 'Donghu', '东湖'] },
				{ id: 23, name: ['南港軟體園區', 'Nangang Software Park', '南港软件园区'] },
				{ id: 24, name: ['南港展覽館', 'Taipei Nangang Exhibition Center', '南港展览馆'] },
			]
		},
		{
			id: 'tamsui',
			name: ['淡水信義線', 'Tamsui-Xinyi Line', '淡水信义线'],
			children: [
				{ id: 25, name: ['象山', 'Xiangshan', '象山'] },
				{ id: 26, name: ['台北101/世貿', 'Taipei 101/World Trade Center', '台北101/世贸'] },
				{ id: 27, name: ['信義安和', 'Xinyi Anhe', '信义安和'] },
				{ id: 28, name: ['大安', 'Daan', '大安'] },
				{ id: 29, name: ['大安森林公園', 'Daan Park', '大安森林公园'] },
				{ id: 30, name: ['東門', 'Dongmen', '东门'] },
				{ id: 31, name: ['中正紀念堂', 'C.K.S. Memorial Hall', '中正纪念堂'] },
				{ id: 32, name: ['台大醫院', 'NTU Hospital', '台大医院'] },
				{ id: 33, name: ['台北車站', 'Taipei Main Station', '台北车站'] },
				{ id: 34, name: ['中山', 'Zhongshan', '中山'] },
				{ id: 35, name: ['雙連', 'Shuanglian', '双连'] },
				{ id: 36, name: ['民權西路', 'Minquan W. Rd.', '民权西路'] },
				{ id: 37, name: ['圓山', 'Yuanshan', '圆山'] },
				{ id: 38, name: ['劍潭', 'Jiantan', '剑潭'] },
				{ id: 39, name: ['士林', 'Shilin', '士林'] },
				{ id: 40, name: ['芝山', 'Zhishan', '芝山'] },
				{ id: 41, name: ['明德', 'Mingde', '明德'] },
				{ id: 42, name: ['石牌', 'Shipai', '石牌'] },
				{ id: 43, name: ['唭哩岸', 'Qilian', '唭哩岸'] },
				{ id: 44, name: ['奇岩', 'Qiyan', '奇岩'] },
				{ id: 45, name: ['北投', 'Beitou', '北投'] },
				{ id: 46, name: ['新北投', 'Xinbeitou', '新北投'] },
				{ id: 47, name: ['復興崗', 'Fuxinggang', '复兴岗'] },
				{ id: 48, name: ['忠義', 'Zhongyi', '忠义'] },
				{ id: 49, name: ['關渡', 'Guandu', '关渡'] },
				{ id: 50, name: ['竹圍', 'Zhuwei', '竹围'] },
				{ id: 51, name: ['紅樹林', 'Hongshulin', '红树林'] },
				{ id: 52, name: ['淡水', 'Tamsui', '淡水'] },
			]
		},
		{
			id: 'sds',
			name: ['松山新店線', 'Songshan-Xindian Line', '松山新店线'],
			children: [
				{ id: 53, name: ['新店', 'Xindian', '新店'] },
				{ id: 54, name: ['新店區公所', 'Xindian District Office', '新店区公所'] },
				{ id: 55, name: ['七張', 'Qizhang', '七张'] },
				{ id: 56, name: ['小碧潭', 'Xiaobitan', '小碧潭'] },
				{ id: 57, name: ['大坪林', 'Dapinglin', '大坪林'] },
				{ id: 58, name: ['景美', 'Jingmei', '景美'] },
				{ id: 59, name: ['萬隆', 'Wanlong', '万隆'] },
				{ id: 60, name: ['公館', 'Gongguan', '公馆'] },
				{ id: 61, name: ['台電大樓', 'Taipower Building', '台电大楼'] },
				{ id: 62, name: ['古亭', 'Guting', '古亭'] },
				{ id: 63, name: ['中正紀念堂', 'C.K.S. Memorial Hall', '中正纪念堂'] },
				{ id: 64, name: ['小南門', 'Xiaonanmen', '小南门'] },
				{ id: 65, name: ['西門', 'Ximen', '西门'] },
				{ id: 66, name: ['北門', 'Beimen', '北门'] },
				{ id: 67, name: ['中山', 'Zhongshan', '中山'] },
				{ id: 68, name: ['松江南京', 'Songjiang Nanjing', '松江南京'] },
				{ id: 69, name: ['南京復興', 'Nanjing Fuxing', '南京复兴'] },
				{ id: 70, name: ['台北小巨蛋', 'Taipei Arena', '台北小巨蛋'] },
				{ id: 71, name: ['南京三民', 'Nanjing Sanmin', '南京三民'] },
				{ id: 72, name: ['松山', 'Songshan', '松山'] },
			]
		},
		{
			id: 'zhonghe',
			name: ['中和新蘆線', 'Zhonghe-Xinlu Line', '中和新芦线'],
			children: [
				{ id: 73, name: ['南勢角', 'Nanshijiao', '南势角'] },
				{ id: 74, name: ['景安', 'Jingan', '景安'] },
				{ id: 75, name: ['永安市場', 'Yongan Market', '永安市场'] },
				{ id: 76, name: ['頂溪', 'Dingxi', '顶溪'] },
				{ id: 77, name: ['古亭', 'Guting', '古亭'] },
				{ id: 78, name: ['東門', 'Dongmen', '东门'] },
				{ id: 79, name: ['忠孝新生', 'Zhongxiao Xinsheng', '忠孝新生'] },
				{ id: 80, name: ['松江南京', 'Songjiang Nanjing', '松江南京'] },
				{ id: 81, name: ['行天宮', 'Xingtian Temple', '行天宫'] },
				{ id: 82, name: ['中山國小', 'Zhongshan Elementary School', '中山国小'] },
				{ id: 83, name: ['民權西路', 'Minquan W. Rd.', '民权西路'] },
				{ id: 84, name: ['大橋頭', 'Daqiaotou', '大桥头'] },
				{ id: 85, name: ['台北橋', 'Taipei Bridge', '台北桥'] },
				{ id: 86, name: ['菜寮', 'Cailiao', '菜寮'] },
				{ id: 87, name: ['三重', 'Sanchong', '三重'] },
				{ id: 88, name: ['先嗇宮', 'Xianse Temple', '先嗇宫'] },
				{ id: 89, name: ['頭前庄', 'Touqianzhuang', '头前庄'] },
				{ id: 90, name: ['新莊', 'Xinzhuang', '新庄'] },
				{ id: 91, name: ['輔大', 'Fu Jen University', '辅大'] },
				{ id: 92, name: ['丹鳳', 'Danfeng', '丹凤'] },
				{ id: 93, name: ['迴龍', 'Huilong', '迴龙'] },
				{ id: 94, name: ['三重國小', 'Sanchong Elementary School', '三重国小'] },
				{ id: 95, name: ['三和國中', 'Sanhe Junior High School', '三和国中'] },
				{ id: 96, name: ['徐匯中學', 'St. Ignatius High School', '徐汇中学'] },
				{ id: 97, name: ['三民高中', 'Sanmin Senior High School', '三民高中'] },
				{ id: 98, name: ['蘆洲', 'Luzhou', '芦洲'] },
			]
		},
		{
			id: 'bannan',
			name: ['板南線', 'Bannan Line', '板南线'],
			children: [
				{ id: 99, name: ['頂埔', 'Dingpu', '顶埔'] },
				{ id: 100, name: ['永寧', 'Yongning', '永宁'] },
				{ id: 101, name: ['土城', 'Tucheng', '土城'] },
				{ id: 102, name: ['海山', 'Haishan', '海山'] },
				{ id: 103, name: ['亞東醫院', 'Far Eastern Hospital', '亚东医院'] },
				{ id: 104, name: ['府中', 'Fuzhong', '府中'] },
				{ id: 105, name: ['板橋', 'Banqiao', '板桥'] },
				{ id: 106, name: ['新埔', 'Xinpu', '新埔'] },
				{ id: 107, name: ['江子翠', 'Jiangzicui', '江子翠'] },
				{ id: 108, name: ['龍山寺', 'Longshan Temple', '龙山寺'] },
				{ id: 109, name: ['西門', 'Ximen', '西门'] },
				{ id: 110, name: ['台北車站', 'Taipei Main Station', '台北车站'] },
				{ id: 111, name: ['善導寺', 'Shandao Temple', '善导寺'] },
				{ id: 112, name: ['忠孝新生', 'Zhongxiao Xinsheng', '忠孝新生'] },
				{ id: 113, name: ['忠孝復興', 'Zhongxiao Fuxing', '忠孝复兴'] },
				{ id: 114, name: ['忠孝敦化', 'Zhongxiao Dunhua', '忠孝敦化'] },
				{ id: 115, name: ['國父紀念館', 'S.Y.S. Memorial Hall', '国父纪念馆'] },
				{ id: 116, name: ['市政府', 'Taipei City Hall', '市政府'] },
				{ id: 117, name: ['永春', 'Yongchun', '永春'] },
				{ id: 118, name: ['後山埤', 'Houshanpi', '后山埤'] },
				{ id: 119, name: ['昆陽', 'Kunyang', '昆阳'] },
				{ id: 120, name: ['南港', 'Nangang', '南港'] },
				{ id: 121, name: ['南港展覽館', 'Taipei Nangang Exhibition Center', '南港展览馆'] },
			]
		},
		{
			id: 'huan',
			name: ['環狀線', 'Circular Line', '环状线'],
			children: [
				{ id: 122, name: ['大坪林', 'Dapinglin', '大坪林'] },
				{ id: 123, name: ['十四張', 'Shisizhang', '十四张'] },
				{ id: 124, name: ['秀朗橋', 'Xiulang Bridge', '秀朗桥'] },
				{ id: 125, name: ['景平', 'Jingping', '景平'] },
				{ id: 126, name: ['景安', 'Jingan', '景安'] },
				{ id: 127, name: ['中和', 'Zhonghe', '中和'] },
				{ id: 128, name: ['橋和', 'Qiaohe', '桥和'] },
				{ id: 129, name: ['中原', 'Zhongyuan', '中原'] },
				{ id: 130, name: ['板新', 'Banxin', '板新'] },
				{ id: 131, name: ['板橋', 'Banqiao', '板桥'] },
				{ id: 132, name: ['新埔民生', 'Xinpu Minsheng', '新埔民生'] },
				{ id: 133, name: ['頭前庄', 'Touqianzhuang', '头前庄'] },
				{ id: 134, name: ['幸福', 'Xingfu', '幸福'] },
				{ id: 135, name: ['新北產業園區', 'New Taipei Industrial Park', '新北产业园区'] },
			]
		}
	],
	'ce.trans.taoyuanMetro': [
		{
			id: 'airport',
			name: ['機場線', 'Airport Line', '机场线'],
			children: [
				{ id: 136, name: ['台北車站', 'Taipei Main Station', '台北车站'] },
				{ id: 137, name: ['三重', 'Sanchong Station', '三重'] },
				{ id: 138, name: ['新北產業園區', 'New Taipei Industrial Park Station', '新北产业园区'] },
				{ id: 139, name: ['新莊副都心', 'Xinzhuang Fuduxin Station', '新庄副都心'] },
				{ id: 140, name: ['泰山', 'Taishan Station', '泰山'] },
				{ id: 141, name: ['泰山貴和', 'Taishan Guihe Station', '泰山贵和'] },
				{ id: 142, name: ['體育大學', 'National Taiwan Sport University Station', '体育大学'] },
				{ id: 143, name: ['長庚醫院', 'Chang Gung Memorial Hospital Station', '长庚医院'] },
				{ id: 144, name: ['林口', 'Linkou Station', '林口'] },
				{ id: 145, name: ['山鼻', 'Shanbi Station', '山鼻'] },
				{ id: 146, name: ['坑口', 'Kengkou Station', '坑口'] },
				{ id: 147, name: ['機場第一航廈', 'Airport Terminal 1 Station', '机场第一航厦'] },
				{ id: 148, name: ['機場第二航廈', 'Airport Terminal 2 Station', '机场第二航厦'] },
				{ id: 150, name: ['機場旅館', 'Airport Hotel Station', '机场旅馆'] },
				{ id: 151, name: ['大園', 'Dayuan Station', '大园'] },
				{ id: 152, name: ['橫山', 'Hengshan Station', '横山'] },
				{ id: 153, name: ['領航', 'Linghang Station', '领航'] },
				{ id: 154, name: ['高鐵桃園站', 'Taoyuan HSR Station', '高铁桃园站'] },
				{ id: 155, name: ['桃園體育園區', 'Taoyuan Sports Park Station', '桃园体育园区'] },
				{ id: 156, name: ['興南', 'Xingnan Station', '兴南'] },
				{ id: 157, name: ['環北', 'Huanbei Station', '环北'] },
				{ id: 158, name: ['老街溪', 'Laojie River Station', '老街溪'] },
			]
		}
	],

	'ce.trans.taichungMetro': [
		{
			id: 'green',
			name: ['台中捷運', 'Taichung Metro', '台中捷运'],
			children: [
				{ id: 160, name: ['北屯總站', 'Beitun Main Station', '北屯总站'] },
				{ id: 161, name: ['舊社', 'Jiushe', '旧社'] },
				{ id: 162, name: ['松竹', 'Songzhu', '松竹'] },
				{ id: 163, name: ['四維國小', 'Sihwei Elementary School', '四维国小'] },
				{ id: 164, name: ['文心崇德', 'Wenxin Chongde', '文心崇德'] },
				{ id: 165, name: ['文心中清', 'Wenxin Zhongqing', '文心中清'] },
				{ id: 166, name: ['文華高中', 'Wenhua Senior High School', '文华高中'] },
				{ id: 167, name: ['文心櫻花', 'Wenxin Yinghua', '文心樱花'] },
				{ id: 168, name: ['市政府', 'Taichung City Hall', '市政府'] },
				{ id: 169, name: ['水安宮', 'Shui-an Temple', '水安宫'] },
				{ id: 170, name: ['文心森林公園', 'Wenxin Forest Park', '文心森林公园'] },
				{ id: 171, name: ['南屯', 'Nantun', '南屯'] },
				{ id: 172, name: ['豐樂公園', 'Feng-le Park', '丰乐公园'] },
				{ id: 173, name: ['大慶', 'Daqing', '大庆'] },
				{ id: 174, name: ['九張犁', 'Jiuzhangli', '九张犁'] },
				{ id: 175, name: ['九德', 'Jiude', '九德'] },
				{ id: 176, name: ['烏日', 'Wuri', '乌日'] },
				{ id: 177, name: ['高鐵臺中站', 'HSR Taichung Station', '高铁台中站'] },
			]
		}
	],

	'ce.trans.allStops' : {
		1: ['動物園', 'Taipei Zoo', '动物园'],
		2: ['木柵', 'Muzha', '木栅'],
		3: ['萬芳社區', 'Wanfang Community', '万芳社区'],
		4: ['萬芳醫院', 'Wanfang Hospital', '万芳医院'],
		5: ['辛亥', 'Xinhai', '辛亥'],
		6: ['麟光', 'Linguang', '麟光'],
		7: ['六張犁', 'Liuzhangli', '六张犁'],
		8: ['科技大樓', 'Technology Building', '科技大楼'],
		9: ['大安', 'Daan', '大安'],
		10: ['忠孝復興', 'Zhongxiao Fuxing', '忠孝复兴'],
		11: ['南京復興', 'Nanjing Fuxing', '南京复兴'],
		12: ['中山國中', 'Zhongshan Junior High School', '中山国中'],
		13: ['松山機場', 'Songshan Airport', '松山机场'],
		14: ['大直', 'Dazhi', '大直'],
		15: ['劍南路', 'Jiannan Rd.', '剑南路'],
		16: ['西湖', 'Xihu', '西湖'],
		17: ['港墘', 'Gangqian', '港墘'],
		18: ['文德', 'Wende', '文德'],
		19: ['內湖', 'Neihu', '内湖'],
		20: ['大湖公園', 'Dahu Park', '大湖公园'],
		21: ['葫洲', 'Huzhou', '葫洲'],
		22: ['東湖', 'Donghu', '东湖'],
		23: ['南港軟體園區', 'Nangang Software Park', '南港软件园区'],
		24: ['南港展覽館', 'Taipei Nangang Exhibition Center', '南港展览馆'],
		25: ['象山', 'Xiangshan', '象山'],
		26: ['台北101/世貿', 'Taipei 101/World Trade Center', '台北101/世贸'],
		27: ['信義安和', 'Xinyi Anhe', '信义安和'],
		28: ['大安', 'Daan', '大安'],
		29: ['大安森林公園', 'Daan Park', '大安森林公园'],
		30: ['東門', 'Dongmen', '东门'],
		31: ['中正紀念堂', 'C.K.S. Memorial Hall', '中正纪念堂'],
		32: ['台大醫院', 'NTU Hospital', '台大医院'],
		33: ['台北車站', 'Taipei Main Station', '台北车站'],
		34: ['中山', 'Zhongshan', '中山'],
		35: ['雙連', 'Shuanglian', '双连'],
		36: ['民權西路', 'Minquan W. Rd.', '民权西路'],
		37: ['圓山', 'Yuanshan', '圆山'],
		38: ['劍潭', 'Jiantan', '剑潭'],
		39: ['士林', 'Shilin', '士林'],
		40: ['芝山', 'Zhishan', '芝山'],
		41: ['明德', 'Mingde', '明德'],
		42: ['石牌', 'Shipai', '石牌'],
		43: ['唭哩岸', 'Qilian', '唭哩岸'],
		44: ['奇岩', 'Qiyan', '奇岩'],
		45: ['北投', 'Beitou', '北投'],
		46: ['新北投', 'Xinbeitou', '新北投'],
		47: ['復興崗', 'Fuxinggang', '复兴岗'],
		48: ['忠義', 'Zhongyi', '忠义'],
		49: ['關渡', 'Guandu', '关渡'],
		50: ['竹圍', 'Zhuwei', '竹围'],
		51: ['紅樹林', 'Hongshulin', '红树林'],
		52: ['淡水', 'Tamsui', '淡水'],
		53: ['新店', 'Xindian', '新店'],
		54: ['新店區公所', 'Xindian District Office', '新店区公所'],
		55: ['七張', 'Qizhang', '七张'],
		56: ['小碧潭', 'Xiaobitan', '小碧潭'],
		57: ['大坪林', 'Dapinglin', '大坪林'],
		58: ['景美', 'Jingmei', '景美'],
		59: ['萬隆', 'Wanlong', '万隆'],
		60: ['公館', 'Gongguan', '公馆'],
		61: ['台電大樓', 'Taipower Building', '台电大楼'],
		62: ['古亭', 'Guting', '古亭'],
		63: ['中正紀念堂', 'C.K.S. Memorial Hall', '中正纪念堂'],
		64: ['小南門', 'Xiaonanmen', '小南门'],
		65: ['西門', 'Ximen', '西门'],
		66: ['北門', 'Beimen', '北门'],
		67: ['中山', 'Zhongshan', '中山'],
		68: ['松江南京', 'Songjiang Nanjing', '松江南京'],
		69: ['南京復興', 'Nanjing Fuxing', '南京复兴'],
		70: ['台北小巨蛋', 'Taipei Arena', '台北小巨蛋'],
		71: ['南京三民', 'Nanjing Sanmin', '南京三民'],
		72: ['松山', 'Songshan', '松山'],
		73: ['南勢角', 'Nanshijiao', '南势角'],
		74: ['景安', 'Jingan', '景安'],
		75: ['永安市場', 'Yongan Market', '永安市场'],
		76: ['頂溪', 'Dingxi', '顶溪'],
		77: ['古亭', 'Guting', '古亭'],
		78: ['東門', 'Dongmen', '东门'],
		79: ['忠孝新生', 'Zhongxiao Xinsheng', '忠孝新生'],
		80: ['松江南京', 'Songjiang Nanjing', '松江南京'],
		81: ['行天宮', 'Xingtian Temple', '行天宫'],
		82: ['中山國小', 'Zhongshan Elementary School', '中山国小'],
		83: ['民權西路', 'Minquan W. Rd.', '民权西路'],
		84: ['大橋頭', 'Daqiaotou', '大桥头'],
		85: ['台北橋', 'Taipei Bridge', '台北桥'],
		86: ['菜寮', 'Cailiao', '菜寮'],
		87: ['三重', 'Sanchong', '三重'],
		88: ['先嗇宮', 'Xianse Temple', '先嗇宫'],
		89: ['頭前庄', 'Touqianzhuang', '头前庄'],
		90: ['新莊', 'Xinzhuang', '新庄'],
		91: ['輔大', 'Fu Jen University', '辅大'],
		92: ['丹鳳', 'Danfeng', '丹凤'],
		93: ['迴龍', 'Huilong', '迴龙'],
		94: ['三重國小', 'Sanchong Elementary School', '三重国小'],
		95: ['三和國中', 'Sanhe Junior High School', '三和国中'],
		96: ['徐匯中學', 'St. Ignatius High School', '徐汇中学'],
		97: ['三民高中', 'Sanmin Senior High School', '三民高中'],
		98: ['蘆洲', 'Luzhou', '芦洲'],
		99: ['頂埔', 'Dingpu', '顶埔'],
		100: ['永寧', 'Yongning', '永宁'],
		101: ['土城', 'Tucheng', '土城'],
		102: ['海山', 'Haishan', '海山'],
		103: ['亞東醫院', 'Far Eastern Hospital', '亚东医院'],
		104: ['府中', 'Fuzhong', '府中'],
		105: ['板橋', 'Banqiao', '板桥'],
		106: ['新埔', 'Xinpu', '新埔'],
		107: ['江子翠', 'Jiangzicui', '江子翠'],
		108: ['龍山寺', 'Longshan Temple', '龙山寺'],
		109: ['西門', 'Ximen', '西门'],
		110: ['台北車站', 'Taipei Main Station', '台北车站'],
		111: ['善導寺', 'Shandao Temple', '善导寺'],
		112: ['忠孝新生', 'Zhongxiao Xinsheng', '忠孝新生'],
		113: ['忠孝復興', 'Zhongxiao Fuxing', '忠孝复兴'],
		114: ['忠孝敦化', 'Zhongxiao Dunhua', '忠孝敦化'],
		115: ['國父紀念館', 'S.Y.S. Memorial Hall', '国父纪念馆'],
		116: ['市政府', 'Taipei City Hall', '市政府'],
		117: ['永春', 'Yongchun', '永春'],
		118: ['後山埤', 'Houshanpi', '后山埤'],
		119: ['昆陽', 'Kunyang', '昆阳'],
		120: ['南港', 'Nangang', '南港'],
		121: ['南港展覽館', 'Taipei Nangang Exhibition Center', '南港展览馆'],
		122: ['大坪林', 'Dapinglin', '大坪林'],
		123: ['十四張', 'Shisizhang', '十四张'],
		124: ['秀朗橋', 'Xiulang Bridge', '秀朗桥'],
		125: ['景平', 'Jingping', '景平'],
		126: ['景安', 'Jingan', '景安'],
		127: ['中和', 'Zhonghe', '中和'],
		128: ['橋和', 'Qiaohe', '桥和'],
		129: ['中原', 'Zhongyuan', '中原'],
		130: ['板新', 'Banxin', '板新'],
		131: ['板橋', 'Banqiao', '板桥'],
		132: ['新埔民生', 'Xinpu Minsheng', '新埔民生'],
		133: ['頭前庄', 'Touqianzhuang', '头前庄'],
		134: ['幸福', 'Xingfu', '幸福'],
		135: ['新北產業園區', 'New Taipei Industrial Park', '新北产业园区'],

		136: ['台北車站', 'Taipei Main Station', '台北车站'],
		137: ['三重', 'Sanchong Station', '三重'],
		138: ['新北產業園區', 'New Taipei Industrial Park Station', '新北产业园区'],
		139: ['新莊副都心', 'Xinzhuang Fuduxin Station', '新庄副都心'],
		140: ['泰山', 'Taishan Station', '泰山'],
		141: ['泰山貴和', 'Taishan Guihe Station', '泰山贵和'],
		142: ['體育大學', 'National Taiwan Sport University Station', '体育大学'],
		143: ['長庚醫院', 'Chang Gung Memorial Hospital Station', '长庚医院'],
		144: ['林口', 'Linkou Station', '林口'],
		145: ['山鼻', 'Shanbi Station', '山鼻'],
		146: ['坑口', 'Kengkou Station', '坑口'],
		147: ['機場第一航廈', 'Airport Terminal 1 Station', '机场第一航厦'],
		148: ['機場第二航廈', 'Airport Terminal 2 Station', '机场第二航厦'],
		150: ['機場旅館', 'Airport Hotel Station', '机场旅馆'],
		151: ['大園', 'Dayuan Station', '大园'],
		152: ['橫山', 'Hengshan Station', '横山'],
		153: ['領航', 'Linghang Station', '领航'],
		154: ['高鐵桃園站', 'Taoyuan HSR Station', '高铁桃园站'],
		155: ['桃園體育園區', 'Taoyuan Sports Park Station', '桃园体育园区'],
		156: ['興南', 'Xingnan Station', '兴南'],
		157: ['環北', 'Huanbei Station', '环北'],
		158: ['老街溪', 'Laojie River Station', '老街溪'],

		160: ['北屯總站', 'Beitun Main Station', '北屯总站'],
		161: ['舊社', 'Jiushe', '旧社'],
		162: ['松竹', 'Songzhu', '松竹'],
		163: ['四維國小', 'Sihwei Elementary School', '四维国小'],
		164: ['文心崇德', 'Wenxin Chongde', '文心崇德'],
		165: ['文心中清', 'Wenxin Zhongqing', '文心中清'],
		166: ['文華高中', 'Wenhua Senior High School', '文华高中'],
		167: ['文心櫻花', 'Wenxin Yinghua', '文心樱花'],
		168: ['市政府', 'Taichung City Hall', '市政府'],
		169: ['水安宮', 'Shui-an Temple', '水安宫'],
		170: ['文心森林公園', 'Wenxin Forest Park', '文心森林公园'],
		171: ['南屯', 'Nantun', '南屯'],
		172: ['豐樂公園', 'Feng-le Park', '丰乐公园'],
		173: ['大慶', 'Daqing', '大庆'],
		174: ['九張犁', 'Jiuzhangli', '九张犁'],
		175: ['九德', 'Jiude', '九德'],
		176: ['烏日', 'Wuri', '乌日'],
		177: ['高鐵臺中站', 'HSR Taichung Station', '高铁台中站'],

  		178: ['南港', 'Nangang', '南港'],
		179: ['台北', 'Taipei', '台北'],
		180: ['板橋', 'Banqiao', '板桥'],
		181: ['桃園', 'Taoyuan', '桃园'],
		182: ['新竹', 'Hsinchu', '新竹'],
		183: ['苗栗', 'Miaoli', '苗栗'],
		184: ['台中', 'Taichung', '台中'],
		185: ['彰化', 'Changhua', '彰化'],
		186: ['雲林', 'Yunlin', '云林'],
		187: ['嘉義', 'Chiayi', '嘉义'],
		188: ['台南', 'Tainan', '台南'],
		189: ['左營', 'Zuoying', '左营']
	},

	'ce.factorRule.note': {
		'1': ['台灣高速鐵路', 'Taiwan High-Speed Rail', '台湾高铁'],
		'2': ['國內/國際航線', 'Domestic / International Flights', '国内/国际航线']
	},

	'ce.factorRule.unit': {
		'1': ['kgCO2e/pkm', 'kgCO2e/pkm', 'kgCO2e/pkm'],
		'2': ['kgCO2e', 'kgCO2e', 'kgCO2e']
	},

	'ce.emp.fillStatus': {
		'0': ['未填寫', 'Unfilled', '未填写'],
		'1': ['已填寫', 'Filled', '已填写'],
	},

	'global.adjustType': {
		'0': ['不調整', 'Not adjusted', '不调整'],
		'1': ['加', 'plus', '加'],
		'2': ['減', 'Less', '减']
	},
	'global.and_or': {
		'OR': ['或', 'or', '或'],
		'AND': ['且', 'and', '且']
	},
	'global.boolean': {
		'1': ['是', 'Yes', '是'],
		'0': ['否', 'No', '否']
	},
	'global.isOpen': {
		'1': ['開啟','Turn on','开启'],
		'0': ['關閉','Shut down','关闭']
	},
	'global.isAllow': {
		'1': ['允許','allow','允许'],
		'0': ['不允許','Not allowed','不允许']
	},
	'global.isNeed': {
		'1': ['需要','need','需要'],
		'0': ['不需要','No need','不需要']
	},
	'global.isDeduct': {
		'1': ['計入','deduct','计入'],
		'0': ['不計入','No deduct','不计入']
	},
	'global.isShow': {
		'1': ['顯示','Show','显示'],
		'0': ['不顯示','Do not show','不显示']
	},
	'global.isPrint': {
		'1': ['列印','Print','列印'],
		'0': ['不列印','Not print','不列印']
	},
	'global.isNotify': {
		'1': ['通知','Notice','通知'],
		'0': ['不通知','No notice','不通知']
	},
	'global.isNotify._sort': [1, 0],
	'global.isReport': {
		'1': ['已申報','Declared','已申报'],
		'0': ['未申報','Undeclared','未申报']
	},
	'global.calSum': {
		'0': ['先將小數點X再加總', 'First add the decimal point X', '先将小数点X再加总'],
		'1': ['先加總再將小數點X', 'Add the total number of points to X', '先加总再将小数点X']
	},
	'global.changeType': {
		'BEFORE': ['調整前', 'before', '调整前'],
		'AFTER': ['調整後', 'after', '调整后']
	},
	'global.isAgentSign': {
		'1': ['需簽核', 'Need to sign off', '需签核'],
		'0': ['不需簽核', 'No sign-off required', '不需签核']
	},
	'global.currency': {
		'TWD': ['新台幣','TWD','新台币'],
		'AUD': ['澳幣','AUD','澳币'],
		'CAD': ['加拿大幣','CAD','加拿大币'],
		'CHF': ['瑞士法郎','CHF','瑞士法郎'],
		'CNY': ['人民幣','CNY','人民币'],
		'EUR': ['歐元','EUR','欧元'],
		'GBP': ['英鎊','GBP','英镑'],
		'HKD': ['港幣','HKD','港币'],
		'IDR': ['印尼幣','IDR','印尼币'],
		'JPY': ['日圓','JPY','日圆'],
		'KRW': ['韓元','KRW','韩元'],
		'MYR': ['馬來幣','MYR','马来币'],
		'NZD': ['紐元','NZD','纽元'],
		'PGK': ['吉納','PGK','吉纳'],
		'PHP': ['菲國比索','PHP','菲国比索'],
		'SEK': ['瑞典幣','SEK','瑞典币'],
		'SGD': ['新加坡幣','SGD','新加坡币'],
		'THB': ['泰幣','THB','泰币'],
		'USD': ['美金','USD','美金'],
		'VND': ['越南盾','VND','越南盾'],
		'ZAR': ['南非幣','ZAR','南非币']
	},
	'global.currency.maxDecimal': {
		'AUD': ['2','2','2'],
		'CAD': ['2','2','2'],
		'CHF': ['2','2','2'],
		'CNY': ['1','1','1'],
		'EUR': ['2','2','2'],
		'GBP': ['2','2','2'],
		'HKD': ['1','1','1'],
		'IDR': ['0','0','0'],
		'JPY': ['0','0','0'],
		'KRW': ['0','0','0'],
		'MYR': ['2','2','2'],
		'NZD': ['2','2','2'],
		'PGK': ['2','2','2'],
		'PHP': ['2','2','2'],
		'SEK': ['2','2','2'],
		'SGD': ['2','2','2'],
		'THB': ['2','2','2'],
		'TWD': ['0','0','0'],
		'USD': ['2','2','2'],
		'VND': ['0','0','0'],
		'ZAR': ['2','2','2']
	},
	'global.dateTimeUnit': {
		'year': ['年', 'year', '年'],
		'month': ['月', 'month', '月'],
		'week': ['週', 'week', '周'],
		'workday': ['工作天', 'workday', '工作日'],
		'day': ['日', 'day', '日'],
		'hour': ['小時', 'hour', '小时'],
		'minute': ['分', 'minute', '分'],
		'second': ['秒', 'second', '秒']
	},
	'global.day': {
		'1': ['1日', '1st', '1日'],
		'2': ['2日', '2nd', '2日'],
		'3': ['3日', '3rd', '3日'],
		'4': ['4日', '4th', '4日'],
		'5': ['5日', '5th', '5日'],
		'6': ['6日', '6th', '6日'],
		'7': ['7日', '7th', '7日'],
		'8': ['8日', '8th', '8日'],
		'9': ['9日', '9th', '9日'],
		'10': ['10日', '10th', '10日'],
		'11': ['11日', '11th', '11日'],
		'12': ['12日', '12th', '12日'],
		'13': ['13日', '13th', '13日'],
		'14': ['14日', '14th', '14日'],
		'15': ['15日', '15th', '15日'],
		'16': ['16日', '16th', '16日'],
		'17': ['17日', '17th', '17日'],
		'18': ['18日', '18th', '18日'],
		'19': ['19日', '19th', '19日'],
		'20': ['20日', '20th', '20日'],
		'21': ['21日', '21st', '21日'],
		'22': ['22日', '22nd', '22日'],
		'23': ['23日', '23rd', '23日'],
		'24': ['24日', '24th', '24日'],
		'25': ['25日', '25th', '25日'],
		'26': ['26日', '26th', '26日'],
		'27': ['27日', '27th', '27日'],
		'28': ['28日', '28th', '28日'],
		'29': ['29日', '29th', '29日'],
		'30': ['30日', '30th', '30日'],
		'31': ['31日', '31st', '31日'],
		'99': ['月底', 'End of month', '月底']
	},
	'global.day.add': {
		'1': ['第1日', 'Day 1', '第1日'],
		'2': ['第2日', 'Day 2', '第2日'],
		'3': ['第3日', 'Day 3', '第3日'],
		'4': ['第4日', 'Day 4', '第4日'],
		'5': ['第5日', 'Day 5', '第5日'],
		'6': ['第6日', 'Day 6', '第6日'],
		'7': ['第7日', 'Day 7', '第7日'],
		'8': ['第8日', 'Day 8', '第8日'],
		'9': ['第9日', 'Day 9', '第9日'],
		'10': ['第10日', 'Day 10', '第10日'],
		'11': ['第11日', 'Day 11', '第11日'],
		'12': ['第12日', 'Day 12', '第12日'],
		'13': ['第13日', 'Day 13', '第13日'],
		'14': ['第14日', 'Day 14', '第14日'],
		'15': ['第15日', 'Day 15', '第15日'],
		'16': ['第16日', 'Day 16', '第16日'],
		'17': ['第17日', 'Day 17', '第17日'],
		'18': ['第18日', 'Day 18', '第18日'],
		'19': ['第19日', 'Day 19', '第19日'],
		'20': ['第20日', 'Day 20', '第20日'],
		'21': ['第21日', 'Day 21', '第21日'],
		'22': ['第22日', 'Day 22', '第22日'],
		'23': ['第23日', 'Day 23', '第23日'],
		'24': ['第24日', 'Day 24', '第24日'],
		'25': ['第25日', 'Day 25', '第25日'],
		'26': ['第26日', 'Day 26', '第26日'],
		'27': ['第27日', 'Day 27', '第27日'],
		'28': ['第28日', 'Day 28', '第28日'],
		'29': ['第29日', 'Day 29', '第29日'],
		'30': ['第30日', 'Day 30', '第30日'],
		'99': ['最後一日', 'The last day', '最後一日']
	},
	'global.day28': {
		'1': ['1日', '1 day', '1日'],
		'2': ['2日', '2 days', '2日'],
		'3': ['3日', '3 days', '3日'],
		'4': ['4日', '4 days', '4日'],
		'5': ['5日', '5 days', '5日'],
		'6': ['6日', '6 days', '6日'],
		'7': ['7日', '7 days', '7日'],
		'8': ['8日', '8 days', '8日'],
		'9': ['9日', '9 days', '9日'],
		'10': ['10日', '10 days', '10日'],
		'11': ['11日', '11 days', '11日'],
		'12': ['12日', '12 days', '12日'],
		'13': ['13日', '13th', '13日'],
		'14': ['14日', '14 days', '14日'],
		'15': ['15日', '15 days', '15日'],
		'16': ['16日', '16th', '16日'],
		'17': ['17日', '17 days', '17日'],
		'18': ['18日', '18 days', '18日'],
		'19': ['19日', '19 days', '19日'],
		'20': ['20日', '20 days', '20日'],
		'21': ['21日', '21 days', '21日'],
		'22': ['22日', '22 days', '22日'],
		'23': ['23日', '23 days', '23日'],
		'24': ['24日', '24 days', '24日'],
		'25': ['25日', '25 days', '25日'],
		'26': ['26日', '26 days', '26日'],
		'27': ['27日', '27 days', '27日'],
		'28': ['28日', '28 days', '28日']
	},
	'global.dayWithZero': {
		'0': ['0日', '0 day', '0日'],
		'1': ['1日', '1 day', '1日'],
		'2': ['2日', '2 days', '2日'],
		'3': ['3日', '3 days', '3日'],
		'4': ['4日', '4 days', '4日'],
		'5': ['5日', '5 days', '5日'],
		'6': ['6日', '6 days', '6日'],
		'7': ['7日', '7 days', '7日'],
		'8': ['8日', '8 days', '8日'],
		'9': ['9日', '9 days', '9日'],
		'10': ['10日', '10 days', '10日'],
		'11': ['11日', '11 days', '11日'],
		'12': ['12日', '12 days', '12日'],
		'13': ['13日', '13th', '13日'],
		'14': ['14日', '14 days', '14日'],
		'15': ['15日', '15 days', '15日'],
		'16': ['16日', '16th', '16日'],
		'17': ['17日', '17 days', '17日'],
		'18': ['18日', '18 days', '18日'],
		'19': ['19日', '19 days', '19日'],
		'20': ['20日', '20 days', '20日'],
		'21': ['21日', '21 days', '21日'],
		'22': ['22日', '22 days', '22日'],
		'23': ['23日', '23 days', '23日'],
		'24': ['24日', '24 days', '24日'],
		'25': ['25日', '25 days', '25日'],
		'26': ['26日', '26 days', '26日'],
		'27': ['27日', '27 days', '27日'],
		'28': ['28日', '28 days', '28日'],
		'29': ['29日', '29 days', '29日'],
		'30': ['30日', '30 days', '30日']
	},
	'global.hour': {
		'0': ['00', '00', '00'],
		'1': ['01', '01', '01'],
		'2': ['02', '02', '02'],
		'3': ['03', '03', '03'],
		'4': ['04', '04', '04'],
		'5': ['05', '05', '05'],
		'6': ['06', '06', '06'],
		'7': ['07', '07', '07'],
		'8': ['08', '08', '08'],
		'9': ['09', '09', '09'],
		'10': ['10', '10', '10'],
		'11': ['11', '11', '11'],
		'12': ['12', '12', '12'],
		'13': ['13', '13', '13'],
		'14': ['14', '14', '14'],
		'15': ['15', '15', '15'],
		'16': ['16', '16', '16'],
		'17': ['17', '17', '17'],
		'18': ['18', '18', '18'],
		'19': ['19', '19', '19'],
		'20': ['20', '20', '20'],
		'21': ['21', '21', '21'],
		'22': ['22', '22', '22'],
		'23': ['23', '23', '23'],
	},
	'global.minute': {
		'0': ['00', '00', '00'],
		'1': ['01', '01', '01'],
		'2': ['02', '02', '02'],
		'3': ['03', '03', '03'],
		'4': ['04', '04', '04'],
		'5': ['05', '05', '05'],
		'6': ['06', '06', '06'],
		'7': ['07', '07', '07'],
		'8': ['08', '08', '08'],
		'9': ['09', '09', '09'],
		'10': ['10', '10', '10'],
		'11': ['11', '11', '11'],
		'12': ['12', '12', '12'],
		'13': ['13', '13', '13'],
		'14': ['14', '14', '14'],
		'15': ['15', '15', '15'],
		'16': ['16', '16', '16'],
		'17': ['17', '17', '17'],
		'18': ['18', '18', '18'],
		'19': ['19', '19', '19'],
		'20': ['20', '20', '20'],
		'21': ['21', '21', '21'],
		'22': ['22', '22', '22'],
		'23': ['23', '23', '23'],
		'24': ['24', '24', '24'],
		'25': ['25', '25', '25'],
		'26': ['26', '26', '26'],
		'27': ['27', '27', '27'],
		'28': ['28', '28', '28'],
		'29': ['29', '29', '29'],
		'30': ['30', '30', '30'],
		'31': ['31', '31', '31'],
		'32': ['32', '32', '32'],
		'33': ['33', '33', '33'],
		'34': ['34', '34', '34'],
		'35': ['35', '35', '35'],
		'36': ['36', '36', '36'],
		'37': ['37', '37', '37'],
		'38': ['38', '38', '38'],
		'39': ['39', '39', '39'],
		'40': ['40', '40', '40'],
		'41': ['41', '41', '41'],
		'42': ['42', '42', '42'],
		'43': ['43', '43', '43'],
		'44': ['44', '44', '44'],
		'45': ['45', '45', '45'],
		'46': ['46', '46', '46'],
		'47': ['47', '47', '47'],
		'48': ['48', '48', '48'],
		'49': ['49', '49', '49'],
		'50': ['50', '50', '50'],
		'51': ['51', '51', '51'],
		'52': ['52', '52', '52'],
		'53': ['53', '53', '53'],
		'54': ['54', '54', '54'],
		'55': ['55', '55', '55'],
		'56': ['56', '56', '56'],
		'57': ['57', '57', '57'],
		'58': ['58', '58', '58'],
		'59': ['59', '59', '59'],
	},
	'global.decimals': {
		'1': ['1', '1', '1'],
		'2': ['2', '2', '2'],
		'3': ['3', '3', '3'],
		'4': ['4', '4', '4'],
		'5': ['5', '5', '5'],
		'6': ['6', '6', '6'],
		'7': ['7', '7', '7'],
		'8': ['8', '8', '8']
	},
	'global.groupRuleLevel': {
		'1': ['第一層', 'Level 1', '第一层'],
		'2': ['第二層', 'Level 2', '第二层'],
		'3': ['第三層', 'Level 3', '第三层'],
		'9': ['排除對象', 'Exclude', '排除对象'],
		'4': ['第四層', 'Level 4', '第四层'],
		'5': ['第五層', 'Level 5', '第五层']
	},
	'global.groupRuleType': {
		'CO': ['公司 ','the company ','公司'],
		'DEPT': ['部門','Department','部门'],
		'WORK_STATUS': ['在職狀況','Working status','在职状况'],
		'HIRE_DATE': ['到職日期','Duty date','到职日期'],
		'QUIT_DATE': ['離職日期','Date of departure','离职日期'],
		'STOP_DATE': ['留職停薪日期','No payroll date','留职停薪日期'],
		'SNO': ['扣繳單位','Withholding unit','扣缴单位'],
		'LABOR_NO': ['勞保統編','Labor insurance system compiled','劳保统编'],
		'HEALTH_NO': ['健保統編','Health insurance system','健保统编'],
		'JOB': ['職位','position','职位'],
		'GRADE': ['職等','Grade','职等'],
		'LEVEL': ['職等/職級','Grade / rank','职等/职级'],
		'JOB_CAT': ['職務類別','Job category','职务类别'],
		'JOB_STYLE': ['職種','Type of job','职种'],
		'IDENTITY': ['身分類別','Identity category','身分类别'],
		'EMP_TYPE': ['直間接別','Straight away','直间接别'],
		'RESPOBILITY': ['責任區分','Responsibility distinction','责任区分'],
		'HEADCOUNT_STATUS': ['編制狀況','Preparation status','编制状况'],
		'NATIONALITY': ['國籍','Country','国籍'],
		'AREA': ['工作區域','Work area','工作区域'],
		'SITE': ['工作區域/地點','Work area / location','工作区域/地点'],
		'FACTORY': ['廠別','Site','厂别'],
		'SHIFT_TYPE': ['班別屬性','Class attribute','班别属性'],
		'SHIFT': ['班別','Class','班别'],
		'PROBATION': ['試用期滿狀態','Trial expired status','试用期满状态'],
		'SALARY_TYPE': ['計薪方式','Ways to pay','计薪方式'],
		'GENDER': ['性別','gender','性别'],
		'AGE': ['年齡','age','年龄'],
		'WORKYEAR': ['年資','Years','年资'],
		'EMP': ['員工','Employee','员工'],
		'EMP_RANGE': ['員工編號起訖','Staff number from the beginning','员工编号起讫'],
		'CARDNO_RANGE': ['員工卡號起訖','Staff card number from the beginning','员工卡号起讫'],
		'LIVE_ADDRESS': ['戶籍地址地區','Household address area','户籍地址地区'],
		'CONTACT_ADDRESS': ['通訊地址地區','Mailing address area','通讯地址地区']
	},
	'global.isAdjustment': {
		'0': ['不調整', 'Not adjusted', '不调整'],
		'1': ['調整為', 'adjust to', '调整为']
	},
	'global.isStart': {
		'1': ['啟用', 'Enable', '启用'],
		'0': ['不啟用', 'Not enabled', '不启用']
	},
	'global.language': {
		'zh_TW': ['繁體中文', 'traditional Chinese', '繁体中文'],
		'en_US': ['英文', 'English', '英文'],
		'zh_CN': ['簡體中文', 'Simplified Chinese', '简体中文']
	},
	'global.languageSelect': {0: '繁體中文',1: 'English',2: '简体中文'},
	'global.logic': {
		'<': ['小於', 'Less than', '小于'],
		'<=': ['小於等於', 'Less than or equal to', '小于等于'],
		'>': ['大於', 'more than the', '大于'],
		'>=': ['大於等於', 'greater or equal to', '大于等于']
	},
	'global.logic2': { //注：順序在 global.logic2._sort
		'1': ['包含', 'contain', '包含'],
		'0': ['排除', 'exclude', '排除']
	},
	'global.logic2._sort': [1, 0],
	'global.logic3': {
		'>': ['大於', 'more than the', '大于'],
		'>=': ['大於等於', 'greater or equal to', '大于等于'],
		'=': ['等於', 'equal', '等于'],
		'<=': ['小於等於', 'Less than or equal to', '小于等于'],
		'<': ['小於', 'Less than', '小于']
	},
	'global.messageIcon': {
		'success': ['成功', 'success', '成功'],
		'warning': ['警告', 'caveat', '警告'],
		'error': ['錯誤', 'error', '错误'],
		'custom': ['自訂', 'Customize', '自订']
	},
	'global.messageType': {
		'okonly': ['僅顯示 [確定] 按鈕', 'Only the [OK] button is displayed', '仅显示 [确定] 按钮'],
		'okcancel': ['顯示 [確定] 和 [取消] 按鈕', 'The [OK] and [Cancel] buttons are displayed', '显示 [确定] 和 [取消] 按钮'],
		'abortretryignore': ['顯示 [中止]、[重試] 和 [忽略] 按鈕', 'The [Abort], [Retry], and [Ignore] buttons are displayed', '显示 [中止]、[重试] 和 [忽略] 按钮'],
		'yesnocancel': ['顯示 [是]、[否] 和 [取消] 按鈕', 'The [Yes], [No], and [Cancel] buttons are displayed', '显示 [是]、[否] 和 [取消] 按钮'],
		'yesno': ['顯示 [是] 和 [否] 按鈕', 'The [Yes] and [No] buttons are displayed', '显示 [是] 和 [否] 按钮'],
		'retrycancel': ['顯示 [重試] 和 [取消] 按鈕', 'The [Retry] and [Cancel] buttons are displayed', '显示 [重试] 和 [取消] 按钮']
	},
	'global.month': {
		'1': ['1月', 'January', '1月'],
		'2': ['2月', 'February', '2月'],
		'3': ['3月', 'March', '3月'],
		'4': ['4月', 'April', '4月'],
		'5': ['5月', 'May', '5月'],
		'6': ['6月', 'June', '6月'],
		'7': ['7月', 'July', '7月'],
		'8': ['8月', 'August', '8月'],
		'9': ['9月', 'September', '9月'],
		'10': ['10月', 'October', '10月'],
		'11': ['11月', 'November', '11月'],
		'12': ['12月', 'December', '12月']
	},
	'global.monthWithZero': {
		'0': ['0月', 'zero', '0月'],
		'1': ['1月', 'January', '1月'],
		'2': ['2月', 'February', '2月'],
		'3': ['3月', 'March', '3月'],
		'4': ['4月', 'April', '4月'],
		'5': ['5月', 'May', '5月'],
		'6': ['6月', 'June', '6月'],
		'7': ['7月', 'July', '7月'],
		'8': ['8月', 'August', '8月'],
		'9': ['9月', 'September', '9月'],
		'10': ['10月', 'October', '10月'],
		'11': ['11月', 'November', '11月'],
		'12': ['12月', 'December', '12月']
	},
	'global.objectTarget': {
		'0': ['全體員工', 'All employees', '全体员工'],
		'1': ['特定員工', 'Specific staff', '特定员工']
	},
	'global.operation': {
		'>': ['大於', 'more than the', '大于'],
		'>=': ['大於等於', 'greater or equal to', '大于等于'],
		'=': ['等於', 'equal', '等于'],
		'<=': ['小於等於', 'Less than or equal to', '小于等于'],
		'<': ['小於', 'Less than', '小于']
	},
	'global.overdue': {
		'1': ['已逾期', 'Overdue', '已逾期'],
		'0': ['未逾期', 'Not overdue', '未逾期']
	},
	'global.round': {
		'0': ['四捨五入', 'rounding', '四舍五入'],
		'1': ['無條件捨去', 'Quit unconditionally', '无条件舍去'],
		'2': ['無條件進位', 'Unconditional carry', '无条件进位']
	},
	'global.success': {
		'1': ['成功', 'Success', '成功'],
		'0': ['失敗', 'Failure', '失败']
	},
	'global.timeZone': {
		'Asia/Taipei': ['亞洲/台北(+08:00)', 'Asia/Taipei(+08:00)', '亚洲/台北(+08:00)'],
		'Asia/Ho_Chi_Minh': ['亞洲/胡志明(+07:00)', 'Asia/Ho_Chi_Minh(+07:00)', '亚洲/胡志明(+07:00)'],
		'Asia/Bangkok': ['亞洲/曼谷(+07:00)', 'Asia/Bangkok(+07:00)', '亚洲/曼谷(+07:00)'],
		'Asia/Shanghai': ['亞洲/上海(+08:00)', 'Asia/Shanghai(+08:00)', '亚洲/上海(+08:00)'],
		'Asia/Kuala_Lumpur': ['亞洲/吉隆坡(+08:00)', 'Asia/Kuala_Lumpur(+08:00)', '亚洲/吉隆坡(+08:00)'],
		'Asia/Tokyo': ['亞洲/東京(+09:00)', 'Asia/Tokyo(+09:00)', '亚洲/东京(+09:00)'],
		'Asia/Seoul': ['亞洲/首爾(+09:00)', 'Asia/Seoul(+09:00)', '亚洲/首尔(+09:00)'],
		'Europe/London': ['歐洲/倫敦(+00:00)', 'Europe/London(+00:00)', '欧洲/伦敦(+00:00)'],
		'US/Hawaii': ['美國/夏威夷(-10:00)', 'US/Hawaii(-10:00)', '美国/夏威夷(-10:00)'],
		'US/Alaska': ['美國/阿拉斯加(-09:00)', 'US/Alaska(-09:00)', '美国/阿拉斯加(-09:00)'],
		'US/Arizona': ['美國/亞利桑那(-07:00)', 'US/Arizona(-07:00)', '美国/亚利桑那(-07:00)'],
		'US/Central': ['美國/中部(-06:00)', 'US/Central(-06:00)', '美国/中部(-06:00)'],
		'US/Eastern': ['美國/東部(-05:00)', 'US/Eastern(-05:00)', '美国/东部(-05:00)'],
		'Asia/Kolkata': ['亞洲/印度(-02:30)', 'Asia/Kolkata(-02:30)', '亚洲/印度(-02:30)'],
		'America/Los_Angeles': ['美國/洛杉磯(-08:00)', 'America/Los_Angeles(-08:00)', '美国/洛杉矶(-08:00)'],
		'Atlantic/Azores': ['大西洋/亞速爾群島(-01:00)', 'Atlantic/Azores(-01:00)', '大西洋/亚速尔群岛(-01:00)'],
        'Europe/Berlin': ['歐洲/柏林(+01:00)', 'Europe/Berlin(+01:00)', '欧洲/柏林(+01:00)'],
        'Europe/Vilnius': ['歐洲/立陶宛(+02:00)', 'Europe/Vilnius(+02:00)', '欧洲/立陶宛(+02:00)'],
        'Australia/Sydney': ['澳洲/雪梨(+10:00)', 'Australia/Sydney(+10:00)', '澳洲/悉尼(+10:00)'],
        'Pacific/Guadalcanal': ['太平洋/瓜達康納爾(+11:00)', 'Pacific/Guadalcanal(+11:00)', '太平洋/瓜达康纳尔(+11:00)']
	},
	'global.usedStatus': {
		'1': ['使用中', 'In use', '使用中'],
		'0': ['停用', 'Deactivated', '停用']
	},
	'am.otRule.usedStatus': {
		'2': ['未完成', 'Undone', '未完成'],
		'1': ['使用中', 'Using', '使用中'],
		'0': ['停用', 'Disabled', '停用']
	},
	'global.useStatus': {
		'1': ['使用中', 'Using', '使用中'],
		'2': ['已過期', 'expired', '已过期'],
		'3': ['未生效', 'Not active', '未生效']
	},
	'global.effected': {
		0: ['未生效', 'uneff', '未生效'],
		1: ['已生效', 'eff', '已生效'],
	},
	'global.week': {
		'0': ['星期一', 'Mon.', '星期一'],
		'1': ['星期二', 'Tue.', '星期二'],
		'2': ['星期三', 'Wed.', '星期三'],
		'3': ['星期四', 'Thur.', '星期四'],
		'4': ['星期五', 'Fri.', '星期五'],
		'5': ['星期六', 'Sat.', '星期六'],
		'6': ['星期日', 'Sun.', '星期日']
	},
	'global.weekWithNationalHoliday': {
		'0': ['星期一', 'Mon.', '星期一'],
		'1': ['星期二', 'Tue.', '星期二'],
		'2': ['星期三', 'Wed.', '星期三'],
		'3': ['星期四', 'Thur.', '星期四'],
		'4': ['星期五', 'Fri.', '星期五'],
		'5': ['星期六', 'Sat.', '星期六'],
		'6': ['星期日', 'Sun.', '星期日'],
		'7': ['國定假日', 'National Holiday', '国定假日']
	},
	'global.weekAbbr': {
		'0': ['一', 'Mon.', '一'],
		'1': ['二', 'Tue.', '二'],
		'2': ['三', 'Wed.', '三'],
		'3': ['四', 'Thur.', '四'],
		'4': ['五', 'Fri.', '五'],
		'5': ['六', 'Sat.', '六'],
		'6': ['日', 'Sun.', '日']
	},
	'global.weekAbbrWithNationalHoliday': {
		'0': ['一', 'Mon.', '一'],
		'1': ['二', 'Tue.', '二'],
		'2': ['三', 'Wed.', '三'],
		'3': ['四', 'Thur.', '四'],
		'4': ['五', 'Fri.', '五'],
		'5': ['六', 'Sat.', '六'],
		'6': ['日', 'Sun.', '日'],
		'7': ['國定假日', 'National Holiday', '国定假日']
	},
	'global.withData': {
		'0': ['無', 'No', '无'],
		'1': ['有', 'Yes', '有']
	},
	'global.reportMergeCell': {
		'0': ['不合併儲存格','Do not merge cells','不合并储存格'],
		'1': ['合併儲存格','Merge cells','合并储存格']
	},
	'global.reportDownload': {
		'1': ['合併為一個檔案','Merge into one file','合并为一个档案'],
		'2': ['多個檔案','Multiple files','多个档案']
	},
	'global.reportPassword': {
		'1': ['電子薪資袋密碼','Electronic salary bag password','电子薪资袋密码'],
		'2': ['身分證號/統一編號','Identity Card / Uniform Number','身分证号/统一编号'],
		'3': ['不需密碼','No password required','不需密码']
	},
	'global.reportSortType1': {
		'1': ['員工編號','employee number','员工编号'],
		'2': ['部門','department','部门'],
		'3': ['工作區域/地點','Work area / location','工作区域/地点'],
		'4': ['扣繳統編','Withholding Editor','扣缴统编']
	},
	'global.isCal': {
		'1': ['列入計算','included in the calculation','列入计算'],
		'0': ['不列入計算','not counted','不列入计算']
	},
	'os.branchCode': {
		'1': ['總機構', 'Head office', '总机构'],
		'2': ['分支機構', 'Branch office', '分支机构']
	},
	'os.company.levelName': {
		'000': ['公司', 'company', '公司']
	},
	'os.healthBranch': {
		'1': ['臺北業務組', '', ''],
		'2': ['北區業務組', '', ''],
		'3': ['中區業務組', '', ''],
		'4': ['南區業務組', '', ''],
		'5': ['高屏業務組', '', ''],
		'6': ['東區業務組', '', '']
	},
	'os.laborNotes': {
		'Y': ['Y 適用 ( 適用勞基法單位，惟部分人員不適用 )', '', ''],
		'YP': ['YP 特定勞工適用 ( 私立學校 )', '', ''],
		'YN': ['YN 適用，不提繳 ( 適用勞基法單位，惟不提繳勞退 )', '', ''],
		'G': ['G 特定勞工適用 ( 政府機關，特定勞工適用勞基法 )', '', ''],
		' ': ['( 空白 ) 不適用 ( 不適用勞基法單位 )', '', ''],
		'NP': ['NP 不適用，要提繳 ( 不適用勞基法單位，惟單位來函申請自願提繳 )', '', '']
	},
	'os.leader.status': {
		'1': ['兼職', 'Part-time', '兼职'],
		'2': ['代理', 'proxy', '代理']
	},
	'os.leader.type': {
		'1': ['主管', 'Supervisor', '主管'],
		'2': ['副主管', 'Deputy Head', '副主管']
	},
	'os.taxInstitute': {
		'A03': ['財政部臺北國稅局信義分局', '', ''],
		'A04': ['財政部臺北國稅局北投稽徵所', '', ''],
		'A05': ['財政部臺北國稅局', '', ''],
		'A07': ['財政部臺北國稅局大同稽徵所', '', ''],
		'A08': ['財政部臺北國稅局中北稽徵所', '', ''],
		'A09': ['財政部臺北國稅局萬華稽徵所', '', ''],
		'A10': ['財政部臺北國稅局中正分局', '', ''],
		'A11': ['財政部臺北國稅局松山分局', '', ''],
		'A12': ['財政部臺北國稅局南港稽徵所', '', ''],
		'A13': ['財政部臺北國稅局文山稽徵所', '', ''],
		'A14': ['財政部臺北國稅局大安分局', '', ''],
		'A15': ['財政部臺北國稅局中南稽徵所', '', ''],
		'A16': ['財政部臺北國稅局士林稽徵所', '', ''],
		'A72': ['財政部臺北國稅局內湖稽徵所', '', ''],
		'B01': ['財政部中區國稅局', '', ''],
		'B47': ['財政部中區國稅局東山稽徵所', '', ''],
		'B48': ['財政部中區國稅局民權稽徵所', '', ''],
		'B49': ['財政部中區國稅局臺中分局', '', ''],
		'B50': ['財政部中區國稅局豐原分局', '', ''],
		'B51': ['財政部中區國稅局沙鹿稽徵所', '', ''],
		'B52': ['財政部中區國稅局大屯稽徵所', '', ''],
		'B53': ['財政部中區國稅局東勢稽徵所', '', ''],
		'B58': ['財政部中區國稅局大智稽徵所', '', ''],
		'C01': ['財政部北區國稅局基隆分局', '', ''],
		'C02': ['財政部北區國稅局七堵稽徵所(停用)', '', ''],
		'C03': ['財政部北區國稅局信義稽徵所', '', ''],
		'D01': ['財政部南區國稅局', '', ''],
		'D70': ['財政部南區國稅局臺南分局', '', ''],
		'D71': ['財政部南區國稅局安南稽徵所', '', ''],
		'D73': ['財政部南區國稅局新營分局', '', ''],
		'D74': ['財政部南區國稅局新化稽徵所', '', ''],
		'D75': ['財政部南區國稅局佳里稽徵所', '', ''],
		'E01': ['財政部高雄國稅局', '', ''],
		'E02': ['財政部高雄國稅局新興稽徵所', '', ''],
		'E03': ['財政部高雄國稅局鹽埕稽徵所', '', ''],
		'E04': ['財政部高雄國稅局苓雅稽徵所', '', ''],
		'E05': ['財政部高雄國稅局高雄加工出口區稽徵所(停用)', '', ''],
		'E06': ['財政部高雄國稅局鼓山稽徵所', '', ''],
		'E07': ['財政部高雄國稅局楠梓稽徵所', '', ''],
		'E08': ['財政部高雄國稅局前鎮稽徵所', '', ''],
		'E09': ['財政部高雄國稅局楠梓加工出口區稽徵所(停用)', '', ''],
		'E10': ['財政部高雄國稅局三民分局', '', ''],
		'E11': ['財政部高雄國稅局小港稽徵所', '', ''],
		'E12': ['財政部高雄國稅局左營稽徵所', '', ''],
		'E83': ['財政部高雄國稅局鳳山分局', '', ''],
		'E84': ['財政部高雄國稅局旗山稽徵所', '', ''],
		'E85': ['財政部高雄國稅局岡山稽徵所', '', ''],
		'F28': ['財政部北區國稅局汐止稽徵所', '', ''],
		'F30': ['財政部北區國稅局板橋分局', '', ''],
		'F31': ['財政部北區國稅局三重稽徵所', '', ''],
		'F32': ['財政部北區國稅局淡水稽徵所', '', ''],
		'F33': ['財政部北區國稅局新店稽徵所', '', ''],
		'F34': ['財政部北區國稅局瑞芳服務處', '', ''],
		'F35': ['財政部北區國稅局中和稽徵所', '', ''],
		'F36': ['財政部北區國稅局新莊稽徵所', '', ''],
		'G36': ['財政部北區國稅局宜蘭分局', '', ''],
		'G37': ['財政部北區國稅局羅東稽徵所', '', ''],
		'H01': ['財政部北區國稅局', '', ''],
		'H38': ['財政部北區國稅局楊梅稽徵所', '', ''],
		'H39': ['財政部北區國稅局桃園分局', '', ''],
		'H40': ['財政部北區國稅局中壢稽徵所', '', ''],
		'H41': ['財政部北區國稅局大溪稽徵所', '', ''],
		'H42': ['財政部北區國稅局蘆竹稽徵所', '', ''],
		'I66': ['財政部南區國稅局嘉義市分局（102年9月1日起改名）', '', ''],
		'J42': ['財政部北區國稅局竹北分局', '', ''],
		'J43': ['財政部北區國稅局竹東稽徵所', '', ''],
		'K45': ['財政部中區國稅局苗栗分局', '', ''],
		'K46': ['財政部中區國稅局竹南稽徵所', '', ''],
		'M59': ['財政部中區國稅局南投分局', '', ''],
		'M60': ['財政部中區國稅局埔里稽徵所', '', ''],
		'M61': ['財政部中區國稅局竹山稽徵所', '', ''],
		'N55': ['財政部中區國稅局彰化分局', '', ''],
		'N56': ['財政部中區國稅局員林稽徵所', '', ''],
		'N57': ['財政部中區國稅局北斗稽徵所', '', ''],
		'O44': ['財政部北區國稅局新竹分局', '', ''],
		'P63': ['財政部中區國稅局雲林分局', '', ''],
		'P64': ['財政部中區國稅局北港稽徵所', '', ''],
		'P65': ['財政部中區國稅局虎尾稽徵所', '', ''],
		'Q67': ['財政部南區國稅局嘉義縣分局（102年9月1日起改名）', '', ''],
		'Q68': ['財政部南區國稅局民雄稽徵所', '', ''],
		'T90': ['財政部南區國稅局屏東分局', '', ''],
		'T91': ['財政部南區國稅局東港稽徵所', '', ''],
		'T92': ['財政部南區國稅局潮州稽徵所', '', ''],
		'T93': ['財政部南區國稅局恆春稽徵所', '', ''],
		'U96': ['財政部北區國稅局花蓮分局', '', ''],
		'U97': ['財政部北區國稅局玉里稽徵所', '', ''],
		'V94': ['財政部南區國稅局臺東分局', '', ''],
		'W01': ['財政部北區國稅局金門稽徵所', '', ''],
		'X99': ['財政部南區國稅局澎湖', '', ''],
		'Z01': ['財政部北區國稅局馬祖服務處', '', '']
	},
	'os.taxInstitute.areaCode': {
		'A': ['臺北市', '', ''],
		'B': ['臺中市', '', ''],
		'C': ['基隆市', '', ''],
		'D': ['臺南市', '', ''],
		'E': ['高雄市', '', ''],
		'F': ['新北市', '', ''],
		'G': ['宜蘭縣', '', ''],
		'H': ['桃園市', '', ''],
		'I': ['嘉義市', '', ''],
		'J': ['新竹縣', '', ''],
		'K': ['苗栗縣', '', ''],
		'M': ['南投縣', '', ''],
		'N': ['彰化縣', '', ''],
		'O': ['新竹市', '', ''],
		'P': ['雲林縣', '', ''],
		'Q': ['嘉義縣', '', ''],
		'T': ['屏東縣', '', ''],
		'U': ['花蓮縣', '', ''],
		'V': ['臺東縣', '', ''],
		'W': ['金門縣', '', ''],
		'X': ['澎湖縣', '', ''],
		'Z': ['連江縣', '', ''],
	},
	'pb.2nd.health.incomeCode': {
		'62': ['所屬投保單位給付全年累計逾當月投保金額X倍部分之獎金', 'The insured unit pays a bonus of X times the total amount of insurance in the current month.', '所属投保单位给付全年累计逾当月投保金额X倍部分之奖金'],
		'63': ['非所屬投保單位給付之薪資所得', 'Salary income from non-insurance units', '非所属投保单位给付之薪资所得'],
		'65': ['執行業務收入', 'Execution of business income', '执行业务收入'],
		// '66': ['股利所得', 'Dividend income', '股利所得'],
		'67': ['利息所得', 'Interest income', '利息所得'],
		'68': ['租金收入', 'rental income', '租金收入']
	},
	'pb.2nd.health.incomeCodeAbbr': {
		'62': ['獎金', 'bonus', '奖金'],
		'63': ['兼職薪資所得', 'Part-time salary income', '兼职薪资所得'],
		'65': ['執行業務收入', 'Execution of business income', '执行业务收入'],
		// '66': ['股利所得', 'Dividend income', '股利所得'],
		'67': ['利息所得', 'Interest income', '利息所得'],
		'68': ['租金收入', 'rental income', '租金收入']
	},
	'pb.base.2ndHealthIdentity': {
		'1': ['一般人員','General staff','一般人员'],
		'2': ['兼職薪資人員','Part-time salary staff','兼职薪资人员'],
		'3': ['兼職薪資人員(未達最低工資免扣取)','Part-time salary staff (exempt from deduction if the minimum wage is not reached)','兼职薪资人员(未达最低工资免扣取)'],
		'4': ['無投保資格','No insurance qualification','无投保资格'],
		'5': ['低收入戶','Low income household','低收入户'],
		'6': ['職業工會會員','Professional union member','职业工会会员'],
		'7': ['專門職業及技術人員','Specialized professional and technical staff','专门职业及技术人员'],
		// '8': ['自營作業者','Self-employed operator','自营作业者']
	},
	'pb.base.accountType': {
		'1': ['帳號一', 'Account one', '帐号一'],
		'2': ['帳號二', 'Account number two', '帐号二'],
		'3': ['帳號三', 'Account number three', '帐号三'],
		'4': ['帳號四', 'Account number four', '帐号四']
	},
	'pb.base.amountPay': {
		'1': ['銀行轉帳', 'money transfer', '银行转帐'],
		'2': ['支票', 'check', '支票'],
		'3': ['現金支領', 'Cash support', '现金支领']
	},
	'pb.base.bankApportion': {
		'1': ['固定金額', 'fixed amount', '固定金额'],
		'2': ['固定比例', 'Fixed ratio', '固定比例'],
		'3': ['亂數比例', 'Random proportion', '乱数比例']
	},
	'pb.base.foreignCountType': {
		'1': ['算至所得當年度12/31', 'Calculated to the income of the year 12/31', '算至所得当年度12/31'],
		'2': ['算至當月外籍計稅截止日', 'Calculated to the foreign taxation deadline of the month', '算至当月外籍计税截止日'],
		'3': ['算至當月外籍計稅截止日-每年重新計算', 'Calculated to the foreign tax expiration date of the month - recalculated each year', '算至当月外籍计税截止日-每年重新计算']
	},
	'pb.base.habitantType': {
		'1': ['居住者', 'Resident', '居住者'],
		'2': ['非居住者', 'Non-occupier', '非居住者']
	},
	'pb.base.habitantType2': {
		'1': ['境內居住者','Domestic residents','境内居住者'],
		'2': ['非境內居住者','Non-domestic residents','非境内居住者']
	},
	'pb.base.itemSalaryType': {
		'MONTH': ['每月', 'per month', '每月'],
		'DAY': ['每日', 'daily', '每日'],
		'HOUR': ['每小時', 'per hour', '每小时'],
	},
	'pb.base.holidayPay': {
		'0': ['不給薪','Unpaid','不给薪'],
		'1': ['給薪','Pay','给薪']
	},
	'pb.base.PTcalPay': {
		'1': ['依排班時數給薪', 'Pay according to the number of shifts', '依排班时数给薪'],
		'2': ['依申請出勤時數給薪', 'Pay according to the number of applications for attendance', '依申请出勤时数给薪']
	},
	'pb.base.retireSet': {
		'1': ['個人帳戶制', 'Personal account system', '个人帐户制'],
		'2': ['舊制', 'Old system', '旧制'],
		'3': ['不需提繳', 'No need to pay', '不需提缴']
	},
	'pb.base.salaryPayCat': {
		'1': ['月結薪資', 'Monthly salary', '月结薪资'],
		'2': ['獎金', 'Bonus', '奖金'],
		'4': ['津貼', 'allowance', '津贴'],
		'8': ['費用', 'cost', '费用']
	},
	'pb.base.salary_type': {
		'MONTH': ['月薪', 'Monthly salary', '月薪'],
		'DAY': ['日薪', 'Daily salary', '日薪'],
		'HOUR': ['時薪', 'Hourly salary', '时薪']
	},
	'pb.base.taxFormat': {
		'50': ['50 薪資所得','50 Salary income','50 薪资所得'],
		'93': ['93 退職所得','93 Retirement Income','93 退职所得'],
		'91': ['91 競技競賽及機會中獎獎金','91 Competitive competitions and opportunities to win prizes','91 竞技竞赛及机会中奖奖金'],
		'92': ['92 其他所得','92 Other income','92 其他所得'],
		'51': ['51 租賃所得','51 Rental income','51 租赁所得'],
		'9A': ['9A 執行業務所得','9A Income from business execution','9A 执行业务所得'],
		'9B': ['9B 稿費、版稅、樂譜、作曲、編劇、漫畫及講演之鐘點費等七項所得','9B Seven incomes including manuscript fees, royalties, music scores, composition, screenwriting, comics and lecture fees','9B 稿费、版税、乐谱、作曲、编剧、漫画及讲演之钟点费等七项所得'],
		'52': ['52 短期票券利息所得','52 Short-term bill interest income','52 短期票券利息所得'],
		'53': ['53 權利金所得','53 royalty income','53 权利金所得'],
		'5A': ['5A 金融業利息','5A Financial industry interest','5A 金融业利息'],
		'5B': ['5B 其他利息所得','5B Other interest income','5B 其他利息所得'],
		'5C': ['5C 公債、公司債、金融債券利息所得','5C Interest income from public bonds, corporate bonds, and financial bonds','5C 公债、公司债、金融债券利息所得'],
		'60': ['60 資產基礎證券分配之利息所得','60 Interest income from asset-based securities distribution','60 资产基础证券分配之利息所得'],
		'61': ['61 附條件交易之利息所得','61 Interest income from conditional transactions','61 附条件交易之利息所得'],
		'90': ['90 告發或檢舉獎金','90 Report or report bonus','90 告发或检举奖金'],
		'94': ['94 員工認股所得','94 Employee stock subscription income','94 员工认股所得'],
		'95': ['95 政府補助款','95 Government grants','95 政府补助款'],
		'96': ['96 結構型商品交易之所得','96 Income from structured commodity transactions','96 结构型商品交易之所得'],
		'97': ['97 受贈所得','97 Income from donations','97 受赠所得']
	},
	'pb.base.taxSet': {
		'1': ['依據系統參數', 'According to system parameters', '依据系统参数'],
		'2': ['依據固定稅率', 'Fixed tax rate', '依据固定税率'],
		'3': ['自訂稅率', 'Custom tax rate', '自订税率'],
		'4': ['自訂所得稅額', 'Customized income tax', '自订所得税额']
	},
	'pb.base.taxMark50': {
		' ': ['一般薪資所得','General salary income','一般薪资所得'],
		'C': ['大陸地區薪資所得','Salary income in mainland China','大陆地区薪资所得']
	},
	'pb.base.taxMark91': {
		' ': ['(空白) 非政府舉辦','(Blank) non-governmental organization','(空白) 非政府举办'],
		'D': ['D 分離課稅利息所得；政府舉辦獎券中獎獎金；資產基礎證券分配之利息所得；告發或檢舉獎金；結構型商品交易之所得；附條件交易之利息所得','D. Separate taxable interest income; government-sponsored lottery winning prizes; interest income from asset-based securities distribution; reporting or reporting bonuses; income from structured commodity transactions; interest income from conditional transactions','D 分离课税利息所得；政府举办奖券中奖奖金；资产基础证券分配之利息所得；告发或检举奖金；结构型商品交易之所得；附条件交易之利息所得']
	},
	'pb.base.taxMark51': {
		' ': ['(空白) 固定資產租賃所得－房屋租賃','(Blank) Income from lease of fixed assets-house lease','(空白) 固定资产租赁所得－房屋租赁'],
		'R': ['R 固定資產租賃所得－符合住宅法第23條規定住宅經由主管機關、租屋服務事業轉租者','R Rental income from fixed assets－If the property is subleased by the competent authorities or rental service enterprises in accordance with Article 23 of the Housing Act.','R 固定资产租赁所得－符合住宅法第23条规定住宅经由主管机关、租屋服务事业转租者'],
		'M': ['M 固定資產租賃所得－符合租賃住宅市場發展及管理條例第17條規定住宅經由包租業轉租者','M Rental income from fixed assets－If the property is subleased by leasing businesses in accordance with Article 17 of the Rental Housing Market Development and Management Act.','M 固定资产租赁所得－符合租赁住宅市场发展及管理条例第17条规定住宅经由包租业转租者'],
		'Q': ['Q 固定資產租賃所得－符合住宅法第15條規定住宅經由社會福利團體轉租者','Q Rental income from fixed assets－If the property is subleased by social welfare organizations in accordance with Article 15 of the Housing Act.','Q 固定资产租赁所得－符合住宅法第15条规定住宅经由社会福利团体转租者'],
		'L': ['L 固定資產租賃所得－土地','L Income from lease of fixed assets-land','L 固定资产租赁所得－土地'],
		'J': ['J 固定資產租賃所得－其他','J Income from lease of fixed assets-other','J 固定资产租赁所得－其他'],
		'K': ['K 非固定資產租賃所得－債券租借','K Non-fixed asset lease income-bond lease','K 非固定资产租赁所得－债券租借'],
		'I': ['I 非固定資產租賃所得－其他','I Income from lease of non-fixed assets-other','I 非固定资产租赁所得－其他']
	},
	'pb.base.taxMark52': {
		'H': ['H 發票日在99年1月1日以後之短期票券利息所得','H Income from short-term coupon interest on the invoice date after January 1, 1999','H 發票日在99年1月1日以後之短期票券利息所得'],
		'D':['D 分離課稅利息所得；政府舉辦獎券中獎獎金；資產基礎證券分配之利息所得；告發或檢舉獎金；結構型商品交易之所得；附條件交易之利息所得','D. Separate taxable interest income; government-sponsored lottery winning prizes; interest income from asset-based securities distribution; reporting or reporting bonuses; income from structured commodity transactions; interest income from conditional transactions','D 分離課稅利息所得；政府舉辦獎券中獎獎金；資產基礎證券分配之利息所得；告發或檢舉獎金；結構型商品交易之所得；附條件交易之利息所得']
	},
	'pb.base.taxMark5C': {
		'D': ['D 分離課稅利息所得；政府舉辦獎券中獎獎金；資產基礎證券分配之利息所得；告發或檢舉獎金；結構型商品交易之所得；附條件交易之利息所得','D. Separate taxable interest income; government-sponsored lottery winning bonus; interest income from asset-based securities distribution; reporting or reporting bonuses; income from structured commodity transactions; interest income from conditional transactions','D 分离课税利息所得；政府举办奖券中奖奖金；资产基础证券分配之利息所得；告发或检举奖金；结构型商品交易之所得；附条件交易之利息所得']
	},
	'pb.base.taxMark60': {
		'D': ['D 分離課稅利息所得；政府舉辦獎券中獎獎金；資產基礎證券分配之利息所得；告發或檢舉獎金；結構型商品交易之所得；附條件交易之利息所得','D. Separate taxable interest income; government-sponsored lottery winning bonus; interest income from asset-based securities distribution; reporting or reporting bonuses; income from structured commodity transactions; interest income from conditional transactions','D 分离课税利息所得；政府举办奖券中奖奖金；资产基础证券分配之利息所得；告发或检举奖金；结构型商品交易之所得；附条件交易之利息所得']
	},
	'pb.base.taxMark61': {
		'D': ['D 分離課稅利息所得；政府舉辦獎券中獎獎金；資產基礎證券分配之利息所得；告發或檢舉獎金；結構型商品交易之所得；附條件交易之利息所得','D. Separate taxable interest income; government-sponsored lottery winning bonus; interest income from asset-based securities distribution; reporting or reporting bonuses; income from structured commodity transactions; interest income from conditional transactions','D 分离课税利息所得；政府举办奖券中奖奖金；资产基础证券分配之利息所得；告发或检举奖金；结构型商品交易之所得；附条件交易之利息所得']
	},
	'pb.base.taxMark90': {
		'D': ['D 分離課稅利息所得；政府舉辦獎券中獎獎金；資產基礎證券分配之利息所得；告發或檢舉獎金；結構型商品交易之所得；附條件交易之利息所得','D. Separate taxable interest income; government-sponsored lottery winning bonus; interest income from asset-based securities distribution; reporting or reporting bonuses; income from structured commodity transactions; interest income from conditional transactions','D 分离课税利息所得；政府举办奖券中奖奖金；资产基础证券分配之利息所得；告发或检举奖金；结构型商品交易之所得；附条件交易之利息所得']
	},
	'pb.base.taxMark95': {
		'A': ['A 實報實銷之政府補助款','A Government subsidies for actual reimbursement','A 实报实销之政府补助款'],
		'B': ['B 非實報實銷之政府補助款','B Non-accountable government subsidies','B 非实报实销之政府补助款']
	},
	'pb.base.taxMark96': {
		'D': ['D 分離課稅利息所得；政府舉辦獎券中獎獎金；資產基礎證券分配之利息所得；告發或檢舉獎金；結構型商品交易之所得；附條件交易之利息所得','D. Separate taxable interest income; government-sponsored lottery winning bonus; interest income from asset-based securities distribution; reporting or reporting bonuses; income from structured commodity transactions; interest income from conditional transactions','D 分离课税利息所得；政府举办奖券中奖奖金；资产基础证券分配之利息所得；告发或检举奖金；结构型商品交易之所得；附条件交易之利息所得']
	},
	'pb.base.taxBusiness9A': {
		'10': ['律師','lawyer','律师'],
		'11': ['會計師','Accountant','会计师'],
		'12': ['精算師','Actuary','精算师'],
		'13': ['地政士','Landlord','地政士'],
		'14': ['記帳士','Bookkeeper','记帐士'],
		'15': ['仲裁人','arbitrator','仲裁人'],
		'16': ['民間公證人','Civil notary','民间公证人'],
		'17': ['不動產估價師','Real estate appraiser','不动产估价师'],
		'18': ['受委託代辦國有非公用不動產之承租、續租、過戶及繼承等申請者','Entrusted to handle applications for lease, renewal, transfer and inheritance of state-owned non-public real estate','受委托代办国有非公用不动产之承租、续租、过户及继承等申请者'],
		'19': ['記帳及報稅代理業務人','Accounting and tax filing agent business person','记帐及报税代理业务人'],
		'20': ['技師','technician','技师'],
		'21': ['建築師','architect','建筑师'],
		'22': ['公共安檢人員','Public security officer','公共安检人员'],
		'23': ['未具會計師、記帳士及報稅代理人資格，辦理工商登記等業務者','Those who do not have the qualifications of accountants, bookkeepers and tax agents, and handle business registration and other business','未具会计师、记帐士及报税代理人资料，行政工商业登记等业务员'],
		'24': ['工匠 (工資收入)','Craftsman (wage income)','工匠 (工资收入)'],
		'25': ['工匠 (工料收入)','Craftsman (production income)','工匠 (工料收入)'],
		'26': ['引水人','Pilot','引水人'],
		'27': ['律師配合政府政策辦理法律服助案件及法院指定義務辨護案件之收入','Income from lawyers cooperating with government policies in handling legal assistance cases and court-appointed voluntary defense cases','律师配合政府政策办理法律服助案件及法院指定义务辨护案件之收入'],
		'30': ['內科醫師','Physician','内科医师'],
		'31': ['外科醫師','surgeon','外科医师'],
		'32': ['小兒科醫師','Pediatrician','小儿科医师'],
		'33': ['婦產科醫師','Obstetrician and Gynecologist','妇产科医师'],
		'34': ['眼科醫師','Ophthalmologist','眼科医师'],
		'35': ['耳鼻喉科醫師','Otolaryngologist','耳鼻喉科医师'],
		'36': ['牙科醫師','Dentist','牙科医师'],
		'37': ['精神科醫師','Psychiatrist','精神科医师'],
		'38': ['骨科醫師','Orthopedist','骨科医师'],
		'39': ['其他科別醫師','Physicians in other departments','其他科别医师'],
		'40': ['助產師 (士)','Midwife (person)','助产师 (士)'],
		'41': ['藥師','Pharmacist','药师'],
		'42': ['醫事檢驗師 (生)','Medical examiner (student)','医事检验师 (生)'],
		'45': ['營養師','Nutritionist','营养师'],
		'46': ['醫師經核准至該他醫療機構服務但與該他醫療機構不具僱傭關係者','Doctors who are approved to serve in other medical institutions but have no employment relationship with other medical institutions','医师经核准至该他医疗机构服务但与该他医疗机构不具雇佣关系者'],
		'47': ['獸醫師','Veterinarian','兽医师'],
		'48': ['皮膚科醫師','Dermatologist','皮肤科医师'],
		'49': ['家庭醫學科醫師','Family Medicine Physician','家庭医学科医师'],
		'50': ['中醫師','Chinese medicine practitioner','中医师'],
		'51': ['語言治療師','Speech therapist','语言治疗师'],
		'52': ['人壽保險醫療檢查','Life insurance medical examination','人寿保险医疗检查'],
		'53': ['物理治療師','Physical therapist','物理治疗师'],
		'54': ['職能治療師','Occupational Therapist','职能治疗师'],
		'55': ['心理師','Psychologist','心理师'],
		'56': ['牙體技術師(生)','Dental technician (student)','牙体技术师(生)'],
		'57': ['配合政府政策辦理老人、兒童、中低收入者、身心障礙者及其他特定對象補助','Cooperate with government policies to handle subsidies for the elderly, children, low- and middle-income people, persons with disabilities and other specific objects','配合政府政策办理老人、儿童、中低收入者、身心障碍者及其他特定对象补助'],
		'58': ['自費疫苗注射收入','Self-funded vaccination income','自费疫苗注射收入'],
		'59': ['C肝藥品費用之全民健康保險收入','National health insurance income from liver drug costs','C肝药品费用之全民健康保险收入'],
		'61': ['書畫家、版畫家','Calligrapher, printmaker','书画家、版画家'],
		'62': ['命理卜卦','Numerology','命理卜卦'],
		'70': ['表演人','Performer','表演人'],
		'71': ['保險經紀人','Insurance broker','保险经纪人'],
		'72': ['節目製作人','Show producer','节目制作人'],
		'73': ['公益彩券立即型彩券經銷商','Charity Lottery Instant Lottery Dealer','公益彩券立即型彩券经销商'],
		'76': ['一般經紀人','General broker','一般经纪人'],
		'90': ['其他','other','其他'],
		'91': ['商標代理人','Trademark Attorney','商标代理人'],
		'92': ['程式設計師','Programmer','程式设计师'],
		'93': ['專利師及專利代理人','Patent Attorney and Patent Attorney','专利师及专利代理人'],
		'94': ['未具律師資格，辦理訴訟代理人業務','Not qualified as a lawyer, handling litigation agent business','未具律师资格，办理诉讼代理人业务'],
		'95': ['未具建築師資格，辦理建築規劃設計及監造等業務者','Those who do not have the qualifications of architects and handle architectural planning, design and supervision','未具建筑师资格，办理建筑规划设计及监造等业务者'],
		'96': ['未具地政士資格，辦理土地登記等業務者','Those who do not have the qualifications of a landlord who handle land registration and other businesses','未具地政士资格，办理土地登记等业务者'],
		'97': ['受大陸地區人民委託辦理繼承、公法給付或其他事務者','Entrusted by the people of the mainland to handle inheritance, public law payments or other matters','受大陆地区人民委托办理继承、公法给付或其他事务者']
	},
	'pb.base.taxBusiness9B': {
		'98': ['著作人：非自行出版之稿費、版稅、樂譜、作曲、編劇、漫畫及講演之鐘點費等七項','Author: Seven items including manuscript fees, royalties, music scores, composition, screenwriters, comics, and lecture hours for non-self-publishing','著作人：非自行出版之稿费、版税、乐谱、作曲、编剧、漫画及讲演之钟点费等七项'],
		'99': ['著作人：自行出版之稿費、版稅、作曲、編劇、漫畫等','Author: self-published manuscript fee, royalties, composition, screenwriter, comics, etc.','著作人：自行出版之稿费、版税、作曲、编剧、漫画等']
	},
	'pb.base.taxBusiness92': {
		'80': ['民營汽車駕駛人訓練機構','Private car driver training institution','民营汽车驾驶人训练机构'],
		'81': ['文理類(升學、語文、法商及其他)補習班','Liberal arts (preparatory school, Chinese, French business and other) cram school','文理类(升学、语文、法商及其他)补习班'],
		'82': ['技藝類(縫紉、美容、美髮、音樂、舞蹈及其他)補習班','Skills (sewing, beauty, hairdressing, music, dancing and others) cram school','技艺类(缝纫、美容、美发、音乐、舞蹈及其他)补习班'],
		'84': ['私立托嬰中心、幼兒園','Private childcare centers, kindergartens','私立托婴中心、幼儿园'],
		'86':['兒童課後照顧服務中心',"Children's After School Care Service Center",'儿童课后照顾服务中心'],
		'87': ['私立養護、療養院所','Private nursing and nursing homes','私立养护、疗养院所'],
		'88':['依「護理機構分類設置標準」設置之私立護理機構、依「老人福利機構設立標準」設立之機構、依「精神復健機構設置及管理辦法」設置之精神復健機構及依「長期照顧服務機構設立許可及管理辦法」設立之長期照顧服務機構','Private nursing institutions established in accordance with the 「Standards for the Establishment of Classification of Nursing Institutions」, institutions established in accordance with the 「Standards for the Establishment of Welfare Institutions for the Elderly」, mental rehabilitation institutions established in accordance with the 「Measures for the Establishment and Management of Mental Rehabilitation Institutions」 and 「Long-term Care Service Institutions」 Long-term care service institutions established under the 「Permission and Management Measures for Establishment」','「护理设置标准设置设置私立护理机构，「福利机构设立设立标准​​标准标准标准」设立之机构机构，依「精神复健机构机构设置及管理管理设置设置设置许可及管理办公室法」设置之长周期照相服务机构'],
		'8A': ['職工福利金','Employee benefits','职工福利金'],
		'8B': ['違約金','Liquidated damages','违约金'],
		'8C':['佃農因終止375租約取得之補償費',"Tenant's compensation for terminating the 375 lease",'佃农因终止375租约取得之补偿费'],
		'8D': ['個人遷讓非自有房屋、土地所取得之補償費','Compensation fees received by individuals for transferring non-owned houses and land','个人迁让非自有房屋、土地所取得之补偿费'],
		'8E': ['多層次傳銷參加人直接進貨取得之業績獎金或各種補助費','Performance bonus or various subsidies obtained by direct purchase of multi-level marketing participants','多层次传销参加人直接进货取得之业绩奖金或各种补助费'],
		'8F': ['技術費','Technology fee','技术费'],
		'8Z': ['其他','other','其他']
	},
	'pb.cal.labor.inputType': {
		'1': ['負擔明細','Burden details','负担明细'],
		'2': ['負擔金額','Burden amount','负担金额']
	},
	'pb.cal.labor.dataSource': {
		'1': ['薪資計算', 'Salary calculation', '薪资计算'],
		'2': ['保費追溯', 'Premium retrospective', '保费追溯'],
		'3': ['保費退還', 'Premium refund', '保费退还'],
		'4': ['保費比對', 'Premium comparison', '保费比对'],
		'5': ['加扣項匯入', 'Import deductions', '加扣项汇入'],
		'6': ['人工輸入', 'Manual input', '人工输入'],
		'9': ['手動維護', 'Manual maintenance', '手动维护']
	},
	'pb.cal.dataSource': {
		'1': ['薪資計算', 'Salary calculation', '薪资计算'],
		'2': ['保費追溯', 'Premium retrospective', '保费追溯'],
		'3': ['保費退還', 'Premium refund', '保费退还'],
		'4': ['保費比對', 'Premium comparison', '保费比对'],
		'5': ['加扣項匯入', 'Import deductions', '加扣项汇入'],
		'6': ['人工輸入', 'Manual input', '人工输入'],
		'9': ['手動維護', 'Manual maintenance', '手动维护']
	},
	'pb.court.areaCode': {
		'99': ['其他地區', 'other areas', '其他地区']
	},
	'pb.emp.court.closeType': {
		'0': ['未結清', 'Unclear', '未结清'],
		'1': ['已結清', 'Closed', '已结清']
	},
	'pb.emp.court.debtorReturnType': {
		'1': ['銀行轉帳', 'money transfer', '银行转帐'],
		'2': ['支票', 'check', '支票'],
		'3': ['現金', 'cash', '现金']
	},
	'pb.emp.court.dedType': {
		'1': ['留有每人每月最低生活費', 'Minimum monthly living allowance per person', '留有每人每月最低生活费'],
		'2': ['依比例扣款', 'Prorated deduction', '依比例扣款'],
		'3': ['依比例扣款並留有每人每月最低生活費', 'Deductible according to the proportion and leave a monthly minimum living allowance per person', '依比例扣款并留有每人每月最低生活费'],
		'4': ['固定金額', 'fixed amount', '固定金额']
	},
	'pb.emp.groupInsurance.nowStatus': {
		'11': ['投保中', 'Insured', '投保中'],
		'21': ['已退保', 'Surrendered', '已退保']
	},
	'pb.emp.groupInsurance.status': {
		'11': ['加保', 'Additional insurance', '加保'],
		'21': ['退保', 'Surrender', '退保'],
		'91': ['加保內容變更', 'Insurance content change', '加保内容变更']
	},
	'pb.emp.health.addEmpCause': {
		'1': ['到職起薪', 'Starting salary', '到职起薪'],
		'2': ['入會', 'Admission', '入会']
	},
	'pb.emp.health.addFamilyCause': {
		'4': ['依附投保', 'Attached to insurance', '依附投保'],
		'5': ['改變身分', 'Change identity', '改变身分'],
		'6': ['結婚', 'marry', '结婚'],
		'7': ['收養', 'adoption', '收养'],
		'8': ['新生嬰兒', 'Newborn baby', '新生婴儿'],
		'S': ['在學就讀且無職業（在學無業）', 'Studying at school and having no occupation (unemployed in school)', '在学就读且无职业（在学无业）'],
		'P': ['受禁治產宣告尚未撤銷（禁治產宣告）', 'The declaration of banned production has not been revoked (prohibition of production)', '受禁治产宣告尚未撤销（禁治产宣告）'],
		'A': ['殘障而不能自謀生活（殘障不能謀生）', 'Disabled and unable to live on their own (disability can not make a living)', '残障而不能自谋生活（残障不能谋生）'],
		'H': ['罹患重大傷病且無職業（重傷病無業）', 'Suffering from major injuries and no occupations (heavy injuries and unemployed)', '罹患重大伤病且无职业（重伤病无业）'],
		'G': ['應屆畢業或服兵役退伍且無職業，於畢業學期終了或退伍日起一年內（應屆畢業）', 'Graduation or military service, no occupation, at the end of the graduation period or within one year from the date of graduation (graduation)', '应届毕业或服兵役退伍且无职业，于毕业学期终了或退伍日起一年内（应届毕业）']
	},
	'pb.emp.health.familyExitCause': {
		'1': ['轉換單位', 'Attached to Conversion unit', '转换单位']
	},
	'pb.emp.health.exitCause': {
		'3': ['停歇業', 'Stopping', '停歇业'],
		'1': ['離職', 'Resignation', '离职'],
		'4': ['退會', 'Withdrawal', '退会'],
		'2': ['退休', 'retirement', '退休']
	},
	'pb.emp.health.isSubsidies': {
		'1': ['納入補助', 'Inclusion subsidy', '纳入补助'],
		'0': ['不納入補助', 'Not included in the subsidy', '不纳入补助']
	},
	'pb.emp.health.leaveCause': {
		'U': ['喪失全民健康保險投保資格者', 'Loss of universal health insurance policy', '丧失全民健康保险投保资格者'],
		'M': ['死亡', 'death', '死亡'],
		'E': ['失蹤滿六個月', 'Missing for six months', '失踪满六个月']
	},
	'pb.emp.health.nowStatus': {
		'11': ['投保中', 'Insured', '投保中'],
		'21': ['已退保', 'Surrendered', '已退保'],
		'22': ['已轉出', 'Has been transferred out', '已转出'],
		'41': ['已停保', 'Discontinued', '已停保']
	},
	'pb.emp.health.personnelType': {
		'1': ['本人', 'Personnel', '本人'],
		'2': ['眷屬', 'Genus', '眷属']
	},
	'pb.emp.health.renewCause': {
		'S': ['在學就讀且無職業（在學無業）', 'Studying at school and having no occupation (unemployed in school)', '在学就读且无职业（在学无业）'],
		'P': ['受禁治產宣告尚未撤銷（禁治產宣告）', 'The declaration of banned production has not been revoked (prohibition of production)', '受禁治产宣告尚未撤销（禁治产宣告）'],
		'A': ['殘障而不能自謀生活（殘障不能謀生）', 'Disabled and unable to live on their own (disability can not make a living)', '残障而不能自谋生活（残障不能谋生）'],
		'H': ['罹患重大傷病且無職業（重傷病無業）', 'Suffering from major injuries and no occupations (heavy injuries and unemployed)', '罹患重大伤病且无职业（重伤病无业）'],
		'G': ['應屆畢業或服兵役退伍且無職業，於畢業學期終了或退伍日起一年內（應屆畢業）', 'Graduation or military service, no occupation, at the end of the graduation period or within one year from the date of graduation (graduation)', '应届毕业或服兵役退伍且无职业，于毕业学期终了或退伍日起一年内（应届毕业）']
	},
	'pb.emp.health.returnCause': {
		'3': ['失蹤未逾六個月尋獲', 'Missing less than six months found', '失踪未逾六个月寻获'],
		'1': ['出國逾六個月返國', 'Returning to the country for more than six months', '出国逾六个月返国'],
		'2': ['出國未逾六個月返國', 'Going abroad for less than six months', '出国未逾六个月返国']
	},
	'pb.emp.health.status': {
		'11': ['加保', 'Additional insurance', '加保'],
		'21': ['退保', 'Surrender', '退保'],
		'22': ['轉出', 'Transfer out', '转出'],
		'31': ['投保薪資調整', 'Insured salary adjustment', '投保薪资调整'],
		'32': ['投保版本平移', 'Insured version translation', '投保版本平移'],
		'41': ['停保', 'Stop insurance', '停保'],
		'42': ['停保後復保', 'Reinsurance after the suspension of insurance', '停保后复保'],
		'51': ['親屬續保', 'Relatives renewal', '亲属续保'],
		'81': ['留職停薪繼續投保', 'Leave without pay and continue to apply for insurance', '留职停薪继续投保'],
		'91': ['員工投保資料變更', 'Employee insurance data change', '员工投保资料变更']
	},
	'pb.emp.health.stopCause': {
		'D': ['失蹤未滿六個月', 'Missing less than six months', '失踪未满六个月'],
		'F': ['預定出國六個月', 'Scheduled to go abroad for six months', '预定出国六个月']
	},
	'pb.emp.insurancePause': {
		'1': ['允許加保', 'Allow for insurance', '允许加保'],
		'0': ['暫停加保', 'Suspend', '暂停加保']
	},
	'pb.emp.labor.alienIdcType': {
		'1': ['外僑統一證號', 'Alien Uniform Certificate', '外侨统一证号'],
		'2': ['護照號碼', 'Passport number', '护照号码']
	},
	'pb.emp.labor.alienIdentity': {
		'Y': ['外籍', 'Foreign nationality', '外籍'],
		'1': ['外籍配偶(含港澳配偶)', 'Foreign spouse (including Hong Kong and Macao spouses)', '外籍配偶（含港澳配偶）'],
		'2': ['大陸配偶', 'Mainland spouse', '大陆配偶'],
		'L': ['永居外籍專業人才', 'Foreign professionals with permanent residency', '永居外籍专业人才'],
		'P': ['外籍專業人才', 'Foreign professionals', '外籍专业人才'],
	},
	'pb.emp.labor.isAlien': {
		'1': ['本國籍', 'Taiwanese', '本国籍'],
		'2': ['外籍', 'Foreign nationality', '外籍'],
	},
	'pb.emp.labor.amountAdjustType': {
		'1': ['月平均薪資', 'Monthly average salary', '月平均薪资'],
		'2': ['自選等級', 'Optional level', '自选等级']
	},
	'pb.emp.labor.amountCalType': {
		'1': ['依薪資資料', 'By salary information', '依薪资资料'],
		'2': ['自選等級', 'Optional level', '自选等级']
	},
	'pb.emp.labor.cate': {
		'1': ['勞工保險', 'Labor insurance', '劳工保险'],
		'2': ['職業災害保險', 'Professional disaster insurance', '职业灾害保险']
	},
	'pb.emp.labor.identity': {
		'1': ['部分工時', 'Partial working hours', '部分工时'],
		'2': ['職業工會低收入戶', 'Professional union low-income households', '职业工会低收入户'],
		'5': ['雇主', 'employer', '雇主'],
		'6': ['上岸候船', 'Ashore waiting', '上岸候船'],
		'7': ['庇護性身心障礙就業者', 'Asylum-related physical and mental disabilities', '庇护性身心障碍就业者'],
		'8': ['部分工時及庇護性身心障礙就業者', 'Partial working hours and sheltered persons with physical and mental disabilities', '部分工时及庇护性身心障碍就业者'],
		'A': ['公法救助及部分工時人員', 'Public law assistance and part-time workers', '公法救助及部分工时人员'],
		'B': ['公法救助', 'Public law assistance', '公法救助'],
		'S': ['建教生及部分工時人員', 'Jiansheng students and some working hours', '建教生及部分工时人员'],
		'T': ['建教生', 'Teaching student', '建教生']
	},
	'pb.emp.labor.identity._sort': [1,5,6,7,8,'A','B','S','T',2],
	'pb.emp.labor.isDelay': {
		'1': ['遞延繳納', 'Deferred payment', '递延缴纳'],
		'0': ['不遞延繳納', 'Non-deferred payment', '不递延缴纳']
	},
	'pb.emp.labor.isWithHold': {
		'1': ['復職時一併代扣', 'At the time of reinstatement', '复职时一并代扣'],
		'0': ['不代扣員工自行繳納', 'Not withheld by employees', '不代扣员工自行缴纳']
	},
	'pb.emp.labor.lawIdentity': {
		'0': ['雇主', 'employer', '雇主'],
		'1': ['律師', 'lawyer', '律师'],
		'2': ['會計師', 'Accountant', '会计师'],
		'3': ['醫師', 'Doctor', '医师'],
		'5': ['教師職員', 'Teacher staff', '教师职员'],
		'6': ['研究人員', 'Researchers', '研究人员'],
		'8': ['公務員兼具勞工身分', 'Civil servants have both labor status', '公务员兼具劳工身分'],
		'9': ['教練球員裁判', 'Coach player referee', '教练球员裁判'],
		'A': ['委任經理人', 'Appointment of manager', '委任经理人'],
		'B': ['其他不適用勞基法之本國籍勞工', 'Other national laborers who do not apply to the Latif Law', '其他不适用劳基法之本国籍劳工'],
		'G': ['編制內技工.工友.駕駛.駐衛警', 'Compilation of internal mechanics, workers, driving, stationed police', '编制内技工，工友，驾驶，驻卫警'],
		'H': ['編制外教師.職員', 'Compilation of teachers and staff', '编制外教师。职员'],
		'I': ['編制外非教師.職員身分之工作者', 'Compilation of non-teachers and staff members', '编制外非教师。职员身分之工作者'],
		'4': ['技工工友駕駛', 'Technician driving', '技工工友驾驶'],
		'7': ['清潔隊員', 'Cleaning team', '清洁队员'],
		'S': ['停車場收費員', 'Parking lot charge', '停车场收费员'],
		'C': ['立法院國會助理', 'Legislative Assembly Assistant', '立法院国会助理'],
		'D': ['地方民意代聘(遴)、僱用之助理', 'Local public opinion appointment (遴), employment assistant', '地方民意代聘（遴），雇用之助理'],
		'F': ['一般公立單位臨時人員戶', 'General public unit temporary staff', '一般公立单位临时人员户'],
		'E': ['公立醫療院所之臨時人員', 'Temporary staff of public medical institutions', '公立医疗院所之临时人员']
	},
	'pb.emp.labor.nowStatus': {
		'11': ['投保中', 'nsured', '投保中'],
		'21': ['已退保', 'Surrendered', '已退保'],
		'22': ['已轉出', 'Has been transferred out', '已转出']
	},
	'pb.emp.labor.socialInsure': {
		'1': ['已領取勞工保險老年給付', 'Received labor insurance old age payment', '已领取劳工保险老年给付'],
		'2': ['已領取其他社會保險給付且年逾65歲', 'Has received other social insurance benefits and is over 65 years old', '已领取其他社会保险给付且年逾65岁'],
		'0': ['非上述種類', 'other than the above', '非上述种类']
	},
	'pb.emp.labor.socialInsure._sort': [1, 2, 0],
	'pb.emp.labor.status': {
		'11': ['加保', 'Additional insurance', '加保'],
		'12': ['轉入', 'Transfer', '转入'],
		'21': ['退保', 'Surrender', '退保'],
		'22': ['轉出', 'Transfer out', '转出'],
		'31': ['投保薪資調整', 'Insured salary adjustment', '投保薪资调整'],
		'32': ['投保版本平移', 'Insured version translation', '投保版本平移'],
		'81': ['留職停薪續保', 'Retirement', '留职停薪续保'],
		'82': ['留職停薪復職', 'Retirement', '留职停薪复职'],
		'91': ['員工投保資料變更', 'Employee insurance data change', '员工投保资料变更']
	},
	'pb.emp.labor.addressType': {
		'1': ['通訊地址','mailing address','通讯地址'],
		'2': ['戶籍地址','Residence address','户籍地址']
	},
	'pb.emp.retire.identity': {
		'1': ['外籍╱陸港澳地區配偶', 'Foreign spouse in Lu, Hong Kong and Macao', '外籍╱陆港澳地区配偶'],
		'2': ['永久居留之專業人才', 'Permanent resident', '永久居留之专业人才']
	},
	'pb.emp.retire.nowStatus': {
		'11': ['提繳中','Withdrawing','提缴中'],
		'21': ['停止提繳','Stop withdrawing','停止提缴'],
		'22': ['已轉出','Transferred out','已转出']
	},
	'pb.emp.retire.status': {
		'11': ['提繳(加保)','Withdraw (add insurance)','提缴(加保)'],
		'12': ['提繳(轉入)','Withdrawal (transfer-in)','提缴(转入)'],
		'13': ['提繳(提繳率加保)','Withdrawal (withdrawal rate plus insurance)','提缴(提缴率加保)'],
		'21': ['停繳(退保)','Withdrawal (surrender)','停缴(退保)'],
		'22': ['停繳(轉出)','Suspend (transfer out)','停缴(转出)'],
		'23': ['停繳','Suspension of payment','停缴'],
		'31': ['提繳工資調整','Payroll adjustment','提缴工资调整'],
		'32': ['提繳工資版本平移','Payroll version shift','提缴工资版本平移'],
		'61': ['提繳率調整','Withdrawal rate adjustment','提缴率调整']
	},
	'pb.emp.retire.search': {
		'10': ['提繳','Withdraw','提缴'],
		'20': ['停繳','Suspension of payment','停缴'],
		'30': ['提繳工資調整','Payroll adjustment','提缴工资调整'],
		'60': ['提繳率調整','Withdrawal rate adjustment','提缴率调整']
	},

	'pb.emp.retire.target': {
		'3': ['雇主自願提繳', 'Employer’s voluntary payment', '雇主自愿提缴'],
		'1': ['強制提繳對象', 'Mandatory object', '强制提缴对象'],
		'2': ['自願提繳對象', 'Voluntary object of payment', '自愿提缴对象']
	},
	'pb.emp.retire.stopItem': {
		'23A': ['停止雇主提繳及個人自願提繳', 'Stop employer’s withdrawal and individual voluntary withdrawal', '停止雇主提缴及个人自愿提缴'],
		'23B': ['僅停止個人自願提繳', 'Only stop personal voluntary withdrawal', '仅停止个人自愿提缴'],
		'23C': ['僅停止雇主提繳', 'Only stop employers from withdrawing', '仅停止雇主提缴']
	},
	'pb.emp.source': { //注：順序在 pb.emp.source._sort
		'1': ['員工', 'Staff', '员工'],
		'0': ['非員工', 'Non employee', '非员工']
	},
	'pb.emp.source._sort': [1, 0],
	'pb.emp.personnelType': {
		'1': ['員工','Staff','员工'],
		'2': ['非員工','Non employee','非员工']
	},
	'pb.emp.vars.type': {
		'BASIC': ['薪資規則異動', 'Salary rules change', '薪资规则异动'],
		'STRUCTURE': ['薪資結構異動', 'Salary structure change', '薪资结构异动'],
		'RCCC': ['成本中心異動', 'Cost center transaction', '成本中心异动']
	},
	'pb.emp.varsItem': {
		'RULE_TEMPLATE_ID': ['薪資規則範本','Sample salary rules','薪资规则范本'],
		'AMOUNT_PAY': ['支薪方式','Payment method','支薪方式'],
		'EMP_BANK': ['銀行帳號','Bank account','银行帐号'],
		'BANK_APPORTION': ['銀行轉帳金額分配','Bank transfer amount allocation','银行转帐金额分配'],
		'2ND_HEALTH_IDENTITY': ['補充補費扣取身分','Supplementary fee deduction','补充补费扣取身分'],
		'IS_2ND_HEALTH_WEAK': ['是否為弱勢民眾','Whether it is a vulnerable population','是否为弱势民众'],
		'RETIRE_SET': ['退休金制度選擇','Choice of pension system','退休金制度选择'],
		'TAX_SET': ['所得稅計算規則','Income tax calculation rules','所得税计算规则'],
		'FOREIGN_COUNT_TYPE': ['外籍在台天數計算','Calculation of the number of foreigners in Taiwan','外籍在台天数计算'],
		'PERIOD_ID': ['計薪週期','Pay period','计薪周期'],
		'RULE_WAGE_ID': ['工資計算基礎規則','Basic rules for salary calculation','工资计算基础规则'],
		'RULE_BASIC_ID': ['基本薪資規則','Basic salary rules','基本薪资规则'],
		'RULE_OT_ID': ['加班費規則','Overtime pay rules','加班费规则'],
		'RULE_LEAVE_ID': ['請假扣款規則','Leave deduction rules','请假扣款规则'],
		'RULE_FATTN_ID': ['全勤獎金規則','Full attendance bonus rules','全勤奖金规则'],
		'RULE_DELAYMEAL_ID': ['誤餐費規則','Missed meal fee rules','误餐费规则'],
		'RULE_SAVING_ID': ['強制儲蓄扣款規則','Mandatory savings deduction rules','强制储蓄扣款规则'],
		'EMP_SAVE_BANK_ID': ['強制儲蓄銀行帳號','Mandatory savings bank account','强制储蓄银行帐号'],
		'RULE_CARDMATCH_IDS': ['刷卡異常扣薪規則','Abnormal deduction rules for swiping cards','刷卡异常扣薪规则'],
		'RULE_WORK_ALLOWANCE_IDS': ['輪班津貼規則','Shift allowance rules','轮班津贴规则']
		// 'RULE_BORROW_ID': ['借發薪資規則','Payroll rules','借发薪资规则'],
	},
	'pb.fattn.basis': {
		'1': ['薪資結構', 'Salary structure', '薪资结构'],
		'2': ['當月計薪結果', 'Monthly salary result', '当月计薪结果']
	},
	'pb.groupInsurance.calType': {
		'1': ['固定金額(每人)', 'Fixed amount (per person)', '固定金额(每人)'],
		'2': ['固定金額(每戶)', 'Fixed amount (per household)', '固定金额(每户)'],
		'9': ['依個人設定', 'Personal setting', '依个人设定']
	},
	'pb.groupInsurance.shortageMonthRule': {
		'1': ['依保費天數比例計算', 'Calculated on the basis of the percentage of premium days', '依保费天数比例计算'],
		'2': ['收取全月保費', 'Charge full month premium', '收取全月保费']
	},
	'pb.incdec.type': {
		'1': ['依加扣金額', 'Depending on the amount of deduction', '依加扣金额'],
		'2': ['依加扣比例', 'Proportion', '依加扣比例']
	},
	'pb.insure.cert': {
		'11': ['勞保保費證明', 'Labor insurance premium certificate', '劳保保费证明'],
		'12': ['健保保費證明', 'Health insurance premium certificate', '健保保费证明'],
		'13': ['團保保費證明', 'Group insurance premium certificate', '团保保费证明'],
		'14': ['勞保、健保保費證明', 'Labor insurance, health insurance premium certificate', '劳保、健保保费证明'],
		'15': ['勞保、健保、團保保費證明', 'Labor insurance, health insurance, group insurance premium certificate', '劳保、健保、团保保费证明'],
		'21': ['勞保保費明細', 'Labor insurance premium details', '劳保保费明细'],
		'22': ['健保保費明細', 'Health insurance premium details', '健保保费明细'],
		'23': ['團保保費明細', 'Group insurance premium details', '团保保费明细'],
		'24': ['勞保、健保保費明細', 'Labor insurance, health insurance premium details', '劳保、健保保费明细'],
		'25': ['勞保、健保、團保保費明細', 'Labor insurance, health insurance, group insurance premium details', '劳保、健保、团保保费明细']
	},
	'pb.insure.reportType': {
		'01': ['加保申報表 (勞保、健保及勞退3合1表格)', 'Insurance Declaration Form (Labor Protection, Health Insurance and Retirement 3 in 1 Form)', '加保申报表 (劳保、健保及劳退3合1表格)'],
		'02': ['加保申報表(勞保及勞退2合1表格)', 'Guaranteed Declaration Form (Labor Protection and Retirement 2 in 1 Form)', '加保申报表(劳保及劳退2合1表格)'],
		'03': ['全民健康保險保險對象投保申報表(105.06.23更新)', 'National Health Insurance Insurance Insured Declaration Form (updated at 105.06.23)', '全民健康保险保险对象投保申报表(105.06.23更新)'],
		'05': ['勞工退休金提繳申報表(108年1月修訂版)', 'Labor Pension Payment Return (Revised January, 2008)', '劳工退休金提缴申报表(108年1月修订版)'],
		'06': ['全民健康保險投保金額調整申報表(107.09.27更新)', 'National Health Insurance Insured Amount Adjustment Report (Update 107.09.27)', '全民健康保险投保金额调整申报表(107.09.27更新)'],
		'07': ['全民健康保險保險對象退保申報表(105.06.23更新)', 'National Health Insurance Insurance Objects Return Declaration Form (105.06.23 update)', '全民健康保险保险对象退保申报表(105.06.23更新)'],
		'09': ['全民健康保險對象停、復保申報表(105.06.23更新)', 'National Health Insurance Target Stop and Reinsurance Declaration Form (updated at 105.06.23)', '全民健康保险对象停、复保申报表(105.06.23更新)'],
		'11': ['投保薪資調整表(勞保、健保及勞退3合1表格)', 'Insured salary adjustment form (labor insurance, health insurance and labor retreat 3 in 1 form)', '投保薪资调整表(劳保、健保及劳退3合1表格)'],
		'12': ['投保薪資調整表(勞保及勞退2合1表格)', 'Insured salary adjustment form (labor and retired 2 in 1 form)', '投保薪资调整表(劳保及劳退2合1表格)'],
		'13': ['個人自願提繳率調整表', 'Individual voluntary rate adjustment table', '个人自愿提缴率调整表'],
		'14': ['退保申報表(勞保、健保及勞退3合1表格)', 'Declaration of surrender (labor insurance, health insurance and retired 3 in 1 form)', '退保申报表(劳保、健保及劳退3合1表格)'],
		'15': ['退保申報表(勞保及勞退2合1表格)', 'Refund Declaration Form (Labor Protection and Retirement 2 in 1 Form)', '退保申报表(劳保及劳退2合1表格)'],
		'19': ['勞工保險轉保申報表(勞保及勞退2合1表格)', 'Labor Insurance Transfer Declaration Form (Labor Protection and Retirement 2 in 1 Form)', '劳工保险转保申报表(劳保及劳退2合1表格)'],
		'20': ['勞工保險轉保申報表(勞保及勞退2合1表格)', 'Labor Insurance Transfer Declaration Form (Labor Protection and Retirement 2 in 1 Form)', '劳工保险转保申报表(劳保及劳退2合1表格)'],
		'21': ['勞工退休金停止提繳申報表（105年12月修訂版）', 'Labor Pensions Stop Payment Form (Revised December, December)', '劳工退休金停止提缴申报表（105年12月修订版）'],
		'22': ['提繳工資調整表', 'Payroll adjustment form', '提缴工资调整表'],
		'23': ['雇主提繳率調整表', 'Employer', ''],
		'24': ['職業災害保險加保申報表(勞保及勞退2合1表格)', 'Occupational Disaster Insurance Plus Declaration Form (Labor Protection and Retirement 2 in 1 Form)', '职业灾害保险加保申报表(劳保及劳退2合1表格)'],
		'25': ['職業災害保險退保申報表(勞保及勞退2合1表格)', 'Occupational Disaster Insurance Return Declaration Form (Labor Protection and Retirement 2 in 1 Form)', '职业灾害保险退保申报表(劳保及劳退2合1表格)'],
		'26': ['勞保(含職災保險)勞退二合一加保excel', 'Labor insurance (including occupational disaster insurance) labor retreat two in one plus insurance excel', '劳保(含职灾保险)劳退二合一加保excel'],
		'27': ['勞保(含職災保險)勞退二合一加保txt', 'Labor insurance (including occupational disaster insurance) labor retreat two in one plus insurance txt', '劳保(含职灾保险)劳退二合一加保txt'],
		'28': ['勞保(含職災保險)勞退二合一轉保excel', 'Labor insurance (including occupational disaster insurance) labor return two in one transfer insurance excel', '劳保(含职灾保险)劳退二合一转保excel'],
		'29': ['勞保(含職災保險)勞退二合一轉保txt', 'Labor insurance (including occupational disaster insurance) labor return two in one transfer insurance txt', '劳保(含职灾保险)劳退二合一转保txt'],
		'30': ['勞保(含職災保險)勞退二合一退保excel', 'Labor insurance (including occupational disaster insurance) labor return two in one surrender excel', '劳保(含职灾保险)劳退二合一退保excel'],
		'31': ['勞保(含職災保險)勞退二合一退保txt', 'Labor insurance (including occupational disaster insurance) labor return two in one surrender txt', '劳保(含职灾保险)劳退二合一退保txt'],
		'32': ['勞保(含職災保險)勞退二合一投保薪資調整excel', 'Labor insurance (including occupational disaster insurance) labor retreat two in one insurance salary adjustment excel', '劳保(含职灾保险)劳退二合一投保薪资调整excel'],
		'33': ['勞保(含職災保險)勞退二合一投保薪資調整txt', 'Labor insurance (including occupational disaster insurance) labor retreat two in one insurance salary adjustment txt', '劳保(含职灾保险)劳退二合一投保薪资调整txt'],
		'34': ['勞保(含職災保險)健保勞退三合一加保excel', 'Labor insurance (including occupational disaster insurance) health insurance labor retreat three in one plus insurance excel', '劳保(含职灾保险)健保劳退三合一加保excel'],
		'35': ['勞保(含職災保險)健保勞退三合一加保txt', 'Labor insurance (including occupational disaster insurance) health insurance labor retreat three in one plus insurance txt', '劳保(含职灾保险)健保劳退三合一加保txt'],
		'36': ['勞保(含職災保險)健保勞退三合一退保excel', 'Labor insurance (including occupational disaster insurance) health insurance labor retreat three in one plus insurance excel', '勞保(含職災保險)健保勞退三合一退保excel'],
		'37': ['勞保(含職災保險)健保勞退三合一退保txt', 'Labor insurance (including occupational disaster insurance) health insurance labor retreat three in one plus insurance txt', '勞保(含職災保險)健保勞退三合一退保txt'],
		'38': ['勞保(含職災保險)健保勞退三合一調整excel', 'Labor insurance (including occupational disaster insurance) health insurance labor return three-in-one adjustment excel', '劳保(含职灾保险)健保劳退三合一调整excel'],
		'39': ['勞保(含職災保險)健保勞退三合一調整txt', 'Labor insurance (including occupational disaster insurance) health insurance labor return three-in-one adjustment txt', '劳保(含职灾保险)健保劳退三合一调整txt'],
		'40': ['單獨申報健保異動上傳檔案/薪調', 'Individually filed a health insurance transaction file/salary', '单独申报健保异动上传档案/薪调'],
		'41': ['單獨申報健保異動上傳檔案/員工轉出', 'Separate declaration of health insurance transaction upload file / employee transfer', '单独申报健保异动上传档案/员工转出'],
		'42': ['單獨申報健保異動上傳檔案/員工退保', 'Separate declaration of health insurance upload file / employee surrender', '单独申报健保异动上传档案/员工退保'],
		'43': ['單獨申報健保異動上傳檔案/眷屬轉出', 'Separate declaration of health care change upload file /out', '单独申报健保异动上传档案/眷属转出'],
		'44': ['單獨申報健保異動上傳檔案/眷屬退保', 'Separate declaration of health insurance upload file / surrender', '单独申报健保异动上传档案/眷属退保'],
		'45': ['單獨申報健保異動上傳檔案/員工加保', 'Separate declaration of health insurance upload file / employee plus insurance', '单独申报健保异动上传档案/员工加保'],
		'46': ['單獨申報健保異動上傳檔案/眷屬加保', 'Individually filed a health insurance change upload file / plus insurance', '单独申报健保异动上传档案/眷属加保']
	},
	'pb.insure.source': {
		'1': ['資料輸入', 'Data entry', '资料输入'],
		'2': ['資料匯入', 'Data import', '资料汇入'],
		'3': ['整批加退保', 'Whole batch plus surrender', '整批加退保'],
		'6': ['電子表單', 'Electronic form', '电子表单'],
		'7': ['介接', 'Interface', '介接']
	},
	'pb.insure.status': {
		'1': ['投保中', 'Insured', '投保中'],
		'2': ['已退保', 'Surrendered', '已退保']
	},
	'pb.insure.declaration.format': {
		'1': ['EXCEL申報','EXCEL declaration','EXCEL申报'],
		'2': ['TXT申報','TXT declaration','TXT申报'],
		'3': ['紙本申報','Paper declaration','纸本申报']
	},
	'pb.insure.declaration.type': {
		'1': ['二合一','Two in one','二合一'],
		'2': ['三合一','triple','三合一'],
		'3': ['健保','Health insurance','健保'],
		'4': ['勞退','Retire','劳退'],
		'5': ['勞保','labor protection','劳保'],
	},
	'pb.insure.declaration.status': {
		'11': ['加保檔','Add security','加保档'],
		'21': ['退保檔','Surrender','退保档'],
		'31': ['投保薪資調整檔','Insured salary adjustment','投保薪资调整档'],
		'81': ['育嬰留停續保檔','Retention without pay','育婴留停续保档'],
		'82': ['育嬰留停復保檔','Retention without pay','育婴留停复保档'],
		'12': ['轉保檔','Transfer','转保档'],
		'41': ['停保申報表','Discontinued','停保'],
		'42': ['復保申報表','Reinsured','复保']
	},
	'pb.insure.declaration.status._sort': [11,21,31,81,82,12,41,42],
	'pb.insJob.mode': {
		'1': ['調保','Adjust insurance','调保'],
		'2': ['平移','Pan','平移']
	},
	'pb.insJob.type': {
		'L': ['勞工/職災保險','Labor and Disaster insurance','劳工/职灾保险'],
		'H': ['全民健保','National Health Insurance','全民健保'],
		'R': ['勞工退休金','Labor pension','劳工退休金']
	},
	'pb.insJob.kind': {
		'L': ['勞工保險', 'Labor insurance', '劳工保险'],
		'D': ['職業災害', 'Professional disaster insurance', '职业灾害'],
		'H': ['全民健保','National Health Insurance','全民健保'],
		'R': ['勞工退休金','Labor pension','劳工退休金']
	},
	'pb.insJob.status': {
		'4': ['試算完成','Trial calculation completed','试算完成'],
		'7': ['調保完成','Guarantee completion','调保完成']
	},
	'pb.insJob.adjStatus': {
		'0': ['未處理','Untreated','未处理'],
		'1': ['調整版本','Adjusted version','调整版本'],
		'2': ['調升','Upgrade','调升'],
		'3': ['調降','Downgrade','调降'],
		'4': ['不調整','No adjustment','不调整'],
		'5': ['自選等級未處理','Chosen by Oneself','自选等级未处理']
	},
	'pb.insJob.trnStatus': {
		'0': ['未調整','Not tentative','未试算'],
		'4': ['試算完成','Trial calculation completed','试算完成'],
		'7': ['調保完成','Guarantee completion','调保完成'],
		'9': ['調保失敗','Failed to adjust insurance','调保失败']
	},
	'pb.insVars.item': {
		'ed_emp.NATIONALITY': ['國籍','Country of Citizenship','国籍'],
		'pb_emp_labor.ALIEN_IDC_TYPE': ['外籍身分證號','Foreign Identity Card Number','外籍身分证号'],
		'pb_emp_labor.ALIEN_IDENTITY': ['外籍身分類別','Foreign status category','外籍身分类别'],
		'pb_emp_labor.CRIPPLES_LEVEL': ['勞保身障程度','Labor insurance disability','劳保身障程度'],
		'pb_emp_labor.LABOR_IDENTITY': ['特殊身分別','Special body distinction','特殊身分别'],
		'pb_emp_labor.AMOUNT_ADJUST_TYPE1': ['勞工保險調整方式','Labor insurance adjustment method','劳工保险调整方式'],
		'pb_emp_health.CRIPPLES_LEVEL': ['健保身障程度','Health care disability','健保身障程度'],
		'pb_emp_health.CRIPPLES_IS_SUBSIDIES': ['身障類別納入補助','Disability category inclusion subsidy','身障类别纳入补助'],
		'pb_emp_health.SUBSIDIES_PROJECT_IDS': ['其他補助身分','Other subsidy status','其他补助身分'],
		'pb_emp_health.AMOUNT_ADJUST_TYPE1': ['全民健保調整方式','National health insurance adjustment method','全民健保调整方式'],
		'pb_emp_health.HEALTH_CAUSE': ['眷屬加保原因','Reasons for dependents','眷属加保原因'],
		'pb_emp_retire.LABOR_LAW_IDENTITY': ['勞基法特殊身分','Special status','劳基法特殊身分'],
		'pb_emp_retire.AMOUNT_ADJUST_TYPE1': ['勞工退休金調整方式','Labor pension adjustment method','劳工退休金调整方式']
	},
	'pb.item.baseCode': {
		'LABOR': ['勞保月投保薪資', 'Labor insurance monthly insurance salary', '劳保月投保薪资'],
		'HEALTH': ['健保月投保薪資', 'Health insurance monthly insurance salary', '健保月投保薪资'],
		'RETIRE': ['勞工退休金月投保薪資', 'Labor pension monthly insurance salary', '劳工退休金月投保薪资'],
		'2ND_HEALTH': ['補充保費累計獎金', 'Supplementary premium accumulative bonus', '补充保费累计奖金'],
		'WELFARE': ['福利金', 'Welfare', '福利金'],
		'BONUS': ['獎金提撥', 'Bonus', '奖金提拨'],
		'COURT_REMAIN': ['法院強制執行-剩餘薪資科目', '法院強制執行-剩餘薪資科目EN', '法院強制執行-剩餘薪資科目CN'],
		'COURT': ['法院強制執行-應領薪資科目', '法院強制執行-應領薪資科目EN', '法院強制執行-應領薪資科目CN'],
		'COURT_DED': ['法院強制執行-履行公法義務科目', '法院強制執行-履行公法義務科目EN', '法院強制執行-履行公法義務科目CN'],
		'PREPAID': ['預告期薪資', 'Notice period salary', '预告期薪资'],
		'LAYOFF': ['資遣費平均工資', 'Disbursement fee', '资遣费'],
		'MATERNITY': ['產假薪資差額-當月薪資基數', 'Maternity leave salary difference - the monthly salary base', '产假薪资差额-当月薪资基数'],
		'MATERNITY_AVG': ['產假薪資差額-平均薪資基數', 'Maternity leave salary difference - average salary base', '产假薪资差额-平均薪资基数'],
		'LESS_SHIFT': ['欠(補)班薪資', 'Owe (pay) class salary', '欠(补)班薪资'],
		'ANNUAL': ['特休折現', 'Special discount', '特休折现'],
		'CL': ['補休折現', 'Discounted break', '补休折现'],
		'FLEXIBLE': ['彈性假折現', 'Flexible false discount', '弹性假折现'],
		'LEAVEITEM': ['一般假勤折現', 'General false discount', '一般假勤折现'],
		'OLD_RETIRE': ['舊制退休金提撥', 'Old pension', '旧制退休金提拨'],
		'OLD_RETIRE_AVG': ['舊制退休金平均工資', 'Old pension pension', '旧制退休金平均工资']
	},
	'pb.layoff.avgWageSet': {
		'0': ['參照薪資結構', 'Reference salary structure', '参照薪资结构'],
		'1': ['當月不計算(平均工資區間補足)', 'Not calculated for the month (average salary interval is added)', '当月不计算(平均工资区间补足)']
	},
	'pb.leave.isCount': {
		'0': ['未計薪', 'Unpaid', '未计薪'],
		'1': ['計算中', 'In calculation', '计算中'],
		'2': ['已計薪', 'Payable', '已计薪']
	},
	'pb.oldRetire.avgWageSet': {
		'0': ['參照薪資結構', 'Reference salary structure', '参照薪资结构'],
		'1': ['當月不計算(平均工資區間補足)', 'Not calculated for the month (average salary interval is added)', '当月不计算(平均工资区间补足)']
	},
	'pb.otrange.month': {
		'3': ['3個月', '3 months', '3个月']
	},
	'pb.period.calEnd': {
		'1': ['依截止日', 'By deadline day', '依截止日'],
		'2': ['依截止期限', 'By deadline', '依截止期限']
	},
	'pb.period.calTiming': {
		'1': ['於第一次週期計算', 'Calculated in the first cycle', '于第一次周期计算'],
		'2': ['於第二次週期計算', 'Calculated in the second cycle', '于第二次周期计算'],
		'3': ['於一二週期分別計算', 'Calculated separately in one or two cycles', '于一二周期分别计算']
	},
	'pb.period.calTiming2': {
		'1': ['第一次週期', 'First cycle', '第一次周期'],
		'2': ['第二次週期', 'Second cycle', '第二次周期']
	},
	'pb.period.itemCode': {
		'BORROW': ['薪資借支週期', 'Payroll period', '薪资借支周期'],
		'STRUCT': ['薪資結構週期', 'Pay structure cycle', '薪资结构周期'],
		'FATTN': ['全勤獎金週期', 'Full attendance bonus cycle', '全勤奖金周期'],
		'SHIFT': ['輪班津貼週期', 'Shift allowance cycle', '轮班津贴周期'],
		'INSURE': ['保險費週期', 'Insurance premium cycle', '保险费周期'],
		'LEAVE': ['請假扣款週期', 'Leave deduction cycle', '请假扣款周期'],
		'OT': ['加班費週期', 'Overtime period', '加班费周期'],
		'ATTEND': ['出勤時數週期', 'Attendance hours', '出勤时数周期'],
		'LEAVE_CANCEL': ['銷假還款週期', 'Leave deduction cycle', '销假还款周期'],
		'OT_CANCEL': ['取消加班費週期', 'Overtime period', '加班费周期'],
		'ATTEND_CANCEL': ['取消出勤時數週期', 'Attendance hours', '出勤时数周期'],
		'CARDMATCH': ['刷卡異常結算週期', 'Swipe abnormal billing cycle', '刷卡异常结算周期'],
		'WELFARE': ['福利金計算', 'Benefit settlement cycle', '福利金结算周期'],
		'SAVING': ['強制儲蓄扣款計算', 'Compulsory savings debit settlement cycle', '强制储蓄扣款结算周期'],
		'TAX': ['所得稅計算', 'Income tax settlement period', '所得税结算周期'],
		'COURT': ['法院強制扣款', 'Court compulsory deduction cycle', '法院强制扣款周期'],
		'ALLOT': ['薪資提撥計算', 'Payroll calculation', '薪资提拨计算结算周期'],
		'WORKHOUR': ['排班工時折現計算', 'Scheduling work settlement period', '排班工时结算周期'],
		'LEAVE_PAY': ['假勤折現計算', 'Resignation and settlement', '离职留停结算'],
		'BIZ': ['出差費用計算', 'Travel settlement fee', '出差结算费用']
	},
	'pb.period.month': {
		'-2': ['前二個月', 'The first two months', '前二个月'],
		'-1': ['前一個月', 'Previous month', '前一个月'],
		'0': ['本月', 'Current month', '本月'],
		'1': ['次月', 'Next month', '次月']
	},
	'pb.period.type': {
		'1': ['全月薪', 'Full monthly salary', '全月薪'],
		'2': ['二次薪(分段計算)', 'Second salary (segment calculation)', '二次薪(分段计算)'],
		'3': ['二次薪(借支/結算)', 'Second salary (borrowing/settlement)', '二次薪(借支/结算)']
	},
	'pb.reportType': {
		'04': ['報表1', 'Report1', '報表1'],
		'03': ['報表1', 'Report1', '報表1'],
		'02': ['報表1', 'Report1', '報表1'],
		'01': ['報表1', 'Report1', '報表1']
	},
	'pb.rule.bank.fileFormat': {
		'BIG5': ['BIG5', 'BIG5', 'BIG5'],
		'UTF-8': ['UTF-8', 'UTF-8', 'UTF-8'],
		// '950': ['ANSI', 'ANSI', 'ANSI'],
	},
	'pb.rule.bank.headFootRow': {
		'0': ['無', 'no', '无'],
		'1': ['1行', '1 line', '1行'],
		'2': ['2行', '2 lines', '2行']
	},
	'pb.rule.bank.fileSplitType': {
		'1': ['分隔符號', 'Separator symbol', '分隔符号'],
		'2': ['固定寬度', 'Fixed width', '固定宽度']
	},
	'pb.rule.bank.fileSplitMark': {
		'1': ['Tab', 'Tab', 'Tab'],
		'2': ['分號', 'semicolon', '分号'],
		'3': ['逗號', 'Comma', '逗号'],
		'4': ['空格', 'Space', '空格'],
		'5': ['其他', 'Other', '其他'],
	},
	'pb.rule.bank.settingAlign': {
		'0': ['靠右前補0', 'Back to the right to fill 0', '靠右前补0'],
		'1': ['靠左後補0', 'Back left 0', '靠左后补0'],
		'2': ['靠右前補空格(半型)', 'Right front space (half type)', '靠右前补空格(半型)'],
		'3': ['靠左後補空格(半型)', 'Left back space (half type)', '靠左后补空格(半型)'],
		'4': ['靠右前補空格(全型)', 'Add space to the right front (full type)', '靠右前补空格(全型)'],
		'5': ['靠左後補空格(全型)', 'Left back space (full type)', '靠左后补空格(全型)']
	},
	'pb.rule.bank.settingField': {
		'11I': ['匯出日期', 'Export date', '汇出日期'],
		'12I': ['轉帳日期', 'Transfer date', '转帐日期'],
		'13A': ['轉帳日期序號', 'Transfer date number', '转帐日期序号'],
		'14A': ['匯出時間', 'Export time', '汇出时间'],
		'21A': ['銀行代碼', 'Bank Code', '银行代码'],
		'22C': ['公司分行代碼', 'Company branch code', '公司分行代码'],
		'23A': ['員工分行代碼', 'Employee branch code', '员工分行代码'],
		'31A': ['公司統編', 'Company editor', '公司统编'],
		'32A': ['公司統編中文名稱', 'Company name Chinese name', '公司统编中文名称'],
		'33D': ['公司銀行帳號', 'Company bank account number', '公司银行帐号'],
		'41A': ['員工編號', 'employee ID', '员工编号'],
		'42A': ['員工姓名', 'name of worker', '员工姓名'],
		'43A': ['身分證號', 'Identity card number', '身分证号'],
		'44A': ['員工e-mail', 'Employee e-mail', '员工e-mail'],
		'45A': ['員工帳號', 'Employee account', '员工帐号'],
		'51A': ['轉帳金額', 'Transfer amount', '转帐金额'],
		'52A': ['轉帳金額(小數)', 'Transfer amount (decimal)', '转帐金额(小数)'],
		'53A': ['轉帳總金額', 'Total transfer amount', '转帐总金额'],
		'54A': ['轉帳總金額(小數)', 'Total transfer amount (decimal)', '转帐总金额(小数)'],
		'55A': ['手續費設定', 'Handling fee settings', '手续费设定'],
		'61A': ['幣別', 'Currency', '币别'],
		'71A': ['行數', 'Rows', '行数'],
		'72G': ['行數減X', 'Number of rows minus X', '行数减X'],
		'73G': ['行數加X', 'Number of rows plus X', '行数加X'],
		'74A': ['轉帳筆數', 'Transfer number', '转帐笔数'],
		'75G': ['空格X個', 'Space X', '空格X个'],
		'76B': ['Tab X個', 'Tab X', 'Tab X个'],
		'77G': ['固定值X', 'Fixed value X', '固定值X'],
		'91A': ['本國籍員工檢查碼', 'Nationality employee inspection code', '本国籍员工检查码'],
		'92J': ['世華薪資單日期', 'Shihua pays date', '世华薪资单日期'],
		'93F': ['世華帳號檢查碼', 'Shihua account check code', '世华帐号检查码'],
		'94E': ['世華金額檢查碼', 'Shihua amount check code', '世华金额检查码'],
		'95A': ['永豐銀行安全碼', 'Wing Fung Bank Security Code', '永丰银行安全码'],
		'96H': ['台新銀行企業編碼', 'Taishin Bank Enterprise Code', '台新银行企业编码'],
		'T02': ['台新銀行-手續費總金額', 'Taishin Bank Total Handling Fee', '台新银行-手续费总金额'],
		'T01': ['台新銀行手續費', 'Taishin Bank Handling Fee', '台新银行手续费'],
		'97A': ['彰化銀行核證總數', 'Changhua Bank Certification', '彰化银行核证总数'],
		'98A': ['台中商銀核證總數', 'Total number of Taichung Commercial Bank Certifications', '台中商银核证总数']
	},
	'pb.rule.bank.settingType': {
		'0': ['文件頭(一)', 'Header (1)', '文件头(一)'],
		'1': ['文件頭(二)', 'File header (2)', '文件头(二)'],
		'2': ['文件內容', 'document content', '文件内容'],
		'3': ['文件尾(一)', 'End of file (1)', '文件尾(一)'],
		'4': ['文件尾(二)', 'End of file (2)', '文件尾(二)']
	},
	'pb.rule.basic.monthDayRule': {
		'0': ['當月實際天數', 'Actual number of days in the month', '当月实际天数'],
		'1': ['固定X天', 'Fixed X days', '固定X天']
	},
	'pb.rule.basic.workDayRule': {
		'0': ['實際在職天數', 'Actual working days', '实际在职天数'],
		'1': ['固定X天扣除實際不在職天數', 'Fixed X days deducting actual days of absence', '固定X天扣除实际不在职天数']
	},
	'pb.rule.borrow.type': {
		'1': ['依固定金額發放', 'Issued at a fixed amount', '依固定金额发放'],
		'2': ['依薪資比例發放', 'Issued according to salary ratio', '依薪资比例发放']
	},
	'pb.rule.cardMatch.dedType': {
		'1': ['依固定金額扣款', 'Deducted according to a fixed amount', '依固定金额扣款'],
		'2': ['依薪資比例扣款', 'Deducted according to salary ratio', '依薪资比例扣款']
	},
	'pb.rule.cardMatch.salaryItemSetting': {
		'1': ['依薪資科目基礎','By salary subject basis','依薪资科目基础'],
		'2': ['自行設定','Set your own','自行设定']
	},
	'pb.rule.cardMatch.totalType': {
		'1': ['依每月合計(依週期)', 'On a monthly basis (by cycle)', '依每月合计(依周期)'],
		'2': ['依每日合計', 'Total daily', '依每日合计'],
		'3': ['依每筆計算', 'Calculated per stroke', '依每笔计算'],
		'4': ['依各班別計算', 'Calculated by each class', '依各班别计算']
	},
	'pb.rule.delayMeal.payRule': {
		'1': ['依時數規則計算', 'Calculated by time rule', '依時數規則計算'],
		'2': ['依時段規則計算', 'Calculated according to time period rules', '依時段規則計算'],
		'3': ['依時數及時段規則計算', 'Calculated by hour and time period rules', '依時數及時段規則計算']
	},
	'pb.rule.delayMeal.mergePay': {
		'IS_OT_MERGE': ['同一加班歸屬日，合併加班時數計算誤餐費', 'IS_OT_MERGE', '同时加班归属日，合并加班时数计算误餐费'],
		'IS_NOT_PAY_CL': ['僅申請加班補休時，不予計算誤餐費', 'IS_NOT_PAY_CL', '仅申请加班补休时，不予计算误餐费']
	},
	'pb.rule.fattn.crossLeave': {
		'1': ['列入本週期計算', 'Included in this cycle calculation', '列入本周期计算'],
		'2': ['回歸原週期計算', 'Return to the original cycle calculation', '回归原周期计算']
	},
	'pb.rule.fattn.dedPeriod': {
		'0': ['全月', 'Full moon', '全月'],
		'1': ['第1期', 'Phase 1', '第1期'],
		'2': ['第2期', 'Phase 2', '第2期'],
		'3': ['第3期', 'Phase 3', '第3期'],
		'4': ['第4期', 'Phase 4', '第4期']
	},
	'pb.rule.fattn.itemType': {
		'LEAVE': ['請假資料', 'Leave information', '请假资料'],
		'CARD': ['刷卡異常', 'Swipe abnormal', '刷卡异常']
	},
	'pb.rule.fattn.payRule': {
		'0': ['不予發放', 'Not issued', '不予发放'],
		'1': ['比例發放', 'Prorated distribution', '比例发放']
	},
	'pb.rule.fattn.payRuleItem': {
		'PAY_RULE1': ['到職', 'Arrival', '到职'],
		'PAY_RULE2': ['離職', 'Resignation', '离职'],
		'PAY_RULE3': ['一般留停', 'General unpaid leave', '一般留停'],
		'PAY_RULE4': ['育嬰留停', 'Parental leave', '育婴留停'],
		'PAY_RULE5': ['復職(原:離職)', 'Reinstatement (original: resignation)', '复职(原:离职)'],
		'PAY_RULE6': ['復職(原:一般留停)', 'Reinstatement (original: general unpaid leave)', '复职(原:一般留停)'],
		'PAY_RULE7': ['復職(原:育嬰留停)', 'Reinstatement (original: baby staying)', '复职(原:育婴留停)']
	},
	'pb.rule.leave.dayToHour': {
		'0': ['時薪 = 日薪 / 當日班表工時', 'Hourly hour = daily salary / day shift time', '时薪 = 日薪 / 当日班表工时'],
		'1': ['時薪 = 日薪 / X 小時', 'Hourly rate = daily salary / X hours', '时薪 = 日薪 / X 小时']
	},
	'pb.rule.leave.dayBase': {
		'0': ['當日實際薪資','Actual salary of the day','当日实际薪资'],
		'1': ['當月平均月薪','Average monthly salary for the month','当月平均月薪']
	},
	'pb.rule.leave.monthToDay': {
		'0': ['日薪 = 月薪 / 當月份日曆天數', 'Daily salary = monthly salary / calendar days in the month', '日薪 = 月薪 / 当月份日历天数'],
		'1': ['日薪 = 月薪 / X 天', 'Daily salary = monthly salary / X days', '日薪 = 月薪 / X 天']
	},
	'pb.rule.leaveitem': {
		'1': ['依薪資科目區分應免稅', 'Salary account distinction should be tax-free', '依薪资科目区分应免税'],
		'2': ['全部納入應稅扣款', 'All included in taxable deductions', '全部纳入应税扣款'],
		'3': ['全部納入免稅扣款', 'All included in tax-free deductions', '全部纳入免税扣款'],
		'4': ['無請假扣款科目，直接扣減在原薪資費基科目中', 'No deductions for deductions, direct deductions in the original salary base', '无请假扣款科目，直接扣减在原薪资费基科目中']
	},
	'pb.rule.otBaseRule': {
		'1': ['依薪資科目設定', 'Set by salary account', '依薪资科目设定'],
		'2': ['每小時固定金額', 'Fixed amount per hour', '每小时固定金额']
	},
	'pb.rule.otHourCalType': {
		'1': ['班別實際時數', 'Actual hours by shift', '班别实际时数'],
		'2': ['工作時間', 'Working hours', '工作时间']
	},
	'pb.rule.otStartOpt': {
		'1': ['依加班費週期', 'Iigaban fee cycle', '依加班费周期'],
		'2': ['每月固定X', 'Fixed X days per month', '每月固定X']
	},
	'pb.rule.saving.dedType': {
		'1': ['依固定金額扣款', 'Deducted according to a fixed amount', '依固定金额扣款'],
		'2': ['依薪資比例扣款', 'Deducted according to salary ratio', '依薪资比例扣款']
	},
	'pb.rule.saving.ruleType': {
		'HIRE_DATE': ['到職日期', 'Duty date', '到职日期'],
		'GRADE': ['職等', 'Grade', '职等'],
		'JOB': ['職位', 'position', '职位'],
		'EMP_TYPE': ['直間接別', 'Straight away', '直间接别'],
		'IDENTITY': ['身分類別', 'Identity category', '身分类别'],
		'RESPOBILITY': ['責任區分', 'Responsibility distinction', '责任区分'],
		'WORKYEAR': ['工作年資', 'Work years', '工作年资']
	},
	'pb.ruleWorkAllowance.base': {
		'1': ['以當日輪班津貼金額/當日工作時數', 'The amount of shift allowance for the day / working hours for the day', '以当日轮班津贴金额/当日工作时数'],
		'2': ['以當月輪班津貼金額/當月工作總時數', 'The amount of shift allowance for the current month / total hours of work in the current month', '以当月轮班津贴金额/当月工作总时数']
	},
	'pb.ruleWorkAllowance.baseIn': {
		'1': ['已計入', 'Already counted', '已计入'],
		'0': ['未計入', 'Not counted', '未计入']
	},
	'pb.ruleWorkAllowance.leaveCal': {
		'1': ['以請假時數比例扣除', 'Deducted by the proportion of leave hours', '以请假时数比例扣除'],
		'2': ['以請假時數區間扣除', 'Deducted from the time interval', '以请假时数区间扣除'],
		'3': ['全部扣除', 'Full deduction', '全部扣除'],
		'4': ['不予扣除', 'Not deductible', '不予扣除']
	},
	'pb.ruleWorkAllowance.otCal': {
		'1': ['以加班時數比例發放','Proportion of overtime hours','以加班时数比例发放'],
		'2': ['以加班時數區間發放','Distributed in overtime hours','以加班时数区间发放'],
		'3': ['不論加班時數均發放','Distributed regardless of overtime hours','不论加班时数均发放'],
		'4': ['不予發放','Not issued','不予发放']
	},
	'pb.ruleWorkAllowance.leaveLogic2': {
		'1': ['發給輪班津貼', 'Issued for shift allowance', '发给轮班津贴'],
		'0': ['不發輪班津貼', 'No shift allowance', '不发轮班津贴']
	},
	'pb.ruleWorkAllowance.leaveLogic3': {
		'1': ['加班時數可抵消請假時數', 'Overtime hours can offset the number of hours', '加班时数可抵消请假时数'],
		'0': ['加班時數不可抵消請假時數', 'Overtime hours cannot be offset by the number of hours', '加班时数不可抵消请假时数']
	},
	'pb.ruleWorkAllowance.leaveLogic4': {
		'1': ['當日輪班津貼重計差額', 'Same day shift allowance recalculated', '当日轮班津贴重计差额'],
		'0': ['當日輪班津貼不重計差額', 'The shift allowance for the day does not recalculate the difference', '当日轮班津贴不重计差额']
	},
	'pb.ruleWorkAllowance.leaveLogic5': {
		'1': ['補發給輪班津貼', 'Reissued to shift allowance', '补发给轮班津贴'],
		'0': ['不發輪班津貼', 'No shift allowance', '不发轮班津贴']
	},
	'pb.ruleWorkAllowance.ot2Logic1': {
		'1': ['得超過輪班津貼當日金額', 'More than the amount of the shift allowance on the day', '得超过轮班津贴当日金额'],
		'0': ['不得超過輪班津貼當日金額', 'Do not exceed the amount of the shift allowance on the day', '不得超过轮班津贴当日金额']
	},
	'pb.ruleWorkAllowance.ot2Logic2': {
		'1': ['以前一個工作日班別為計算基礎', 'The class of the previous working day is the basis for calculation', '以前一个工作日的班别为计算基础'],
		'2': ['全月班別相同，以全月班別為計算基礎', 'The calculation is based on the same class throughout the month', '全月班别相同，以全月班别为计算基础']
	},
	'pb.ruleWorkAllowance.pay': {
		'1': ['依當日班別計算', 'Calculated according to the day shift', '依当日班别计算'],
		'2': ['依當日工作時段計算', 'Calculated according to the working hours of the day', '依当日工作时段计算']
	},
	'pb.ruleWorkAllowance.set': {
		'1': ['依班別', 'Dependent', '依班别'],
		'2': ['依時段', 'Time period', '依时段'],
		'3': ['班別及時段均使用', 'Used in class and time', '班别及时段均使用']
	},
	'pb.ruleWorkAllowance.unit': {
		'month': ['每月', 'month', '每月'],
		'day': ['每日', 'day', '每日'],
		'hour': ['每小時', 'hour', '每小时'],
		'half_hour': ['每半小時', 'half hour', '每半小时']
	},
	'pb.salaryItem.class': {
		'0': ['加項', 'Add item', '加项'],
		'1': ['減項', 'Subtraction', '减项'],
		'2': ['提撥', 'Make a call', '提拨']
	},
	'pb.salaryItem.itemArea': {
		'1': ['薪資結構', 'Salary structure', '薪资结构'],
		'2': ['個人加扣項', 'Personal deduction', '个人加扣项'],
		'4': ['獎金紅利', 'Bonus bonus', '奖金红利'],
		'8': ['其他', 'other', '其他'],
		// '16': ['教育訓練類', 'Education and training', '教育训练类'],
		// '32': ['資源管理類', 'Resource management class', '资源管理类'],
		// '64': ['福利補助類', 'Welfare subsidy', '福利补助类']
	},
	'pb.salaryItem.taxType': {
		'1': ['固定薪資', 'Fixed salary', '固定薪资'],
		'2': ['非固定薪資', 'Non-fixed salary', '非固定薪资']
	},
	'pb.salaryItemBase.calMethod': {
		'1': ['依比例計算','Proportional','依比例计算'],
		'2': ['全額計算','Full calculation','全额计算']
	},
	'pb.salaryItemBase.type': {
		'1': ['依薪資科目基礎','By salary subject basis','依薪资科目基础'],
		'2': ['自行設定','Set your own','自行设定']
	},
	'pb.salaryItemValue.setHV': {
		'DEPT_1': ['部門1', 'department1', '部门1'],
		'DEPT_2': ['部門2', 'department2', '部门2'],
		'DEPT_3': ['部門3', 'department3', '部门3'],
		'DEPT_4': ['部門4', 'department4', '部门4'],
		'DEPT_5': ['部門5', 'department5', '部门5'],
		'JOB': ['職位', 'Job', '职位'],
		'GRADE': ['職等', 'Grade', '职等'],
		'LEVEL': ['職等/職級', 'Grade / rank', '职等/职级'],
		'JOB_CAT': ['職務類別', 'Job category', '职务类别'],
		'JOB_STYLE': ['職種', 'Job style', '职种'],
		'IDENTITY': ['身分類別', 'Identity category', '身分类别'],
		'EMP_TYPE': ['直間接別', 'Straight to the other', '直间接别'],
		'RESPOBILITY': ['責任區分', 'Distinction of responsibility', '责任区分'],
		'AREA': ['工作區域', 'Work area', '工作区域'],
		'SITE': ['工作區域/地點', 'Work area / location', '工作区域/地点'],
		'FACTORY': ['廠別', 'Site', '厂别'],
		'SALARY_TYPE': ['計薪方式', 'Paid way', '计薪方式']
	},
	'pb.salaryItemValue.setWay': {
		'1': ['一維運算', 'One-dimensional operation', '一维运算'],
		'2': ['二維運算', 'Two-dimensional operation', '二维运算']
	},
	'pb.salaryJob.class': {
		'1': ['在職','Current employee','在职'],
		'2': ['離職','Terminated employees','离职']
	},
	'pb.salaryJob.bonus.class': {
		'1': ['獨立發放','Independent pay','独立发放'],
		'2': ['併薪發放','With Salary','并薪发放']
	},
	'pb.salaryJob.objectTarget': {
		'0': ['薪資結構計薪範圍內在職員工','Current employees within the salary structure','薪资结构计薪范围内在职员工'],
		'1': ['特定員工','Specific employee','特定员工']
	},
	'pb.salaryJob.PeriodItemCode': {
		'STRUCT': ['薪資結構','Salary structure','薪资结构'],
		'FATTN': ['全勤獎金','Full attendance bonus','全勤奖金'],
		'SHIFT': ['輪班津貼','Shift allowance','轮班津贴'],
		'INSURE': ['保險費','insurance','保险费'],
		'LEAVE': ['請假扣款','Leave for deduction/refund','请假扣款'],
		'LEAVE_CANCEL': ['銷假還款','Leave for deduction/refund','销假还款'],
		'OT': ['加班費','Overtime pay','加班费'],
		'ATTEND': ['出勤時數','Attendance hours','出勤时数'],
		'CARDMATCH': ['刷卡異常扣薪','Abnormal salary deduction','刷卡异常扣薪'],
		'OT_CANCEL': ['取消加班費','Cancel overtime pay','取消加班费'],
		'ATTEND_CANCEL': ['取消出勤時數','Attendance hours','取消出勤时数']
	},
	'pb.salaryJob.progressItem': {
		'BORROW': ['薪資借支', 'Salary loan', '薪资借支'],
		'STRUCT': ['薪資結構', 'Salary structure', '薪资结构'],
		'FATTN': ['全勤獎金', 'Full attendance bonus', '全勤奖金'],
		'SHIFT': ['輪班津貼', 'Shift allowance', '轮班津贴'],
		'LABOR': ['勞保', 'labor protection', '劳保'],
		'HEALTH': ['健保', 'Health insurance', '健保'],
		'RETIRE': ['勞退', 'Retire', '劳退'],
		'2ND_HEALTH': ['補充保費', 'Supplementary premium', '补充保费'],
		'GROUP_INSURANCE': ['團保', 'Group insurance', '团保'],
		'LEAVE': ['請假扣款', 'Leave deduction', '请假扣款'],
		'OT': ['加班費', 'Overtime pay', '加班费'],
		'ATTEND': ['出勤時數', 'Attendance hours', '出勤时数'],
		'LEAVE_CANCEL': ['銷假扣款', 'Sales deduction', '销假扣款'],
		'OT_CANCEL': ['取消加班費', 'Cancel overtime pay', '取消加班费'],
		'ATTEND_CANCEL': ['取消出勤時數', 'Cancel attendance hours', '取消出勤时数'],
		'CARDMATCH': ['刷卡異常結算', 'Swipe abnormal settlement', '刷卡异常结算'],
		'WELFARE': ['福利金結算', 'Benefit settlement', '福利金结算'],
		'SAVING': ['強制儲蓄扣款結算', 'Compulsory savings debit settlement', '强制储蓄扣款结算'],
		'TAX': ['所得稅結算', 'Income tax settlement', '所得税结算'],
		'COURT': ['法院強制扣款', 'Court compulsory deduction', '法院强制扣款'],
		'ALLOT': ['薪資提撥計算結算', 'Payroll calculation', '薪资提拨计算结算']
	},
	'pb.salaryJob.quitPeriod': {
		'1': ['依原計薪週期','Pay-as-you-go','依原计薪周期'],
		'2': ['計算至離職/留停日','Calculate to the date of separation/retention','计算至离职/留停日']
	},
	'pb.salaryJob.quitPeriodItemCode': {
		'LEAVE': ['請假扣款','Leave for deduction','请假扣款'],
		'LEAVE_CANCEL': ['銷假還款','Leave for refund','销假还款'],
		'OT': ['加班費','Overtime pay','加班费'],
		'CARDMATCH': ['刷卡異常扣薪','Abnormal salary deduction','刷卡异常扣薪']
	},
	'pb.salaryJob.calculationItemCode':{
		'DEDUCTION':['加扣項','Deduction','加扣項'],
		'OT':['加班費','Overtime pay','加班费'],
		'LEAVE_PAY':['假勤折現','Fake discount','假勤折现'],
		'LEAVE_CANCEL':['銷假扣款','Sales deduction','销假扣款'],
		'LEAVE_OL':['假勤超休扣回','Deductions for overtime leave','假勤超休扣回'],
		'LEAVE':['請假扣款','Leave deduction','请假扣款'],
		'ATTEND_AD':['出勤異常扣薪','Abnormal attendance deduction','出勤异常扣薪'],
	},
	'pb.salaryJob.source': {
		'M': ['人工輸入', 'Manual input', '人工输入'],
		'A': ['自動排程', 'Automatic scheduling', '自动排程']
	},
	'pb.salaryJob.status': {
		'0': ['未計算','Not calculated','未计算'],
		'2': ['計算中','Calculating','计算中'],
		'3': ['計算失敗','Calculation failed','计算失败'],
		'4': ['計算完畢(有異常)','Completion of calculation (abnormal)','计算完毕(有异常)'],
		'5': ['計算完畢','Calculated','计算完毕'],
		'6': ['結檔中','Closing','结档中'],
		'7': ['已結檔','Closed','已结档']
	},
	'pb.salaryJob.timing1': {
		'1': ['第一次週期', 'First cycle', '第一次周期'],
		'2': ['第二次週期', 'Second cycle', '第二次周期']
	},
	'pb.salaryJob.timing2': {
		'1': ['借支', 'Borrow', '借支'],
		'2': ['結算', 'Settlement', '结算']
	},
	'pb.salaryJobBonus.set1.opt': {
		'1': ['固定金額','fixed amount','固定金额'],
		'2': ['計算公式','Calculation formula','计算公式']
	},
	'pb.salaryJobBonus.set1.percentRule': {
		'1': ['在職比例','Serving ratio','在职比例'],
		'2': ['不依比例','Not to scale','不依比例']
	},
	'pb.salaryJobBonus.set1.fixed': {
		'1': ['個','one','个'],
		'10': ['十','ten','十'],
		'100': ['百','hundred','百'],
		'1000': ['千','thousand','千'],
		'10000': ['萬','Million','万']
	},
	'pb.salaryJobBonus.set2.opt': {
		'1': ['當月天數','Number of days in the month','当月天数'],
		'2': ['固定X天','Fixed X days','固定X天']
	},
	'pb.subsidies.dataType': {
		'1': ['身障補助規則', 'Disability support rules', '身障补助规则'],
		'2': ['其他身分補助規則', 'Other identity grant rules', '其他身分补助规则']
	},
	'pb.subsidies.insureType': {
		'LABOR': ['勞保', 'labor protection', '劳保'],
		'HEALTH': ['健保', 'Health insurance', '健保']
	},
	'pb.subsidies.unit': {
		'1': ['元', 'dollar', '元'],
		'2': ['％', '％', '％']
	},
	'pb.tax.calType': {
		'0': ['依照速算公式', 'According to the quick calculation formula', '依照速算公式'],
		'1': ['依扣繳稅額表', 'Dependent tax payment schedule', '依扣缴税额表']
	},
	'pb.template.type': {
		'1': ['薪資規則範本', 'Salary rule template', '薪资规则范本'],
		'2': ['薪資結構範本', 'Salary structure template', '薪资结构范本']
	},
	'pb.incdec.snoSel': {
		'1': ['依員工扣繳統編', "According to the employee's deduction", '依员工扣缴统编'],
		'2': ['指定扣繳統編', 'Designated withholding', '指定扣缴统编']
	},
	'pb.salaryClose.lock': {
		'0': ['未鎖定','unlock','未鎖定'],
		'1': ['已鎖定','locking','已鎖定']
	},
	'pb.salaryClose.lockHistory': {
		'0': ['解鎖','Unlock','解锁'],
		'1': ['鎖定','locking','锁定']
	},
	'pb.salaryClose.stopStatus': {
		'0': ['未設定','UnSetting','未設定'],
		'1': ['止付','Stop payment','止付'],
		'2': ['取消止付','Cancel stop payment','取消止付']
	},
	'pb.paysheet.lang': {
		'zh_TW': ['繁體中文','traditional Chinese','繁体中文'],
		'zh_CN': ['簡體中文','Simplified Chinese','简体中文'],
		'en_US': ['英文','English','英文'],
		'id': ['印尼文','Indonesian','印尼文'],
		'vi': ['越南文','Vietnamese','越南文'],
		'th': ['泰文','Thai','泰文']
	},
	'pb.paysheet.passwordDefault': {
		'2': ['身分證號／統一證號(護照號碼)','Identity card number / unified card number (passport number)','身分证号／统一证号(护照号码)'],
		'3': ['員工編號+生日(yyyymmdd)','Employee number + birthday (yyyymmdd)','员工编号+生日(yyyymmdd)']
	},
	'pb.paysheet.loginMethod': {
		'1': ['預設密碼(1種忘密規則)','Default password (1 kinds of forgetting rules)','预设密码(1种忘密规则)'],
		'2': ['預設密碼(2種忘密規則)','Default password (2 kinds of forgetting rules)','预设密码(2种忘密规则)']
	},
	'pb.paysheet.loginMethod._sort': [2,1],
	'pb.paysheet.forgotPassword': {
		'1': ['寄發密碼通知函','Send password notification letter','寄发密码通知函'],
		'2': ['通知HR處理','Notify HR processing','通知HR处理']
	},
	'pb.paysheet.passwordRule9': {
		'1': ['前','before','前'],
		'2': ['後','after','后']
	},
	'pb.paysheet.format.sendType': {
		'1': ['紙本','Paper','纸本'],
		'2': ['Email','Email','Email'],
		'3': ['電子薪資袋','Electronic Payroll','电子薪资袋']
	},
	'pb.paysheet.format.paperSize': {
		'1': ['中一刀','One hit','中一刀'],
		'2': ['A4尺寸','A4 size','A4尺寸']
	},
	'pb.paysheet.format.templateType': {
		'1': ['套表','settable','套表'],
		'2': ['非套表','non-settable','非套表']
	},
	'pb.paysheet.format.foreignNameType': {
		'1': ['英文姓名','English name','英文姓名'],
		'2': ['護照姓名','Passport name','护照姓名']
	},
	'pb.paysheet.format.coNameDesc': {
		'1': ['依組織圖顯示','Show by organization chart','依组织图显示'],
		'2': ['依當月計算歸屬顯示','Calculate attribution display based on current month','依当月计算归属显示']
	},
	'pb.paysheet.msg.effType': {
		'1': ['依生效期間','According to the effective period','依生效期间'],
		'2': ['依指定結檔薪資','According to the specified final salary','依指定结档薪资']
	},
	'pb.paysheet.format.printOtType': {
		'1': ['不顯示','Do not show','不显示'],
		'2': ['免稅/應稅加班時數分開列印','Duty-free/taxable overtime hours are printed separately','免税/应税加班时数分开列印'],
		'3': ['免稅/應稅加班時數合併列印為「加班總時數」','Duty-free/taxable overtime hours are combined and printed as total overtime hours','免税/应税加班时数合并列印为「加班总时数」'],
		'4': ['只列印免稅加班時數','Only print duty-free overtime hours','只列印免税加班时数']
	},
	'pb.paysheet.accountStatus': {
		'1': ['待啟用','To be activated','待启用'],
		'3': ['啟用','Enable','启用'],
		'4': ['停用','Deactivate','停用'],
		'2': ['鎖定','locking','锁定']
	},
	'pb.paysheet.passwordStatus': {
		'1': ['預設密碼','Default password','预设密码'],
		'2': ['員工自設','Employee','员工自设']
	},
	'pb.paysheet.logType': {
		'11': ['登入成功','sign in suceesfully','登入成功'],
		'21': ['登入失敗','Login failed','登入失败'],
		'31': ['密碼變更成功','Password changed successfully','密码变更成功'],
		'32': ['密碼變更失敗','Password change failed','密码变更失败'],
		'41': ['提交忘記密碼請求','Submit a forgotten password request','提交忘记密码请求'],
		'51': ['密碼被啟用','Password is enabled','密码被启用'],
		'52': ['密碼被停用','Password is disabled','密码被停用'],
		'53': ['密碼被鎖定','Password is locked','密码被锁定'],
		'61': ['發送[密碼變更提醒] 通知信','Send [password change reminder] notification letter','发送[密码变更提醒] 通知信'],
		'62': ['發送[密碼通知信] 通知信','Send [password notification letter] notification letter','发送[密码通知信] 通知信'],
		'63': ['發送[重設密碼] 通知信','Send [Reset Password] notification letter','发送[重设密码] 通知信'],
		'64': ['發送[變更薪資袋密碼通知] 通知信','Send the notification letter of [Payroll Password Change Notification]','发送[变更薪资袋密码通知] 通知信'],
		'65': ['發送[員工薪資袋密碼異常] 通知信','Send [Employee Pay Bag Password Abnormal] Notification Letter','发送[员工薪资袋密码异常] 通知信'],
		'71': ['還原成預設密碼','Restore to default password','还原成预设密码'],
		'81': ['登入時薪資袋密碼未啟用','Paybag password is not enabled when logging in','登入时薪资袋密码未启用']
	},
	'pb.paysheet.insuranceType': {
		'1': ['勞工保險','Labor insurance','劳工保险'],
		'2': ['職災保險','Occupational Accident Insurance','职灾保险'],
		'4': ['全民健保','National Health Insurance','全民健保'],
		'8': ['勞工退休金','Labor pension','劳工退休金'],
	},
	'pb.salaryClose.paysheet.logType': {
		'11': ['薪資袋紙本列印','Payroll printing on paper','薪资袋纸本列印'],
		'12': ['薪資袋Email寄發','Payroll email sent','薪资袋Email寄发'],
		'13': ['電子薪資袋開放','Electronic payroll opening','电子薪资袋开放'],
		'21': ['薪資袋紙本格式調整','Adjustment of paper format of salary bag','薪资袋纸本格式调整'],
		'22': ['薪資袋Email 格式調整','Payroll email format adjustment','薪资袋Email 格式调整'],
		'23': ['電子薪資袋格式調整','Electronic payroll format adjustment','电子薪资袋格式调整'],
		'31': ['薪資袋明細格式調整','Payroll details format adjustment','薪资袋明细格式调整'],
		'41': ['員工開啟電子薪資袋','Employees open electronic payroll','员工开启电子薪资袋']
	},
	'pb.salaryClose.export.nameType': {
		'1': ['姓名','Name','姓名'],
		'2': ['護照姓名','Passport name','护照姓名']
	},
	'pb.salaryClose.export.idnoType': {
		'1': ['外籍人員統一證號','Uniform Certificate Number for Foreigners','外籍人员统一证号'],
		'2': ['護照證號','Passport number','护照证号']
	},
	'pb.salaryClose.export.transferType': {
		'3': ['薪資／獎金','Salary/bonus','薪资／奖金'],
		'9': ['強制儲蓄','Mandatory savings','强制储蓄']
	},
	'pb.salaryClose.export.mergeType': {
		'1': ['合併出帳','Consolidated accounts','合并出帐'],
		'2': ['分扣繳單位出帳','Separate accounts','分扣缴单位出帐']
	},
	'pb.salaryClose.export.bankGroupType': {
		'1': ['銀行','bank','银行'],
		'2': ['部門','department','部门']
	},
	'pb.taxyear.dataSource': {
		'1': ['薪資結檔','Salary closing','薪资结档'],
		'8': ['手動匯入','Import manually','手动汇入'],
		'9': ['手動調整','Manual maintenance','手动维护']
	},
	'pb.teaxyear.identityType': {
		'0': ['0 本國個人','0 National Individual','0 本国个人'],
		'1': ['1 事業團體','1 Business group','1 事业团体'],
		'3': ['3 境內住滿183天之外僑或大陸地區人民','3 Aliens or people from mainland China who have lived in the Republic of China for 183 days','3 在中华民国境内住满183天之外侨或大陆地区人民'],
		'4': ['4 總機構在境外之在臺分公司','4 The income person is a branch in Taiwan whose head office is outside the Republic of China','4 所得人为总机构在中华民国境外之在台分公司'],
		'5': ['5 境內未住滿183天之大陸地區人民','5 People in mainland China who have not lived in the Republic of China for 183 days','5 在中华民国境内未住满183天之大陆地区人民'],
		'6': ['6 在大陸地區單位','6 Units in the mainland','6 在大陆地区单位'],
		'7': ['7 境內未住滿183天之外僑','7 Aliens who have not lived in the Republic of China for 183 days','7 在中华民国境内未住满183天之外侨'],
		'8': ['8 總機構在境外之法人、團體或其他機構','8 Legal persons, organizations or other institutions whose head office is outside the Republic of China','8 总机构在中华民国境外之法人、团体或其他机构'],
		'9': ['9 非屬居住者之本國個人','9 The income person is a non-resident individual','9 所得人为非属居住者之本国个人'],
		'A': ['A 在本國籍漁船工作滿183天且無居留證之外僑或大陸地區人民','A The income earners are foreigners or people from mainland China who have worked on a fishing boat of the Republic of China nationality for 183 days without a residence permit','A 所得人为在中华民国国籍渔船工作满183天且无居留证之外侨或大陆地区人民']
	},
	'pb.teaxyear.nonempType': {
		'0': ['自然人','Natural person','自然人'],
		'1': ['公司行號','Company line number','公司行号']
	},
	'pb.teaxyear.certType': {
		'1': ['免填發','Free','免填发'],
		'2': ['電子憑單','Electronic voucher','电子凭单'],
		'3': ['紙本憑單','Paper voucher','纸本凭单']
	},
	'pb.teaxyear.certKind': {
		'1': ['扣繳憑單','Withholding Voucher','扣缴凭单'],
		'2': ['勞健保證明','Labor and health guarantee','劳健保证明'],
		'3': ['補充保費證明','Proof of supplementary premium','补充保费证明']
	},
	'pb.teaxyear.payFormat': {
		'1': ['薪資','Salary','薪资'],
		'2': ['非薪資','Non-salary','非薪资']
	},
	'reg.license.downloadStatus': {
		'0': ['下載中', 'downloading', '下载中'],
		'1': ['下載成功', 'download successful', '下载成功']
	},
	'sa.auth.dataSource': {
		'B': ['後台', 'HR Max', '后台'],
		'F': ['Portal', 'Portal', 'Portal']
	},
	'sa.auth.target': {
		'0': ['全部排班管理人員', 'All shift managers', '全部排班管理人员'],
		'1': ['部分排班管理人員', 'Some shift managers', '部分排班管理人员'],
		'2': ['不開放前台使用', 'Reception not open', '不开放前台使用']
	},
	'sa.check.objectTarget':{
		'1':['所有排班員工'],
		'2':['選擇排班群組'],
		'3':['部分員工'],
	},
	'sa.check.rule':{
		'1':['區間內皆未排班'],
		'2':['區間內任一天未排班'],
		'3':['區間內任一天工作日已排班別時數加總小於以下設定'],
	},
	'sa.export.info':{
		'1':['排班標籤','Shift label','排班标签'],
		'2':['員工部門','Dept.','员工部门'],
		'3':['員工職位','Position','员工职位'],
		'4':['班表統計資料','Shift statistics','班表统计资料'],
		'5': ['變形工時線', 'Flexible working hour schedule', '变形工时线'],
	},
	'sa.export.info._sort': [5, 1, 2, 3, 4],
	'sa.export.format':{
		'1':['顯示前X個字','Show the first X words','显示前X个字'],
		'2':['顯示完整名稱','Display full name','显示完整名称'],
		// '3':['顯示特殊符號','Display special symbols','显示特殊符号'],
	},
	'sa.group.period': {
		'1': ['固定週期', 'Fixed cycle', '固定周期'],
		'2': ['依照工時規則週期', 'Cycle based on working hour regulations', '依照工时规则周期']
	},
	'sa.group.preUseData': {
		'W': ['工作標籤', 'Work label', '工作标签'],
		'S': ['班別', 'Class', '班别'],
		'L': ['請假', 'Leave', '请假'],
		'4': ['例假日', 'Holiday', '例假日'],
		'3': ['休息日', 'off day', '休息日'],
		'2': ['國定假日', 'National holiday', '国定假日']
	},
	'sa.group.shiftType': {
		'2': ['班別排班', 'Rotating shifts (by shift)', '班别排班'],
		'3': ['時段排班', 'Rotating shifts (by period)', '时段排班']
	},
	'sa.job.status': {
		'1': ['排班中', 'Scheduling', '排班中'],
		'2': ['待審核', 'Pending review', '待审核'],
		'200': ['已發佈', 'Published', '已发布']
	},
	'sa.job.perUseData': {
		'1': ['工作日', 'Workday', '工作日'],
		'2': ['國定假日', 'National holiday', '国定假日'],
		'3': ['休息日', 'off day', '休息日'],
		'4': ['例假日', 'Holiday', '例假日'],
		'5': ['空班', 'Empty class', '空班'],
		'S': ['班別', 'Class', '班别'],
		'W': ['標籤', 'Label', '标签'],
		// 'L': ['預請假', 'Advance Leave', '預请假'], //暫時先隱藏
		// 'O': ['預加班', 'Pre-work overtime', '預加班'], //暫時先隱藏
	},
	'sa.range.min': {
		'15': ['15 分鐘', '15 minutes', '15分钟'],
		'30': ['30 分鐘', '30 minutes', '30分钟'],
		'60': ['1 小時', '1 hour', '1小时']
	},
	'sa.rule.holidayCalRule': {
		'1': ['當月依比例計算', 'The month is calculated according to the ratio', '当月依比例计算'],
		'2': ['當月不予計算', 'Not calculated for the month', '当月不予计算'],
		'3': ['當月全部給予', 'All given in the month', '当月全部给予']
	},
	'sa.rule.holidayCalType': {
		'1': ['依行事曆', 'Dependent calendar', '依行事历'],
		'2': ['自行設定每月天數', 'Set your own number of days per month', '自行设定每月天数']
	},
	'sa.rule.less': {
		'L1': ['不處理(不扣款、不補班)', 'Not processed (no deduction, no replenishment)', '不处理（不扣款，不补班）'],
		'L2': ['欠班扣款(依薪資科目【欠班扣款】扣款)', 'Derelict deductions (according to salary subjects [deduction of deductions] deductions)', '欠班扣款（依薪资科目【欠班扣款】扣款）'],
		'L3': ['欠班補班(結算後，系統自動將欠班時數延至次月工時)', 'After the class is replenished (after the settlement, the system automatically delays the time of the class to the next month)', '欠班补班（结算后，系统自动将欠班时数延至次月工时）'],
		'L4': ['欠班扣假(結算後，系統自動寫入請假記錄)', 'Derelict deduction (after the settlement, the system automatically writes the leave record)', '欠班扣假（结算后，系统自动写入请假记录）']
	},
	'sa.rule.offKind': {
		'1': ['依行事曆之例假日、休息日排休', 'According to the calendar of holidays, rest days', '依行事历之例假日，休息日排休'],
		'2': ['依行事曆之例假日、休息日天數，自行排休', 'According to the calendar of holidays, the number of days off, and self-discharge', '依行事历之例假日，休息日天数，自行排休'],
		'3': ['星期固定日排休', 'Week fixed day', '星期固定日排休'],
		'4': ['每月固定天數排休', 'Fixed days per month', '每月固定天数排休']
	},
	'sa.rule.offKindValue': {
		'3': ['休息日', 'off day', '休息日'],
		'4': ['例假日', 'Holiday', '例假日']
	},
	'sa.rule.over': {
		'O1': ['不處理 (不發薪、不扣次月時數)', 'Not processed (no pay, no deduction for the next month)', '不处理（不发薪，不扣次月时数）'],
		'O2': ['超時給薪(依薪資科目【超時排班給薪】發放)', 'Time-out pay (according to salary account [timeout shift pay)]', '超时给薪（依薪资科目【超时排班给薪】发放）'],
		'O3': ['超時抵班(結算後，系統自動將超時時數扣次月工時)', 'Timeout arrives (after settlement, the system automatically deducts the timeout for the next month)', '超时抵班（结算后，系统自动将超时时数扣次月工时）'],
		'O4': ['超時加班(結算後，系統自動寫入加班記錄)', 'Overtime overtime (after settlement, the system automatically writes overtime records)', '超时加班（结算后，系统自动写入加班记录）']
	},
	'sa.rule.period': {
		'-1': ['上一個月', '1 month before', '上1个月'],
		'0': ['本月', 'this month', '本月'],
		'1': ['次月', 'next month', '次月']
	},
	'sa.shift.stat': {
		'1': ['排班時數彙總表', 'Shift hours summary', '排班时数汇总表'],
		'2': ['人力明細表（依員工／時段）', 'Manpower details by employee/period', '人力明细表（依员工／时段）'],
		'3': ['人力統計表（依班別／日期）', 'Manpower statistics by shift/date', '人力统计表（依班别／日期）'],
		'4': ['人力統計表（依時段／日期）', 'Manpower statistics by period/date', '人力统计表（依时段／日期）']
	},
	'sa.transfer.type': {
		'1': ['與其它日期對調', 'Interact with other dates', '与其它日期对调'],
		'2': ['直接調整', 'Direct adjustment', '直接调整'],
		'3': ['與其他人對調', 'Align with others', '与其他人对调']
	},
	'sys.config.columnType': {
		'char': ['字串', 'String', '字串'],
		'textarea': ['字串(多筆)', 'String (multiple)', '字串(多笔)'],
		'yyyymmdd': ['日期', 'Date', '日期'],
		'yyyymm': ['年月', 'Year and month', '年月'],
		'yyyy': ['年度', 'Year', '年度'],
		'int': ['整數', 'Integer', '整数'],
		'list': ['下拉值', 'List value', '下拉值']
	},
	'sys.config.dataSrc': {
		'1': ['預設', 'Default', '预设'],
		'2': ['自訂', 'Customize', '自订']
	},
	'sys.config.fieldAlign': {
		'left': ['向左', 'left', '向左'],
		'right': ['向右', 'right', '向右'],
		'center': ['置中', 'center', '置中']
	},
	'sys.job.cycleType': {
		'day': ['天', 'day', '天'],
		'week': ['週', 'week', '周'],
		'month': ['月', 'month', '月']
	},
	'sys.job.execSet': {
		'1': ['指定時間執行', 'Specify the time to execute', '指定时间执行'],
		'2': ['重複執行', 'Repeat execution', '重复执行'],
		'3': ['自訂頻率', 'Manual execution', '人工执行']
	},
	'sys.job.programType': {
		'0': ['SQL程式', 'SQL program', 'SQL程式'],
		'1': ['eHRMS 程式', 'EHRMS program', 'eHRMS 程式'],
		'2': ['外部程式', 'External program', '外部程式']
	},
	'sys.job.status': {
		'0': ['未啟動', 'have not started', '未启动'],
		'1': ['進行中', 'processing', '进行中']
	},
	'sys.log.eventKind': {
		'info': ['訊息', 'message', '讯息'],
		'err': ['錯誤', 'error', '错误'],
		'imp': ['重大', 'major', '重大']
	},
	'sys.log.loginStatus': {
		'info11': ['登入成功', 'sign in suceesfully', '登入成功'],
		'info12': ['登出成功', 'Log out successfully', '登出成功'],
		'info13': ['密碼變更成功', 'Password changed successfully', '密码变更成功'],
		'err21': ['登入失敗', 'Login failed', '登入失败'],
		'err22': ['帳號鎖定中', 'Account is locking', '帐号锁定中'],
		'err23': ['帳號已關閉', 'Account closed', '帐号已关闭'],
		'err25': ['帳號IP錯誤', 'Account IP error', '帐号IP错误'],
		'err24': ['帳號未認證', 'Account is not certified', '帐号未认证'],
		'err26': ['輸入太多次錯誤,帳號已被鎖定', 'The account has been locked due to too many errors', '输入太多次错误,帐号已被锁定']
	},
	'sys.log.type': {
		'1': ['資料搜尋', 'Data search', '资料搜寻'],
		'2': ['新增存檔', 'Add archives', '新增存档'],
		'4': ['修改存檔', 'Modify the archive', '修改存档'],
		'5': ['刪除', 'delete', '删除']
	},
	'sys.mailJob.status': {
		'0': ['失敗', 'failure', '失败'],
		'1': ['成功', 'success', '成功'],
		'2': ['排程中', 'Scheduled', '排程中']
	},
	'sys.module': {
		'OS': ['組織模組', 'Organization module', '组织模组'],
		'ED': ['人事模組', 'Personnel module', '人事模组'],
		'AM': ['出勤模組', 'Attendance module', '出勤模组'],
		'PB': ['薪資模組', 'Payroll module', '薪资模组'],
		'WF': ['表單模組', 'Form module', '表单模组'],
		'PORTAL': ['員工入口網站', 'Employee portal', '员工入口网站'],
		'SA': ['排班模組', 'Shift module', '排班模组'],
		'AC': ['權限模組', 'Permission module', '权限模组']
	},
	'sys.notify.expiredBF': {
		'1': ['前', 'before', '前'],
		'2': ['後', 'Rear', '后']
	},
	'sys.notify.expiredType': {
		'1': ['依基準日', 'By base date', '依基准日'],
		'2': ['依日期期間', 'Period by date', '依日期期间'],
		'3': ['不需通知規則', 'expiredType is not required', '不需通知规则']
	},
	'sys.notify.expiredUnit': {
		'day': ['天', 'day', '天'],
		'month': ['月', 'month', '月']
	},
	'sys.notify.object': {
		'10': ['本人', 'Self', '本人'],
		'20': ['主管', 'Supervisor', '主管'],
		'30': ['指定學員', 'Designated student', '指定学员'],
		'31': ['符合報名資格員工', 'In line with the qualifications of employees', '符合报名资格员工'],
		'32': ['報名學員', 'Enroll students', '报名学员'],
		'33': ['訓練課程講師', 'Training course instructor', '训练课程讲师'],
		'41': ['考評人員', 'Evaluation staff', '考评人员'],
		'42': ['評核人員', 'Assessment staff', '评核人员'],
		'90': ['業務承辦人', 'Designated staff', '业务承办人']
	},
	'sys.todo.object': {
		'OS110':['部門主管未設定', '', ''],
		'OS120':['部門副主管未設定', '', ''],
		'ED110':['錄取待報到', '', ''],
		'ED120':['出境日到期', '', ''],
		'ED130':['居留證到期', '', ''],
		'ED140':['試用期待評核', '', ''],
		'ED150':['留職停薪將復職', '', ''],
		'AM110':['出勤規則未設定', '', ''],
		'AM120':['打卡異常未處理', '', ''],
		'AM130':['超時出勤未處理', '', ''],
		'AM140':['離職/留停員工特休假待結轉', '', ''],
		'AM150':['離職/留停員工補休假待結轉', '', ''],
		'AM160':['離職/留停員工彈性假待結轉', '', ''],
		'AM170':['年度特休假待結轉', '', ''],
		'AM180':['年度補休假待結轉', '', ''],
		'AM190':['年度彈性假待結轉', '', ''],
		'AM200':['員工工時異常', '', ''],
		'WF110':['文件申請單待處理', '', ''],
		'PB110':['員工未敘薪', '', ''],
		'PB120':['員工成本中心未設定', '', ''],
		'PB130':['員工法扣償還將到期', '', ''],
		'PB140':['員工未加保', '', ''],
		'PB150':['員工未加保勞保', '', ''],
		'PB160':['員工未加保健保', '', ''],
		'PB170':['員工未加保勞退', '', ''],
		'PB180':['眷屬未加保', '', ''],
		'PB190':['眷屬未加保', '', ''],
		'PB200':['離職/留停未退保', '', ''],
		'PB210':['離職/留停勞保未退保', '', ''],
		'PB220':['離職/留停健保未退保', '', ''],
		'PB230':['離職/留停勞退未退保', '', ''],
		'PB240':['身心障礙類別補助未納入健保', '', ''],
		'PB250':['眷屬身心障礙類別補助未納入健保', '', ''],
		'PB260':['員工電子薪資袋未啟用', '', ''],
		'PB270':['薪資袋未發放', '', ''],
		'PB280':['結檔資料未匯出', '', ''],
		'PB290':['平移新年度投保版本', '', ''],
		'PB300':['平移新年度勞保投保版本', '', ''],
		'PB310':['平移新年度健保投保版本', '', ''],
		'PB320':['平移新年度勞退投保版本', '', ''],
		'PB330':['新年度所得稅規則已更新', '', ''],
		'AM210':['更新新年度行事曆', '', ''],
		'AM220':['育嬰留停復職特休可休截止日修改提醒', '', ''],
		'AM230':['育嬰留停復職補休可休截止日修改提醒', '', ''],
	},
	'sys.upload.storage': {
		'1': ['實體檔案', 'Entity file', '实体档案'],
		'2': ['Base64', 'Base64', 'Base64编码']
	},
	'sys.userJob.execStatus': {
		'0': ['未執行', 'Not performed', '未执行'],
		'1': ['執行中', 'In progress', '执行中'],
		'2': ['執行完成', 'Execution completed', '执行完成'],
		'3': ['執行異常', 'Execution exception', '执行异常'],
		'9': ['已取消', 'Cancelled', '已取消']
	},
	'sys_code:sys.userJob.type': {
		'1': ['報表類', 'Report class', '报表类'],
		'2': ['計算類', 'Computing class', '计算类']
	},
	'sys.progressJob.show1': {
		'0': ['未計算', 'Not calculated', '未计算'],
		'2': ['計算中', 'Calculation in progress', '计算中'],
		'3': ['計算失敗', 'Calculation failed', '计算失败'],
		'4': ['計算完成(有異常)', 'Calculation completed (with error)', '计算完成(有异常)'],
		'5': ['計算完成', 'Calculation completed', '计算完成'],
		'11': ['驗證完成', 'Verification complete', '验证完成'],
		'21': ['作業完成(全部成功)', 'Job completed (all successful)', '作业完成(全部成功)'],
		'22': ['作業完成', 'Job complete', '作业完成'],
		'23': ['作業結束', 'Job done', '作业結束'],
		'31': ['作業失敗', 'Job failed', '作业失败'],
		'41': ['驗證進行中…', 'Verification in progress...', '验证进行中…'],
		'51': ['作業進行中…', 'Job in progress...', '作业进行中…'],
		'61': ['作業取消', 'Cancel job', '作业取消'],
		'91': ['作業失敗', 'Job failed', '作业失败'],
	},
	'sys.progressJob.type': {
		'1': ['匯入作業','Import operation','汇入作业'],
		'2': ['匯出作業','Export','汇出作业'],
		'3': ['批次作業','Batch job','批次作业'],
		'4': ['薪資計算','Salary calculation','薪资计算'],
	},
	'ux.msgIntent': {
		'1': ['匯入作業', 'Import operation', '汇入作业'],
		'2': ['匯出作業', 'Export operation', '汇出作业'],
		'3': ['薪資計算', 'Salary calculation', '薪资计算'],
		'4': ['建立公司', 'Establish companies', '建立公司']
	},
	'sys.progressJob.show2': {
		'23': ['匯出完成','Export completed','汇出完成'],
		'31': ['匯出失敗','Export failed','汇出失败'],
		'51': ['匯出進行中…','Export in progress...','汇出进行中…'],
		'91': ['匯出失敗','Export failed','汇出失败'],
	},
	'sys.progressJob.show3': {
		'23': ['作業完成','Homework completed','作业完成'],
		'31': ['作業失敗','Job failed','作业失败'],
		'51': ['作業進行中…','Work in progress...','作业进行中…'],
	},
	'sys.dataEdit.faeType': {
		'1': ['修改員工編號','Modify employee number','修改员工编号'],
		'2': ['修改到職日、工作/退休年資起算日','Modify the date of employment and the starting date of working/retirement seniority','修改到职日、工作/退休年资起算日'],
		'3': ['修改特休年資起算日','Modify the starting date of annual','修改特休年资起算日'],
		'4': ['修改特休可休起訖時間','Modify the start and end time of special annual','修改特休可休起讫时间'],
		'5': ['刪除特休可休時數','Delete the number of hours available for annual','删除特休可休时数'],
	},
	'sys.effectHistory.type': {
		'1': ['組織圖','Organizational Chart','组织图'],
		'2': ['離職作業','Resignation','离职作业'],
		'3': ['留職停薪作業','Leave without pay assignments','留职停薪作业'],
		'4': ['人事異動作業','Personnel Change Assignment','人事异动作业'],
		'5': ['復職作業','Reinstatement','复职作业'],
		'6': ['薪資規則異動作業','Payroll rules change operations','薪资规则异动作业'],
		'7': ['出勤規則異動作業','Attendance rules change operations','出勤规则异动作业'],
		'8': ['轉在職','Transfer to the job','转在职'],
		'9': ['預先生效育嬰留停及復職作業','Pre-effective Maternity/Paternity Leave and Reinstatement Procedures','预先生效育婴留停及复职作业'],
	},
	'sys.effectHistory.execType': {
		'1': ['生效','Take effect','生效'],
		'2': ['取消生效','Cancellation takes effect','取消生效']
	},
	'sys.portal.banner.type': {
		'1': ['插入', 'Insert', '插入'],
		'2': ['切換', 'Switch', '切换']
	},
	'ux.msgType': {
		'1': ['長時作業通知', 'Long-term job notification', '长时作业通知'],
		'2': ['訊息通知', 'Message notification', '讯息通知'],
		'3': ['待辦事項', 'To do list', '待办事项']
	},
	'ux.todo.annualType': {
		'0': ['本期','This period','本期'],
		'1': ['預支','Advance','预支'],
		'2': ['上期','Last','上期']
	},

	'ep.boss.dom': {
		'1': ['本身部門內人員','Personnel in own department','本身部门内人员'],
		'2': ['本身部門內人員及下一層部門主管','Personnel in your own department and the next level department head','本身部门内人员及下一层部门主管'],
		'3': ['以下X層人員','The following X-tier people','以下X层人员'],
		'4': ['以下所有人員','All following','以下所有人员']
	},
	'ep.mt.areaCode': {
		'profile': ['個人摘要','Personal summary','个人摘要'],
		'contact': ['聯絡資訊','Contact information','联络资讯'],
		'edu': ['學歷','Education','学历'],
		'exp': ['經歷','experience','经历'],
		'skill': ['技能專長','Talent','技能专长'],
		'license': ['證照','License','证照'],
		'family': ['親屬名單','Relatives','亲属名单']
	},
	'ep.agent.status': {
		'1': ['代理中', 'Under agency', '代理中'],
		'2': ['即將代理','About to be an agent', '即将代理'],
		'3': ['已結束','Finished', '已结束'],
		'4': ['已關閉','Closed', '已关闭'],
	},
	'ep.doa.isAllItem': {
		'0': ['部分項目', '部分項目EN', '部分項目CN'],
		'1': ['全部項目', '全部項目EN', '全部項目CN'],
	},
	'ep.doa.isAllItem._sort': [1, 0],
	'ep.parm.insReportType': {
		'1': ['勞保保費明細','Labor insurance premium details','劳保保费明细'],
		'2': ['健保保費明細','Health insurance premium details','健保保费明细'],
		'4': ['補充保費證明','Proof of supplementary premium','补充保费证明'],
		'8': ['勞、健保保費明細及證明','Labor and health insurance premium details and certification','劳、健保保费明细及证明']
	},
	'ep.parm.insType': {
		'1': ['勞保費','Labor insurance premium','劳保费'],
		'2': ['健保費','Health insurance fee','健保费'],
		'4': ['補充保費','Supplementary premium','补充保费']
	},
	'ep.parm.insReportPermission': {
		'1': ['查詢','Inquire','查询'],
		'2': ['下載','download','下载']
	},
	'ep.bulletin.type': {
		'1': ['一般公告','General','一般公告'],
		'2': ['重大公告','Important','重大公告'],
		'3': ['強制公告','Mandatory','强制公告']
	},
	'ep.bulletin.type._sort': [1,2,3],
	'ep.bulletin.releaseStatus': {
		'1': ['草稿','Draft','草稿'],
		'2': ['已排定','Scheduled','已排定'],
		'3': ['發佈中','Publishing','发布中'],
		'4': ['已取消','Cancelled','已取消'],
		'5': ['已結束','Ended','已结束']
	},
	'ep.bulletin.releaseStatus._sort': [3,2,1,4,5],
	'ep.bulletin.releaseTarget': {
		'0': ['全體員工','All employees','全体员工'],
		'1': ['部分員工','Specific employees','部分员工'],
		'2': ['常用名單','Frequently used list','常用名单']
	},
	'ep.bulletin.repeatType': {
		'1': ['設定時間內永久顯示','Permanently display within the set time.','设定时间内永久显示'],
		'2': ['設定時間內顯示1次','Display once within the set time.','设定时间内显示1次'],
		'3': ['設定時間內限制顯示頻率','Limit display frequency within the set time.','设定时间内限制显示频率']
	},
	'ep.bulletin.repeatRate': {
		'DAY': ['每天重複頻率','Daily repetition frequency','每天重复频率'],
		'WEEK': ['每週重複頻率','Weekly repetition frequency','每周重复频率']
	},
	'ep.bulletin.releaseWay': {
		'1': ['系統平台','Portal','系统平台'],
		'2': ['系統平台+Email通知','Portal and email','系统平台+Email通知']
	},
	'wf.agentStatus': {
		'1': ['代理中TW', '非代理中EN', '非代理中CN'],
		'0': ['非代理中TW', '非代理中EN', '非代理中CN']
	},
	'wf.ws.usedStatus': {
		'1': ['全部停用TW', '全部停用EN', '全部停用CN'],
		'2': ['全部啟用TW', '全部啟用EN', '全部啟用CN'],
		'3': ['無法申請及簽核TW', '無法申請及簽核EN', '無法申請及簽核CN'],
		'4': ['無法申請TW', '無法申請EN', '無法申請CN']
	},
	'wf.notify.code': {
		'WF_MSG100': ['表單申請-成功','Form application-successful','表单申请-成功'],
		// 'WF_MSG110': ['表單申請-失敗','Form application-failed','表单申请-失败'],
		'WF_MSG120': ['表單申請-通知職務代理人','Form application-notice agent','表单申请-通知职务代理人'],
		'WF_MSG200': ['簽核通知-待簽核','Sign-off notice-pending','签核通知-待签核'],
		'WF_MSG210': ['簽核通知-待簽核(代理簽核)','Sign-off notice-to be signed (agent sign-off)','签核通知-待签核(代理签核)'],
		'WF_MSG300': ['簽核作業-核准','Sign-off operation-approval','签核作业-核准'],
		'WF_MSG310': ['簽核作業-駁回','Sign-off operation-rejected','签核作业-驳回'],
		'WF_MSG320': ['簽核作業-會簽他人','Sign-off assignment-counter-sign others','签核作业-会签他人'],
		'WF_MSG330': ['簽核作業-詢問意見','Sign-off work-ask for opinions','签核作业-询问意见'],
		'WF_MSG340': ['簽核作業-意見回覆','Sign-off operation-reply to comments','签核作业-意见回覆'],
		'WF_MSG400': ['簽核逾期-簽核時間逾期','Approval overdue-Approval time is overdue','签核逾期-签核时间逾期'],
		'WF_MSG410': ['簽核逾期-簽核時間逾期(代理簽核)','Approval Overdue-Approval Time Overdue (Agent Approval)','签核逾期-签核时间逾期(代理签核)'],
		'WF_MSG420': ['簽核逾期-申請時間逾期','Approval is overdue-application time is overdue','签核逾期-申请时间逾期'],
		'WF_MSG430': ['簽核逾期-申請時間逾期(代理簽核)','Approval is overdue-the application time is overdue (agent approval)','签核逾期-申请时间逾期(代理签核)'],
		'WF_MSG500': ['簽核異動-變更簽核人','Sign-off change-change signer','签核异动-变更签核人'],
		'WF_MSG510': ['簽核異動-抽單','Sign-off transaction-draw','签核异动-抽单'],
		'WF_MSG520': ['簽核異動-刪單','Sign the transaction-delete the order','签核异动-删单'],
		'WF_MSG530': ['簽核異動-簽核人離職','Sign-off change-sign-off person resigns','签核异动-签核人离职'],
		'WF_MSG540': ['簽核異動-簽核代理人離職','Sign-off change-sign-off agent resignation','签核异动-签核代理人离职'],
		'WF_MSG900': ['簽核完成','Sign-off completed','签核完成']
	},
	'wf.notify.way': {
		'1': ['僅在首頁提醒','Reminder only on the homepage','仅在首页提醒'],
		'2': ['僅 Email 通知','Email notification only','仅 Email 通知'],
	},
	'wf.formset.doaTarget': {
		'7': ['承辦人','Undertaker','承办人'],
		'3': ['組織圖','Organizational Chart','组织图'],
		'6': ['簽核角色','Role','签核角色'],
		'10': ['職位','Sign-off role','职位'],
		'11': ['被調班員工']
	},
	'wf.formset.doaTarget._sort': [7, 3, 6, 10, 11],
	'wf.formset.edVarItem': {
		'SNO_ID': ['扣繳單位','Withholding entity','扣缴单位'],
		'DEPT1_ID': ['部門1','department1','部门1'],
		'DEPT2_ID': ['部門2','department2','部门2'],
		'DEPT3_ID': ['部門3','department3','部门3'],
		'DEPT4_ID': ['部門4','department4','部门4'],
		'DEPT5_ID': ['部門5','department5','部门5'],
		'JOB_ID': ['職位','Position','职位'],
		'GRADE_ID': ['職等','Job grade','职等'],
		'LEVEL_ID': ['職級','Job level','职级'],
		'JOB_CAT_ID': ['職務類別','Job type','职务类别'],
		'JOB_STYLE_ID': ['職種','Job category','职种'],
		'JOB_DESC_ID': ['職務說明書','Job instruction','职务说明书'],
		'JOB_BIZ_ID': ['名片職務','Business card title','名片职务'],
		'IDENTITY_ID': ['身分類別','Identity type','身分类别'],
		'EMPLOYEE_TYPE': ['直間接別','Direct/indirect','直间接别'],
		'RESPOBILITY': ['責任區分','Distinction of responsibility','责任区分'],
		'HEADCOUNT_STATUS': ['編制狀況','Staff status','编制状况'],
		'AREA_ID': ['工作區域','Work area','工作区域'],
		'SITE_ID': ['工作地點','Work location','工作地点'],
		'FACTORY_ID': ['廠別','Factory','厂别'],
		// 'AM_TEMPLATE_ID': ['出勤規則範本','Attendance rule template','出勤规则范本'],
		'SHIFT_TYPE': ['班別屬性','Shift nature','班别属性'],
		'PARTTIME_STATUS': ['部分工時/全時','Part time/Full time','部分工时/全时'],
		'PARTTIME_SETTING': ['約定比例/約定工時','Agreed ratio/Agreed working hours','约定比例/约定工时'],
		'SHIFT_ID': ['班別','Shift','班别'],
		'CALENDAR_BASIC_ID': ['行事曆','Calendar','行事历'],
		// 'SA_RULE_ID': ['排班規則','Scheduling rules','排班规则'],
		'SECTION_RULE_ID':['時段班別規則','Staff scheduling rules','时段班別规则'],
		'ANNUAL_ID': ['特休規則','Annual leave rules','特休规则'],
		// 'CO_ANNUAL_IDS': ['公司假規則','Corporate fake rules','公司假规则'],
		'FLEXIBLE_IDS': ['彈性假規則','Flexible leave rules','弹性假规则'],
		'ATTEND_RULE_ID': ['出勤時數規則','Attendance hour rules','出勤时数规则'],
		'TRN_TYPE': ['工作日打卡轉加班','Conversion of clock-in/out entries on workdays to overtime','工作日打卡转加班'],
		'OT_RULE_ID': ['加班規則','Overtime rules','加班规则'],
		'OT_WORKHOUR_ID': ['工時規則','Working hour rules','工时规则'],
		'IS_CARD_CLOCK': ['允許打卡-刷卡鐘','Clock punch-in','允许打卡-刷卡钟'],
		'IS_CARD_NETWORK': ['允許打卡-網路打卡', 'Network punch-in', '允许打卡-网路打卡'],
		'IS_CARD_GPS': ['允許打卡-GPS打卡', 'GPS punch-in', '允许打卡-GPS打卡'],
		'IS_CARD_WIFI': ['允許打卡-Wi-Fi打卡', 'Wi-Fi punch-in', '允许打卡-Wi-Fi打卡'],
		'CARD_MATCH':['刷卡比對','Clock-in/out comparison','刷卡比对'],
	},
	'wf.formset.pbVarItem': {
		'TAX_SET': ['所得稅計算規則','Income tax calculation rules','所得税计算规则'],
		'RCCC': ['成本中心','Cost Center','成本中心'],
		'SALARY_STRUCTURE': ['薪資結構','salary structure','薪资结构'],
	},
	'wf.formsetBasic.searchType': {
		'1': ['同部門','Same department','同部门'],
		'2': ['組織圖層級','Organization layer level','组织图层级'],
		'3': ['職等 / 職級','Rank / rank','职等 / 职级'],
		'4': ['同工作區域/工作地點','Same Work area/Work location','工作区域/工作地点'],
		'5': ['全體員工', 'All employees', '全体员工']
	},
	'wf.formsetBasic.leaveDefaultTime': {
		'0': ['空白', 'Blank', '空白'],
		'1': ['自訂時間', '', ''],
		'2': ['依公司表定時間', '', '']
	},
	'wf.formset.doaGenType': {
		'1': ['申請者','applicant','申请者'],
		'2': ['被異動者','Moved','被异动者']
	},
	'wf.formsetBasic.frontendStatus': {
		'1': ['啟用','',''],
		'2': ['部分啟用(僅簽核)','',''],
		'0': ['停用','','']
	},
	'wf.formsetBasic.frontendStatus._sort': [1, 2, 0],
	'wf.formsetBasic.isRequestCardMatch': {
		'0': ['不須判斷', '', ''],
		'1': ['判斷刷卡時間', '', ''],
	},
	'wf.formsetBasic.isRequestCardMatch.portal': {
		'0': ['不須判斷', '', ''],
		'1': ['判斷刷卡資料', '', ''],
	},
	'wf.formsetBasic.modifyCardmatchIdentity': {
		'1': ['員工申請', '', ''],
		'3': ['主管簽核', '', ''],
		'7': ['承辦人簽核', '', ''],
	},
	'wf.formsetBasic.childrenRelatedColumns': {
		'1': ['顯示且必填', '', ''],
		'2': ['顯示且非必填', '', ''],
		'3': ['不顯示', '', ''],
	},
	'wf.formsetBasic.modifyCardmatchIdentity._sort': [3, 7, 1],
	'wf.signer.ckpType': {
		1: ['申請者', 'Applicant', '申请人'],
		2: ['代理人', 'Substitute', '代理人'],
		3: ['主管', 'Manager', '主管'],
		4: ['會簽人', 'Countersigner', '会签人'],
		5: ['詢問意見人', 'Ask for opinions', '询问意见人'],
		6: ['簽核角色', 'Role', '签核角色'],
		7: ['承辦人', 'Person in charge', '承办人'],
		8: ['特殊處理人', 'Processor', '特殊处理人'],
		9: ['其他', 'Others', '其他'],
		11: ['被異動人', 'Staff be changed', '被异动人'],
		21: ['指定員工', 'Designated employee', '指定员工'],
		22: ['部門主管', 'Dept. supervisor', '部门主管'],
		23: ['部門成員', 'Dept. members', '部门成员'],
		24: ['組織層級', 'Org. hierarchy', '组织层级'],
		25: ['表單關係人', 'Stakeholders', '表单关系人'],
		26: ['員工群組', 'Employee group', '员工群组'],
		27: ['條件式', 'Conditional', '条件式'],
		28: ['簽核角色', 'Role', '签核角色']
	},
	'wf.request.wfResult': {
		1: ['簽核中', 'Approving', '签核中'],
		2: ['核准', 'Approved', '核准'],
		3: ['駁回', 'Rejected', '驳回'],
		4: ['抽單', 'Withdrawn', '抽单'],
		5: ['刪單', 'Deleted', '删单'],
		440: ['系統駁回', 'Rejected by system', '系统驳回'],
	},
	'wf.request.wfResult._sort': [1, 3, 4, 2, 5, 440],
	'wf.request.wfResult.dichotomy': {
		'1': ['簽核中', 'On the way', '签核中'],
		'2': ['簽核完成', 'Sign-off completed', '签核完成']
	},

	'hp.base': {
		'denied': ['無權限', 'Permission Denied', '无权限'],
		'more': ['查看更多', 'More', '查看更多'],
		'clearAll': ['全部清除', 'Clear', '全部清除'],
		'punchInOut': ['我要打卡', 'Punch In / Out', '我要打卡'],
		'moreCard': ['更多打卡明細', 'More', '更多打卡明细'],
		'required': ['必填欄位', 'Required', '必填栏位'],
		'close': ['關閉', 'Close', '关闭'],
		'loadErr.banner': ['Banner載入錯誤', 'Banner载入错误', 'Loading Error'],
	},
	'hp.m0.title': {
		'functions': ['常用功能', 'Frequently Used Functions', '常用功能'],
		'announcements': ['最新公告', 'Latest Announcements', '最新公告'],
		'reminders': ['通知提醒', 'Reminders', '通知提醒'],
		'punchClock': ['我的打卡鐘', 'Punch Clock', '我的打卡钟'],
		'attRecords': ['打卡明細', 'Attendance Records', '打卡明细'],
		'incorrectAttRecords': ['異常打卡', 'Incorrect Attendance Records', '异常打卡'],
		'leaveSummary': ['假勤統計', 'Leaves Summary', '假勤统计'],
		'calendar': ['行事曆', 'Calendar', '行事历'],
	},
	'hp.m0.functions': {
		'pendingApprovals': ['表單簽核', 'Pending Approvals', '表单签核'],
		'leaveRequest': ['表單申請', 'Form Request', '表单申请'],
		'attRecords': ['出勤資料', 'Attendance Records', '出勤资料'],
		'meeting': ['會議預約', 'Meeting Appointment', '会议预约'],
		'payslips': ['薪資袋', 'Payslips', '薪资袋'],
		'empInfo': ['同仁資料查詢', 'Employee Info.', '同仁资料查询'],
		'empInfo.placeholder': ['輸入員編、姓名、分機、信箱', 'Enter Employee No., Name, Ext., Email', '输入员编、姓名、分机、信箱'],
	},
	'hp.m0.wfType.notificatioin.template': {
		'0': ['待簽核表單 <%=x%> 筆', 'Pending Approvals (<%=x%>)', '待签核表单 <%=x%> 笔'],
		'1': ['提醒事項 <%=x%> 項', 'Notes (<%=x%>)', '提醒事项 <%=x%> 项'],
		'2': ['表單追蹤 <%=x%> 筆', 'Request Forms Tracking (<%=x%>)', '表单追踪 <%=x%> 笔'],
	},
	'hp.m0.wfType.notificatioin.title': {
		'0': ['待簽核表單', 'Pending Approvals', '待签核表单'],
		'1': ['提醒事項', 'Notes', '提醒事项'],
		'2': ['表單追蹤', 'Request Forms Tracking', '表单追踪'],
	},
	'hp.m0.notificatioin.confirm': {
		'title1': ['清除提醒事項通知', 'Delete Notes', '清除提醒事项通知'],
		'title2': ['清除表單追蹤通知', 'Delete Request Forms Tracking', '清除表单追踪通知'],
		'msg1': ['確定要清除全部通知嗎？', 'Delete all reminders?', '确定要清除全部通知吗？'],
		'msg2': ['確定要刪除「 <%=topic%> 」通知嗎？', 'Delete the reminder of "<%=topic%> "?', '确定要删除「 <%=topic%> 」通知吗？'],
	},
	'hp.m0.notificatioin.empty': {
		'0': ['您沒有待簽表單通知！', 'No Results.', '您没有待签表单通知！'],
		'1': ['您沒有提醒事項通知！', 'No Results.', '您没有提醒事项通知！'],
		'else': ['您沒有表單追蹤通知！', 'No Results.', '您没有表单追踪通知！'],
	},
	'hp.m0.notificatioin.filter': {
		'1': ['不拘', 'All', '不拘'],
		'2': ['個人', 'Personal', '个人'],
		'3': ['會議', 'Meeting', '会议'],
		'4': ['表單', 'Request Forms', '表单'],
		'5': ['班表', 'Shift', '班表'],
	},
	'hp.m0.punchClock.template': {
		'dateWeekFmt': ['[<%=weekday%>], M[月]D[日]', '[<%=weekday%>], [<%=month%>] D', '[<%=weekday%>], M[月]D[日]'],
	},
	'hp.m0.punchClock.result': {
		'success': ['打卡成功！', 'Punch in/out successfully.', '打卡成功！'],
		'success.unusual': ['提醒您，您的體溫高出設定的體溫安全值，請您特別留意健康狀況。', 'Your body temperature is higher than the normal range. Please take care of your health.', '提醒您，您的体温高出设定的体温安全值，请您特别留意健康状况。'],
		'errMsg': ['打卡失敗', 'Failure', '打卡失败'],
		'490': ['不符合規則', 'Against Regulation', '不符合规则'],
		'491': ['打卡時間已存在', 'Punch time already exists.', '打卡时间已存在'],
		'492': ['無網路打卡權限', 'Permission Denied', '无网路打卡权限'],
		'493': ['體溫為必填欄位', 'Temperature is required.', '体温为必填栏位'],
		'494': ['體溫為必填欄位', 'Temperature is required.', '体温为必填栏位'],
		'errMsg.lastCard': ['載入打卡明細失敗', 'Fail to load the attendance records.', '载入打卡明细失败'],
	},
	'hp.m0.abnormal': {
		'processing': ['尚未處理', 'Processing', '尚未处理'],
		'result': ['筆', 'Results', '笔'],
	},
	'hp.m0.abnormal.result': {
		'errMsg': ['載入異常打卡失敗', 'Failed to load the incorrect attendance records', '载入异常打卡失败'],
	},
	'hp.m0.leaveSummary': {
		'empty': ['尚無假勤設定', 'No Results.', '尚无假勤设定'],
	},
	'hp.m0.leaveSummary.template': {
		'remaing': ['<%=kind%>假可申請餘額', 'Remaining <%=kind%> Leave', '<%=kind%>假可申请余额'],
		'expiration': ['<%=currEndDate%> 到期', 'Expired: <%=currEndDate%>', '<%=currEndDate%> 到期'],
	},
	'hp.m0.calendar': {
		'more': ['更多', 'More', '更多'],
		'today': ['今天', 'Today', '今天'],
		'noResult': ['無資訊', 'No Results.', '无资讯'],
		'noResult.leave': ['無人請假! 同仁一起打拼', 'No Results.', '无人请假! 同仁一起打拼'],
		'noResult.abnormal': ['無人異常! 很棒呢', 'No Results.', '无人异常! 很棒呢'],
		'noResult.meeting': ['今日無會議! 緩一緩 再加油', 'No Meeting.', '今日无会议! 缓一缓 再加油'],
		'limit.past': ['太久了啦! 已成回憶', 'Not allowed to check the information of the past year.', '太久了啦! 已成回忆'],
		'limit.future': ['燒等幾嘞，別著急!', 'Not allowed to check the information of the coming year.', '烧等几嘞，别着急!'],
		'attendance': ['出勤通知', 'Attendance Records', '出勤通知'],
		'subordinateLeave': ['部屬請假', 'Leaves of Subordinates', '部属请假'],
		'subordinateAbnormal': ['部屬出勤異常', 'Incorrect Attendance of Subordinates', '部属出勤异常'],
		'meeting': ['會議通知', 'Meeting', '会议通知'],
	},
	'hp.m0.calendar.result': {
		'errMsg': ['計算請假表單、忘刷表單數量失敗', 'Fail to account the leave request and punch change request.', '计算请假表单、忘刷表单数量失败'],
	},
	'hp.m0.calendar.template': {
		'yearMonth': ['<%= year %> 年 <%= month %> 月', '<%= month %> <%= year %>', '<%= year %> 年 <%= month %>月'],
		'attendanceErrors': ['(異常 <%=x%> 筆)', '(Incorrect <%=x%>)', '(异常 <%=x%> 笔)'],
		'subordinateLeave': ['(<%=x%> 筆)', '(<%=x%>)', '(<%=x%> 笔)'],
		'subordinateAbnormal': ['(<%=x%>筆)', '(<%=x%>)', '(<%=x%>笔)'],
		'meeting': ['(<%=x%>筆)', '(<%=x%>)', '(<%=x%>笔)'],
	},
	'hp.m0.calendar.navigation': {
		'wf020': ['請假', 'Leave Request', '请假'],
		'wf030': ['忘刷', 'Punch Change Request', '忘刷'],
		'overErr': ['超時出勤', 'Work Overtime', '超时出勤'],
	},
	'hp.m5.m510010.form.unit': {
		'day': ['天', 'day(s)', '天'],
		'hour': ['小時', 'hour(s)', '小时'],
		'minute': ['分鐘', 'min(s)', '分钟']
	},
	'app.form.unit': {
		'day': ['天', 'day', '天'],
		'hour': ['小時', 'hour', '小时'],
		'minute': ['分鐘', 'min', '分钟']
	},
	'am.leaveitem.Parttime.genRule': {
		'1': ['依實際出勤時數 ', 'According to actual attendance hours', '依实际出勤时数'],
		'2': ['依約定比例', 'According to the agreed ratio', '依约定比例'],
		'3': ['依約定工時', 'Working hours as agreed', '依约定工时'],
		'4': ['依固定時數', 'According to fixed hours', '依固定时数'],
		'5': ['依約定比例/工時', 'According to the agreed ratio / working hours', '依約定比例/工時'],
	},
	'am.leaveitem.Parttime.source': {
		'1': ['新增', 'Add', '新增'],
		'2': ['匯入', 'import', '汇入'],
		'3': ['批次產生', 'Batch generation', '批次产生'],
		'4': ['請假寫入', 'Write a request for leave', '请假写入'],
	},
	'am.biz.requestType': {
		'1': ['整體出差行程', 'Total business trip', '整体出差行程'],
		'2': ['詳細出差行程', 'Detailed business trip', '详细出差行程'],
	},
	'wf.formsetBasic.leaveApply': {
		'1': ['請假時段', 'Leave period', '请假时段'],
		'2': ['請假時數', 'Leave hours', '请假时数'],
	},

	'wf.formsetBasic.copyType': {
		'1': ['不允許複製表單', 'Not allowed to copy sheet', '不允许复制表单'],
		'2': ['允許同公司複製表單', 'Allowed to copy sheet within same company', '允许同公司复制表单'],
		'3': ['允許跨公司複製表單', 'Allowed to copy sheet across companies', '允许跨公司复制表单'],
	},

	'custom.form.isNotify.msg100': {
		'1': ['通知','Notice','通知'],
		'0': ['不通知，申請人','No notification, applicant','不通知，申请人']
	},
	'custom.form.isNotify.msg100._sort': [1, 0],
	'custom.form.notify.way': {
		'1': ['首頁提醒','Home page reminder','首页提醒'],
		'2': ['Email 通知','Email notification','Email 通知'],
	},
	'custom.form.isNotify.msg200': {
		'1': ['通知','Notice','通知'],
		'0': ['不通知，簽核人員進行簽核','Without notification, the sign-off personnel will sign off.','不通知，签核人员进行签核']
	},
	'custom.form.isNotify.msg200._sort': [1, 0],
	'custom.form.isNotify.msg310': {
		'1': ['通知','Notice','通知'],
		'0': ['不通知，','No notification,','不通知，']
	},
	'custom.form.isNotify.msg310._sort': [1, 0],
	'custom.form.isNotify.msg330': {
		'1': ['通知','Notice','通知'],
		'0': ['不通知，被詢問意見者','Without notifying the person whose opinions are being asked.','不通知，被询问意见者，']
	},
	'custom.form.isNotify.msg330._sort': [1, 0],
	'custom.notify.code': {
		'WF_MSG100': ['申請成功通知','Notification of successful application','申请成功通知'],
		'WF_MSG200': ['待簽核通知','Notification pending approval','待签核通知'],
	    'WF_MSG300': ['核准通知','Approval notice','核准通知'],
		'WF_MSG310': ['駁回通知','Notice of rejection','驳回通知'],
		'WF_MSG320': ['會簽通知','Countersign notice','会签通知'],
		'WF_MSG330': ['詢問意見通知','Notice of inquiry','询问意见通知'],
		'WF_MSG340': ['回覆意見通知','Reply to comment notice','回覆意见通知'],
		'WF_MSG400': ['簽核逾期通知','Sign off overdue notice','签核逾期通知'],
		'WF_MSG420': ['逾期未完成簽核通知','Notification of overdue sign-off','逾期未完成签核通知'],
		'WF_MSG500': ['更改簽核人通知','Notification of change of signer','更改签核人通知'],
		'WF_MSG510': ['抽單通知','Order drawing notice','抽单通知'],
		'WF_MSG520': ['刪單通知','Order deletion notice','删单通知'],
		'WF_MSG530': ['簽核人離職通知','Notice of resignation of signer','签核人离职通知'],
		'WF_MSG540': ['簽核代理人離職通知',`Signing agent's resignation notice`,'签核代理人离职通知'],
		'WF_MSG900': ['簽核完成通知','Notification of completion of sign-off','签核完成通知']
	},
	'hp.m3.m310040.abnormal': {
		'0': ['不拘','Not specified','不拘'],
		'1': ['異常-不拘', 'Anomalous-Not specified' , '异常-不拘'],
		'2': ['異常-遲到', 'Late' , '异常-迟到'],
		'3': ['異常-早退', 'Leave early' , '异常-早退'],
		'4': ['異常-曠職', 'Absenteeism' , '异常-旷职'],
		'5': ['異常-未打卡', 'Failure to clock in' , '异常-未打卡'],
		'6': ['異常-超時出勤', 'Excess attendance hours' , '异常-超时出勤'],
		'7': ['異常-加班刷卡時間不足', 'Insufficient overtime clock-in time' , '异常-加班刷卡时间不足'],
		'8': ['異常-刷卡資料不足', 'Insufficient clock-in/out data' , '异常-刷卡资料不足'],
	},
	'h2.shift.type': {
		'1': ['一段班', 'One Shift', '一段班'],
		'2': ['二段班', 'Two Shifts', '二段班'],
		'3': ['三段班', 'Three Shifts', '三段班'],
		'4': ['四段班', 'Four Shifts', '四段班'],
	},
	'h2.input.required': {
		'1': ['必填', 'Required', '必填'],
		'0': ['非必填', 'Not Required', '非必填'],
	},
	'wf.formset.supportItem': {
		1: ['調一人的班'], 2: ['與他人調班'], 4: ['支援排班']
	},
	'wf.formset.supportIdentity': {
		1: ['申請人'], 2: ['被調班員工']
	},
	'sys.dataSync.syncStatus': {
		'1': ['資料上傳中', '資料上傳中(EN)', '資料上傳中(CN)'],
		'2': ['資料上傳失敗', '資料上傳失敗(EN)', '資料上傳失敗(CN)'],
		'3': ['資料同步失敗', '資料同步失敗(EN)', '資料同步失敗(CN)'],
		'4': ['資料更新完成(失敗)', '資料更新完成(失敗)(EN)', '資料更新完成(失敗)(CN)'],
		'5': ['資料更新完成(異常)', '資料更新完成(異常)(EN)', '資料更新完成(異常)(CN)'],
		'6': ['資料更新完成(成功)', '資料更新完成(成功)(EN)', '資料更新完成(成功)(CN)'],
	},
	'ce.errorDesc': {
		1: ['交通工具沒有所屬的排放源項目', '交通工具沒有所屬的排放源項目', '交通工具沒有所屬的排放源項目'],
		2: ['當年度工作日天數為0', '當年度工作日天數為0', '當年度工作日天數為0'],
		3: ['沒有里程資料無法計算', '沒有里程資料無法計算', '沒有里程資料無法計算'],
		4: ['未填寫查詢數值', '未填寫查詢數值', '未填寫查詢數值'],
		5: ['排放源項目無法判斷', '排放源項目無法判斷', '排放源項目無法判斷'],
		6: ['碳排已計入其他年度', '碳排已計入其他年度', '碳排已計入其他年度']
	},

	'ce.commute.source': {
		1: ['資料匯入', '資料匯入', '資料匯入'],
		2: ['員工自行填寫(Portal)', '員工自行填寫(Portal)', '員工自行填寫(Portal)'],
	},

	/**
	 * 碳盤查里程 start
	 */
	'taipeiMetroMile': {
		1: {
			1: 0,
			2: 0.68,
			3: 1.2,
			4: 2.34,
			5: 3.1,
			6: 4.7,
			7: 5.52,
			8: 6.65,
			9: 7.4,
			10: 8.29,
			11: 9.56,
			12: 10.49,
			13: 11.97,
			14: 14.55,
			15: 15.88,
			16: 17.17,
			17: 17.99,
			18: 19,
			19: 20.13,
			20: 20.37,
			21: 18.74,
			22: 17.89,
			23: 16.85,
			24: 16.2,
			25: 10.11,
			26: 9.38,
			27: 8.39,
			28: 7.4,
			29: 8.19,
			30: 8.85,
			31: 10.41,
			32: 11.4,
			33: 11.03,
			34: 11.69,
			35: 12.24,
			36: 12.77,
			37: 13.8,
			38: 15.32,
			39: 16.41,
			40: 17.51,
			41: 18.39,
			42: 18.99,
			43: 20.25,
			44: 21.08,
			45: 21.84,
			46: 22.87,
			47: 23.45,
			48: 24.9,
			49: 25.77,
			50: 27.91,
			51: 29.82,
			52: 31.91,
			53: 18.84,
			54: 17.73,
			55: 16.83,
			56: 18.77,
			57: 15.98,
			58: 14.83,
			59: 13.77,
			60: 12.21,
			61: 11.31,
			62: 10.43,
			63: 10.41,
			64: 11.18,
			65: 11.99,
			66: 12.81,
			67: 11.69,
			68: 10.55,
			69: 9.56,
			70: 10.5,
			71: 11.69,
			72: 13.05,
			73: 15.79,
			74: 14.98,
			75: 13.9,
			76: 12.57,
			77: 10.43,
			78: 8.85,
			79: 9.41,
			80: 10.55,
			81: 11.35,
			82: 12.3,
			83: 12.77,
			84: 13.43,
			85: 14.76,
			86: 15.75,
			87: 16.62,
			88: 18.34,
			89: 18.89,
			90: 19.9,
			91: 21.64,
			92: 23.01,
			93: 24.41,
			94: 15.31,
			95: 16.54,
			96: 17.37,
			97: 18.28,
			98: 19.44,
			99: 26.63,
			100: 24.68,
			101: 23.57,
			102: 22.11,
			103: 20.46,
			104: 19.18,
			105: 18.53,
			106: 17.25,
			107: 16.39,
			108: 13.31,
			109: 11.99,
			110: 11.03,
			111: 10.35,
			112: 9.41,
			113: 8.29,
			114: 8.96,
			115: 9.69,
			116: 10.53,
			117: 11.51,
			118: 12.33,
			119: 13.69,
			120: 15.11,
			121: 16.2,
			122: 15.98,
			123: 17.53,
			124: 16.96,
			125: 16.06,
			126: 14.98,
			127: 16.5,
			128: 17.13,
			129: 17.87,
			130: 19.28,
			131: 18.53,
			132: 17.25,
			133: 18.89,
			134: 20.04,
			135: 21.28
		},
		2: {
			1: 0.68,
			2: 0,
			3: 0.51,
			4: 1.66,
			5: 2.42,
			6: 4.01,
			7: 4.84,
			8: 5.97,
			9: 6.72,
			10: 7.61,
			11: 8.88,
			12: 9.81,
			13: 11.29,
			14: 13.87,
			15: 15.2,
			16: 16.48,
			17: 17.31,
			18: 18.32,
			19: 19.45,
			20: 19.69,
			21: 18.06,
			22: 17.21,
			23: 16.17,
			24: 15.52,
			25: 9.43,
			26: 8.7,
			27: 7.7,
			28: 6.72,
			29: 7.5,
			30: 8.17,
			31: 9.73,
			32: 10.72,
			33: 10.35,
			34: 11.01,
			35: 11.56,
			36: 12.09,
			37: 13.12,
			38: 14.64,
			39: 15.73,
			40: 16.83,
			41: 17.71,
			42: 18.31,
			43: 19.57,
			44: 20.4,
			45: 21.16,
			46: 22.19,
			47: 22.77,
			48: 24.22,
			49: 25.09,
			50: 27.23,
			51: 29.14,
			52: 31.23,
			53: 18.16,
			54: 17.05,
			55: 16.15,
			56: 18.09,
			57: 15.3,
			58: 14.15,
			59: 13.09,
			60: 11.53,
			61: 10.63,
			62: 9.75,
			63: 9.73,
			64: 10.49,
			65: 11.31,
			66: 12.13,
			67: 11.01,
			68: 9.87,
			69: 8.88,
			70: 9.82,
			71: 11.01,
			72: 12.37,
			73: 15.11,
			74: 14.3,
			75: 13.22,
			76: 11.89,
			77: 9.75,
			78: 8.17,
			79: 8.73,
			80: 9.87,
			81: 10.67,
			82: 11.61,
			83: 12.09,
			84: 12.75,
			85: 14.08,
			86: 15.07,
			87: 15.94,
			88: 17.66,
			89: 18.2,
			90: 19.22,
			91: 20.96,
			92: 22.33,
			93: 23.73,
			94: 14.63,
			95: 15.86,
			96: 16.69,
			97: 17.59,
			98: 18.76,
			99: 25.95,
			100: 24,
			101: 22.89,
			102: 21.43,
			103: 19.78,
			104: 18.5,
			105: 17.85,
			106: 16.57,
			107: 15.71,
			108: 12.63,
			109: 11.31,
			110: 10.35,
			111: 9.67,
			112: 8.73,
			113: 7.61,
			114: 8.28,
			115: 9,
			116: 9.85,
			117: 10.83,
			118: 11.65,
			119: 13.01,
			120: 14.43,
			121: 15.52,
			122: 15.3,
			123: 16.85,
			124: 16.28,
			125: 15.38,
			126: 14.3,
			127: 15.82,
			128: 16.45,
			129: 17.19,
			130: 18.6,
			131: 17.85,
			132: 16.57,
			133: 18.2,
			134: 19.36,
			135: 20.6
		},
		3: {
			1: 1.2,
			2: 0.51,
			3: 0,
			4: 1.14,
			5: 1.9,
			6: 3.5,
			7: 4.32,
			8: 5.46,
			9: 6.2,
			10: 7.09,
			11: 8.36,
			12: 9.29,
			13: 10.77,
			14: 13.36,
			15: 14.69,
			16: 15.97,
			17: 16.8,
			18: 17.81,
			19: 18.94,
			20: 19.17,
			21: 17.55,
			22: 16.69,
			23: 15.65,
			24: 15.01,
			25: 8.92,
			26: 8.18,
			27: 7.19,
			28: 6.2,
			29: 6.99,
			30: 7.66,
			31: 9.22,
			32: 10.21,
			33: 9.83,
			34: 10.49,
			35: 11.04,
			36: 11.57,
			37: 12.6,
			38: 14.12,
			39: 15.21,
			40: 16.31,
			41: 17.19,
			42: 17.79,
			43: 19.05,
			44: 19.88,
			45: 20.64,
			46: 21.67,
			47: 22.25,
			48: 23.7,
			49: 24.57,
			50: 26.71,
			51: 28.62,
			52: 30.71,
			53: 17.64,
			54: 16.53,
			55: 15.63,
			56: 17.58,
			57: 14.78,
			58: 13.63,
			59: 12.57,
			60: 11.01,
			61: 10.11,
			62: 9.23,
			63: 9.22,
			64: 9.98,
			65: 10.8,
			66: 11.61,
			67: 10.49,
			68: 9.35,
			69: 8.36,
			70: 9.3,
			71: 10.5,
			72: 11.85,
			73: 14.59,
			74: 13.78,
			75: 12.7,
			76: 11.37,
			77: 9.23,
			78: 7.66,
			79: 8.21,
			80: 9.35,
			81: 10.15,
			82: 11.1,
			83: 11.57,
			84: 12.24,
			85: 13.57,
			86: 14.56,
			87: 15.42,
			88: 17.15,
			89: 17.69,
			90: 18.71,
			91: 20.45,
			92: 21.82,
			93: 23.22,
			94: 14.11,
			95: 15.35,
			96: 16.18,
			97: 17.08,
			98: 18.25,
			99: 25.44,
			100: 23.49,
			101: 22.38,
			102: 20.91,
			103: 19.27,
			104: 17.99,
			105: 17.33,
			106: 16.06,
			107: 15.19,
			108: 12.11,
			109: 10.8,
			110: 9.83,
			111: 9.15,
			112: 8.21,
			113: 7.09,
			114: 7.76,
			115: 8.49,
			116: 9.33,
			117: 10.32,
			118: 11.13,
			119: 12.49,
			120: 13.92,
			121: 15.01,
			122: 14.78,
			123: 16.33,
			124: 15.77,
			125: 14.87,
			126: 13.78,
			127: 15.31,
			128: 15.94,
			129: 16.68,
			130: 18.08,
			131: 17.33,
			132: 16.06,
			133: 17.69,
			134: 18.85,
			135: 20.09
		},
		4: {
			1: 2.34,
			2: 1.66,
			3: 1.14,
			4: 0,
			5: 0.76,
			6: 2.36,
			7: 3.18,
			8: 4.31,
			9: 5.06,
			10: 5.95,
			11: 7.22,
			12: 8.15,
			13: 9.63,
			14: 12.22,
			15: 13.54,
			16: 14.83,
			17: 15.66,
			18: 16.67,
			19: 17.8,
			20: 18.03,
			21: 16.4,
			22: 15.55,
			23: 14.51,
			24: 13.87,
			25: 7.78,
			26: 7.04,
			27: 6.05,
			28: 5.06,
			29: 5.85,
			30: 6.51,
			31: 8.07,
			32: 9.06,
			33: 8.69,
			34: 9.35,
			35: 9.9,
			36: 10.43,
			37: 11.46,
			38: 12.98,
			39: 14.07,
			40: 15.17,
			41: 16.05,
			42: 16.65,
			43: 17.91,
			44: 18.74,
			45: 19.5,
			46: 20.53,
			47: 21.11,
			48: 22.56,
			49: 23.43,
			50: 25.57,
			51: 27.48,
			52: 29.57,
			53: 16.5,
			54: 15.39,
			55: 14.49,
			56: 16.43,
			57: 13.64,
			58: 12.49,
			59: 11.43,
			60: 9.87,
			61: 8.97,
			62: 8.09,
			63: 8.07,
			64: 8.84,
			65: 9.66,
			66: 10.47,
			67: 9.35,
			68: 8.21,
			69: 7.22,
			70: 8.16,
			71: 9.36,
			72: 10.71,
			73: 13.45,
			74: 12.64,
			75: 11.56,
			76: 10.23,
			77: 8.09,
			78: 6.51,
			79: 7.07,
			80: 8.21,
			81: 9.01,
			82: 9.96,
			83: 10.43,
			84: 11.09,
			85: 12.43,
			86: 13.41,
			87: 14.28,
			88: 16.01,
			89: 16.55,
			90: 17.57,
			91: 19.31,
			92: 20.67,
			93: 22.07,
			94: 12.97,
			95: 14.2,
			96: 15.04,
			97: 15.94,
			98: 17.1,
			99: 24.29,
			100: 22.35,
			101: 21.24,
			102: 19.77,
			103: 18.13,
			104: 16.84,
			105: 16.19,
			106: 14.91,
			107: 14.05,
			108: 10.97,
			109: 9.66,
			110: 8.69,
			111: 8.01,
			112: 7.07,
			113: 5.95,
			114: 6.62,
			115: 7.35,
			116: 8.19,
			117: 9.18,
			118: 9.99,
			119: 11.35,
			120: 12.78,
			121: 13.87,
			122: 13.64,
			123: 15.19,
			124: 14.63,
			125: 13.72,
			126: 12.64,
			127: 14.17,
			128: 14.8,
			129: 15.53,
			130: 16.94,
			131: 16.19,
			132: 14.91,
			133: 16.55,
			134: 17.7,
			135: 18.95
		},
		5: {
			1: 3.1,
			2: 2.42,
			3: 1.9,
			4: 0.76,
			5: 0,
			6: 1.6,
			7: 2.42,
			8: 3.55,
			9: 4.3,
			10: 5.19,
			11: 6.46,
			12: 7.39,
			13: 8.87,
			14: 11.45,
			15: 12.78,
			16: 14.07,
			17: 14.89,
			18: 15.9,
			19: 17.03,
			20: 17.27,
			21: 15.64,
			22: 14.79,
			23: 13.75,
			24: 13.1,
			25: 7.01,
			26: 6.28,
			27: 5.29,
			28: 4.3,
			29: 5.09,
			30: 5.75,
			31: 7.31,
			32: 8.3,
			33: 7.93,
			34: 8.59,
			35: 9.14,
			36: 9.67,
			37: 10.7,
			38: 12.22,
			39: 13.31,
			40: 14.41,
			41: 15.29,
			42: 15.89,
			43: 17.15,
			44: 17.98,
			45: 18.74,
			46: 19.77,
			47: 20.35,
			48: 21.8,
			49: 22.67,
			50: 24.81,
			51: 26.72,
			52: 28.81,
			53: 15.74,
			54: 14.63,
			55: 13.73,
			56: 15.67,
			57: 12.88,
			58: 11.73,
			59: 10.67,
			60: 9.11,
			61: 8.21,
			62: 7.33,
			63: 7.31,
			64: 8.08,
			65: 8.89,
			66: 9.71,
			67: 8.59,
			68: 7.45,
			69: 6.46,
			70: 7.4,
			71: 8.59,
			72: 9.95,
			73: 12.69,
			74: 11.88,
			75: 10.8,
			76: 9.47,
			77: 7.33,
			78: 5.75,
			79: 6.31,
			80: 7.45,
			81: 8.25,
			82: 9.2,
			83: 9.67,
			84: 10.33,
			85: 11.66,
			86: 12.65,
			87: 13.52,
			88: 15.24,
			89: 15.79,
			90: 16.8,
			91: 18.54,
			92: 19.91,
			93: 21.31,
			94: 12.21,
			95: 13.44,
			96: 14.27,
			97: 15.18,
			98: 16.34,
			99: 23.53,
			100: 21.58,
			101: 20.47,
			102: 19.01,
			103: 17.36,
			104: 16.08,
			105: 15.43,
			106: 14.15,
			107: 13.29,
			108: 10.21,
			109: 8.89,
			110: 7.93,
			111: 7.25,
			112: 6.31,
			113: 5.19,
			114: 5.86,
			115: 6.59,
			116: 7.43,
			117: 8.41,
			118: 9.23,
			119: 10.59,
			120: 12.01,
			121: 13.1,
			122: 12.88,
			123: 14.43,
			124: 13.86,
			125: 12.96,
			126: 11.88,
			127: 13.4,
			128: 14.03,
			129: 14.77,
			130: 16.18,
			131: 15.43,
			132: 14.15,
			133: 15.79,
			134: 16.94,
			135: 18.18
		},
		6: {
			1: 4.7,
			2: 4.01,
			3: 3.5,
			4: 2.36,
			5: 1.6,
			6: 0,
			7: 0.82,
			8: 1.96,
			9: 2.7,
			10: 3.59,
			11: 4.86,
			12: 5.79,
			13: 7.27,
			14: 9.86,
			15: 11.19,
			16: 12.47,
			17: 13.3,
			18: 14.31,
			19: 15.44,
			20: 15.67,
			21: 14.05,
			22: 13.19,
			23: 12.15,
			24: 11.51,
			25: 5.42,
			26: 4.68,
			27: 3.69,
			28: 2.7,
			29: 3.49,
			30: 4.16,
			31: 5.72,
			32: 6.71,
			33: 6.33,
			34: 6.99,
			35: 7.54,
			36: 8.07,
			37: 9.1,
			38: 10.62,
			39: 11.71,
			40: 12.81,
			41: 13.69,
			42: 14.29,
			43: 15.55,
			44: 16.38,
			45: 17.14,
			46: 18.17,
			47: 18.75,
			48: 20.2,
			49: 21.07,
			50: 23.21,
			51: 25.12,
			52: 27.21,
			53: 14.14,
			54: 13.03,
			55: 12.13,
			56: 14.08,
			57: 11.28,
			58: 10.13,
			59: 9.07,
			60: 7.51,
			61: 6.61,
			62: 5.73,
			63: 5.72,
			64: 6.48,
			65: 7.3,
			66: 8.11,
			67: 6.99,
			68: 5.85,
			69: 4.86,
			70: 5.8,
			71: 7,
			72: 8.35,
			73: 11.09,
			74: 10.28,
			75: 9.2,
			76: 7.87,
			77: 5.73,
			78: 4.16,
			79: 4.71,
			80: 5.85,
			81: 6.65,
			82: 7.6,
			83: 8.07,
			84: 8.74,
			85: 10.07,
			86: 11.06,
			87: 11.92,
			88: 13.65,
			89: 14.19,
			90: 15.21,
			91: 16.95,
			92: 18.32,
			93: 19.72,
			94: 10.61,
			95: 11.85,
			96: 12.68,
			97: 13.58,
			98: 14.75,
			99: 21.94,
			100: 19.99,
			101: 18.88,
			102: 17.41,
			103: 15.77,
			104: 14.49,
			105: 13.83,
			106: 12.56,
			107: 11.69,
			108: 8.61,
			109: 7.3,
			110: 6.33,
			111: 5.65,
			112: 4.71,
			113: 3.59,
			114: 4.26,
			115: 4.99,
			116: 5.83,
			117: 6.82,
			118: 7.63,
			119: 8.99,
			120: 10.42,
			121: 11.51,
			122: 11.28,
			123: 12.83,
			124: 12.27,
			125: 11.37,
			126: 10.28,
			127: 11.81,
			128: 12.44,
			129: 13.18,
			130: 14.58,
			131: 13.83,
			132: 12.56,
			133: 14.19,
			134: 15.35,
			135: 16.59
		},
		7: {
			1: 5.52,
			2: 4.84,
			3: 4.32,
			4: 3.18,
			5: 2.42,
			6: 0.82,
			7: 0,
			8: 1.14,
			9: 1.88,
			10: 2.77,
			11: 4.04,
			12: 4.97,
			13: 6.45,
			14: 9.04,
			15: 10.36,
			16: 11.65,
			17: 12.48,
			18: 13.49,
			19: 14.62,
			20: 14.85,
			21: 13.22,
			22: 12.37,
			23: 11.33,
			24: 10.69,
			25: 4.6,
			26: 3.86,
			27: 2.87,
			28: 1.88,
			29: 2.67,
			30: 3.34,
			31: 4.9,
			32: 5.89,
			33: 5.51,
			34: 6.17,
			35: 6.72,
			36: 7.25,
			37: 8.28,
			38: 9.8,
			39: 10.89,
			40: 11.99,
			41: 12.87,
			42: 13.47,
			43: 14.73,
			44: 15.56,
			45: 16.32,
			46: 17.35,
			47: 17.93,
			48: 19.38,
			49: 20.25,
			50: 22.39,
			51: 24.3,
			52: 26.39,
			53: 13.32,
			54: 12.21,
			55: 11.31,
			56: 13.25,
			57: 10.46,
			58: 9.31,
			59: 8.25,
			60: 6.69,
			61: 5.79,
			62: 4.91,
			63: 4.9,
			64: 5.66,
			65: 6.48,
			66: 7.29,
			67: 6.17,
			68: 5.03,
			69: 4.04,
			70: 4.98,
			71: 6.18,
			72: 7.53,
			73: 10.27,
			74: 9.46,
			75: 8.38,
			76: 7.05,
			77: 4.91,
			78: 3.34,
			79: 3.89,
			80: 5.03,
			81: 5.83,
			82: 6.78,
			83: 7.25,
			84: 7.91,
			85: 9.25,
			86: 10.23,
			87: 11.1,
			88: 12.83,
			89: 13.37,
			90: 14.39,
			91: 16.13,
			92: 17.49,
			93: 18.9,
			94: 9.79,
			95: 11.02,
			96: 11.86,
			97: 12.76,
			98: 13.93,
			99: 21.11,
			100: 19.17,
			101: 18.06,
			102: 16.59,
			103: 14.95,
			104: 13.67,
			105: 13.01,
			106: 11.74,
			107: 10.87,
			108: 7.79,
			109: 6.48,
			110: 5.51,
			111: 4.83,
			112: 3.89,
			113: 2.77,
			114: 3.44,
			115: 4.17,
			116: 5.01,
			117: 6,
			118: 6.81,
			119: 8.17,
			120: 9.6,
			121: 10.69,
			122: 10.46,
			123: 12.01,
			124: 11.45,
			125: 10.55,
			126: 9.46,
			127: 10.99,
			128: 11.62,
			129: 12.36,
			130: 13.76,
			131: 13.01,
			132: 11.74,
			133: 13.37,
			134: 14.52,
			135: 15.77
		},
		8: {
			1: 6.65,
			2: 5.97,
			3: 5.46,
			4: 4.31,
			5: 3.55,
			6: 1.96,
			7: 1.14,
			8: 0,
			9: 0.75,
			10: 1.64,
			11: 2.91,
			12: 3.84,
			13: 5.32,
			14: 7.9,
			15: 9.23,
			16: 10.51,
			17: 11.34,
			18: 12.35,
			19: 13.48,
			20: 13.72,
			21: 12.09,
			22: 11.24,
			23: 10.2,
			24: 9.55,
			25: 3.46,
			26: 2.73,
			27: 1.73,
			28: 0.75,
			29: 1.53,
			30: 2.2,
			31: 3.76,
			32: 4.75,
			33: 4.38,
			34: 5.04,
			35: 5.59,
			36: 6.12,
			37: 7.15,
			38: 8.67,
			39: 9.76,
			40: 10.86,
			41: 11.74,
			42: 12.34,
			43: 13.6,
			44: 14.43,
			45: 15.19,
			46: 16.22,
			47: 16.8,
			48: 18.25,
			49: 19.12,
			50: 21.26,
			51: 23.17,
			52: 25.26,
			53: 12.19,
			54: 11.08,
			55: 10.18,
			56: 12.12,
			57: 9.33,
			58: 8.18,
			59: 7.12,
			60: 5.56,
			61: 4.66,
			62: 3.78,
			63: 3.76,
			64: 4.52,
			65: 5.34,
			66: 6.16,
			67: 5.04,
			68: 3.9,
			69: 2.91,
			70: 3.85,
			71: 5.04,
			72: 6.4,
			73: 9.14,
			74: 8.33,
			75: 7.25,
			76: 5.92,
			77: 3.78,
			78: 2.2,
			79: 2.76,
            80: 3.9,
			81: 4.7,
			82: 5.64,
			83: 6.12,
			84: 6.78,
			85: 8.11,
			86: 9.1,
			87: 9.97,
			88: 11.69,
			89: 12.23,
			90: 13.25,
			91: 14.99,
			92: 16.36,
			93: 17.76,
			94: 8.66,
			95: 9.89,
			96: 10.72,
			97: 11.62,
			98: 12.79,
			99: 19.98,
			100: 18.03,
			101: 16.92,
			102: 15.46,
			103: 13.81,
			104: 12.53,
			105: 11.88,
			106: 10.6,
			107: 9.74,
			108: 6.66,
			109: 5.34,
			110: 4.38,
			111: 3.7,
			112: 2.76,
			113: 1.64,
			114: 2.31,
			115: 3.03,
			116: 3.88,
			117: 4.86,
			118: 5.68,
			119: 7.04,
			120: 8.46,
			121: 9.55,
			122: 9.33,
			123: 10.88,
			124: 10.31,
			125: 9.41,
			126: 8.33,
			127: 9.85,
			128: 10.48,
			129: 11.22,
			130: 12.63,
			131: 11.88,
			132: 10.6,
			133: 12.23,
			134: 13.39,
			135: 14.63
		},
		9: {
			1: 7.4,
			2: 6.72,
			3: 6.2,
			4: 5.06,
			5: 4.3,
			6: 2.7,
			7: 1.88,
			8: 0.75,
			9: 0,
			10: 0.89,
			11: 2.16,
			12: 3.09,
			13: 4.57,
			14: 7.16,
			15: 8.48,
			16: 9.77,
			17: 10.6,
			18: 11.61,
			19: 12.74,
			20: 12.97,
			21: 11.34,
			22: 10.49,
			23: 9.45,
			24: 8.81,
			25: 2.72,
			26: 1.98,
			27: 0.99,
			28: 0,
			29: 0.79,
			30: 1.46,
			31: 3.02,
			32: 4.01,
			33: 3.63,
			34: 4.29,
			35: 4.84,
			36: 5.37,
			37: 6.4,
			38: 7.92,
			39: 9.01,
			40: 10.11,
			41: 10.99,
			42: 11.59,
			43: 12.85,
			44: 13.68,
			45: 14.44,
			46: 15.47,
			47: 16.05,
			48: 17.5,
			49: 18.37,
			50: 20.51,
			51: 22.42,
			52: 24.51,
			53: 11.44,
			54: 10.33,
			55: 9.43,
			56: 11.37,
			57: 8.58,
			58: 7.43,
			59: 6.37,
			60: 4.81,
			61: 3.91,
			62: 3.03,
			63: 3.02,
			64: 3.78,
			65: 4.6,
			66: 5.41,
			67: 4.29,
			68: 3.15,
			69: 2.16,
			70: 3.1,
			71: 4.3,
			72: 5.65,
			73: 8.39,
			74: 7.58,
			75: 6.5,
			76: 5.17,
			77: 3.03,
			78: 1.46,
			79: 2.01,
			80: 3.15,
			81: 3.95,
			82: 4.9,
			83: 5.37,
			84: 6.03,
			85: 7.37,
			86: 8.35,
			87: 9.22,
			88: 10.95,
			89: 11.49,
			90: 12.51,
			91: 14.25,
			92: 15.61,
			93: 17.02,
			94: 7.91,
			95: 9.14,
			96: 9.98,
			97: 10.88,
			98: 12.05,
			99: 19.23,
			100: 17.29,
			101: 16.18,
			102: 14.71,
			103: 13.07,
			104: 11.79,
			105: 11.13,
			106: 9.86,
			107: 8.99,
			108: 5.91,
			109: 4.6,
			110: 3.63,
			111: 2.95,
			112: 2.01,
			113: 0.89,
			114: 1.56,
			115: 2.29,
			116: 3.13,
			117: 4.12,
			118: 4.93,
			119: 6.29,
			120: 7.72,
			121: 8.81,
			122: 8.58,
			123: 10.13,
			124: 9.57,
			125: 8.67,
			126: 7.58,
			127: 9.11,
			128: 9.74,
			129: 10.48,
			130: 11.88,
			131: 11.13,
			132: 9.86,
			133: 11.49,
			134: 12.64,
			135: 13.89
		},
		10: {
			1: 8.29,
			2: 7.61,
			3: 7.09,
			4: 5.95,
			5: 5.19,
			6: 3.59,
			7: 2.77,
			8: 1.64,
			9: 0.89,
			10: 0,
			11: 1.27,
			12: 2.2,
			13: 3.68,
			14: 6.26,
			15: 7.59,
			16: 8.88,
			17: 9.7,
			18: 10.71,
			19: 11.84,
			20: 12.08,
			21: 10.45,
			22: 9.6,
			23: 8.56,
			24: 7.91,
			25: 3.61,
			26: 2.88,
			27: 1.88,
			28: 0.89,
			29: 1.68,
			30: 2.32,
			31: 3.88,
			32: 3.37,
			33: 2.74,
			34: 3.4,
			35: 3.95,
			36: 4.48,
			37: 5.51,
			38: 7.03,
			39: 8.12,
			40: 9.22,
			41: 10.1,
			42: 10.7,
			43: 11.96,
			44: 12.79,
			45: 13.55,
			46: 14.58,
			47: 15.16,
			48: 16.61,
			49: 17.48,
			50: 19.62,
			51: 21.53,
			52: 23.62,
			53: 12.31,
			54: 11.2,
			55: 10.3,
			56: 12.24,
			57: 9.45,
			58: 8.3,
			59: 7.24,
			60: 5.68,
			61: 4.78,
			62: 3.9,
			63: 3.88,
			64: 4.64,
			65: 4.09,
			66: 4.66,
			67: 3.4,
			68: 2.26,
			69: 1.27,
			70: 2.21,
			71: 3.4,
			72: 4.76,
			73: 9.26,
			74: 8.45,
			75: 7.37,
			76: 6.04,
			77: 3.9,
			78: 2.32,
			79: 1.12,
			80: 2.26,
			81: 3.06,
			82: 4.01,
			83: 4.48,
			84: 5.14,
			85: 6.47,
			86: 7.46,
			87: 8.33,
			88: 10.05,
			89: 10.98,
			90: 12,
			91: 13.74,
			92: 15.11,
			93: 16.51,
			94: 7.02,
			95: 8.25,
			96: 9.08,
			97: 9.99,
			98: 11.15,
			99: 18.73,
			100: 16.78,
			101: 15.67,
			102: 14.2,
			103: 12.56,
			104: 11.28,
			105: 10.63,
			106: 9.35,
			107: 8.48,
			108: 5.4,
			109: 4.09,
			110: 2.74,
			111: 2.06,
			112: 1.12,
			113: 0,
			114: 0.67,
			115: 1.4,
			116: 2.24,
			117: 3.22,
			118: 4.04,
			119: 5.4,
			120: 6.82,
			121: 7.91,
			122: 9.45,
			123: 11,
			124: 10.43,
			125: 9.53,
			126: 8.45,
			127: 9.97,
			128: 10.6,
			129: 11.34,
			130: 11.52,
			131: 10.63,
			132: 9.35,
			133: 10.98,
			134: 12.14,
			135: 13.38
		},
		11: {
			1: 9.56,
			2: 8.88,
			3: 8.36,
			4: 7.22,
			5: 6.46,
			6: 4.86,
			7: 4.04,
			8: 2.91,
			9: 2.16,
			10: 1.27,
			11: 0,
			12: 0.93,
			13: 2.41,
			14: 5,
			15: 6.32,
			16: 7.61,
			17: 8.44,
			18: 9.45,
			19: 10.58,
			20: 11.44,
			21: 11.72,
			22: 10.87,
			23: 9.83,
			24: 9.18,
			25: 4.88,
			26: 4.14,
			27: 3.15,
			28: 2.16,
			29: 2.95,
			30: 3.34,
			31: 4.57,
			32: 3.58,
			33: 2.95,
			34: 2.29,
			35: 2.84,
			36: 3.37,
			37: 4.4,
			38: 5.92,
			39: 7.01,
			40: 8.11,
			41: 8.99,
			42: 9.59,
			43: 10.85,
			44: 11.68,
			45: 12.44,
			46: 13.47,
			47: 14.05,
			48: 15.5,
			49: 16.37,
			50: 18.51,
			51: 20.42,
			52: 22.51,
			53: 13.32,
			54: 12.21,
			55: 11.31,
			56: 13.26,
			57: 10.46,
			58: 9.31,
			59: 8.25,
			60: 6.69,
			61: 5.79,
			62: 4.91,
			63: 4.57,
			64: 5.12,
			65: 4.3,
			66: 3.55,
			67: 2.29,
			68: 0.99,
			69: 0,
			70: 0.94,
			71: 2.14,
			72: 3.49,
			73: 10.27,
			74: 9.46,
			75: 8.38,
			76: 7.05,
			77: 4.91,
			78: 3.34,
			79: 2.14,
            80: 0.99,
			81: 1.79,
			82: 2.74,
			83: 3.37,
			84: 4.03,
			85: 5.36,
			86: 6.35,
			87: 7.22,
			88: 8.94,
			89: 10.21,
			90: 11.23,
			91: 12.97,
			92: 14.34,
			93: 15.74,
			94: 5.91,
			95: 7.14,
			96: 7.97,
			97: 8.87,
			98: 10.04,
			99: 18.93,
			100: 16.99,
			101: 15.88,
			102: 14.41,
			103: 12.77,
			104: 11.49,
			105: 10.83,
			106: 9.56,
			107: 8.69,
			108: 5.61,
			109: 4.3,
            110: 2.95,
			111: 3.07,
			112: 2.14,
			113: 1.27,
			114: 1.94,
			115: 2.66,
			116: 3.51,
			117: 4.49,
			118: 5.31,
			119: 6.67,
			120: 8.09,
			121: 9.18,
			122: 10.46,
			123: 12.01,
			124: 11.45,
			125: 10.55,
			126: 9.46,
			127: 10.99,
			128: 11.62,
			129: 12.36,
			130: 11.73,
			131: 10.83,
			132: 9.56,
			133: 10.21,
			134: 11.37,
			135: 12.61
		},
		12: {
			1: 10.49,
			2: 9.81,
			3: 9.29,
			4: 8.15,
			5: 7.39,
			6: 5.79,
			7: 4.97,
			8: 3.84,
			9: 3.09,
			10: 2.2,
			11: 0.93,
			12: 0,
			13: 1.48,
			14: 4.06,
			15: 5.39,
			16: 6.68,
			17: 7.5,
			18: 8.52,
			19: 9.64,
			20: 10.51,
			21: 12.14,
			22: 11.8,
			23: 10.76,
			24: 10.11,
			25: 5.81,
			26: 5.07,
			27: 4.08,
			28: 3.09,
			29: 3.88,
			30: 4.27,
			31: 5.5,
			32: 4.51,
			33: 3.88,
			34: 3.22,
			35: 3.77,
			36: 4.3,
			37: 5.33,
			38: 6.85,
			39: 7.94,
			40: 9.04,
			41: 9.92,
			42: 10.52,
			43: 11.78,
			44: 12.61,
			45: 13.37,
			46: 14.4,
			47: 14.98,
			48: 16.43,
			49: 17.3,
			50: 19.44,
			51: 21.35,
			52: 23.44,
			53: 14.25,
			54: 13.14,
			55: 12.24,
			56: 14.19,
			57: 11.39,
			58: 10.24,
			59: 9.18,
			60: 7.62,
			61: 6.72,
			62: 5.84,
			63: 5.5,
			64: 6.05,
			65: 5.23,
			66: 4.48,
			67: 3.22,
			68: 1.92,
			69: 0.93,
			70: 1.87,
			71: 3.07,
			72: 4.42,
			73: 11.2,
			74: 10.39,
			75: 9.31,
			76: 7.98,
			77: 5.84,
			78: 4.27,
			79: 3.07,
            80: 1.92,
			81: 2.72,
			82: 3.67,
			83: 4.3,
			84: 4.96,
			85: 6.29,
			86: 7.28,
			87: 8.15,
			88: 9.87,
			89: 11.15,
			90: 12.16,
			91: 13.9,
			92: 15.27,
			93: 16.67,
			94: 6.84,
			95: 8.07,
			96: 8.9,
			97: 9.8,
			98: 10.97,
			99: 19.87,
			100: 17.92,
			101: 16.81,
			102: 15.34,
			103: 13.7,
			104: 12.42,
			105: 11.76,
			106: 10.49,
			107: 9.62,
			108: 6.54,
			109: 5.23,
			110: 3.88,
			111: 4.01,
			112: 3.07,
			113: 2.2,
			114: 2.87,
			115: 3.59,
			116: 4.44,
			117: 5.42,
			118: 6.24,
			119: 7.6,
			120: 9.02,
			121: 10.11,
			122: 11.39,
			123: 12.94,
			124: 12.38,
			125: 11.48,
			126: 10.39,
			127: 11.92,
			128: 12.55,
			129: 13.29,
			130: 12.66,
			131: 11.76,
			132: 10.49,
			133: 11.15,
			134: 12.3,
			135: 13.54
		},
		13: {
			1: 11.97,
			2: 11.29,
			3: 10.77,
			4: 9.63,
			5: 8.87,
			6: 7.27,
			7: 6.45,
			8: 5.32,
			9: 4.57,
			10: 3.68,
			11: 2.41,
			12: 1.48,
			13: 0,
			14: 2.59,
			15: 3.91,
			16: 5.2,
			17: 6.03,
			18: 7.04,
			19: 8.17,
			20: 9.03,
			21: 10.66,
			22: 11.51,
			23: 12.24,
			24: 11.59,
			25: 7.29,
			26: 6.55,
			27: 5.56,
			28: 4.57,
			29: 5.36,
			30: 5.75,
			31: 6.98,
			32: 5.99,
			33: 5.36,
			34: 4.7,
			35: 5.25,
			36: 5.78,
			37: 6.81,
			38: 8.33,
			39: 9.42,
			40: 10.52,
			41: 11.4,
			42: 12,
			43: 13.26,
			44: 14.09,
			45: 14.85,
			46: 15.88,
			47: 16.46,
			48: 17.91,
			49: 18.78,
			50: 20.92,
			51: 22.83,
			52: 24.92,
			53: 15.73,
			54: 14.62,
			55: 13.72,
			56: 15.67,
			57: 12.87,
			58: 11.72,
			59: 10.66,
			60: 9.1,
			61: 8.2,
			62: 7.32,
			63: 6.98,
			64: 7.53,
			65: 6.71,
			66: 5.96,
			67: 4.7,
			68: 3.4,
			69: 2.41,
			70: 3.35,
			71: 4.55,
			72: 5.9,
			73: 12.68,
			74: 11.87,
			75: 10.79,
			76: 9.46,
			77: 7.32,
			78: 5.75,
			79: 4.55,
            80: 3.4,
			81: 4.2,
			82: 5.15,
			83: 5.78,
			84: 6.44,
			85: 7.77,
			86: 8.76,
			87: 9.63,
			88: 11.35,
			89: 12.62,
			90: 13.64,
			91: 15.38,
			92: 16.75,
			93: 18.15,
			94: 8.32,
			95: 9.55,
			96: 10.38,
			97: 11.28,
			98: 12.45,
			99: 21.34,
			100: 19.4,
			101: 18.29,
			102: 16.82,
			103: 15.18,
			104: 13.89,
			105: 13.24,
			106: 11.96,
			107: 11.1,
			108: 8.02,
			109: 6.71,
            110: 5.36,
			111: 5.48,
			112: 4.55,
			113: 3.68,
			114: 4.34,
			115: 5.07,
			116: 5.91,
			117: 6.9,
			118: 7.72,
			119: 9.08,
			120: 10.5,
			121: 11.59,
			122: 12.87,
			123: 14.42,
			124: 13.86,
			125: 12.96,
			126: 11.87,
			127: 13.4,
			128: 14.03,
			129: 14.77,
			130: 14.14,
			131: 13.24,
			132: 11.96,
			133: 12.62,
			134: 13.78,
			135: 15.02
		},
		14: {
			1: 14.55,
			2: 13.87,
			3: 13.36,
			4: 12.22,
			5: 11.45,
			6: 9.86,
			7: 9.04,
			8: 7.9,
			9: 7.16,
			10: 6.26,
			11: 5,
			12: 4.06,
			13: 2.59,
			14: 0,
			15: 1.33,
			16: 2.61,
			17: 3.44,
			18: 4.45,
			19: 5.58,
			20: 6.45,
			21: 8.07,
			22: 8.93,
			23: 9.97,
			24: 10.61,
			25: 9.87,
			26: 9.14,
			27: 8.14,
			28: 7.16,
			29: 7.94,
			30: 8.33,
			31: 9.56,
			32: 8.57,
			33: 7.94,
			34: 7.28,
			35: 7.83,
			36: 8.36,
			37: 9.39,
			38: 10.91,
			39: 12,
			40: 13.1,
			41: 13.98,
			42: 14.58,
			43: 15.84,
			44: 16.67,
			45: 17.43,
			46: 18.46,
			47: 19.04,
			48: 20.49,
			49: 21.36,
			50: 23.5,
			51: 25.41,
			52: 27.5,
			53: 18.32,
			54: 17.21,
			55: 16.31,
			56: 18.25,
			57: 15.46,
			58: 14.31,
			59: 13.25,
			60: 11.69,
			61: 10.79,
			62: 9.91,
			63: 9.56,
			64: 10.11,
			65: 9.29,
			66: 8.55,
			67: 7.28,
			68: 5.99,
			69: 5,
			70: 5.93,
			71: 7.13,
			72: 8.48,
			73: 15.27,
			74: 14.46,
			75: 13.38,
			76: 12.05,
			77: 9.91,
			78: 8.33,
			79: 7.13,
			80: 5.99,
			81: 6.79,
			82: 7.73,
			83: 8.36,
			84: 9.02,
			85: 10.36,
			86: 11.34,
			87: 12.21,
			88: 13.94,
			89: 15.21,
			90: 16.23,
			91: 17.97,
			92: 19.33,
			93: 20.74,
			94: 10.9,
			95: 12.13,
			96: 12.97,
			97: 13.87,
			98: 15.04,
			99: 23.93,
			100: 21.98,
			101: 20.87,
			102: 19.41,
			103: 17.76,
			104: 16.48,
			105: 15.83,
			106: 14.55,
			107: 13.69,
			108: 10.61,
			109: 9.29,
			110: 7.94,
			111: 8.07,
			112: 7.13,
			113: 6.26,
			114: 6.93,
			115: 7.66,
			116: 8.5,
			117: 9.49,
			118: 10.3,
			119: 11.66,
			120: 11.7,
			121: 10.61,
			122: 15.46,
			123: 17.01,
			124: 16.44,
			125: 15.54,
			126: 14.46,
			127: 15.98,
			128: 16.61,
			129: 17.35,
			130: 16.72,
			131: 15.83,
			132: 14.55,
			133: 15.21,
			134: 16.36,
			135: 17.61
		},
		15: {
			1: 15.88,
			2: 15.2,
			3: 14.69,
			4: 13.54,
			5: 12.78,
			6: 11.19,
			7: 10.36,
			8: 9.23,
			9: 8.48,
			10: 7.59,
			11: 6.32,
			12: 5.39,
			13: 3.91,
			14: 1.33,
			15: 0,
			16: 1.28,
			17: 2.11,
			18: 3.12,
			19: 4.25,
			20: 5.12,
			21: 6.75,
			22: 7.6,
			23: 8.64,
			24: 9.28,
			25: 11.2,
			26: 10.47,
			27: 9.47,
			28: 8.48,
			29: 9.27,
			30: 9.66,
			31: 10.89,
			32: 9.9,
			33: 9.27,
			34: 8.61,
			35: 9.16,
			36: 9.69,
			37: 10.72,
			38: 12.24,
			39: 13.33,
			40: 14.43,
			41: 15.31,
			42: 15.91,
			43: 17.17,
			44: 18,
			45: 18.76,
			46: 19.79,
			47: 20.37,
			48: 21.82,
			49: 22.69,
			50: 24.83,
			51: 26.74,
			52: 28.83,
			53: 19.65,
			54: 18.54,
			55: 17.64,
			56: 19.58,
			57: 16.79,
			58: 15.64,
			59: 14.58,
			60: 13.02,
			61: 12.12,
			62: 11.24,
			63: 10.89,
			64: 11.44,
			65: 10.62,
			66: 9.87,
			67: 8.61,
			68: 7.32,
			69: 6.32,
			70: 7.26,
			71: 8.46,
			72: 9.81,
			73: 16.6,
			74: 15.79,
			75: 14.71,
			76: 13.38,
			77: 11.24,
			78: 9.66,
			79: 8.46,
            80: 7.32,
			81: 8.11,
			82: 9.06,
			83: 9.69,
			84: 10.35,
			85: 11.68,
			86: 12.67,
			87: 13.54,
			88: 15.26,
			89: 16.54,
			90: 17.56,
			91: 19.29,
			92: 20.66,
			93: 22.06,
			94: 12.23,
			95: 13.46,
			96: 14.3,
			97: 15.2,
			98: 16.36,
			99: 25.26,
			100: 23.31,
			101: 22.2,
			102: 20.73,
			103: 19.09,
			104: 17.81,
			105: 17.16,
			106: 15.88,
			107: 15.01,
			108: 11.93,
			109: 10.62,
			110: 9.27,
			111: 9.4,
			112: 8.46,
			113: 7.59,
			114: 8.26,
			115: 8.99,
			116: 9.83,
			117: 10.81,
			118: 11.63,
			119: 11.8,
			120: 10.37,
			121: 9.28,
			122: 16.79,
			123: 18.34,
			124: 17.77,
			125: 16.87,
			126: 15.79,
			127: 17.31,
			128: 17.94,
			129: 18.68,
			130: 18.05,
			131: 17.16,
			132: 15.88,
			133: 16.54,
			134: 17.69,
			135: 18.93
		},
		16: {
			1: 17.17,
			2: 16.48,
			3: 15.97,
			4: 14.83,
			5: 14.07,
			6: 12.47,
			7: 11.65,
			8: 10.51,
			9: 9.77,
			10: 8.88,
			11: 7.61,
			12: 6.68,
			13: 5.2,
			14: 2.61,
			15: 1.28,
			16: 0,
			17: 0.83,
			18: 1.84,
			19: 2.97,
			20: 3.84,
			21: 5.46,
			22: 6.32,
			23: 7.35,
			24: 8,
			25: 12.49,
			26: 11.75,
			27: 10.76,
			28: 9.77,
			29: 10.56,
			30: 10.94,
			31: 12.18,
			32: 11.19,
			33: 10.56,
			34: 9.9,
			35: 10.45,
			36: 10.98,
			37: 12.01,
			38: 13.53,
			39: 14.62,
			40: 15.72,
			41: 16.6,
			42: 17.2,
			43: 18.46,
			44: 19.29,
			45: 20.05,
			46: 21.08,
			47: 21.66,
			48: 23.11,
			49: 23.98,
			50: 26.12,
			51: 28.03,
			52: 30.12,
			53: 20.93,
			54: 19.82,
			55: 18.92,
			56: 20.86,
			57: 18.07,
			58: 16.92,
			59: 15.86,
			60: 14.3,
			61: 13.4,
			62: 12.52,
			63: 12.18,
			64: 12.72,
			65: 11.9,
			66: 11.16,
			67: 9.9,
			68: 8.6,
			69: 7.61,
			70: 8.55,
			71: 9.74,
			72: 11.1,
			73: 17.88,
			74: 17.07,
			75: 15.99,
			76: 14.66,
			77: 12.52,
			78: 10.94,
			79: 9.74,
			80: 8.6,
			81: 9.4,
			82: 10.35,
			83: 10.98,
			84: 11.64,
			85: 12.97,
			86: 13.96,
			87: 14.83,
			88: 16.55,
			89: 17.82,
			90: 18.84,
			91: 20.58,
			92: 21.95,
			93: 23.35,
			94: 13.51,
			95: 14.75,
			96: 15.58,
			97: 16.48,
			98: 17.65,
			99: 26.54,
			100: 24.59,
			101: 23.48,
			102: 22.02,
			103: 20.37,
			104: 19.09,
			105: 18.44,
			106: 17.16,
			107: 16.3,
			108: 13.22,
			109: 11.9,
            110: 10.56,
			111: 10.68,
			112: 9.74,
			113: 8.88,
			114: 9.54,
			115: 10.27,
			116: 11.11,
			117: 12.1,
			118: 11.88,
			119: 10.51,
			120: 9.09,
			121: 8,
			122: 18.07,
			123: 19.62,
			124: 19.06,
			125: 18.15,
			126: 17.07,
			127: 18.6,
			128: 19.23,
			129: 19.96,
			130: 19.33,
			131: 18.44,
			132: 17.16,
			133: 17.82,
			134: 18.98,
			135: 20.22
		},
		17: {
			1: 17.99,
			2: 17.31,
			3: 16.8,
			4: 15.66,
			5: 14.89,
			6: 13.3,
			7: 12.48,
			8: 11.34,
			9: 10.6,
			10: 9.7,
			11: 8.44,
			12: 7.5,
			13: 6.03,
			14: 3.44,
			15: 2.11,
			16: 0.83,
			17: 0,
			18: 1.01,
			19: 2.14,
			20: 3.01,
			21: 4.63,
			22: 5.49,
			23: 6.53,
			24: 7.17,
			25: 13.31,
			26: 12.58,
			27: 11.58,
			28: 10.6,
			29: 11.38,
			30: 11.77,
			31: 13,
			32: 12.01,
			33: 11.38,
			34: 10.72,
			35: 11.27,
			36: 11.8,
			37: 12.83,
			38: 14.35,
			39: 15.44,
			40: 16.54,
			41: 17.42,
			42: 18.02,
			43: 19.28,
			44: 20.11,
			45: 20.87,
			46: 21.9,
			47: 22.48,
			48: 23.93,
			49: 24.8,
			50: 26.94,
			51: 28.85,
			52: 30.94,
			53: 21.76,
			54: 20.65,
			55: 19.75,
			56: 21.69,
			57: 18.9,
			58: 17.75,
			59: 16.69,
			60: 15.13,
			61: 14.23,
			62: 13.35,
			63: 13,
			64: 13.55,
			65: 12.73,
			66: 11.99,
			67: 10.72,
			68: 9.43,
			69: 8.44,
			70: 9.37,
			71: 10.57,
			72: 11.92,
			73: 18.71,
			74: 17.9,
			75: 16.82,
			76: 15.49,
			77: 13.35,
			78: 11.77,
			79: 10.57,
            80: 9.43,
			81: 10.23,
			82: 11.17,
			83: 11.8,
			84: 12.46,
			85: 13.8,
			86: 14.78,
			87: 15.65,
			88: 17.38,
			89: 18.65,
			90: 19.67,
			91: 21.41,
			92: 22.77,
			93: 24.18,
			94: 14.34,
			95: 15.57,
			96: 16.41,
			97: 17.31,
			98: 18.48,
			99: 27.37,
			100: 25.42,
			101: 24.31,
			102: 22.85,
			103: 21.2,
			104: 19.92,
			105: 19.27,
			106: 17.99,
			107: 17.13,
			108: 14.05,
			109: 12.73,
            110: 11.38,
			111: 11.51,
			112: 10.57,
			113: 9.7,
			114: 10.37,
			115: 11.1,
			116: 11.94,
			117: 11.86,
			118: 11.05,
			119: 9.69,
			120: 8.26,
			121: 7.17,
			122: 18.9,
			123: 20.45,
			124: 19.88,
			125: 18.98,
			126: 17.9,
			127: 19.42,
			128: 20.05,
			129: 20.79,
			130: 20.16,
			131: 19.27,
			132: 17.99,
			133: 18.65,
			134: 19.8,
			135: 21.05
		},
		18: {
			1: 19,
			2: 18.32,
			3: 17.81,
			4: 16.67,
			5: 15.9,
			6: 14.31,
			7: 13.49,
			8: 12.35,
			9: 11.61,
			10: 10.71,
			11: 9.45,
			12: 8.52,
			13: 7.04,
			14: 4.45,
			15: 3.12,
			16: 1.84,
			17: 1.01,
			18: 0,
			19: 1.13,
			20: 2,
			21: 3.62,
			22: 4.48,
			23: 5.52,
			24: 6.16,
			25: 14.32,
			26: 13.59,
			27: 12.6,
			28: 11.61,
			29: 12.4,
			30: 12.78,
			31: 14.01,
			32: 13.02,
			33: 12.39,
			34: 11.73,
			35: 12.28,
			36: 12.81,
			37: 13.84,
			38: 15.36,
			39: 16.45,
			40: 17.55,
			41: 18.43,
			42: 19.03,
			43: 20.29,
			44: 21.12,
			45: 21.88,
			46: 22.91,
			47: 23.49,
			48: 24.94,
			49: 25.81,
			50: 27.95,
			51: 29.86,
			52: 31.95,
			53: 22.77,
			54: 21.66,
			55: 20.76,
			56: 22.7,
			57: 19.91,
			58: 18.76,
			59: 17.7,
			60: 16.14,
			61: 15.24,
			62: 14.36,
			63: 14.01,
			64: 14.56,
			65: 13.74,
			66: 13,
			67: 11.73,
			68: 10.44,
			69: 9.45,
			70: 10.39,
			71: 11.58,
			72: 12.94,
			73: 19.72,
			74: 18.91,
			75: 17.83,
			76: 16.5,
			77: 14.36,
			78: 12.78,
			79: 11.58,
            80: 10.44,
			81: 11.24,
			82: 12.18,
			83: 12.81,
			84: 13.48,
			85: 14.81,
			86: 15.8,
			87: 16.66,
			88: 18.39,
			89: 19.66,
			90: 20.68,
			91: 22.42,
			92: 23.79,
			93: 25.19,
			94: 15.35,
			95: 16.59,
			96: 17.42,
			97: 18.32,
			98: 19.49,
			99: 28.38,
			100: 26.43,
			101: 25.32,
			102: 23.86,
			103: 22.21,
			104: 20.93,
			105: 20.28,
			106: 19,
			107: 18.14,
			108: 15.06,
			109: 13.74,
            110: 12.39,
			111: 12.52,
			112: 11.58,
			113: 10.71,
			114: 11.38,
			115: 12.11,
			116: 11.84,
			117: 10.85,
			118: 10.04,
			119: 8.67,
			120: 7.25,
			121: 6.16,
			122: 19.91,
			123: 21.46,
			124: 20.9,
			125: 19.99,
			126: 18.91,
			127: 20.44,
			128: 21.07,
			129: 21.8,
			130: 21.17,
			131: 20.28,
			132: 19,
			133: 19.66,
			134: 20.82,
			135: 22.06
		},
		19: {
			1: 20.13,
			2: 19.45,
			3: 18.94,
			4: 17.8,
			5: 17.03,
			6: 15.44,
			7: 14.62,
			8: 13.48,
			9: 12.74,
			10: 11.84,
			11: 10.58,
			12: 9.64,
			13: 8.17,
			14: 5.58,
			15: 4.25,
			16: 2.97,
			17: 2.14,
			18: 1.13,
			19: 0,
			20: 0.87,
			21: 2.49,
			22: 3.35,
			23: 4.39,
			24: 5.03,
			25: 15.45,
			26: 14.72,
			27: 13.72,
			28: 12.74,
			29: 13.52,
			30: 13.91,
			31: 15.14,
			32: 14.15,
			33: 13.52,
			34: 12.86,
			35: 13.41,
			36: 13.94,
			37: 14.97,
			38: 16.49,
			39: 17.58,
			40: 18.68,
			41: 19.56,
			42: 20.16,
			43: 21.42,
			44: 22.25,
			45: 23.01,
			46: 24.04,
			47: 24.62,
			48: 26.07,
			49: 26.94,
			50: 29.08,
			51: 30.99,
			52: 33.08,
			53: 23.9,
			54: 22.79,
			55: 21.89,
			56: 23.83,
			57: 21.04,
			58: 19.89,
			59: 18.83,
			60: 17.27,
			61: 16.37,
			62: 15.49,
			63: 15.14,
			64: 15.69,
			65: 14.87,
			66: 14.13,
			67: 12.86,
			68: 11.57,
			69: 10.58,
			70: 11.51,
			71: 12.71,
			72: 14.06,
			73: 20.85,
			74: 20.04,
			75: 18.96,
			76: 17.63,
			77: 15.49,
			78: 13.91,
			79: 12.71,
			80: 11.57,
			81: 12.37,
			82: 13.31,
			83: 13.94,
			84: 14.6,
			85: 15.94,
			86: 16.92,
			87: 17.79,
			88: 19.52,
			89: 20.79,
			90: 21.81,
			91: 23.55,
			92: 24.91,
			93: 26.32,
			94: 16.48,
			95: 17.71,
			96: 18.55,
			97: 19.45,
			98: 20.62,
			99: 29.51,
			100: 27.56,
			101: 26.45,
			102: 24.99,
			103: 23.34,
			104: 22.06,
			105: 21.41,
			106: 20.13,
			107: 19.27,
			108: 16.19,
			109: 14.87,
			110: 13.52,
			111: 13.65,
			112: 12.71,
			113: 11.84,
			114: 12.28,
			115: 11.55,
			116: 10.71,
			117: 9.72,
			118: 8.91,
			119: 7.55,
			120: 6.12,
			121: 5.03,
			122: 21.04,
			123: 22.59,
			124: 22.02,
			125: 21.12,
			126: 20.04,
			127: 21.56,
			128: 22.19,
			129: 22.93,
			130: 22.3,
			131: 21.41,
			132: 20.13,
			133: 20.79,
			134: 21.94,
			135: 23.19
		},
		20: {
			1: 20.37,
			2: 19.69,
			3: 19.17,
			4: 18.03,
			5: 17.27,
			6: 15.67,
			7: 14.85,
			8: 13.72,
			9: 12.97,
			10: 12.08,
			11: 11.44,
			12: 10.51,
			13: 9.03,
			14: 6.45,
			15: 5.12,
			16: 3.84,
			17: 3.01,
			18: 2,
			19: 0.87,
			20: 0,
			21: 1.63,
			22: 2.48,
			23: 3.52,
			24: 4.17,
			25: 15.69,
			26: 14.95,
			27: 13.96,
			28: 12.97,
			29: 13.76,
			30: 14.4,
			31: 15.96,
			32: 15.02,
			33: 14.39,
			34: 13.73,
			35: 14.28,
			36: 14.81,
			37: 15.84,
			38: 17.36,
			39: 18.45,
			40: 19.55,
			41: 20.43,
			42: 21.03,
			43: 22.29,
			44: 23.12,
			45: 23.88,
			46: 24.91,
			47: 25.49,
			48: 26.94,
			49: 27.81,
			50: 29.95,
			51: 31.86,
			52: 33.95,
			53: 24.38,
			54: 23.27,
			55: 22.37,
			56: 24.32,
			57: 21.52,
			58: 20.37,
			59: 19.31,
			60: 17.75,
			61: 16.85,
			62: 15.97,
			63: 15.96,
			64: 16.56,
			65: 15.74,
			66: 14.99,
			67: 13.73,
			68: 12.43,
			69: 11.44,
			70: 12.38,
			71: 13.58,
			72: 14.93,
			73: 21.33,
			74: 20.52,
			75: 19.44,
			76: 18.11,
			77: 15.97,
			78: 14.4,
			79: 13.2,
			80: 12.43,
			81: 13.23,
			82: 14.18,
			83: 14.81,
			84: 15.47,
			85: 16.8,
			86: 17.79,
			87: 18.66,
			88: 20.38,
			89: 21.66,
			90: 22.67,
			91: 24.41,
			92: 25.78,
			93: 27.18,
			94: 17.35,
			95: 18.58,
			96: 19.41,
			97: 20.32,
			98: 21.48,
			99: 30.38,
			100: 28.43,
			101: 27.32,
			102: 25.85,
			103: 24.21,
			104: 22.93,
			105: 22.28,
			106: 21,
			107: 20.13,
			108: 17.05,
			109: 15.74,
            110: 14.39,
			111: 14.14,
			112: 13.2,
			113: 12.08,
			114: 11.41,
			115: 10.68,
			116: 9.84,
			117: 8.86,
			118: 8.04,
			119: 6.68,
			120: 5.25,
			121: 4.17,
			122: 21.52,
			123: 23.07,
			124: 22.51,
			125: 21.61,
			126: 20.52,
			127: 22.05,
			128: 22.68,
			129: 23.42,
			130: 23.17,
			131: 22.28,
			132: 21,
			133: 21.66,
			134: 22.81,
			135: 24.05
		},
		21: {
			1: 18.74,
			2: 18.06,
			3: 17.55,
			4: 16.4,
			5: 15.64,
			6: 14.05,
			7: 13.22,
			8: 12.09,
			9: 11.34,
			10: 10.45,
			11: 11.72,
			12: 12.14,
			13: 10.66,
			14: 8.07,
			15: 6.75,
			16: 5.46,
			17: 4.63,
			18: 3.62,
			19: 2.49,
			20: 1.63,
			21: 0,
			22: 0.85,
			23: 1.89,
			24: 2.54,
			25: 14.06,
			26: 13.33,
			27: 12.33,
			28: 11.34,
			29: 12.13,
			30: 12.77,
			31: 14.33,
			32: 13.82,
			33: 13.19,
			34: 13.85,
			35: 14.4,
			36: 14.93,
			37: 15.96,
			38: 17.48,
			39: 18.57,
			40: 19.67,
			41: 20.55,
			42: 21.15,
			43: 22.41,
			44: 23.24,
			45: 24,
			46: 25.03,
			47: 25.61,
			48: 27.06,
			49: 27.93,
			50: 30.07,
			51: 31.98,
			52: 34.07,
			53: 22.76,
			54: 21.65,
			55: 20.75,
			56: 22.69,
			57: 19.9,
			58: 18.75,
			59: 17.69,
			60: 16.13,
			61: 15.23,
			62: 14.35,
			63: 14.33,
			64: 15.09,
			65: 14.54,
			66: 15.11,
			67: 13.85,
			68: 12.71,
			69: 11.72,
			70: 12.66,
			71: 13.86,
			72: 15.21,
			73: 19.71,
			74: 18.9,
			75: 17.82,
			76: 16.49,
			77: 14.35,
			78: 12.77,
			79: 11.57,
			80: 12.71,
			81: 13.51,
			82: 14.46,
			83: 14.93,
			84: 15.59,
			85: 16.92,
			86: 17.91,
			87: 18.78,
			88: 20.5,
			89: 21.43,
			90: 22.45,
			91: 24.19,
			92: 25.56,
			93: 26.96,
			94: 17.47,
			95: 18.7,
			96: 19.54,
			97: 20.44,
			98: 21.6,
			99: 29.18,
			100: 27.23,
			101: 26.12,
			102: 24.65,
			103: 23.01,
			104: 21.73,
			105: 21.08,
			106: 19.8,
			107: 18.93,
			108: 15.85,
			109: 14.54,
			110: 13.19,
			111: 12.51,
			112: 11.57,
			113: 10.45,
			114: 9.78,
			115: 9.06,
			116: 8.21,
			117: 7.23,
			118: 6.41,
			119: 5.05,
			120: 3.63,
			121: 2.54,
			122: 19.9,
			123: 21.45,
			124: 20.88,
			125: 19.98,
			126: 18.9,
			127: 20.42,
			128: 21.05,
			129: 21.79,
			130: 21.97,
			131: 21.08,
			132: 19.8,
			133: 21.43,
			134: 22.59,
			135: 23.83
		},
		22: {
			1: 17.89,
			2: 17.21,
			3: 16.69,
			4: 15.55,
			5: 14.79,
			6: 13.19,
			7: 12.37,
			8: 11.24,
			9: 10.49,
			10: 9.6,
			11: 10.87,
			12: 11.8,
			13: 11.51,
			14: 8.93,
			15: 7.6,
			16: 6.32,
			17: 5.49,
			18: 4.48,
			19: 3.35,
			20: 2.48,
			21: 0.85,
			22: 0,
			23: 1.04,
			24: 1.69,
			25: 13.21,
			26: 12.47,
			27: 11.48,
			28: 10.49,
			29: 11.28,
			30: 11.92,
			31: 13.48,
			32: 12.97,
			33: 12.34,
			34: 13,
			35: 13.55,
			36: 14.08,
			37: 15.11,
			38: 16.63,
			39: 17.72,
			40: 18.82,
			41: 19.7,
			42: 20.3,
			43: 21.56,
			44: 22.39,
			45: 23.15,
			46: 24.18,
			47: 24.76,
			48: 26.21,
			49: 27.08,
			50: 29.22,
			51: 31.13,
			52: 33.22,
			53: 21.9,
			54: 20.79,
			55: 19.89,
			56: 21.84,
			57: 19.04,
			58: 17.89,
			59: 16.83,
			60: 15.27,
			61: 14.37,
			62: 13.49,
			63: 13.48,
			64: 14.24,
			65: 13.69,
			66: 14.26,
			67: 13,
			68: 11.86,
			69: 10.87,
			70: 11.81,
			71: 13,
			72: 14.36,
			73: 18.85,
			74: 18.04,
			75: 16.96,
			76: 15.63,
			77: 13.49,
			78: 11.92,
			79: 10.72,
			80: 11.86,
			81: 12.66,
			82: 13.6,
			83: 14.08,
			84: 14.74,
			85: 16.07,
			86: 17.06,
			87: 17.93,
			88: 19.65,
			89: 20.58,
			90: 21.6,
			91: 23.34,
			92: 24.7,
			93: 26.11,
			94: 16.62,
			95: 17.85,
			96: 18.68,
			97: 19.58,
			98: 20.75,
			99: 28.32,
			100: 26.38,
			101: 25.27,
			102: 23.8,
			103: 22.16,
			104: 20.88,
			105: 20.22,
			106: 18.95,
			107: 18.08,
			108: 15,
			109: 13.69,
			110: 12.34,
			111: 11.66,
			112: 10.72,
			113: 9.6,
			114: 8.93,
			115: 8.2,
			116: 7.36,
			117: 6.38,
			118: 5.56,
			119: 4.2,
			120: 2.77,
			121: 1.69,
			122: 19.04,
			123: 20.59,
			124: 20.03,
			125: 19.13,
			126: 18.04,
			127: 19.57,
			128: 20.2,
			129: 20.94,
			130: 21.12,
			131: 20.22,
			132: 18.95,
			133: 20.58,
			134: 21.73,
			135: 22.98
		},
		23: {
			1: 16.85,
			2: 16.17,
			3: 15.65,
			4: 14.51,
			5: 13.75,
			6: 12.15,
			7: 11.33,
			8: 10.2,
			9: 9.45,
			10: 8.56,
			11: 9.83,
			12: 10.76,
			13: 12.24,
			14: 9.97,
			15: 8.64,
			16: 7.35,
			17: 6.53,
			18: 5.52,
			19: 4.39,
			20: 3.52,
			21: 1.89,
			22: 1.04,
			23: 0,
			24: 0.65,
			25: 12.17,
			26: 11.43,
			27: 10.44,
			28: 9.45,
			29: 10.24,
			30: 10.88,
			31: 12.44,
			32: 11.93,
			33: 11.3,
			34: 11.96,
			35: 12.51,
			36: 13.04,
			37: 14.07,
			38: 15.59,
			39: 16.68,
			40: 17.78,
			41: 18.66,
			42: 19.26,
			43: 20.52,
			44: 21.35,
			45: 22.11,
			46: 23.14,
			47: 23.72,
			48: 25.17,
			49: 26.04,
			50: 28.18,
			51: 30.09,
			52: 32.18,
			53: 20.86,
			54: 19.75,
			55: 18.85,
			56: 20.8,
			57: 18,
			58: 16.85,
			59: 15.79,
			60: 14.23,
			61: 13.33,
			62: 12.45,
			63: 12.44,
			64: 13.2,
			65: 12.65,
			66: 13.22,
			67: 11.96,
			68: 10.82,
			69: 9.83,
			70: 10.77,
			71: 11.96,
			72: 13.32,
			73: 17.81,
			74: 17.01,
			75: 15.92,
			76: 14.59,
			77: 12.45,
			78: 10.88,
			79: 9.68,
			80: 10.82,
			81: 11.62,
			82: 12.57,
			83: 13.04,
			84: 13.7,
			85: 15.03,
			86: 16.02,
			87: 16.89,
			88: 18.61,
			89: 19.54,
			90: 20.56,
			91: 22.3,
			92: 23.67,
			93: 25.07,
			94: 15.58,
			95: 16.81,
			96: 17.64,
			97: 18.54,
			98: 19.71,
			99: 27.29,
			100: 25.34,
			101: 24.23,
			102: 22.76,
			103: 21.12,
			104: 19.84,
			105: 19.18,
			106: 17.91,
			107: 17.04,
			108: 13.96,
			109: 12.65,
			110: 11.3,
			111: 10.62,
			112: 9.68,
			113: 8.56,
			114: 7.89,
			115: 7.16,
			116: 6.32,
			117: 5.34,
			118: 4.52,
			119: 3.16,
			120: 1.74,
			121: 0.65,
			122: 18,
			123: 19.56,
			124: 18.99,
			125: 18.09,
			126: 17.01,
			127: 18.53,
			128: 19.16,
			129: 19.9,
			130: 20.08,
			131: 19.18,
			132: 17.91,
			133: 19.54,
			134: 20.7,
			135: 21.94
		},
		24: {
			1: 16.2,
			2: 15.52,
			3: 15.01,
			4: 13.87,
			5: 13.1,
			6: 11.51,
			7: 10.69,
			8: 9.55,
			9: 8.81,
			10: 7.91,
			11: 9.18,
			12: 10.11,
			13: 11.59,
			14: 10.61,
			15: 9.28,
			16: 8,
			17: 7.17,
			18: 6.16,
			19: 5.03,
			20: 4.17,
			21: 2.54,
			22: 1.69,
			23: 0.65,
			24: 0,
			25: 11.52,
			26: 10.79,
			27: 9.79,
			28: 8.81,
			29: 9.59,
			30: 10.23,
			31: 11.79,
			32: 11.28,
			33: 10.65,
			34: 11.31,
			35: 11.86,
			36: 12.39,
			37: 13.42,
			38: 14.94,
			39: 16.03,
			40: 17.13,
			41: 18.01,
			42: 18.61,
			43: 19.87,
			44: 20.7,
			45: 21.46,
			46: 22.49,
			47: 23.07,
			48: 24.52,
			49: 25.39,
			50: 27.53,
			51: 29.44,
			52: 31.53,
			53: 20.22,
			54: 19.11,
			55: 18.21,
			56: 20.15,
			57: 17.36,
			58: 16.21,
			59: 15.15,
			60: 13.59,
			61: 12.69,
			62: 11.81,
			63: 11.79,
			64: 12.56,
			65: 12,
			66: 12.58,
			67: 11.31,
			68: 10.17,
			69: 9.18,
			70: 10.12,
			71: 11.32,
			72: 12.67,
			73: 17.17,
			74: 16.36,
			75: 15.28,
			76: 13.95,
			77: 11.81,
			78: 10.23,
			79: 9.03,
			80: 10.17,
			81: 10.97,
			82: 11.92,
			83: 12.39,
			84: 13.05,
			85: 14.39,
			86: 15.37,
			87: 16.24,
			88: 17.97,
			89: 18.89,
			90: 19.91,
			91: 21.65,
			92: 23.02,
			93: 24.42,
			94: 14.93,
			95: 16.16,
			96: 17,
			97: 17.9,
			98: 19.07,
			99: 26.64,
			100: 24.69,
			101: 23.58,
			102: 22.12,
			103: 20.47,
			104: 19.19,
			105: 18.54,
			106: 17.26,
			107: 16.4,
			108: 13.32,
			109: 12,
			110: 10.65,
			111: 9.97,
			112: 9.03,
			113: 7.91,
			114: 7.25,
			115: 6.52,
			116: 5.68,
			117: 4.69,
			118: 3.88,
			119: 2.51,
			120: 1.09,
			121: 0,
			122: 17.36,
			123: 18.91,
			124: 18.35,
			125: 17.44,
			126: 16.36,
			127: 17.89,
			128: 18.52,
			129: 19.25,
			130: 19.43,
			131: 18.54,
			132: 17.26,
			133: 18.89,
			134: 20.05,
			135: 21.29
		},
		25: {
			1: 10.11,
			2: 9.43,
			3: 8.92,
			4: 7.78,
			5: 7.01,
			6: 5.42,
			7: 4.6,
			8: 3.46,
			9: 2.72,
			10: 3.61,
			11: 4.88,
			12: 5.81,
			13: 7.29,
			14: 9.87,
			15: 11.2,
			16: 12.49,
			17: 13.31,
			18: 14.32,
			19: 15.45,
			20: 15.69,
			21: 14.06,
			22: 13.21,
			23: 12.17,
			24: 11.52,
			25: 0,
			26: 0.74,
			27: 1.73,
			28: 2.72,
			29: 3.51,
			30: 4.17,
			31: 5.73,
			32: 6.72,
			33: 6.35,
			34: 7.01,
			35: 7.56,
			36: 8.09,
			37: 9.12,
			38: 10.64,
			39: 11.73,
			40: 12.83,
			41: 13.71,
			42: 14.31,
			43: 15.57,
			44: 16.4,
			45: 17.16,
			46: 18.19,
			47: 18.77,
			48: 20.22,
			49: 21.09,
			50: 23.23,
			51: 25.14,
			52: 27.23,
			53: 14.16,
			54: 13.05,
			55: 12.15,
			56: 14.09,
			57: 11.3,
			58: 10.15,
			59: 9.09,
			60: 7.53,
			61: 6.63,
			62: 5.75,
			63: 5.73,
			64: 6.5,
			65: 7.31,
			66: 8.13,
			67: 7.01,
			68: 5.87,
			69: 4.88,
			70: 5.82,
			71: 7.01,
			72: 8.37,
			73: 11.11,
			74: 10.3,
			75: 9.22,
			76: 7.89,
			77: 5.75,
			78: 4.17,
			79: 4.73,
			80: 5.87,
			81: 6.67,
			82: 7.62,
			83: 8.09,
			84: 8.75,
			85: 10.08,
			86: 11.07,
			87: 11.94,
			88: 13.66,
			89: 14.21,
			90: 15.22,
			91: 16.96,
			92: 18.33,
			93: 19.73,
			94: 10.63,
			95: 11.86,
			96: 12.69,
			97: 13.6,
			98: 14.76,
			99: 21.95,
			100: 20.01,
			101: 18.89,
			102: 17.43,
			103: 15.78,
			104: 14.5,
			105: 13.85,
			106: 12.57,
			107: 11.71,
			108: 8.63,
			109: 7.31,
			110: 6.35,
			111: 5.67,
			112: 4.73,
			113: 3.61,
			114: 4.28,
			115: 5.01,
			116: 5.85,
			117: 6.83,
			118: 7.65,
			119: 9.01,
			120: 10.43,
			121: 11.52,
			122: 11.3,
			123: 12.85,
			124: 12.28,
			125: 11.38,
			126: 10.3,
			127: 11.82,
			128: 12.45,
			129: 13.19,
			130: 14.6,
			131: 13.85,
			132: 12.57,
			133: 14.21,
			134: 15.36,
			135: 16.6
		},
		26: {
			1: 9.38,
			2: 8.7,
			3: 8.18,
			4: 7.04,
			5: 6.28,
			6: 4.68,
			7: 3.86,
			8: 2.73,
			9: 1.98,
			10: 2.88,
			11: 4.14,
			12: 5.07,
			13: 6.55,
			14: 9.14,
			15: 10.47,
			16: 11.75,
			17: 12.58,
			18: 13.59,
			19: 14.72,
			20: 14.95,
			21: 13.33,
			22: 12.47,
			23: 11.43,
			24: 10.79,
			25: 0.74,
			26: 0,
			27: 0.99,
			28: 1.98,
			29: 2.77,
			30: 3.44,
			31: 5,
			32: 5.99,
			33: 5.62,
			34: 6.28,
			35: 6.83,
			36: 7.36,
			37: 8.39,
			38: 9.91,
			39: 11,
			40: 12.1,
			41: 12.98,
			42: 13.58,
			43: 14.84,
			44: 15.67,
			45: 16.43,
			46: 17.46,
			47: 18.04,
			48: 19.49,
			49: 20.36,
			50: 22.5,
			51: 24.41,
			52: 26.5,
			53: 13.42,
			54: 12.31,
			55: 11.41,
			56: 13.36,
			57: 10.56,
			58: 9.41,
			59: 8.35,
			60: 6.79,
			61: 5.89,
			62: 5.01,
			63: 5,
			64: 5.76,
			65: 6.58,
			66: 7.39,
			67: 6.28,
			68: 5.14,
			69: 4.14,
			70: 5.08,
			71: 6.28,
			72: 7.63,
			73: 10.37,
			74: 9.56,
			75: 8.48,
			76: 7.15,
			77: 5.01,
			78: 3.44,
			79: 3.99,
			80: 5.14,
			81: 5.93,
			82: 6.88,
			83: 7.36,
			84: 8.02,
			85: 9.35,
			86: 10.34,
			87: 11.21,
			88: 12.93,
			89: 13.47,
			90: 14.49,
			91: 16.23,
			92: 17.6,
			93: 19,
			94: 9.89,
			95: 11.13,
			96: 11.96,
			97: 12.86,
			98: 14.03,
			99: 21.22,
			100: 19.27,
			101: 18.16,
			102: 16.69,
			103: 15.05,
			104: 13.77,
			105: 13.12,
			106: 11.84,
			107: 10.97,
			108: 7.89,
			109: 6.58,
			110: 5.62,
			111: 4.93,
			112: 3.99,
			113: 2.88,
			114: 3.54,
			115: 4.27,
			116: 5.11,
			117: 6.1,
			118: 6.91,
			119: 8.28,
			120: 9.7,
			121: 10.79,
			122: 10.56,
			123: 12.11,
			124: 11.55,
			125: 10.65,
			126: 9.56,
			127: 11.09,
			128: 11.72,
			129: 12.46,
			130: 13.86,
			131: 13.12,
			132: 11.84,
			133: 13.47,
			134: 14.63,
			135: 15.87
		},
		27: {
			1: 8.39,
			2: 7.7,
			3: 7.19,
			4: 6.05,
			5: 5.29,
			6: 3.69,
			7: 2.87,
			8: 1.73,
			9: 0.99,
			10: 1.88,
			11: 3.15,
			12: 4.08,
			13: 5.56,
			14: 8.14,
			15: 9.47,
			16: 10.76,
			17: 11.58,
			18: 12.6,
			19: 13.72,
			20: 13.96,
			21: 12.33,
			22: 11.48,
			23: 10.44,
			24: 9.79,
			25: 1.73,
			26: 0.99,
			27: 0,
			28: 0.99,
			29: 1.78,
			30: 2.44,
			31: 4,
			32: 4.99,
			33: 4.62,
			34: 5.28,
			35: 5.83,
			36: 6.36,
			37: 7.39,
			38: 8.91,
			39: 10,
			40: 11.1,
			41: 11.98,
			42: 12.58,
			43: 13.84,
			44: 14.67,
			45: 15.43,
			46: 16.46,
			47: 17.04,
			48: 18.49,
			49: 19.36,
			50: 21.5,
			51: 23.41,
			52: 25.5,
			53: 12.43,
			54: 11.32,
			55: 10.42,
			56: 12.36,
			57: 9.57,
			58: 8.42,
			59: 7.36,
			60: 5.8,
			61: 4.9,
			62: 4.02,
			63: 4,
			64: 4.77,
			65: 5.59,
			66: 6.4,
			67: 5.28,
			68: 4.14,
			69: 3.15,
			70: 4.09,
			71: 5.29,
			72: 6.64,
			73: 9.38,
			74: 8.57,
			75: 7.49,
			76: 6.16,
			77: 4.02,
			78: 2.44,
			79: 3,
			80: 4.14,
			81: 4.94,
			82: 5.89,
			83: 6.36,
			84: 7.02,
			85: 8.35,
			86: 9.34,
			87: 10.21,
			88: 11.93,
			89: 12.48,
			90: 13.5,
			91: 15.23,
			92: 16.6,
			93: 18,
			94: 8.9,
			95: 10.13,
			96: 10.97,
			97: 11.87,
			98: 13.03,
			99: 20.22,
			100: 18.28,
			101: 17.17,
			102: 15.7,
			103: 14.06,
			104: 12.77,
			105: 12.12,
			106: 10.84,
			107: 9.98,
			108: 6.9,
			109: 5.59,
			110: 4.62,
			111: 3.94,
			112: 3,
			113: 1.88,
			114: 2.55,
			115: 3.28,
			116: 4.12,
			117: 5.1,
			118: 5.92,
			119: 7.28,
			120: 8.71,
			121: 9.79,
			122: 9.57,
			123: 11.12,
			124: 10.56,
			125: 9.65,
			126: 8.57,
			127: 10.1,
			128: 10.73,
			129: 11.46,
			130: 12.87,
			131: 12.12,
			132: 10.84,
			133: 12.48,
			134: 13.63,
			135: 14.87
		},
		28: {
			1: 7.4,
			2: 6.72,
			3: 6.2,
			4: 5.06,
			5: 4.3,
			6: 2.7,
			7: 1.88,
			8: 0.75,
			9: 0,
			10: 0.89,
			11: 2.16,
			12: 3.09,
			13: 4.57,
			14: 7.16,
			15: 8.48,
			16: 9.77,
			17: 10.6,
			18: 11.61,
			19: 12.74,
			20: 12.97,
			21: 11.34,
			22: 10.49,
			23: 9.45,
			24: 8.81,
			25: 2.72,
			26: 1.98,
			27: 0.99,
			28: 0,
			29: 0.79,
			30: 1.46,
			31: 3.02,
			32: 4.01,
			33: 3.63,
			34: 4.29,
			35: 4.84,
			36: 5.37,
			37: 6.4,
			38: 7.92,
			39: 9.01,
			40: 10.11,
			41: 10.99,
			42: 11.59,
			43: 12.85,
			44: 13.68,
			45: 14.44,
			46: 15.47,
			47: 16.05,
			48: 17.5,
			49: 18.37,
			50: 20.51,
			51: 22.42,
			52: 24.51,
			53: 11.44,
			54: 10.33,
			55: 9.43,
			56: 11.37,
			57: 8.58,
			58: 7.43,
			59: 6.37,
			60: 4.81,
			61: 3.91,
			62: 3.03,
			63: 3.02,
			64: 3.78,
			65: 4.6,
			66: 5.41,
			67: 4.29,
			68: 3.15,
			69: 2.16,
			70: 3.1,
			71: 4.3,
			72: 5.65,
			73: 8.39,
			74: 7.58,
			75: 6.5,
			76: 5.17,
			77: 3.03,
			78: 1.46,
			79: 2.01,
			80: 3.15,
			81: 3.95,
			82: 4.9,
			83: 5.37,
			84: 6.03,
			85: 7.37,
			86: 8.35,
			87: 9.22,
			88: 10.95,
			89: 11.49,
			90: 12.51,
			91: 14.25,
			92: 15.61,
			93: 17.02,
			94: 7.91,
			95: 9.14,
			96: 9.98,
			97: 10.88,
			98: 12.05,
			99: 19.23,
			100: 17.29,
			101: 16.18,
			102: 14.71,
			103: 13.07,
			104: 11.79,
			105: 11.13,
			106: 9.86,
			107: 8.99,
			108: 5.91,
			109: 4.6,
			110: 3.63,
			111: 2.95,
			112: 2.01,
			113: 0.89,
			114: 1.56,
			115: 2.29,
			116: 3.13,
			117: 4.12,
			118: 4.93,
			119: 6.29,
			120: 7.72,
			121: 8.81,
			122: 8.58,
			123: 10.13,
			124: 9.57,
			125: 8.67,
			126: 7.58,
			127: 9.11,
			128: 9.74,
			129: 10.48,
			130: 11.88,
			131: 11.13,
			132: 9.86,
			133: 11.49,
			134: 12.64,
			135: 13.89
		},
		29: {
			1: 8.19,
			2: 7.5,
			3: 6.99,
			4: 5.85,
			5: 5.09,
			6: 3.49,
			7: 2.67,
			8: 1.53,
			9: 0.79,
			10: 1.68,
			11: 2.95,
			12: 3.88,
			13: 5.36,
			14: 7.94,
			15: 9.27,
			16: 10.56,
			17: 11.38,
			18: 12.4,
			19: 13.52,
			20: 13.76,
			21: 12.13,
			22: 11.28,
			23: 10.24,
			24: 9.59,
			25: 3.51,
			26: 2.77,
			27: 1.78,
			28: 0.79,
			29: 0,
			30: 0.67,
			31: 2.23,
			32: 3.22,
			33: 3.49,
			34: 4.15,
			35: 4.7,
			36: 5.23,
			37: 6.26,
			38: 7.78,
			39: 8.87,
			40: 9.97,
			41: 10.85,
			42: 11.45,
			43: 12.71,
			44: 13.54,
			45: 14.3,
			46: 15.33,
			47: 15.91,
			48: 17.36,
			49: 18.23,
			50: 20.37,
			51: 22.28,
			52: 24.37,
			53: 10.65,
			54: 9.54,
			55: 8.64,
			56: 10.59,
			57: 7.79,
			58: 6.64,
			59: 5.58,
			60: 4.02,
			61: 3.12,
			62: 2.24,
			63: 2.23,
			64: 2.99,
			65: 3.81,
			66: 4.62,
			67: 4.15,
			68: 3.01,
			69: 2.95,
			70: 3.89,
			71: 5.09,
			72: 6.44,
			73: 7.6,
			74: 6.79,
			75: 5.71,
			76: 4.38,
			77: 2.24,
			78: 0.67,
			79: 1.87,
			80: 3.01,
			81: 3.81,
			82: 4.76,
			83: 5.23,
			84: 5.89,
			85: 7.22,
			86: 8.21,
			87: 9.08,
			88: 10.8,
			89: 10.7,
			90: 11.72,
			91: 13.46,
			92: 14.83,
			93: 16.23,
			94: 7.77,
			95: 9,
			96: 9.83,
			97: 10.73,
			98: 11.9,
			99: 18.45,
			100: 16.5,
			101: 15.39,
			102: 13.92,
			103: 12.28,
			104: 11,
			105: 10.35,
			106: 9.07,
			107: 8.2,
			108: 5.12,
			109: 3.81,
			110: 3.49,
			111: 2.81,
			112: 1.87,
			113: 1.68,
			114: 2.35,
			115: 3.08,
			116: 3.92,
			117: 4.9,
			118: 5.72,
			119: 7.08,
			120: 8.51,
			121: 9.59,
			122: 7.79,
			123: 9.34,
			124: 8.78,
			125: 7.88,
			126: 6.79,
			127: 8.32,
			128: 8.95,
			129: 9.69,
			130: 11.09,
			131: 10.35,
			132: 9.07,
			133: 10.7,
			134: 11.86,
			135: 13.1
		},
		30: {
			1: 8.85,
			2: 8.17,
			3: 7.66,
			4: 6.51,
			5: 5.75,
			6: 4.16,
			7: 3.34,
			8: 2.2,
			9: 1.46,
			10: 2.32,
			11: 3.34,
			12: 4.27,
			13: 5.75,
			14: 8.33,
			15: 9.66,
			16: 10.94,
			17: 11.77,
			18: 12.78,
			19: 13.91,
			20: 14.4,
			21: 12.77,
			22: 11.92,
			23: 10.88,
			24: 10.23,
			25: 4.17,
			26: 3.44,
			27: 2.44,
			28: 1.46,
			29: 0.67,
			30: 0,
			31: 1.56,
			32: 2.55,
			33: 2.82,
			34: 3.48,
			35: 4.03,
			36: 4.56,
			37: 5.59,
			38: 7.11,
			39: 8.2,
			40: 9.3,
			41: 10.18,
			42: 10.78,
			43: 12.04,
			44: 12.87,
			45: 13.63,
			46: 14.66,
			47: 15.24,
			48: 16.69,
			49: 17.56,
			50: 19.7,
			51: 21.61,
			52: 23.7,
			53: 9.99,
			54: 8.88,
			55: 7.98,
			56: 9.92,
			57: 7.13,
			58: 5.98,
			59: 4.92,
			60: 3.36,
			61: 2.46,
			62: 1.58,
			63: 1.56,
			64: 2.32,
			65: 3.14,
			66: 3.96,
			67: 3.48,
			68: 2.35,
			69: 3.34,
			70: 4.28,
			71: 5.47,
			72: 6.83,
			73: 6.94,
			74: 6.13,
			75: 5.05,
			76: 3.72,
			77: 1.58,
			78: 0,
			79: 1.2,
			80: 2.35,
			81: 3.14,
			82: 4.09,
			83: 4.56,
			84: 5.22,
			85: 6.56,
			86: 7.54,
			87: 8.41,
			88: 10.14,
			89: 10.03,
			90: 11.05,
			91: 12.79,
			92: 14.16,
			93: 15.56,
			94: 7.1,
			95: 8.33,
			96: 9.17,
			97: 10.07,
			98: 11.23,
			99: 17.78,
			100: 15.83,
			101: 14.72,
			102: 13.26,
			103: 11.61,
			104: 10.33,
			105: 9.68,
			106: 8.4,
			107: 7.54,
			108: 4.46,
			109: 3.14,
			110: 2.82,
			111: 2.14,
			112: 1.2,
			113: 2.32,
			114: 2.99,
			115: 3.72,
			116: 4.56,
			117: 5.54,
			118: 6.36,
			119: 7.72,
			120: 9.14,
			121: 10.23,
			122: 7.13,
			123: 8.68,
			124: 8.11,
			125: 7.21,
			126: 6.13,
			127: 7.65,
			128: 8.28,
			129: 9.02,
			130: 10.43,
			131: 9.68,
			132: 8.4,
			133: 10.03,
			134: 11.19,
			135: 12.43
		},
		31: {
			1: 10.41,
			2: 9.73,
			3: 9.22,
			4: 8.07,
			5: 7.31,
			6: 5.72,
			7: 4.9,
			8: 3.76,
			9: 3.02,
			10: 3.88,
			11: 4.57,
			12: 5.5,
			13: 6.98,
			14: 9.56,
			15: 10.89,
			16: 12.18,
			17: 13,
			18: 14.01,
			19: 15.14,
			20: 15.96,
			21: 14.33,
			22: 13.48,
			23: 12.44,
			24: 11.79,
			25: 5.73,
			26: 5,
			27: 4,
			28: 3.02,
			29: 2.23,
			30: 1.56,
			31: 0,
			32: 0.99,
			33: 1.62,
			34: 2.28,
			35: 2.83,
			36: 3.36,
			37: 4.39,
			38: 5.91,
			39: 7,
			40: 8.1,
			41: 8.98,
			42: 9.58,
			43: 10.84,
			44: 11.67,
			45: 12.43,
			46: 13.46,
			47: 14.04,
			48: 15.49,
			49: 16.36,
			50: 18.5,
			51: 20.41,
			52: 22.5,
			53: 9.34,
			54: 8.23,
			55: 7.33,
			56: 9.27,
			57: 6.48,
			58: 5.33,
			59: 4.27,
			60: 2.71,
			61: 1.81,
			62: 0.93,
			63: 0,
			64: 0.76,
			65: 1.58,
			66: 2.4,
			67: 2.28,
			68: 3.58,
			69: 4.57,
			70: 5.51,
			71: 6.7,
			72: 8.06,
			73: 6.29,
			74: 5.48,
			75: 4.4,
			76: 3.07,
			77: 0.93,
			78: 1.56,
			79: 2.76,
			80: 3.58,
			81: 4.37,
			82: 4.07,
			83: 3.36,
			84: 4.02,
			85: 5.35,
			86: 6.34,
			87: 7.21,
			88: 8.93,
			89: 8.47,
			90: 9.49,
			91: 11.23,
			92: 12.6,
			93: 14,
			94: 5.9,
			95: 7.13,
			96: 7.96,
			97: 8.87,
			98: 10.03,
			99: 16.22,
			100: 14.27,
			101: 13.16,
			102: 11.7,
			103: 10.05,
			104: 8.77,
			105: 8.12,
			106: 6.84,
			107: 5.98,
			108: 2.9,
			109: 1.58,
			110: 1.62,
			111: 2.3,
			112: 2.76,
			113: 3.88,
			114: 4.55,
			115: 5.28,
			116: 6.12,
			117: 7.1,
			118: 7.92,
			119: 9.28,
			120: 10.7,
			121: 11.79,
			122: 6.48,
			123: 8.03,
			124: 7.47,
			125: 6.57,
			126: 5.48,
			127: 7.01,
			128: 7.64,
			129: 8.38,
			130: 9.01,
			131: 8.12,
			132: 6.84,
			133: 8.47,
			134: 9.63,
			135: 10.87
		},
		32: {
			1: 11.4,
			2: 10.72,
			3: 10.21,
			4: 9.06,
			5: 8.3,
			6: 6.71,
			7: 5.89,
			8: 4.75,
			9: 4.01,
			10: 3.37,
			11: 3.58,
			12: 4.51,
			13: 5.99,
			14: 8.57,
			15: 9.9,
			16: 11.19,
			17: 12.01,
			18: 13.02,
			19: 14.15,
			20: 15.02,
			21: 13.82,
			22: 12.97,
			23: 11.93,
			24: 11.28,
			25: 6.72,
			26: 5.99,
			27: 4.99,
			28: 4.01,
			29: 3.22,
			30: 2.55,
			31: 0.99,
			32: 0,
			33: 0.63,
			34: 1.29,
			35: 1.84,
			36: 2.37,
			37: 3.4,
			38: 4.92,
			39: 6.01,
			40: 7.11,
			41: 7.99,
			42: 8.59,
			43: 9.85,
			44: 10.68,
			45: 11.44,
			46: 12.47,
			47: 13.05,
			48: 14.5,
			49: 15.37,
			50: 17.51,
			51: 19.42,
			52: 21.51,
			53: 10.33,
			54: 9.22,
			55: 8.32,
			56: 10.26,
			57: 7.47,
			58: 6.32,
			59: 5.26,
			60: 3.7,
			61: 2.8,
			62: 1.92,
			63: 0.99,
			64: 1.75,
			65: 1.98,
			66: 2.55,
			67: 1.29,
			68: 2.59,
			69: 3.58,
			70: 4.52,
			71: 5.71,
			72: 7.07,
			73: 7.28,
			74: 6.47,
			75: 5.39,
			76: 4.06,
			77: 1.92,
			78: 2.55,
			79: 2.25,
			80: 2.59,
			81: 3.38,
			82: 3.08,
			83: 2.37,
			84: 3.03,
			85: 4.36,
			86: 5.35,
			87: 6.22,
			88: 7.94,
			89: 8.87,
			90: 9.89,
			91: 11.63,
			92: 13,
			93: 14.4,
			94: 4.91,
			95: 6.14,
			96: 6.97,
			97: 7.88,
			98: 9.04,
			99: 16.62,
			100: 14.67,
			101: 13.56,
			102: 12.09,
			103: 10.45,
			104: 9.17,
			105: 8.52,
			106: 7.24,
			107: 6.37,
			108: 3.29,
			109: 1.98,
			110: 0.63,
			111: 1.31,
			112: 2.25,
			113: 3.37,
			114: 4.04,
			115: 4.77,
			116: 5.61,
			117: 6.59,
			118: 7.41,
			119: 8.77,
			120: 10.19,
			121: 11.28,
			122: 7.47,
			123: 9.02,
			124: 8.46,
			125: 7.56,
			126: 6.47,
			127: 8,
			128: 8.63,
			129: 9.37,
			130: 9.41,
			131: 8.52,
			132: 7.24,
			133: 8.87,
			134: 10.03,
			135: 11.27
		},
		33: {
			1: 11.03,
			2: 10.35,
			3: 9.83,
			4: 8.69,
			5: 7.93,
			6: 6.33,
			7: 5.51,
			8: 4.38,
			9: 3.63,
			10: 2.74,
			11: 2.95,
			12: 3.88,
			13: 5.36,
			14: 7.94,
			15: 9.27,
			16: 10.56,
			17: 11.38,
			18: 12.39,
			19: 13.52,
			20: 14.39,
			21: 13.19,
			22: 12.34,
			23: 11.3,
			24: 10.65,
			25: 6.35,
			26: 5.62,
			27: 4.62,
			28: 3.63,
			29: 3.49,
			30: 2.82,
			31: 1.62,
			32: 0.63,
			33: 0,
			34: 0.66,
			35: 1.21,
			36: 1.74,
			37: 2.77,
			38: 4.29,
			39: 5.38,
			40: 6.48,
			41: 7.36,
			42: 7.96,
			43: 9.22,
			44: 10.05,
			45: 10.81,
			46: 11.84,
			47: 12.42,
			48: 13.87,
			49: 14.74,
			50: 16.88,
			51: 18.79,
			52: 20.88,
			53: 10.96,
			54: 9.85,
			55: 8.95,
			56: 10.89,
			57: 8.1,
			58: 6.95,
			59: 5.89,
			60: 4.33,
			61: 3.43,
			62: 2.55,
			63: 1.62,
			64: 2.17,
			65: 1.35,
			66: 1.92,
			67: 0.66,
			68: 1.96,
			69: 2.95,
			70: 3.89,
			71: 5.08,
			72: 6.44,
			73: 7.91,
			74: 7.1,
			75: 6.02,
			76: 4.69,
			77: 2.55,
			78: 2.82,
			79: 1.62,
			80: 1.96,
			81: 2.75,
			82: 2.45,
			83: 1.74,
			84: 2.4,
			85: 3.73,
			86: 4.72,
			87: 5.59,
			88: 7.31,
			89: 8.24,
			90: 9.26,
			91: 11,
			92: 12.37,
			93: 13.77,
			94: 4.28,
			95: 5.51,
			96: 6.34,
			97: 7.25,
			98: 8.41,
			99: 15.99,
			100: 14.04,
			101: 12.93,
			102: 11.46,
			103: 9.82,
			104: 8.54,
			105: 7.89,
			106: 6.61,
			107: 5.74,
			108: 2.66,
			109: 1.35,
			110: 0,
			111: 0.68,
			112: 1.62,
			113: 2.74,
			114: 3.41,
			115: 4.14,
			116: 4.98,
			117: 5.96,
			118: 6.78,
			119: 8.14,
			120: 9.56,
			121: 10.65,
			122: 8.1,
			123: 9.65,
			124: 9.09,
			125: 8.19,
			126: 7.1,
			127: 8.63,
			128: 9.26,
			129: 10,
			130: 8.78,
			131: 7.89,
			132: 6.61,
			133: 8.24,
			134: 9.4,
			135: 10.64
		},
		34: {
			1: 11.69,
			2: 11.01,
			3: 10.49,
			4: 9.35,
			5: 8.59,
			6: 6.99,
			7: 6.17,
			8: 5.04,
			9: 4.29,
			10: 3.4,
			11: 2.29,
			12: 3.22,
			13: 4.7,
			14: 7.28,
			15: 8.61,
			16: 9.9,
			17: 10.72,
			18: 11.73,
			19: 12.86,
			20: 13.73,
			21: 13.85,
			22: 13,
			23: 11.96,
			24: 11.31,
			25: 7.01,
			26: 6.28,
			27: 5.28,
			28: 4.29,
			29: 4.15,
			30: 3.48,
			31: 2.28,
			32: 1.29,
			33: 0.66,
			34: 0,
			35: 0.55,
			36: 1.08,
			37: 2.11,
			38: 3.63,
			39: 4.72,
			40: 5.82,
			41: 6.7,
			42: 7.3,
			43: 8.56,
			44: 9.39,
			45: 10.15,
			46: 11.18,
			47: 11.76,
			48: 13.21,
			49: 14.08,
			50: 16.22,
			51: 18.13,
			52: 20.22,
			53: 11.62,
			54: 10.51,
			55: 9.61,
			56: 11.55,
			57: 8.76,
			58: 7.61,
			59: 6.55,
			60: 4.99,
			61: 4.09,
			62: 3.21,
			63: 2.28,
			64: 2.83,
			65: 2.01,
			66: 1.26,
			67: 0,
			68: 1.3,
			69: 2.29,
			70: 3.23,
			71: 4.42,
			72: 5.78,
			73: 8.57,
			74: 7.76,
			75: 6.68,
			76: 5.35,
			77: 3.21,
			78: 3.48,
			79: 2.28,
			80: 1.3,
			81: 2.09,
			82: 1.79,
			83: 1.08,
			84: 1.74,
			85: 3.07,
			86: 4.06,
			87: 4.93,
			88: 6.65,
			89: 7.93,
			90: 8.94,
			91: 10.68,
			92: 12.05,
			93: 13.45,
			94: 3.62,
			95: 4.85,
			96: 5.68,
			97: 6.59,
			98: 7.75,
			99: 16.65,
			100: 14.7,
			101: 13.59,
			102: 12.12,
			103: 10.48,
			104: 9.2,
			105: 8.55,
			106: 7.27,
			107: 6.4,
			108: 3.32,
			109: 2.01,
			110: 0.66,
			111: 1.34,
			112: 2.28,
			113: 3.4,
			114: 4.07,
			115: 4.8,
			116: 5.64,
			117: 6.62,
			118: 7.44,
			119: 8.8,
			120: 10.22,
			121: 11.31,
			122: 8.76,
			123: 10.31,
			124: 9.75,
			125: 8.85,
			126: 7.76,
			127: 9.29,
			128: 9.92,
			129: 10.66,
			130: 9.44,
			131: 8.55,
			132: 7.27,
			133: 7.93,
			134: 9.08,
			135: 10.32
		},
		35: {
			1: 12.24,
			2: 11.56,
			3: 11.04,
			4: 9.9,
			5: 9.14,
			6: 7.54,
			7: 6.72,
			8: 5.59,
			9: 4.84,
			10: 3.95,
			11: 2.84,
			12: 3.77,
			13: 5.25,
			14: 7.83,
			15: 9.16,
			16: 10.45,
			17: 11.27,
			18: 12.28,
			19: 13.41,
			20: 14.28,
			21: 14.4,
			22: 13.55,
			23: 12.51,
			24: 11.86,
			25: 7.56,
			26: 6.83,
			27: 5.83,
			28: 4.84,
			29: 4.7,
			30: 4.03,
			31: 2.83,
			32: 1.84,
			33: 1.21,
			34: 0.55,
			35: 0,
			36: 0.53,
			37: 1.56,
			38: 3.08,
			39: 4.17,
			40: 5.27,
			41: 6.15,
			42: 6.75,
			43: 8.01,
			44: 8.84,
			45: 9.6,
			46: 10.63,
			47: 11.21,
			48: 12.66,
			49: 13.53,
			50: 15.67,
			51: 17.58,
			52: 19.67,
			53: 12.17,
			54: 11.06,
			55: 10.16,
			56: 12.1,
			57: 9.31,
			58: 8.16,
			59: 7.1,
			60: 5.54,
			61: 4.64,
			62: 3.76,
			63: 2.83,
			64: 3.38,
			65: 2.56,
			66: 1.81,
			67: 0.55,
			68: 1.85,
			69: 2.84,
			70: 3.78,
			71: 4.97,
			72: 6.33,
			73: 9.12,
			74: 8.31,
			75: 7.23,
			76: 5.9,
			77: 3.76,
			78: 4.03,
			79: 2.83,
			80: 1.85,
			81: 2.19,
			82: 1.24,
			83: 0.53,
			84: 1.19,
			85: 2.52,
			86: 3.51,
			87: 4.38,
			88: 6.1,
			89: 7.38,
			90: 8.39,
			91: 10.13,
			92: 11.5,
			93: 12.9,
			94: 3.07,
			95: 4.3,
			96: 5.13,
			97: 6.04,
			98: 7.2,
			99: 17.2,
			100: 15.25,
			101: 14.14,
			102: 12.67,
			103: 11.03,
			104: 9.75,
			105: 9.1,
			106: 7.82,
			107: 6.95,
			108: 3.87,
			109: 2.56,
			110: 1.21,
			111: 1.89,
			112: 2.83,
			113: 3.95,
			114: 4.62,
			115: 5.35,
			116: 6.19,
			117: 7.17,
			118: 7.99,
			119: 9.35,
			120: 10.77,
			121: 11.86,
			122: 9.31,
			123: 10.86,
			124: 10.3,
			125: 9.4,
			126: 8.31,
			127: 9.84,
			128: 10.47,
			129: 11.21,
			130: 9.99,
			131: 9.1,
			132: 7.82,
			133: 7.38,
			134: 8.53,
			135: 9.77
		},
		36: {
			1: 12.77,
			2: 12.09,
			3: 11.57,
			4: 10.43,
			5: 9.67,
			6: 8.07,
			7: 7.25,
			8: 6.12,
			9: 5.37,
			10: 4.48,
			11: 3.37,
			12: 4.3,
			13: 5.78,
			14: 8.36,
			15: 9.69,
			16: 10.98,
			17: 11.8,
			18: 12.81,
			19: 13.94,
			20: 14.81,
			21: 14.93,
			22: 14.08,
			23: 13.04,
			24: 12.39,
			25: 8.09,
			26: 7.36,
			27: 6.36,
			28: 5.37,
			29: 5.23,
			30: 4.56,
			31: 3.36,
			32: 2.37,
			33: 1.74,
			34: 1.08,
			35: 0.53,
			36: 0,
			37: 1.03,
			38: 2.55,
			39: 3.64,
			40: 4.74,
			41: 5.62,
			42: 6.22,
			43: 7.48,
			44: 8.31,
			45: 9.07,
			46: 10.1,
			47: 10.68,
			48: 12.13,
			49: 13,
			50: 15.14,
			51: 17.05,
			52: 19.14,
			53: 12.7,
			54: 11.59,
			55: 10.69,
			56: 12.63,
			57: 9.84,
			58: 8.69,
			59: 7.63,
			60: 6.07,
			61: 5.17,
			62: 4.29,
			63: 3.36,
			64: 3.91,
			65: 3.09,
			66: 2.34,
			67: 1.08,
			68: 2.38,
			69: 3.37,
			70: 4.31,
			71: 5.5,
			72: 6.86,
			73: 9.65,
			74: 8.84,
			75: 7.76,
			76: 6.43,
			77: 4.29,
			78: 4.56,
			79: 3.36,
			80: 2.38,
			81: 1.66,
			82: 0.71,
			83: 0,
			84: 0.66,
			85: 1.99,
			86: 2.98,
			87: 3.85,
			88: 5.57,
			89: 6.85,
			90: 7.86,
			91: 9.6,
			92: 10.97,
			93: 12.37,
			94: 2.54,
			95: 3.77,
			96: 4.6,
			97: 5.51,
			98: 6.67,
			99: 17.73,
			100: 15.78,
			101: 14.67,
			102: 13.2,
			103: 11.56,
			104: 10.28,
			105: 9.63,
			106: 8.35,
			107: 7.48,
			108: 4.4,
			109: 3.09,
			110: 1.74,
			111: 2.42,
			112: 3.36,
			113: 4.48,
			114: 5.15,
			115: 5.88,
			116: 6.72,
			117: 7.7,
			118: 8.52,
			119: 9.88,
			120: 11.3,
			121: 12.39,
			122: 9.84,
			123: 11.39,
			124: 10.83,
			125: 9.93,
			126: 8.84,
			127: 10.37,
			128: 11,
			129: 11.74,
			130: 10.52,
			131: 9.63,
			132: 8.35,
			133: 6.85,
			134: 8.01,
			135: 9.24
		},
		37: {
			1: 13.8,
			2: 13.12,
			3: 12.6,
			4: 11.46,
			5: 10.7,
			6: 9.1,
			7: 8.28,
			8: 7.15,
			9: 6.4,
			10: 5.51,
			11: 4.4,
			12: 5.33,
			13: 6.81,
			14: 9.39,
			15: 10.72,
			16: 12.01,
			17: 12.83,
			18: 13.84,
			19: 14.97,
			20: 15.84,
			21: 15.96,
			22: 15.11,
			23: 14.07,
			24: 13.42,
			25: 9.12,
			26: 8.39,
			27: 7.39,
			28: 6.4,
			29: 6.26,
			30: 5.59,
			31: 4.39,
			32: 3.4,
			33: 2.77,
			34: 2.11,
			35: 1.56,
			36: 1.03,
			37: 0,
			38: 1.52,
			39: 2.61,
			40: 3.71,
			41: 4.59,
			42: 5.19,
			43: 6.45,
			44: 7.28,
			45: 8.04,
			46: 9.07,
			47: 9.65,
			48: 11.1,
			49: 11.97,
			50: 14.11,
			51: 16.02,
			52: 18.11,
			53: 13.73,
			54: 12.62,
			55: 11.72,
			56: 13.66,
			57: 10.87,
			58: 9.72,
			59: 8.66,
			60: 7.1,
			61: 6.2,
			62: 5.32,
			63: 4.39,
			64: 4.94,
			65: 4.12,
			66: 3.37,
			67: 2.11,
			68: 3.41,
			69: 4.4,
			70: 5.34,
			71: 6.53,
			72: 7.89,
			73: 10.68,
			74: 9.87,
			75: 8.79,
			76: 7.46,
			77: 5.32,
			78: 5.59,
			79: 4.39,
			80: 3.41,
			81: 2.69,
			82: 1.74,
			83: 1.03,
			84: 1.69,
			85: 3.02,
			86: 4.01,
			87: 4.88,
			88: 6.6,
			89: 7.88,
			90: 8.89,
			91: 10.63,
			92: 12,
			93: 13.4,
			94: 3.57,
			95: 4.8,
			96: 5.63,
			97: 6.54,
			98: 7.7,
			99: 18.76,
			100: 16.81,
			101: 15.7,
			102: 14.23,
			103: 12.59,
			104: 11.31,
			105: 10.66,
			106: 9.38,
			107: 8.51,
			108: 5.43,
			109: 4.12,
			110: 2.77,
			111: 3.45,
			112: 4.39,
			113: 5.51,
			114: 6.18,
			115: 6.91,
			116: 7.75,
			117: 8.73,
			118: 9.55,
			119: 10.91,
			120: 12.33,
			121: 13.42,
			122: 10.87,
			123: 12.42,
			124: 11.86,
			125: 10.96,
			126: 9.87,
			127: 11.4,
			128: 12.03,
			129: 12.77,
			130: 11.55,
			131: 10.66,
			132: 9.38,
			133: 7.88,
			134: 9.03,
			135: 10.27
		},
		38: {
			1: 15.32,
			2: 14.64,
			3: 14.12,
			4: 12.98,
			5: 12.22,
			6: 10.62,
			7: 9.8,
			8: 8.67,
			9: 7.92,
			10: 7.03,
			11: 5.92,
			12: 6.85,
			13: 8.33,
			14: 10.91,
			15: 12.24,
			16: 13.53,
			17: 14.35,
			18: 15.36,
			19: 16.49,
			20: 17.36,
			21: 17.48,
			22: 16.63,
			23: 15.59,
			24: 14.94,
			25: 10.64,
			26: 9.91,
			27: 8.91,
			28: 7.92,
			29: 7.78,
			30: 7.11,
			31: 5.91,
			32: 4.92,
			33: 4.29,
			34: 3.63,
			35: 3.08,
			36: 2.55,
			37: 1.52,
			38: 0,
			39: 1.09,
			40: 2.19,
			41: 3.07,
			42: 3.67,
			43: 4.93,
			44: 5.76,
			45: 6.52,
			46: 7.55,
			47: 8.13,
			48: 9.58,
			49: 10.45,
			50: 12.59,
			51: 14.5,
			52: 16.59,
			53: 15.25,
			54: 14.14,
			55: 13.24,
			56: 15.18,
			57: 12.39,
			58: 11.24,
			59: 10.18,
			60: 8.62,
			61: 7.72,
			62: 6.84,
			63: 5.91,
			64: 6.46,
			65: 5.64,
			66: 4.89,
			67: 3.63,
			68: 4.93,
			69: 5.92,
			70: 6.86,
			71: 8.05,
			72: 9.41,
			73: 12.2,
			74: 11.39,
			75: 10.31,
			76: 8.98,
			77: 6.84,
			78: 7.11,
			79: 5.91,
			80: 4.93,
			81: 4.21,
			82: 3.26,
			83: 2.55,
			84: 3.21,
			85: 4.54,
			86: 5.53,
			87: 6.4,
			88: 8.12,
			89: 9.4,
			90: 10.41,
			91: 12.15,
			92: 13.52,
			93: 14.92,
			94: 5.09,
			95: 6.32,
			96: 7.15,
			97: 8.06,
			98: 9.22,
			99: 20.28,
			100: 18.33,
			101: 17.22,
			102: 15.75,
			103: 14.11,
			104: 12.83,
			105: 12.18,
			106: 10.9,
			107: 10.03,
			108: 6.95,
			109: 5.64,
			110: 4.29,
			111: 4.97,
			112: 5.91,
			113: 7.03,
			114: 7.7,
			115: 8.43,
			116: 9.27,
			117: 10.25,
			118: 11.07,
			119: 12.43,
			120: 13.85,
			121: 14.94,
			122: 12.39,
			123: 13.94,
			124: 13.38,
			125: 12.48,
			126: 11.39,
			127: 12.92,
			128: 13.55,
			129: 14.29,
			130: 13.07,
			131: 12.18,
			132: 10.9,
			133: 9.4,
			134: 10.55,
			135: 11.79
		},
		39: {
			1: 16.41,
			2: 15.73,
			3: 15.21,
			4: 14.07,
			5: 13.31,
			6: 11.71,
			7: 10.89,
			8: 9.76,
			9: 9.01,
			10: 8.12,
			11: 7.01,
			12: 7.94,
			13: 9.42,
			14: 12,
			15: 13.33,
			16: 14.62,
			17: 15.44,
			18: 16.45,
			19: 17.58,
			20: 18.45,
			21: 18.57,
			22: 17.72,
			23: 16.68,
			24: 16.03,
			25: 11.73,
			26: 11,
			27: 10,
			28: 9.01,
			29: 8.87,
			30: 8.2,
			31: 7,
			32: 6.01,
			33: 5.38,
			34: 4.72,
			35: 4.17,
			36: 3.64,
			37: 2.61,
			38: 1.09,
			39: 0,
			40: 1.1,
			41: 1.98,
			42: 2.58,
			43: 3.84,
			44: 4.67,
			45: 5.43,
			46: 6.46,
			47: 7.04,
			48: 8.49,
			49: 9.36,
			50: 11.5,
			51: 13.41,
			52: 15.5,
			53: 16.34,
			54: 15.23,
			55: 14.33,
			56: 16.27,
			57: 13.48,
			58: 12.33,
			59: 11.27,
			60: 9.71,
			61: 8.81,
			62: 7.93,
			63: 7,
			64: 7.55,
			65: 6.73,
			66: 5.98,
			67: 4.72,
			68: 6.02,
			69: 7.01,
			70: 7.95,
			71: 9.14,
			72: 10.5,
			73: 13.29,
			74: 12.48,
			75: 11.4,
			76: 10.07,
			77: 7.93,
			78: 8.2,
			79: 7,
			80: 6.02,
			81: 5.3,
			82: 4.35,
			83: 3.64,
			84: 4.3,
			85: 5.63,
			86: 6.62,
			87: 7.49,
			88: 9.21,
			89: 10.49,
			90: 11.5,
			91: 13.24,
			92: 14.61,
			93: 16.01,
			94: 6.18,
			95: 7.41,
			96: 8.24,
			97: 9.15,
			98: 10.31,
			99: 21.37,
			100: 19.42,
			101: 18.31,
			102: 16.84,
			103: 15.2,
			104: 13.92,
			105: 13.27,
			106: 11.99,
			107: 11.12,
			108: 8.04,
			109: 6.73,
			110: 5.38,
			111: 6.06,
			112: 7,
			113: 8.12,
			114: 8.79,
			115: 9.52,
			116: 10.36,
			117: 11.34,
			118: 12.16,
			119: 13.52,
			120: 14.94,
			121: 16.03,
			122: 13.48,
			123: 15.03,
			124: 14.47,
			125: 13.57,
			126: 12.48,
			127: 14.01,
			128: 14.64,
			129: 15.38,
			130: 14.16,
			131: 13.27,
			132: 11.99,
			133: 10.49,
			134: 11.64,
			135: 12.88
		},
		40: {
			1: 17.51,
			2: 16.83,
			3: 16.31,
			4: 15.17,
			5: 14.41,
			6: 12.81,
			7: 11.99,
			8: 10.86,
			9: 10.11,
			10: 9.22,
			11: 8.11,
			12: 9.04,
			13: 10.52,
			14: 13.1,
			15: 14.43,
			16: 15.72,
			17: 16.54,
			18: 17.55,
			19: 18.68,
			20: 19.55,
			21: 19.67,
			22: 18.82,
			23: 17.78,
			24: 17.13,
			25: 12.83,
			26: 12.1,
			27: 11.1,
			28: 10.11,
			29: 9.97,
			30: 9.3,
			31: 8.1,
			32: 7.11,
			33: 6.48,
			34: 5.82,
			35: 5.27,
			36: 4.74,
			37: 3.71,
			38: 2.19,
			39: 1.1,
			40: 0,
			41: 0.88,
			42: 1.48,
			43: 2.74,
			44: 3.57,
			45: 4.33,
			46: 5.36,
			47: 5.94,
			48: 7.39,
			49: 8.26,
			50: 10.4,
			51: 12.31,
			52: 14.4,
			53: 17.44,
			54: 16.33,
			55: 15.43,
			56: 17.37,
			57: 14.58,
			58: 13.43,
			59: 12.37,
			60: 10.81,
			61: 9.91,
			62: 9.03,
			63: 8.1,
			64: 8.65,
			65: 7.83,
			66: 7.08,
			67: 5.82,
			68: 7.12,
			69: 8.11,
			70: 9.05,
			71: 10.24,
			72: 11.6,
			73: 14.39,
			74: 13.58,
			75: 12.5,
			76: 11.17,
			77: 9.03,
			78: 9.3,
			79: 8.1,
			80: 7.12,
			81: 6.4,
			82: 5.45,
			83: 4.74,
			84: 5.4,
			85: 6.73,
			86: 7.72,
			87: 8.59,
			88: 10.31,
			89: 11.59,
			90: 12.6,
			91: 14.34,
			92: 15.71,
			93: 17.11,
			94: 7.28,
			95: 8.51,
			96: 9.34,
			97: 10.25,
			98: 11.41,
			99: 22.47,
			100: 20.52,
			101: 19.41,
			102: 17.94,
			103: 16.3,
			104: 15.02,
			105: 14.37,
			106: 13.09,
			107: 12.22,
			108: 9.14,
			109: 7.83,
			110: 6.48,
			111: 7.16,
			112: 8.1,
			113: 9.22,
			114: 9.89,
			115: 10.62,
			116: 11.46,
			117: 12.44,
			118: 13.26,
			119: 14.62,
			120: 16.04,
			121: 17.13,
			122: 14.58,
			123: 16.13,
			124: 15.57,
			125: 14.67,
			126: 13.58,
			127: 15.11,
			128: 15.74,
			129: 16.48,
			130: 15.26,
			131: 14.37,
			132: 13.09,
			133: 11.59,
			134: 12.74,
			135: 13.98
		},
		41: {
			1: 18.39,
			2: 17.71,
			3: 17.19,
			4: 16.05,
			5: 15.29,
			6: 13.69,
			7: 12.87,
			8: 11.74,
			9: 10.99,
			10: 10.1,
			11: 8.99,
			12: 9.92,
			13: 11.4,
			14: 13.98,
			15: 15.31,
			16: 16.6,
			17: 17.42,
			18: 18.43,
			19: 19.56,
			20: 20.43,
			21: 20.55,
			22: 19.7,
			23: 18.66,
			24: 18.01,
			25: 13.71,
			26: 12.98,
			27: 11.98,
			28: 10.99,
			29: 10.85,
			30: 10.18,
			31: 8.98,
			32: 7.99,
			33: 7.36,
			34: 6.7,
			35: 6.15,
			36: 5.62,
			37: 4.59,
			38: 3.07,
			39: 1.98,
			40: 0.88,
			41: 0,
			42: 0.6,
			43: 1.86,
			44: 2.69,
			45: 3.45,
			46: 4.48,
			47: 5.06,
			48: 6.51,
			49: 7.38,
			50: 9.52,
			51: 11.43,
			52: 13.52,
			53: 18.32,
			54: 17.21,
			55: 16.31,
			56: 18.25,
			57: 15.46,
			58: 14.31,
			59: 13.25,
			60: 11.69,
			61: 10.79,
			62: 9.91,
			63: 8.98,
			64: 9.53,
			65: 8.71,
			66: 7.96,
			67: 6.7,
			68: 8,
			69: 8.99,
			70: 9.93,
			71: 11.12,
			72: 12.48,
			73: 15.27,
			74: 14.46,
			75: 13.38,
			76: 12.05,
			77: 9.91,
			78: 10.18,
			79: 8.98,
			80: 8,
			81: 7.28,
			82: 6.33,
			83: 5.62,
			84: 6.28,
			85: 7.61,
			86: 8.6,
			87: 9.47,
			88: 11.19,
			89: 12.47,
			90: 13.48,
			91: 15.22,
			92: 16.59,
			93: 17.99,
			94: 8.16,
			95: 9.39,
			96: 10.22,
			97: 11.13,
			98: 12.29,
			99: 23.35,
			100: 21.4,
			101: 20.29,
			102: 18.82,
			103: 17.18,
			104: 15.9,
			105: 15.25,
			106: 13.97,
			107: 13.1,
			108: 10.02,
			109: 8.71,
			110: 7.36,
			111: 8.04,
			112: 8.98,
			113: 10.1,
			114: 10.77,
			115: 11.5,
			116: 12.34,
			117: 13.32,
			118: 14.14,
			119: 15.5,
			120: 16.92,
			121: 18.01,
			122: 15.46,
			123: 17.01,
			124: 16.45,
			125: 15.55,
			126: 14.46,
			127: 15.99,
			128: 16.62,
			129: 17.36,
			130: 16.14,
			131: 15.25,
			132: 13.97,
			133: 12.47,
			134: 13.62,
			135: 14.86
		},
		42: {
			1: 18.99,
			2: 18.31,
			3: 17.79,
			4: 16.65,
			5: 15.89,
			6: 14.29,
			7: 13.47,
			8: 12.34,
			9: 11.59,
			10: 10.7,
			11: 9.59,
			12: 10.52,
			13: 12,
			14: 14.58,
			15: 15.91,
			16: 17.2,
			17: 18.02,
			18: 19.03,
			19: 20.16,
			20: 21.03,
			21: 21.15,
			22: 20.3,
			23: 19.26,
			24: 18.61,
			25: 14.31,
			26: 13.58,
			27: 12.58,
			28: 11.59,
			29: 11.45,
			30: 10.78,
			31: 9.58,
			32: 8.59,
			33: 7.96,
			34: 7.3,
			35: 6.75,
			36: 6.22,
			37: 5.19,
			38: 3.67,
			39: 2.58,
			40: 1.48,
			41: 0.6,
			42: 0,
			43: 1.26,
			44: 2.09,
			45: 2.85,
			46: 3.88,
			47: 4.46,
			48: 5.91,
			49: 6.78,
			50: 8.92,
			51: 10.83,
			52: 12.92,
			53: 18.92,
			54: 17.81,
			55: 16.91,
			56: 18.85,
			57: 16.06,
			58: 14.91,
			59: 13.85,
			60: 12.29,
			61: 11.39,
			62: 10.51,
			63: 9.58,
			64: 10.13,
			65: 9.31,
			66: 8.56,
			67: 7.3,
			68: 8.6,
			69: 9.59,
			70: 10.53,
			71: 11.72,
			72: 13.08,
			73: 15.87,
			74: 15.06,
			75: 13.98,
			76: 12.65,
			77: 10.51,
			78: 10.78,
			79: 9.58,
			80: 8.6,
			81: 7.88,
			82: 6.93,
			83: 6.22,
			84: 6.88,
			85: 8.21,
			86: 9.2,
			87: 10.07,
			88: 11.79,
			89: 13.07,
			90: 14.08,
			91: 15.82,
			92: 17.19,
			93: 18.59,
			94: 8.76,
			95: 9.99,
			96: 10.82,
			97: 11.73,
			98: 12.89,
			99: 23.95,
			100: 22,
			101: 20.89,
			102: 19.42,
			103: 17.78,
			104: 16.5,
			105: 15.85,
			106: 14.57,
			107: 13.7,
			108: 10.62,
			109: 9.31,
			110: 7.96,
			111: 8.64,
			112: 9.58,
			113: 10.7,
			114: 11.37,
			115: 12.1,
			116: 12.94,
			117: 13.92,
			118: 14.74,
			119: 16.1,
			120: 17.52,
			121: 18.61,
			122: 16.06,
			123: 17.61,
			124: 17.05,
			125: 16.15,
			126: 15.06,
			127: 16.59,
			128: 17.22,
			129: 17.96,
			130: 16.74,
			131: 15.85,
			132: 14.57,
			133: 13.07,
			134: 14.22,
			135: 15.46
		},
		43: {
			1: 20.25,
			2: 19.57,
			3: 19.05,
			4: 17.91,
			5: 17.15,
			6: 15.55,
			7: 14.73,
			8: 13.6,
			9: 12.85,
			10: 11.96,
			11: 10.85,
			12: 11.78,
			13: 13.26,
			14: 15.84,
			15: 17.17,
			16: 18.46,
			17: 19.28,
			18: 20.29,
			19: 21.42,
			20: 22.29,
			21: 22.41,
			22: 21.56,
			23: 20.52,
			24: 19.87,
			25: 15.57,
			26: 14.84,
			27: 13.84,
			28: 12.85,
			29: 12.71,
			30: 12.04,
			31: 10.84,
			32: 9.85,
			33: 9.22,
			34: 8.56,
			35: 8.01,
			36: 7.48,
			37: 6.45,
			38: 4.93,
			39: 3.84,
			40: 2.74,
			41: 1.86,
			42: 1.26,
			43: 0,
			44: 0.83,
			45: 1.59,
			46: 2.62,
			47: 3.2,
			48: 4.65,
			49: 5.52,
			50: 7.66,
			51: 9.57,
			52: 11.66,
			53: 20.18,
			54: 19.07,
			55: 18.17,
			56: 20.11,
			57: 17.32,
			58: 16.17,
			59: 15.11,
			60: 13.55,
			61: 12.65,
			62: 11.77,
			63: 10.84,
			64: 11.39,
			65: 10.57,
			66: 9.82,
			67: 8.56,
			68: 9.86,
			69: 10.85,
			70: 11.79,
			71: 12.98,
			72: 14.34,
			73: 17.13,
			74: 16.32,
			75: 15.24,
			76: 13.91,
			77: 11.77,
			78: 12.04,
			79: 10.84,
			80: 9.86,
			81: 9.14,
			82: 8.19,
			83: 7.48,
			84: 8.14,
			85: 9.47,
			86: 10.46,
			87: 11.33,
			88: 13.05,
			89: 14.33,
			90: 15.34,
			91: 17.08,
			92: 18.45,
			93: 19.85,
			94: 10.02,
			95: 11.25,
			96: 12.08,
			97: 12.99,
			98: 14.15,
			99: 25.21,
			100: 23.26,
			101: 22.15,
			102: 20.68,
			103: 19.04,
			104: 17.76,
			105: 17.11,
			106: 15.83,
			107: 14.96,
			108: 11.88,
			109: 10.57,
			110: 9.22,
			111: 9.9,
			112: 10.84,
			113: 11.96,
			114: 12.63,
			115: 13.36,
			116: 14.2,
			117: 15.18,
			118: 16,
			119: 17.36,
			120: 18.78,
			121: 19.87,
			122: 17.32,
			123: 18.87,
			124: 18.31,
			125: 17.41,
			126: 16.32,
			127: 17.85,
			128: 18.48,
			129: 19.22,
			130: 18,
			131: 17.11,
			132: 15.83,
			133: 14.33,
			134: 15.48,
			135: 16.72
		},
		44: {
			1: 21.08,
			2: 20.4,
			3: 19.88,
			4: 18.74,
			5: 17.98,
			6: 16.38,
			7: 15.56,
			8: 14.43,
			9: 13.68,
			10: 12.79,
			11: 11.68,
			12: 12.61,
			13: 14.09,
			14: 16.67,
			15: 18,
			16: 19.29,
			17: 20.11,
			18: 21.12,
			19: 22.25,
			20: 23.12,
			21: 23.24,
			22: 22.39,
			23: 21.35,
			24: 20.7,
			25: 16.4,
			26: 15.67,
			27: 14.67,
			28: 13.68,
			29: 13.54,
			30: 12.87,
			31: 11.67,
			32: 10.68,
			33: 10.05,
			34: 9.39,
			35: 8.84,
			36: 8.31,
			37: 7.28,
			38: 5.76,
			39: 4.67,
			40: 3.57,
			41: 2.69,
			42: 2.09,
			43: 0.83,
			44: 0,
			45: 0.76,
			46: 1.79,
			47: 2.37,
			48: 3.82,
			49: 4.69,
			50: 6.83,
			51: 8.74,
			52: 10.83,
			53: 21.01,
			54: 19.9,
			55: 19,
			56: 20.94,
			57: 18.15,
			58: 17,
			59: 15.94,
			60: 14.38,
			61: 13.48,
			62: 12.6,
			63: 11.67,
			64: 12.22,
			65: 11.4,
			66: 10.65,
			67: 9.39,
			68: 10.69,
			69: 11.68,
			70: 12.62,
			71: 13.81,
			72: 15.17,
			73: 17.96,
			74: 17.15,
			75: 16.07,
			76: 14.74,
			77: 12.6,
			78: 12.87,
			79: 11.67,
			80: 10.69,
			81: 9.97,
			82: 9.02,
			83: 8.31,
			84: 8.97,
			85: 10.3,
			86: 11.29,
			87: 12.16,
			88: 13.88,
			89: 15.16,
			90: 16.17,
			91: 17.91,
			92: 19.28,
			93: 20.68,
			94: 10.85,
			95: 12.08,
			96: 12.91,
			97: 13.82,
			98: 14.98,
			99: 26.04,
			100: 24.09,
			101: 22.98,
			102: 21.51,
			103: 19.87,
			104: 18.59,
			105: 17.94,
			106: 16.66,
			107: 15.79,
			108: 12.71,
			109: 11.4,
			110: 10.05,
			111: 10.73,
			112: 11.67,
			113: 12.79,
			114: 13.46,
			115: 14.19,
			116: 15.03,
			117: 16.01,
			118: 16.83,
			119: 18.19,
			120: 19.61,
			121: 20.7,
			122: 18.15,
			123: 19.7,
			124: 19.14,
			125: 18.24,
			126: 17.15,
			127: 18.68,
			128: 19.31,
			129: 20.05,
			130: 18.83,
			131: 17.94,
			132: 16.66,
			133: 15.16,
			134: 16.31,
			135: 17.55
		},
		45: {
			1: 21.84,
			2: 21.16,
			3: 20.64,
			4: 19.5,
			5: 18.74,
			6: 17.14,
			7: 16.32,
			8: 15.19,
			9: 14.44,
			10: 13.55,
			11: 12.44,
			12: 13.37,
			13: 14.85,
			14: 17.43,
			15: 18.76,
			16: 20.05,
			17: 20.87,
			18: 21.88,
			19: 23.01,
			20: 23.88,
			21: 24,
			22: 23.15,
			23: 22.11,
			24: 21.46,
			25: 17.16,
			26: 16.43,
			27: 15.43,
			28: 14.44,
			29: 14.3,
			30: 13.63,
			31: 12.43,
			32: 11.44,
			33: 10.81,
			34: 10.15,
			35: 9.6,
			36: 9.07,
			37: 8.04,
			38: 6.52,
			39: 5.43,
			40: 4.33,
			41: 3.45,
			42: 2.85,
			43: 1.59,
			44: 0.76,
			45: 0,
			46: 1.03,
			47: 1.61,
			48: 3.06,
			49: 3.93,
			50: 6.07,
			51: 7.98,
			52: 10.07,
			53: 21.77,
			54: 20.66,
			55: 19.76,
			56: 21.7,
			57: 18.91,
			58: 17.76,
			59: 16.7,
			60: 15.14,
			61: 14.24,
			62: 13.36,
			63: 12.43,
			64: 12.98,
			65: 12.16,
			66: 11.41,
			67: 10.15,
			68: 11.45,
			69: 12.44,
			70: 13.38,
			71: 14.57,
			72: 15.93,
			73: 18.72,
			74: 17.91,
			75: 16.83,
			76: 15.5,
			77: 13.36,
			78: 13.63,
			79: 12.43,
			80: 11.45,
			81: 10.73,
			82: 9.78,
			83: 9.07,
			84: 9.73,
			85: 11.06,
			86: 12.05,
			87: 12.92,
			88: 14.64,
			89: 15.92,
			90: 16.93,
			91: 18.67,
			92: 20.04,
			93: 21.44,
			94: 11.61,
			95: 12.84,
			96: 13.67,
			97: 14.58,
			98: 15.74,
			99: 26.8,
			100: 24.85,
			101: 23.74,
			102: 22.27,
			103: 20.63,
			104: 19.35,
			105: 18.7,
			106: 17.42,
			107: 16.55,
			108: 13.47,
			109: 12.16,
			110: 10.81,
			111: 11.49,
			112: 12.43,
			113: 13.55,
			114: 14.22,
			115: 14.95,
			116: 15.79,
			117: 16.77,
			118: 17.59,
			119: 18.95,
			120: 20.37,
			121: 21.46,
			122: 18.91,
			123: 20.46,
			124: 19.9,
			125: 19,
			126: 17.91,
			127: 19.44,
			128: 20.07,
			129: 20.81,
			130: 19.59,
			131: 18.7,
			132: 17.42,
			133: 15.92,
			134: 17.07,
			135: 18.31
		},
		46: {
			1: 22.87,
			2: 22.19,
			3: 21.67,
			4: 20.53,
			5: 19.77,
			6: 18.17,
			7: 17.35,
			8: 16.22,
			9: 15.47,
			10: 14.58,
			11: 13.47,
			12: 14.4,
			13: 15.88,
			14: 18.46,
			15: 19.79,
			16: 21.08,
			17: 21.9,
			18: 22.91,
			19: 24.04,
			20: 24.91,
			21: 25.03,
			22: 24.18,
			23: 23.14,
			24: 22.49,
			25: 18.19,
			26: 17.46,
			27: 16.46,
			28: 15.47,
			29: 15.33,
			30: 14.66,
			31: 13.46,
			32: 12.47,
			33: 11.84,
			34: 11.18,
			35: 10.63,
			36: 10.1,
			37: 9.07,
			38: 7.55,
			39: 6.46,
			40: 5.36,
			41: 4.48,
			42: 3.88,
			43: 2.62,
			44: 1.79,
			45: 1.03,
			46: 0,
			47: 2.64,
			48: 4.09,
			49: 4.96,
			50: 7.1,
			51: 9.01,
			52: 11.1,
			53: 22.8,
			54: 21.69,
			55: 20.79,
			56: 22.73,
			57: 19.94,
			58: 18.79,
			59: 17.73,
			60: 16.17,
			61: 15.27,
			62: 14.39,
			63: 13.46,
			64: 14.01,
			65: 13.19,
			66: 12.44,
			67: 11.18,
			68: 12.48,
			69: 13.47,
			70: 14.41,
			71: 15.6,
			72: 16.96,
			73: 19.75,
			74: 18.94,
			75: 17.86,
			76: 16.53,
			77: 14.39,
			78: 14.66,
			79: 13.46,
			80: 12.48,
			81: 11.76,
			82: 10.81,
			83: 10.1,
			84: 10.76,
			85: 12.09,
			86: 13.08,
			87: 13.95,
			88: 15.67,
			89: 16.95,
			90: 17.96,
			91: 19.7,
			92: 21.07,
			93: 22.47,
			94: 12.64,
			95: 13.87,
			96: 14.7,
			97: 15.61,
			98: 16.77,
			99: 27.83,
			100: 25.88,
			101: 24.77,
			102: 23.3,
			103: 21.66,
			104: 20.38,
			105: 19.73,
			106: 18.45,
			107: 17.58,
			108: 14.5,
			109: 13.19,
			110: 11.84,
			111: 12.52,
			112: 13.46,
			113: 14.58,
			114: 15.25,
			115: 15.98,
			116: 16.82,
			117: 17.8,
			118: 18.62,
			119: 19.98,
			120: 21.4,
			121: 22.49,
			122: 19.94,
			123: 21.49,
			124: 20.93,
			125: 20.03,
			126: 18.94,
			127: 20.47,
			128: 21.1,
			129: 21.84,
			130: 20.62,
			131: 19.73,
			132: 18.45,
			133: 16.95,
			134: 18.1,
			135: 19.34
		},
		47: {
			1: 23.45,
			2: 22.77,
			3: 22.25,
			4: 21.11,
			5: 20.35,
			6: 18.75,
			7: 17.93,
			8: 16.8,
			9: 16.05,
			10: 15.16,
			11: 14.05,
			12: 14.98,
			13: 16.46,
			14: 19.04,
			15: 20.37,
			16: 21.66,
			17: 22.48,
			18: 23.49,
			19: 24.62,
			20: 25.49,
			21: 25.61,
			22: 24.76,
			23: 23.72,
			24: 23.07,
			25: 18.77,
			26: 18.04,
			27: 17.04,
			28: 16.05,
			29: 15.91,
			30: 15.24,
			31: 14.04,
			32: 13.05,
			33: 12.42,
			34: 11.76,
			35: 11.21,
			36: 10.68,
			37: 9.65,
			38: 8.13,
			39: 7.04,
			40: 5.94,
			41: 5.06,
			42: 4.46,
			43: 3.2,
			44: 2.37,
			45: 1.61,
			46: 2.64,
			47: 0,
			48: 1.45,
			49: 2.32,
			50: 4.46,
			51: 6.37,
			52: 8.46,
			53: 23.38,
			54: 22.27,
			55: 21.37,
			56: 23.31,
			57: 20.52,
			58: 19.37,
			59: 18.31,
			60: 16.75,
			61: 15.85,
			62: 14.97,
			63: 14.04,
			64: 14.59,
			65: 13.77,
			66: 13.02,
			67: 11.76,
			68: 13.06,
			69: 14.05,
			70: 14.99,
			71: 16.18,
			72: 17.54,
			73: 20.33,
			74: 19.52,
			75: 18.44,
			76: 17.11,
			77: 14.97,
			78: 15.24,
			79: 14.04,
			80: 13.06,
			81: 12.34,
			82: 11.39,
			83: 10.68,
			84: 11.34,
			85: 12.67,
			86: 13.66,
			87: 14.53,
			88: 16.25,
			89: 17.53,
			90: 18.54,
			91: 20.28,
			92: 21.65,
			93: 23.05,
			94: 13.22,
			95: 14.45,
			96: 15.28,
			97: 16.19,
			98: 17.35,
			99: 28.41,
			100: 26.46,
			101: 25.35,
			102: 23.88,
			103: 22.24,
			104: 20.96,
			105: 20.31,
			106: 19.03,
			107: 18.16,
			108: 15.08,
			109: 13.77,
			110: 12.42,
			111: 13.1,
			112: 14.04,
			113: 15.16,
			114: 15.83,
			115: 16.56,
			116: 17.4,
			117: 18.38,
			118: 19.2,
			119: 20.56,
			120: 21.98,
			121: 23.07,
			122: 20.52,
			123: 22.07,
			124: 21.51,
			125: 20.61,
			126: 19.52,
			127: 21.05,
			128: 21.68,
			129: 22.42,
			130: 21.2,
			131: 20.31,
			132: 19.03,
			133: 17.53,
			134: 18.68,
			135: 19.92
		},
		48: {
			1: 24.9,
			2: 24.22,
			3: 23.7,
			4: 22.56,
			5: 21.8,
			6: 20.2,
			7: 19.38,
			8: 18.25,
			9: 17.5,
			10: 16.61,
			11: 15.5,
			12: 16.43,
			13: 17.91,
			14: 20.49,
			15: 21.82,
			16: 23.11,
			17: 23.93,
			18: 24.94,
			19: 26.07,
			20: 26.94,
			21: 27.06,
			22: 26.21,
			23: 25.17,
			24: 24.52,
			25: 20.22,
			26: 19.49,
			27: 18.49,
			28: 17.5,
			29: 17.36,
			30: 16.69,
			31: 15.49,
			32: 14.5,
			33: 13.87,
			34: 13.21,
			35: 12.66,
			36: 12.13,
			37: 11.1,
			38: 9.58,
			39: 8.49,
			40: 7.39,
			41: 6.51,
			42: 5.91,
			43: 4.65,
			44: 3.82,
			45: 3.06,
			46: 4.09,
			47: 1.45,
			48: 0,
			49: 0.87,
			50: 3.01,
			51: 4.92,
			52: 7.01,
			53: 24.83,
			54: 23.72,
			55: 22.82,
			56: 24.76,
			57: 21.97,
			58: 20.82,
			59: 19.76,
			60: 18.2,
			61: 17.3,
			62: 16.42,
			63: 15.49,
			64: 16.04,
			65: 15.22,
			66: 14.47,
			67: 13.21,
			68: 14.51,
			69: 15.5,
			70: 16.44,
			71: 17.63,
			72: 18.99,
			73: 21.78,
			74: 20.97,
			75: 19.89,
			76: 18.56,
			77: 16.42,
			78: 16.69,
			79: 15.49,
			80: 14.51,
			81: 13.79,
			82: 12.84,
			83: 12.13,
			84: 12.79,
			85: 14.12,
			86: 15.11,
			87: 15.98,
			88: 17.7,
			89: 18.98,
			90: 19.99,
			91: 21.73,
			92: 23.1,
			93: 24.5,
			94: 14.67,
			95: 15.9,
			96: 16.73,
			97: 17.64,
			98: 18.8,
			99: 29.86,
			100: 27.91,
			101: 26.8,
			102: 25.33,
			103: 23.69,
			104: 22.41,
			105: 21.76,
			106: 20.48,
			107: 19.61,
			108: 16.53,
			109: 15.22,
			110: 13.87,
			111: 14.55,
			112: 15.49,
			113: 16.61,
			114: 17.28,
			115: 18.01,
			116: 18.85,
			117: 19.83,
			118: 20.65,
			119: 22.01,
			120: 23.43,
			121: 24.52,
			122: 21.97,
			123: 23.52,
			124: 22.96,
			125: 22.06,
			126: 20.97,
			127: 22.5,
			128: 23.13,
			129: 23.87,
			130: 22.65,
			131: 21.76,
			132: 20.48,
			133: 18.98,
			134: 20.13,
			135: 21.37
		},
		49: {
			1: 25.77,
			2: 25.09,
			3: 24.57,
			4: 23.43,
			5: 22.67,
			6: 21.07,
			7: 20.25,
			8: 19.12,
			9: 18.37,
			10: 17.48,
			11: 16.37,
			12: 17.3,
			13: 18.78,
			14: 21.36,
			15: 22.69,
			16: 23.98,
			17: 24.8,
			18: 25.81,
			19: 26.94,
			20: 27.81,
			21: 27.93,
			22: 27.08,
			23: 26.04,
			24: 25.39,
			25: 21.09,
			26: 20.36,
			27: 19.36,
			28: 18.37,
			29: 18.23,
			30: 17.56,
			31: 16.36,
			32: 15.37,
			33: 14.74,
			34: 14.08,
			35: 13.53,
			36: 13,
			37: 11.97,
			38: 10.45,
			39: 9.36,
			40: 8.26,
			41: 7.38,
			42: 6.78,
			43: 5.52,
			44: 4.69,
			45: 3.93,
			46: 4.96,
			47: 2.32,
			48: 0.87,
			49: 0,
			50: 2.14,
			51: 4.05,
			52: 6.14,
			53: 25.7,
			54: 24.59,
			55: 23.69,
			56: 25.63,
			57: 22.84,
			58: 21.69,
			59: 20.63,
			60: 19.07,
			61: 18.17,
			62: 17.29,
			63: 16.36,
			64: 16.91,
			65: 16.09,
			66: 15.34,
			67: 14.08,
			68: 15.38,
			69: 16.37,
			70: 17.31,
			71: 18.5,
			72: 19.86,
			73: 22.65,
			74: 21.84,
			75: 20.76,
			76: 19.43,
			77: 17.29,
			78: 17.56,
			79: 16.36,
			80: 15.38,
			81: 14.66,
			82: 13.71,
			83: 13,
			84: 13.66,
			85: 14.99,
			86: 15.98,
			87: 16.85,
			88: 18.57,
			89: 19.85,
			90: 20.86,
			91: 22.6,
			92: 23.97,
			93: 25.37,
			94: 15.54,
			95: 16.77,
			96: 17.6,
			97: 18.51,
			98: 19.67,
			99: 30.73,
			100: 28.78,
			101: 27.67,
			102: 26.2,
			103: 24.56,
			104: 23.28,
			105: 22.63,
			106: 21.35,
			107: 20.48,
			108: 17.4,
			109: 16.09,
			110: 14.74,
			111: 15.42,
			112: 16.36,
			113: 17.48,
			114: 18.15,
			115: 18.88,
			116: 19.72,
			117: 20.7,
			118: 21.52,
			119: 22.88,
			120: 24.3,
			121: 25.39,
			122: 22.84,
			123: 24.39,
			124: 23.83,
			125: 22.93,
			126: 21.84,
			127: 23.37,
			128: 24,
			129: 24.74,
			130: 23.52,
			131: 22.63,
			132: 21.35,
			133: 19.85,
			134: 21,
			135: 22.24
		},
		50: {
			1: 27.91,
			2: 27.23,
			3: 26.71,
			4: 25.57,
			5: 24.81,
			6: 23.21,
			7: 22.39,
			8: 21.26,
			9: 20.51,
			10: 19.62,
			11: 18.51,
			12: 19.44,
			13: 20.92,
			14: 23.5,
			15: 24.83,
			16: 26.12,
			17: 26.94,
			18: 27.95,
			19: 29.08,
			20: 29.95,
			21: 30.07,
			22: 29.22,
			23: 28.18,
			24: 27.53,
			25: 23.23,
			26: 22.5,
			27: 21.5,
			28: 20.51,
			29: 20.37,
			30: 19.7,
			31: 18.5,
			32: 17.51,
			33: 16.88,
			34: 16.22,
			35: 15.67,
			36: 15.14,
			37: 14.11,
			38: 12.59,
			39: 11.5,
			40: 10.4,
			41: 9.52,
			42: 8.92,
			43: 7.66,
			44: 6.83,
			45: 6.07,
			46: 7.1,
			47: 4.46,
			48: 3.01,
			49: 2.14,
			50: 0,
			51: 1.91,
			52: 4,
			53: 27.84,
			54: 26.73,
			55: 25.83,
			56: 27.77,
			57: 24.98,
			58: 23.83,
			59: 22.77,
			60: 21.21,
			61: 20.31,
			62: 19.43,
			63: 18.5,
			64: 19.05,
			65: 18.23,
			66: 17.48,
			67: 16.22,
			68: 17.52,
			69: 18.51,
			70: 19.45,
			71: 20.64,
			72: 22,
			73: 24.79,
			74: 23.98,
			75: 22.9,
			76: 21.57,
			77: 19.43,
			78: 19.7,
			79: 18.5,
			80: 17.52,
			81: 16.8,
			82: 15.85,
			83: 15.14,
			84: 15.8,
			85: 17.13,
			86: 18.12,
			87: 18.99,
			88: 20.71,
			89: 21.99,
			90: 23.01,
			91: 24.74,
			92: 26.11,
			93: 27.51,
			94: 17.68,
			95: 18.91,
			96: 19.74,
			97: 20.65,
			98: 21.81,
			99: 32.87,
			100: 30.92,
			101: 29.81,
			102: 28.34,
			103: 26.7,
			104: 25.42,
			105: 24.77,
			106: 23.49,
			107: 22.62,
			108: 19.54,
			109: 18.23,
			110: 16.88,
			111: 17.56,
			112: 18.5,
			113: 19.62,
			114: 20.29,
			115: 21.02,
			116: 21.86,
			117: 22.84,
			118: 23.66,
			119: 25.02,
			120: 26.44,
			121: 27.53,
			122: 24.98,
			123: 26.53,
			124: 25.97,
			125: 25.07,
			126: 23.98,
			127: 25.51,
			128: 26.14,
			129: 26.88,
			130: 25.66,
			131: 24.77,
			132: 23.49,
			133: 21.99,
			134: 23.14,
			135: 24.38
		},
		51: {
			1: 29.82,
			2: 29.14,
			3: 28.62,
			4: 27.48,
			5: 26.72,
			6: 25.12,
			7: 24.3,
			8: 23.17,
			9: 22.42,
			10: 21.53,
			11: 20.42,
			12: 21.35,
			13: 22.83,
			14: 25.41,
			15: 26.74,
			16: 28.03,
			17: 28.85,
			18: 29.86,
			19: 30.99,
			20: 31.86,
			21: 31.98,
			22: 31.13,
			23: 30.09,
			24: 29.44,
			25: 25.14,
			26: 24.41,
			27: 23.41,
			28: 22.42,
			29: 22.28,
			30: 21.61,
			31: 20.41,
			32: 19.42,
			33: 18.79,
			34: 18.13,
			35: 17.58,
			36: 17.05,
			37: 16.02,
			38: 14.5,
			39: 13.41,
			40: 12.31,
			41: 11.43,
			42: 10.83,
			43: 9.57,
			44: 8.74,
			45: 7.98,
			46: 9.01,
			47: 6.37,
			48: 4.92,
			49: 4.05,
			50: 1.91,
			51: 0,
			52: 2.09,
			53: 29.75,
			54: 28.64,
			55: 27.74,
			56: 29.68,
			57: 26.89,
			58: 25.74,
			59: 24.68,
			60: 23.12,
			61: 22.22,
			62: 21.34,
			63: 20.41,
			64: 20.96,
			65: 20.14,
			66: 19.39,
			67: 18.13,
			68: 19.43,
			69: 20.42,
			70: 21.36,
			71: 22.55,
			72: 23.91,
			73: 26.7,
			74: 25.89,
			75: 24.81,
			76: 23.48,
			77: 21.34,
			78: 21.61,
			79: 20.41,
			80: 19.43,
			81: 18.71,
			82: 17.76,
			83: 17.05,
			84: 17.71,
			85: 19.04,
			86: 20.03,
			87: 20.9,
			88: 22.62,
			89: 23.9,
			90: 24.91,
			91: 26.65,
			92: 28.02,
			93: 29.42,
			94: 19.59,
			95: 20.82,
			96: 21.65,
			97: 22.56,
			98: 23.72,
			99: 34.78,
			100: 32.83,
			101: 31.72,
			102: 30.25,
			103: 28.61,
			104: 27.33,
			105: 26.68,
			106: 25.4,
			107: 24.53,
			108: 21.45,
			109: 20.14,
			110: 18.79,
			111: 19.47,
			112: 20.41,
			113: 21.53,
			114: 22.2,
			115: 22.93,
			116: 23.77,
			117: 24.75,
			118: 25.57,
			119: 26.93,
			120: 28.35,
			121: 29.44,
			122: 26.89,
			123: 28.44,
			124: 27.88,
			125: 26.98,
			126: 25.89,
			127: 27.42,
			128: 28.05,
			129: 28.79,
			130: 27.57,
			131: 26.68,
			132: 25.4,
			133: 23.9,
			134: 25.05,
			135: 26.29
		},
		52: {
			1: 31.91,
			2: 31.23,
			3: 30.71,
			4: 29.57,
			5: 28.81,
			6: 27.21,
			7: 26.39,
			8: 25.26,
			9: 24.51,
			10: 23.62,
			11: 22.51,
			12: 23.44,
			13: 24.92,
			14: 27.5,
			15: 28.83,
			16: 30.12,
			17: 30.94,
			18: 31.95,
			19: 33.08,
			20: 33.95,
			21: 34.07,
			22: 33.22,
			23: 32.18,
			24: 31.53,
			25: 27.23,
			26: 26.5,
			27: 25.5,
			28: 24.51,
			29: 24.37,
			30: 23.7,
			31: 22.5,
			32: 21.51,
			33: 20.88,
			34: 20.22,
			35: 19.67,
			36: 19.14,
			37: 18.11,
			38: 16.59,
			39: 15.5,
			40: 14.4,
			41: 13.52,
			42: 12.92,
			43: 11.66,
			44: 10.83,
			45: 10.07,
			46: 11.1,
			47: 8.46,
			48: 7.01,
			49: 6.14,
			50: 4,
			51: 2.09,
			52: 0,
			53: 31.84,
			54: 30.73,
			55: 29.83,
			56: 31.77,
			57: 28.98,
			58: 27.83,
			59: 26.77,
			60: 25.21,
			61: 24.31,
			62: 23.43,
			63: 22.5,
			64: 23.05,
			65: 22.23,
			66: 21.48,
			67: 20.22,
			68: 21.52,
			69: 22.51,
			70: 23.45,
			71: 24.64,
			72: 26,
			73: 28.79,
			74: 27.98,
			75: 26.9,
			76: 25.57,
			77: 23.43,
			78: 23.7,
			79: 22.5,
			80: 21.52,
			81: 20.8,
			82: 19.85,
			83: 19.14,
			84: 19.8,
			85: 21.13,
			86: 22.12,
			87: 22.99,
			88: 24.71,
			89: 25.99,
			90: 27.01,
			91: 28.74,
			92: 30.11,
			93: 31.51,
			94: 21.68,
			95: 22.91,
			96: 23.74,
			97: 24.65,
			98: 25.81,
			99: 36.87,
			100: 34.92,
			101: 33.81,
			102: 32.34,
			103: 30.7,
			104: 29.42,
			105: 28.77,
			106: 27.49,
			107: 26.62,
			108: 23.54,
			109: 22.23,
			110: 20.88,
			111: 21.56,
			112: 22.5,
			113: 23.62,
			114: 24.29,
			115: 25.02,
			116: 25.86,
			117: 26.84,
			118: 27.66,
			119: 29.02,
			120: 30.44,
			121: 31.53,
			122: 28.98,
			123: 30.53,
			124: 29.97,
			125: 29.07,
			126: 27.98,
			127: 29.51,
			128: 30.14,
			129: 30.88,
			130: 29.66,
			131: 28.77,
			132: 27.49,
			133: 25.99,
			134: 27.14,
			135: 28.38
		},
		53: {
			1: 18.84,
			2: 18.16,
			3: 17.64,
			4: 16.5,
			5: 15.74,
			6: 14.14,
			7: 13.32,
			8: 12.19,
			9: 11.44,
			10: 12.31,
			11: 13.32,
			12: 14.25,
			13: 15.73,
			14: 18.32,
			15: 19.65,
			16: 20.93,
			17: 21.76,
			18: 22.77,
			19: 23.9,
			20: 24.38,
			21: 22.76,
			22: 21.9,
			23: 20.86,
			24: 20.22,
			25: 14.16,
			26: 13.42,
			27: 12.43,
			28: 11.44,
			29: 10.65,
			30: 9.99,
			31: 9.34,
			32: 10.33,
			33: 10.96,
			34: 11.62,
			35: 12.17,
			36: 12.7,
			37: 13.73,
			38: 15.25,
			39: 16.34,
			40: 17.44,
			41: 18.32,
			42: 18.92,
			43: 20.18,
			44: 21.01,
			45: 21.77,
			46: 22.8,
			47: 23.38,
			48: 24.83,
			49: 25.7,
			50: 27.84,
			51: 29.75,
			52: 31.84,
			53: 0,
			54: 1.11,
			55: 2.01,
			56: 3.95,
			57: 2.86,
			58: 4.01,
			59: 5.07,
			60: 6.63,
			61: 7.53,
			62: 8.41,
			63: 9.34,
			64: 10.1,
			65: 10.92,
			66: 11.74,
			67: 11.62,
			68: 12.33,
			69: 13.32,
			70: 14.26,
			71: 15.46,
			72: 16.81,
			73: 8.09,
			74: 7.28,
			75: 8.36,
			76: 9.69,
			77: 8.41,
			78: 9.99,
			79: 11.19,
			80: 12.33,
			81: 13.13,
			82: 13.41,
			83: 12.7,
			84: 13.36,
			85: 14.69,
			86: 15.68,
			87: 16.55,
			88: 16.66,
			89: 15.39,
			90: 16.41,
			91: 18.15,
			92: 19.52,
			93: 20.92,
			94: 15.24,
			95: 16.47,
			96: 17.3,
			97: 18.21,
			98: 19.37,
			99: 20.58,
			100: 18.63,
			101: 17.52,
			102: 16.06,
			103: 14.41,
			104: 13.13,
			105: 12.48,
			106: 13.76,
			107: 14.62,
			108: 12.24,
			109: 10.92,
			110: 10.96,
			111: 11.64,
			112: 11.19,
			113: 12.31,
			114: 12.97,
			115: 13.7,
			116: 14.54,
			117: 15.53,
			118: 16.34,
			119: 17.71,
			120: 19.13,
			121: 20.22,
			122: 2.86,
			123: 4.41,
			124: 5.3,
			125: 6.2,
			126: 7.28,
			127: 8.81,
			128: 9.44,
			129: 10.18,
			130: 11.59,
			131: 12.48,
			132: 13.76,
			133: 15.39,
			134: 16.55,
			135: 17.79
		},
		54: {
			1: 17.73,
			2: 17.05,
			3: 16.53,
			4: 15.39,
			5: 14.63,
			6: 13.03,
			7: 12.21,
			8: 11.08,
			9: 10.33,
			10: 11.2,
			11: 12.21,
			12: 13.14,
			13: 14.62,
			14: 17.21,
			15: 18.54,
			16: 19.82,
			17: 20.65,
			18: 21.66,
			19: 22.79,
			20: 23.27,
			21: 21.65,
			22: 20.79,
			23: 19.75,
			24: 19.11,
			25: 13.05,
			26: 12.31,
			27: 11.32,
			28: 10.33,
			29: 9.54,
			30: 8.88,
			31: 8.23,
			32: 9.22,
			33: 9.85,
			34: 10.51,
			35: 11.06,
			36: 11.59,
			37: 12.62,
			38: 14.14,
			39: 15.23,
			40: 16.33,
			41: 17.21,
			42: 17.81,
			43: 19.07,
			44: 19.9,
			45: 20.66,
			46: 21.69,
			47: 22.27,
			48: 23.72,
			49: 24.59,
			50: 26.73,
			51: 28.64,
			52: 30.73,
			53: 1.11,
			54: 0,
			55: 0.9,
			56: 2.84,
			57: 1.75,
			58: 2.9,
			59: 3.96,
			60: 5.52,
			61: 6.42,
			62: 7.3,
			63: 8.23,
			64: 8.99,
			65: 9.81,
			66: 10.63,
			67: 10.51,
			68: 11.22,
			69: 12.21,
			70: 13.15,
			71: 14.35,
			72: 15.7,
			73: 6.98,
			74: 6.17,
			75: 7.25,
			76: 8.58,
			77: 7.3,
			78: 8.88,
			79: 10.08,
			80: 11.22,
			81: 12.02,
			82: 12.3,
			83: 11.59,
			84: 12.25,
			85: 13.58,
			86: 14.57,
			87: 15.44,
			88: 15.55,
			89: 14.28,
			90: 15.3,
			91: 17.04,
			92: 18.41,
			93: 19.81,
			94: 14.13,
			95: 15.36,
			96: 16.19,
			97: 17.1,
			98: 18.26,
			99: 19.47,
			100: 17.52,
			101: 16.41,
			102: 14.95,
			103: 13.3,
			104: 12.02,
			105: 11.37,
			106: 12.65,
			107: 13.51,
			108: 11.13,
			109: 9.81,
			110: 9.85,
			111: 10.53,
			112: 10.08,
			113: 11.2,
			114: 11.86,
			115: 12.59,
			116: 13.43,
			117: 14.42,
			118: 15.23,
			119: 16.6,
			120: 18.02,
			121: 19.11,
			122: 1.75,
			123: 3.3,
			124: 4.19,
			125: 5.09,
			126: 6.17,
			127: 7.7,
			128: 8.33,
			129: 9.07,
			130: 10.48,
			131: 11.37,
			132: 12.65,
			133: 14.28,
			134: 15.44,
			135: 16.68
		},
		55: {
			1: 16.83,
			2: 16.15,
			3: 15.63,
			4: 14.49,
			5: 13.73,
			6: 12.13,
			7: 11.31,
			8: 10.18,
			9: 9.43,
			10: 10.3,
			11: 11.31,
			12: 12.24,
			13: 13.72,
			14: 16.31,
			15: 17.64,
			16: 18.92,
			17: 19.75,
			18: 20.76,
			19: 21.89,
			20: 22.37,
			21: 20.75,
			22: 19.89,
			23: 18.85,
			24: 18.21,
			25: 12.15,
			26: 11.41,
			27: 10.42,
			28: 9.43,
			29: 8.64,
			30: 7.98,
			31: 7.33,
			32: 8.32,
			33: 8.95,
			34: 9.61,
			35: 10.16,
			36: 10.69,
			37: 11.72,
			38: 13.24,
			39: 14.33,
			40: 15.43,
			41: 16.31,
			42: 16.91,
			43: 18.17,
			44: 19,
			45: 19.76,
			46: 20.79,
			47: 21.37,
			48: 22.82,
			49: 23.69,
			50: 25.83,
			51: 27.74,
			52: 29.83,
			53: 2.01,
			54: 0.9,
			55: 0,
			56: 1.94,
			57: 0.85,
			58: 2,
			59: 3.06,
			60: 4.62,
			61: 5.52,
			62: 6.4,
			63: 7.33,
			64: 8.09,
			65: 8.91,
			66: 9.73,
			67: 9.61,
			68: 10.32,
			69: 11.31,
			70: 12.25,
			71: 13.45,
			72: 14.8,
			73: 6.08,
			74: 5.27,
			75: 6.35,
			76: 7.68,
			77: 6.4,
			78: 7.98,
			79: 9.18,
			80: 10.32,
			81: 11.12,
			82: 11.4,
			83: 10.69,
			84: 11.35,
			85: 12.68,
			86: 13.67,
			87: 14.54,
			88: 14.65,
			89: 13.38,
			90: 14.4,
			91: 16.14,
			92: 17.51,
			93: 18.91,
			94: 13.23,
			95: 14.46,
			96: 15.29,
			97: 16.2,
			98: 17.36,
			99: 18.57,
			100: 16.62,
			101: 15.51,
			102: 14.05,
			103: 12.4,
			104: 11.12,
			105: 10.47,
			106: 11.75,
			107: 12.61,
			108: 10.23,
			109: 8.91,
			110: 8.95,
			111: 9.63,
			112: 9.18,
			113: 10.3,
			114: 10.96,
			115: 11.69,
			116: 12.53,
			117: 13.52,
			118: 14.33,
			119: 15.7,
			120: 17.12,
			121: 18.21,
			122: 0.85,
			123: 2.4,
			124: 3.29,
			125: 4.19,
			126: 5.27,
			127: 6.8,
			128: 7.43,
			129: 8.17,
			130: 9.58,
			131: 10.47,
			132: 11.75,
			133: 13.38,
			134: 14.54,
			135: 15.78
		},
		56: {
			1: 18.77,
			2: 18.09,
			3: 17.58,
			4: 16.43,
			5: 15.67,
			6: 14.08,
			7: 13.25,
			8: 12.12,
			9: 11.37,
			10: 12.24,
			11: 13.26,
			12: 14.19,
			13: 15.67,
			14: 18.25,
			15: 19.58,
			16: 20.86,
			17: 21.69,
			18: 22.7,
			19: 23.83,
			20: 24.32,
			21: 22.69,
			22: 21.84,
			23: 20.8,
			24: 20.15,
			25: 14.09,
			26: 13.36,
			27: 12.36,
			28: 11.37,
			29: 10.59,
			30: 9.92,
			31: 9.27,
			32: 10.26,
			33: 10.89,
			34: 11.55,
			35: 12.1,
			36: 12.63,
			37: 13.66,
			38: 15.18,
			39: 16.27,
			40: 17.37,
			41: 18.25,
			42: 18.85,
			43: 20.11,
			44: 20.94,
			45: 21.7,
			46: 22.73,
			47: 23.31,
			48: 24.76,
			49: 25.63,
			50: 27.77,
			51: 29.68,
			52: 31.77,
			53: 3.95,
			54: 2.84,
			55: 1.94,
			56: 0,
			57: 2.79,
			58: 3.94,
			59: 5,
			60: 6.56,
			61: 7.46,
			62: 8.34,
			63: 9.27,
			64: 10.04,
			65: 10.86,
			66: 11.67,
			67: 11.55,
			68: 12.26,
			69: 13.26,
			70: 14.2,
			71: 15.39,
			72: 16.75,
			73: 8.03,
			74: 7.22,
			75: 8.3,
			76: 9.63,
			77: 8.34,
			78: 9.92,
			79: 11.12,
			80: 12.26,
			81: 13.06,
			82: 13.35,
			83: 12.63,
			84: 13.3,
			85: 14.63,
			86: 15.62,
			87: 16.48,
			88: 16.6,
			89: 15.33,
			90: 16.34,
			91: 18.08,
			92: 19.45,
			93: 20.85,
			94: 15.17,
			95: 16.41,
			96: 17.24,
			97: 18.14,
			98: 19.31,
			99: 20.51,
			100: 18.57,
			101: 17.46,
			102: 15.99,
			103: 14.35,
			104: 13.07,
			105: 12.41,
			106: 13.69,
			107: 14.56,
			108: 12.17,
			109: 10.86,
			110: 10.89,
			111: 11.58,
			112: 11.12,
			113: 12.24,
			114: 12.91,
			115: 13.63,
			116: 14.48,
			117: 15.46,
			118: 16.28,
			119: 17.64,
			120: 19.06,
			121: 20.15,
			122: 2.79,
			123: 4.35,
			124: 5.23,
			125: 6.13,
			126: 7.22,
			127: 8.75,
			128: 9.38,
			129: 10.11,
			130: 11.52,
			131: 12.41,
			132: 13.69,
			133: 15.33,
			134: 16.48,
			135: 17.72
		},
		57: {
			1: 15.98,
			2: 15.3,
			3: 14.78,
			4: 13.64,
			5: 12.88,
			6: 11.28,
			7: 10.46,
			8: 9.33,
			9: 8.58,
			10: 9.45,
			11: 10.46,
			12: 11.39,
			13: 12.87,
			14: 15.46,
			15: 16.79,
			16: 18.07,
			17: 18.9,
			18: 19.91,
			19: 21.04,
			20: 21.52,
			21: 19.9,
			22: 19.04,
			23: 18,
			24: 17.36,
			25: 11.3,
			26: 10.56,
			27: 9.57,
			28: 8.58,
			29: 7.79,
			30: 7.13,
			31: 6.48,
			32: 7.47,
			33: 8.1,
			34: 8.76,
			35: 9.31,
			36: 9.84,
			37: 10.87,
			38: 12.39,
			39: 13.48,
			40: 14.58,
			41: 15.46,
			42: 16.06,
			43: 17.32,
			44: 18.15,
			45: 18.91,
			46: 19.94,
			47: 20.52,
			48: 21.97,
			49: 22.84,
			50: 24.98,
			51: 26.89,
			52: 28.98,
			53: 2.86,
			54: 1.75,
			55: 0.85,
			56: 2.79,
			57: 0,
			58: 1.15,
			59: 2.21,
			60: 3.77,
			61: 4.67,
			62: 5.55,
			63: 6.48,
			64: 7.24,
			65: 8.06,
			66: 8.88,
			67: 8.76,
			68: 9.47,
			69: 10.46,
			70: 11.4,
			71: 12.6,
			72: 13.95,
			73: 5.23,
			74: 4.42,
			75: 5.5,
			76: 6.83,
			77: 5.55,
			78: 7.13,
			79: 8.33,
			80: 9.47,
			81: 10.27,
			82: 10.55,
			83: 9.84,
			84: 10.5,
			85: 11.83,
			86: 12.82,
			87: 13.69,
			88: 13.8,
			89: 12.53,
			90: 13.55,
			91: 15.29,
			92: 16.66,
			93: 18.06,
			94: 12.38,
			95: 13.61,
			96: 14.44,
			97: 15.35,
			98: 16.51,
			99: 17.72,
			100: 15.77,
			101: 14.66,
			102: 13.2,
			103: 11.55,
			104: 10.27,
			105: 9.62,
			106: 10.9,
			107: 11.76,
			108: 9.38,
			109: 8.06,
			110: 8.1,
			111: 8.78,
			112: 8.33,
			113: 9.45,
			114: 10.11,
			115: 10.84,
			116: 11.68,
			117: 12.67,
			118: 13.48,
			119: 14.85,
			120: 16.27,
			121: 17.36,
			122: 0,
			123: 1.55,
			124: 2.44,
			125: 3.34,
			126: 4.42,
			127: 5.95,
			128: 6.58,
			129: 7.32,
			130: 8.73,
			131: 9.62,
			132: 10.9,
			133: 12.53,
			134: 13.69,
			135: 14.93
		},
		58: {
			1: 14.83,
			2: 14.15,
			3: 13.63,
			4: 12.49,
			5: 11.73,
			6: 10.13,
			7: 9.31,
			8: 8.18,
			9: 7.43,
			10: 8.3,
			11: 9.31,
			12: 10.24,
			13: 11.72,
			14: 14.31,
			15: 15.64,
			16: 16.92,
			17: 17.75,
			18: 18.76,
			19: 19.89,
			20: 20.37,
			21: 18.75,
			22: 17.89,
			23: 16.85,
			24: 16.21,
			25: 10.15,
			26: 9.41,
			27: 8.42,
			28: 7.43,
			29: 6.64,
			30: 5.98,
			31: 5.33,
			32: 6.32,
			33: 6.95,
			34: 7.61,
			35: 8.16,
			36: 8.69,
			37: 9.72,
			38: 11.24,
			39: 12.33,
			40: 13.43,
			41: 14.31,
			42: 14.91,
			43: 16.17,
			44: 17,
			45: 17.76,
			46: 18.79,
			47: 19.37,
			48: 20.82,
			49: 21.69,
			50: 23.83,
			51: 25.74,
			52: 27.83,
			53: 4.01,
			54: 2.9,
			55: 2,
			56: 3.94,
			57: 1.15,
			58: 0,
			59: 1.06,
			60: 2.62,
			61: 3.52,
			62: 4.4,
			63: 5.33,
			64: 6.09,
			65: 6.91,
			66: 7.73,
			67: 7.61,
			68: 8.32,
			69: 9.31,
			70: 10.25,
			71: 11.45,
			72: 12.8,
			73: 6.38,
			74: 5.57,
			75: 6.65,
			76: 6.54,
			77: 4.4,
			78: 5.98,
			79: 7.18,
			80: 8.32,
			81: 9.12,
			82: 9.4,
			83: 8.69,
			84: 9.35,
			85: 10.68,
			86: 11.67,
			87: 12.54,
			88: 14.26,
			89: 13.68,
			90: 14.7,
			91: 16.44,
			92: 17.81,
			93: 19.21,
			94: 11.23,
			95: 12.46,
			96: 13.29,
			97: 14.2,
			98: 15.36,
			99: 18.87,
			100: 16.92,
			101: 15.81,
			102: 14.35,
			103: 12.7,
			104: 11.42,
			105: 10.77,
			106: 12.05,
			107: 11.31,
			108: 8.23,
			109: 6.91,
			110: 6.95,
			111: 7.63,
			112: 7.18,
			113: 8.3,
			114: 8.96,
			115: 9.69,
			116: 10.53,
			117: 11.52,
			118: 12.33,
			119: 13.7,
			120: 15.12,
			121: 16.21,
			122: 1.15,
			123: 2.7,
			124: 3.59,
			125: 4.49,
			126: 5.57,
			127: 7.1,
			128: 7.73,
			129: 8.47,
			130: 9.88,
			131: 10.77,
			132: 12.05,
			133: 13.68,
			134: 14.84,
			135: 16.08
		},
		59: {
			1: 13.77,
			2: 13.09,
			3: 12.57,
			4: 11.43,
			5: 10.67,
			6: 9.07,
			7: 8.25,
			8: 7.12,
			9: 6.37,
			10: 7.24,
			11: 8.25,
			12: 9.18,
			13: 10.66,
			14: 13.25,
			15: 14.58,
			16: 15.86,
			17: 16.69,
			18: 17.7,
			19: 18.83,
			20: 19.31,
			21: 17.69,
			22: 16.83,
			23: 15.79,
			24: 15.15,
			25: 9.09,
			26: 8.35,
			27: 7.36,
			28: 6.37,
			29: 5.58,
			30: 4.92,
			31: 4.27,
			32: 5.26,
			33: 5.89,
			34: 6.55,
			35: 7.1,
			36: 7.63,
			37: 8.66,
			38: 10.18,
			39: 11.27,
			40: 12.37,
			41: 13.25,
			42: 13.85,
			43: 15.11,
			44: 15.94,
			45: 16.7,
			46: 17.73,
			47: 18.31,
			48: 19.76,
			49: 20.63,
			50: 22.77,
			51: 24.68,
			52: 26.77,
			53: 5.07,
			54: 3.96,
			55: 3.06,
			56: 5,
			57: 2.21,
			58: 1.06,
			59: 0,
			60: 1.56,
			61: 2.46,
			62: 3.34,
			63: 4.27,
			64: 5.03,
			65: 5.85,
			66: 6.67,
			67: 6.55,
			68: 7.26,
			69: 8.25,
			70: 9.19,
			71: 10.39,
			72: 11.74,
			73: 7.44,
			74: 6.63,
			75: 6.81,
			76: 5.48,
			77: 3.34,
			78: 4.92,
			79: 6.12,
			80: 7.26,
			81: 8.06,
			82: 8.34,
			83: 7.63,
			84: 8.29,
			85: 9.62,
			86: 10.61,
			87: 11.48,
			88: 13.2,
			89: 12.74,
			90: 13.76,
			91: 15.5,
			92: 16.87,
			93: 18.27,
			94: 10.17,
			95: 11.4,
			96: 12.23,
			97: 13.14,
			98: 14.3,
			99: 19.93,
			100: 17.98,
			101: 16.87,
			102: 15.41,
			103: 13.76,
			104: 12.48,
			105: 11.83,
			106: 11.11,
			107: 10.25,
			108: 7.17,
			109: 5.85,
			110: 5.89,
			111: 6.57,
			112: 6.12,
			113: 7.24,
			114: 7.9,
			115: 8.63,
			116: 9.47,
			117: 10.46,
			118: 11.27,
			119: 12.64,
			120: 14.06,
			121: 15.15,
			122: 2.21,
			123: 3.76,
			124: 4.65,
			125: 5.55,
			126: 6.63,
			127: 8.16,
			128: 8.79,
			129: 9.53,
			130: 10.94,
			131: 11.83,
			132: 11.11,
			133: 12.74,
			134: 13.9,
			135: 15.14
		},
		60: {
			1: 12.21,
			2: 11.53,
			3: 11.01,
			4: 9.87,
			5: 9.11,
			6: 7.51,
			7: 6.69,
			8: 5.56,
			9: 4.81,
			10: 5.68,
			11: 6.69,
			12: 7.62,
			13: 9.1,
			14: 11.69,
			15: 13.02,
			16: 14.3,
			17: 15.13,
			18: 16.14,
			19: 17.27,
			20: 17.75,
			21: 16.13,
			22: 15.27,
			23: 14.23,
			24: 13.59,
			25: 7.53,
			26: 6.79,
			27: 5.8,
			28: 4.81,
			29: 4.02,
			30: 3.36,
			31: 2.71,
			32: 3.7,
			33: 4.33,
			34: 4.99,
			35: 5.54,
			36: 6.07,
			37: 7.1,
			38: 8.62,
			39: 9.71,
			40: 10.81,
			41: 11.69,
			42: 12.29,
			43: 13.55,
			44: 14.38,
			45: 15.14,
			46: 16.17,
			47: 16.75,
			48: 18.2,
			49: 19.07,
			50: 21.21,
			51: 23.12,
			52: 25.21,
			53: 6.63,
			54: 5.52,
			55: 4.62,
			56: 6.56,
			57: 3.77,
			58: 2.62,
			59: 1.56,
			60: 0,
			61: 0.9,
			62: 1.78,
			63: 2.71,
			64: 3.47,
			65: 4.29,
			66: 5.11,
			67: 4.99,
			68: 5.7,
			69: 6.69,
			70: 7.63,
			71: 8.83,
			72: 10.18,
			73: 7.14,
			74: 6.33,
			75: 5.25,
			76: 3.92,
			77: 1.78,
			78: 3.36,
			79: 4.56,
			80: 5.7,
			81: 6.5,
			82: 6.78,
			83: 6.07,
			84: 6.73,
			85: 8.06,
			86: 9.05,
			87: 9.92,
			88: 11.64,
			89: 11.18,
			90: 12.2,
			91: 13.94,
			92: 15.31,
			93: 16.71,
			94: 8.61,
			95: 9.84,
			96: 10.67,
			97: 11.58,
			98: 12.74,
			99: 18.93,
			100: 16.98,
			101: 15.87,
			102: 14.41,
			103: 12.76,
			104: 11.48,
			105: 10.83,
			106: 9.55,
			107: 8.69,
			108: 5.61,
			109: 4.29,
			110: 4.33,
			111: 5.01,
			112: 4.56,
			113: 5.68,
			114: 6.34,
			115: 7.07,
			116: 7.91,
			117: 8.9,
			118: 9.71,
			119: 11.08,
			120: 12.5,
			121: 13.59,
			122: 3.77,
			123: 5.32,
			124: 6.21,
			125: 7.11,
			126: 6.33,
			127: 7.86,
			128: 8.49,
			129: 9.23,
			130: 10.63,
			131: 10.83,
			132: 9.55,
			133: 11.18,
			134: 12.34,
			135: 13.58
		},
		61: {
			1: 11.31,
			2: 10.63,
			3: 10.11,
			4: 8.97,
			5: 8.21,
			6: 6.61,
			7: 5.79,
			8: 4.66,
			9: 3.91,
			10: 4.78,
			11: 5.79,
			12: 6.72,
			13: 8.2,
			14: 10.79,
			15: 12.12,
			16: 13.4,
			17: 14.23,
			18: 15.24,
			19: 16.37,
			20: 16.85,
			21: 15.23,
			22: 14.37,
			23: 13.33,
			24: 12.69,
			25: 6.63,
			26: 5.89,
			27: 4.9,
			28: 3.91,
			29: 3.12,
			30: 2.46,
			31: 1.81,
			32: 2.8,
			33: 3.43,
			34: 4.09,
			35: 4.64,
			36: 5.17,
			37: 6.2,
			38: 7.72,
			39: 8.81,
			40: 9.91,
			41: 10.79,
			42: 11.39,
			43: 12.65,
			44: 13.48,
			45: 14.24,
			46: 15.27,
			47: 15.85,
			48: 17.3,
			49: 18.17,
			50: 20.31,
			51: 22.22,
			52: 24.31,
			53: 7.53,
			54: 6.42,
			55: 5.52,
			56: 7.46,
			57: 4.67,
			58: 3.52,
			59: 2.46,
			60: 0.9,
			61: 0,
			62: 0.88,
			63: 1.81,
			64: 2.57,
			65: 3.39,
			66: 4.21,
			67: 4.09,
			68: 4.8,
			69: 5.79,
			70: 6.73,
			71: 7.93,
			72: 9.28,
			73: 6.24,
			74: 5.43,
			75: 4.35,
			76: 3.02,
			77: 0.88,
			78: 2.46,
			79: 3.66,
			80: 4.8,
			81: 5.6,
			82: 5.88,
			83: 5.17,
			84: 5.83,
			85: 7.16,
			86: 8.15,
			87: 9.02,
			88: 10.74,
			89: 10.28,
			90: 11.3,
			91: 13.04,
			92: 14.41,
			93: 15.81,
			94: 7.71,
			95: 8.94,
			96: 9.77,
			97: 10.68,
			98: 11.84,
			99: 18.03,
			100: 16.08,
			101: 14.97,
			102: 13.51,
			103: 11.86,
			104: 10.58,
			105: 9.93,
			106: 8.65,
			107: 7.79,
			108: 4.71,
			109: 3.39,
			110: 3.43,
			111: 4.11,
			112: 3.66,
			113: 4.78,
			114: 5.44,
			115: 6.17,
			116: 7.01,
			117: 8,
			118: 8.81,
			119: 10.18,
			120: 11.6,
			121: 12.69,
			122: 4.67,
			123: 6.22,
			124: 7.11,
			125: 6.52,
			126: 5.43,
			127: 6.96,
			128: 7.59,
			129: 8.33,
			130: 9.73,
			131: 9.93,
			132: 8.65,
			133: 10.28,
			134: 11.44,
			135: 12.68
		},
		62: {
			1: 10.43,
			2: 9.75,
			3: 9.23,
			4: 8.09,
			5: 7.33,
			6: 5.73,
			7: 4.91,
			8: 3.78,
			9: 3.03,
			10: 3.9,
			11: 4.91,
			12: 5.84,
			13: 7.32,
			14: 9.91,
			15: 11.24,
			16: 12.52,
			17: 13.35,
			18: 14.36,
			19: 15.49,
			20: 15.97,
			21: 14.35,
			22: 13.49,
			23: 12.45,
			24: 11.81,
			25: 5.75,
			26: 5.01,
			27: 4.02,
			28: 3.03,
			29: 2.24,
			30: 1.58,
			31: 0.93,
			32: 1.92,
			33: 2.55,
			34: 3.21,
			35: 3.76,
			36: 4.29,
			37: 5.32,
			38: 6.84,
			39: 7.93,
			40: 9.03,
			41: 9.91,
			42: 10.51,
			43: 11.77,
			44: 12.6,
			45: 13.36,
			46: 14.39,
			47: 14.97,
			48: 16.42,
			49: 17.29,
			50: 19.43,
			51: 21.34,
			52: 23.43,
			53: 8.41,
			54: 7.3,
			55: 6.4,
			56: 8.34,
			57: 5.55,
			58: 4.4,
			59: 3.34,
			60: 1.78,
			61: 0.88,
			62: 0,
			63: 0.93,
			64: 1.69,
			65: 2.51,
			66: 3.33,
			67: 3.21,
			68: 3.92,
			69: 4.91,
			70: 5.85,
			71: 7.05,
			72: 8.4,
			73: 5.36,
			74: 4.55,
			75: 3.47,
			76: 2.14,
			77: 0,
			78: 1.58,
			79: 2.78,
			80: 3.92,
			81: 4.72,
			82: 5.01,
			83: 4.29,
			84: 4.95,
			85: 6.28,
			86: 7.27,
			87: 8.14,
			88: 9.86,
			89: 9.4,
			90: 10.42,
			91: 12.16,
			92: 13.53,
			93: 14.93,
			94: 6.83,
			95: 8.06,
			96: 8.89,
			97: 9.8,
			98: 10.96,
			99: 17.15,
			100: 15.2,
			101: 14.09,
			102: 12.63,
			103: 10.98,
			104: 9.7,
			105: 9.05,
			106: 7.77,
			107: 6.91,
			108: 3.83,
			109: 2.51,
			110: 2.55,
			111: 3.23,
			112: 2.78,
			113: 3.9,
			114: 4.56,
			115: 5.29,
			116: 6.13,
			117: 7.12,
			118: 7.93,
			119: 9.3,
			120: 10.72,
			121: 11.81,
			122: 5.55,
			123: 7.1,
			124: 6.54,
			125: 5.64,
			126: 4.55,
			127: 6.08,
			128: 6.71,
			129: 7.45,
			130: 8.85,
			131: 9.05,
			132: 7.77,
			133: 9.4,
			134: 10.56,
			135: 11.8
		},
		63: {
			1: 10.41,
			2: 9.73,
			3: 9.22,
			4: 8.07,
			5: 7.31,
			6: 5.72,
			7: 4.9,
			8: 3.76,
			9: 3.02,
			10: 3.88,
			11: 4.57,
			12: 5.5,
			13: 6.98,
			14: 9.56,
			15: 10.89,
			16: 12.18,
			17: 13,
			18: 14.01,
			19: 15.14,
			20: 15.96,
			21: 14.33,
			22: 13.48,
			23: 12.44,
			24: 11.79,
			25: 5.73,
			26: 5,
			27: 4,
			28: 3.02,
			29: 2.23,
			30: 1.56,
			31: 0,
			32: 0.99,
			33: 1.62,
			34: 2.28,
			35: 2.83,
			36: 3.36,
			37: 4.39,
			38: 5.91,
			39: 7,
			40: 8.1,
			41: 8.98,
			42: 9.58,
			43: 10.84,
			44: 11.67,
			45: 12.43,
			46: 13.46,
			47: 14.04,
			48: 15.49,
			49: 16.36,
			50: 18.5,
			51: 20.41,
			52: 22.5,
			53: 9.34,
			54: 8.23,
			55: 7.33,
			56: 9.27,
			57: 6.48,
			58: 5.33,
			59: 4.27,
			60: 2.71,
			61: 1.81,
			62: 0.93,
			63: 0,
			64: 0.76,
			65: 1.58,
			66: 2.4,
			67: 2.28,
			68: 3.58,
			69: 4.57,
			70: 5.51,
			71: 6.7,
			72: 8.06,
			73: 6.29,
			74: 5.48,
			75: 4.4,
			76: 3.07,
			77: 0.93,
			78: 1.56,
			79: 2.76,
			80: 3.58,
			81: 4.37,
			82: 4.07,
			83: 3.36,
			84: 4.02,
			85: 5.35,
			86: 6.34,
			87: 7.21,
			88: 8.93,
			89: 8.47,
			90: 9.49,
			91: 11.23,
			92: 12.6,
			93: 14,
			94: 5.9,
			95: 7.13,
			96: 7.96,
			97: 8.87,
			98: 10.03,
			99: 16.22,
			100: 14.27,
			101: 13.16,
			102: 11.7,
			103: 10.05,
			104: 8.77,
			105: 8.12,
			106: 6.84,
			107: 5.98,
			108: 2.9,
			109: 1.58,
			110: 1.62,
			111: 2.3,
			112: 2.76,
			113: 3.88,
			114: 4.55,
			115: 5.28,
			116: 6.12,
			117: 7.1,
			118: 7.92,
			119: 9.28,
			120: 10.7,
			121: 11.79,
			122: 6.48,
			123: 8.03,
			124: 7.47,
			125: 6.57,
			126: 5.48,
			127: 7.01,
			128: 7.64,
			129: 8.38,
			130: 9.01,
			131: 8.12,
			132: 6.84,
			133: 8.47,
			134: 9.63,
			135: 10.87
		},
		64: {
			1: 11.18,
			2: 10.49,
			3: 9.98,
			4: 8.84,
			5: 8.08,
			6: 6.48,
			7: 5.66,
			8: 4.52,
			9: 3.78,
			10: 4.64,
			11: 5.12,
			12: 6.05,
			13: 7.53,
			14: 10.11,
			15: 11.44,
			16: 12.72,
			17: 13.55,
			18: 14.56,
			19: 15.69,
			20: 16.56,
			21: 15.09,
			22: 14.24,
			23: 13.2,
			24: 12.56,
			25: 6.5,
			26: 5.76,
			27: 4.77,
			28: 3.78,
			29: 2.99,
			30: 2.32,
			31: 0.76,
			32: 1.75,
			33: 2.17,
			34: 2.83,
			35: 3.38,
			36: 3.91,
			37: 4.94,
			38: 6.46,
			39: 7.55,
			40: 8.65,
			41: 9.53,
			42: 10.13,
			43: 11.39,
			44: 12.22,
			45: 12.98,
			46: 14.01,
			47: 14.59,
			48: 16.04,
			49: 16.91,
			50: 19.05,
			51: 20.96,
			52: 23.05,
			53: 10.1,
			54: 8.99,
			55: 8.09,
			56: 10.04,
			57: 7.24,
			58: 6.09,
			59: 5.03,
			60: 3.47,
			61: 2.57,
			62: 1.69,
			63: 0.76,
			64: 0,
			65: 0.82,
			66: 1.63,
			67: 2.83,
			68: 4.12,
			69: 5.12,
			70: 6.06,
			71: 7.25,
			72: 8.61,
			73: 7.05,
			74: 6.24,
			75: 5.16,
			76: 3.83,
			77: 1.69,
			78: 2.32,
			79: 3.52,
			80: 4.12,
			81: 4.92,
			82: 4.62,
			83: 3.91,
			84: 4.57,
			85: 5.9,
			86: 6.89,
			87: 7.76,
			88: 8.98,
			89: 7.71,
			90: 8.73,
			91: 10.47,
			92: 11.84,
			93: 13.24,
			94: 6.45,
			95: 7.68,
			96: 8.51,
			97: 9.41,
			98: 10.58,
			99: 15.46,
			100: 13.51,
			101: 12.4,
			102: 10.93,
			103: 9.29,
			104: 8.01,
			105: 7.36,
			106: 6.08,
			107: 5.21,
			108: 2.13,
			109: 0.82,
			110: 2.17,
			111: 2.85,
			112: 3.52,
			113: 4.64,
			114: 5.31,
			115: 6.04,
			116: 6.88,
			117: 7.87,
			118: 8.68,
			119: 10.04,
			120: 11.47,
			121: 12.56,
			122: 7.24,
			123: 8.79,
			124: 8.23,
			125: 7.33,
			126: 6.24,
			127: 7.77,
			128: 8.4,
			129: 9.14,
			130: 8.25,
			131: 7.36,
			132: 6.08,
			133: 7.71,
			134: 8.87,
			135: 10.11
		},
		65: {
			1: 11.99,
			2: 11.31,
			3: 10.8,
			4: 9.66,
			5: 8.89,
			6: 7.3,
			7: 6.48,
			8: 5.34,
			9: 4.6,
			10: 4.09,
			11: 4.3,
			12: 5.23,
			13: 6.71,
			14: 9.29,
			15: 10.62,
			16: 11.9,
			17: 12.73,
			18: 13.74,
			19: 14.87,
			20: 15.74,
			21: 14.54,
			22: 13.69,
			23: 12.65,
			24: 12,
			25: 7.31,
			26: 6.58,
			27: 5.59,
			28: 4.6,
			29: 3.81,
			30: 3.14,
			31: 1.58,
			32: 1.98,
			33: 1.35,
			34: 2.01,
			35: 2.56,
			36: 3.09,
			37: 4.12,
			38: 5.64,
			39: 6.73,
			40: 7.83,
			41: 8.71,
			42: 9.31,
			43: 10.57,
			44: 11.4,
			45: 12.16,
			46: 13.19,
			47: 13.77,
			48: 15.22,
			49: 16.09,
			50: 18.23,
			51: 20.14,
			52: 22.23,
			53: 10.92,
			54: 9.81,
			55: 8.91,
			56: 10.86,
			57: 8.06,
			58: 6.91,
			59: 5.85,
			60: 4.29,
			61: 3.39,
			62: 2.51,
			63: 1.58,
			64: 0.82,
			65: 0,
			66: 0.81,
			67: 2.01,
			68: 3.31,
			69: 4.3,
			70: 5.24,
			71: 6.43,
			72: 7.79,
			73: 7.87,
			74: 7.06,
			75: 5.98,
			76: 4.65,
			77: 2.51,
			78: 3.14,
			79: 2.97,
			80: 3.31,
			81: 4.1,
			82: 3.8,
			83: 3.09,
			84: 3.75,
			85: 5.08,
			86: 6.07,
			87: 6.94,
			88: 8.17,
			89: 6.89,
			90: 7.91,
			91: 9.65,
			92: 11.02,
			93: 12.42,
			94: 5.63,
			95: 6.86,
			96: 7.69,
			97: 8.59,
			98: 9.76,
			99: 14.64,
			100: 12.69,
			101: 11.58,
			102: 10.11,
			103: 8.47,
			104: 7.19,
			105: 6.54,
			106: 5.26,
			107: 4.39,
			108: 1.31,
			109: 0,
			110: 1.35,
			111: 2.03,
			112: 2.97,
			113: 4.09,
			114: 4.76,
			115: 5.48,
			116: 6.33,
			117: 7.31,
			118: 8.13,
			119: 9.49,
			120: 10.91,
			121: 12,
			122: 8.06,
			123: 9.61,
			124: 9.05,
			125: 8.15,
			126: 7.06,
			127: 8.59,
			128: 9.22,
			129: 8.84,
			130: 7.43,
			131: 6.54,
			132: 5.26,
			133: 6.89,
			134: 8.05,
			135: 9.29
		},
		66: {
			1: 12.81,
			2: 12.13,
			3: 11.61,
			4: 10.47,
			5: 9.71,
			6: 8.11,
			7: 7.29,
			8: 6.16,
			9: 5.41,
			10: 4.66,
			11: 3.55,
			12: 4.48,
			13: 5.96,
			14: 8.55,
			15: 9.87,
			16: 11.16,
			17: 11.99,
			18: 13,
			19: 14.13,
			20: 14.99,
			21: 15.11,
			22: 14.26,
			23: 13.22,
			24: 12.58,
			25: 8.13,
			26: 7.39,
			27: 6.4,
			28: 5.41,
			29: 4.62,
			30: 3.96,
			31: 2.4,
			32: 2.55,
			33: 1.92,
			34: 1.26,
			35: 1.81,
			36: 2.34,
			37: 3.37,
			38: 4.89,
			39: 5.98,
			40: 7.08,
			41: 7.96,
			42: 8.56,
			43: 9.82,
			44: 10.65,
			45: 11.41,
			46: 12.44,
			47: 13.02,
			48: 14.47,
			49: 15.34,
			50: 17.48,
			51: 19.39,
			52: 21.48,
			53: 11.74,
			54: 10.63,
			55: 9.73,
			56: 11.67,
			57: 8.88,
			58: 7.73,
			59: 6.67,
			60: 5.11,
			61: 4.21,
			62: 3.33,
			63: 2.4,
			64: 1.63,
			65: 0.81,
			66: 0,
			67: 1.26,
			68: 2.56,
			69: 3.55,
			70: 4.49,
			71: 5.69,
			72: 7.04,
			73: 8.69,
			74: 7.88,
			75: 6.8,
			76: 5.47,
			77: 3.33,
			78: 3.96,
			79: 3.54,
			80: 2.56,
			81: 3.36,
			82: 3.05,
			83: 2.34,
			84: 3,
			85: 4.34,
			86: 5.32,
			87: 6.19,
			88: 7.92,
			89: 7.71,
			90: 8.72,
			91: 10.46,
			92: 11.83,
			93: 13.23,
			94: 4.88,
			95: 6.11,
			96: 6.95,
			97: 7.85,
			98: 9.02,
			99: 15.45,
			100: 13.5,
			101: 12.39,
			102: 10.93,
			103: 9.28,
			104: 8.01,
			105: 7.35,
			106: 6.07,
			107: 5.21,
			108: 2.13,
			109: 0.81,
			110: 1.92,
			111: 2.61,
			112: 3.54,
			113: 4.66,
			114: 5.33,
			115: 6.06,
			116: 6.9,
			117: 7.89,
			118: 8.7,
			119: 10.06,
			120: 11.49,
			121: 12.58,
			122: 8.88,
			123: 10.43,
			124: 9.86,
			125: 8.96,
			126: 7.88,
			127: 9.4,
			128: 10.03,
			129: 9.65,
			130: 8.24,
			131: 7.35,
			132: 6.07,
			133: 7.71,
			134: 8.86,
			135: 10.1
		},
		67: {
			1: 11.69,
			2: 11.01,
			3: 10.49,
			4: 9.35,
			5: 8.59,
			6: 6.99,
			7: 6.17,
			8: 5.04,
			9: 4.29,
			10: 3.4,
			11: 2.29,
			12: 3.22,
			13: 4.7,
			14: 7.28,
			15: 8.61,
			16: 9.9,
			17: 10.72,
			18: 11.73,
			19: 12.86,
			20: 13.73,
			21: 13.85,
			22: 13,
			23: 11.96,
			24: 11.31,
			25: 7.01,
			26: 6.28,
			27: 5.28,
			28: 4.29,
			29: 4.15,
			30: 3.48,
			31: 2.28,
			32: 1.29,
			33: 0.66,
			34: 0,
			35: 0.55,
			36: 1.08,
			37: 2.11,
			38: 3.63,
			39: 4.72,
			40: 5.82,
			41: 6.7,
			42: 7.3,
			43: 8.56,
			44: 9.39,
			45: 10.15,
			46: 11.18,
			47: 11.76,
			48: 13.21,
			49: 14.08,
			50: 16.22,
			51: 18.13,
			52: 20.22,
			53: 11.62,
			54: 10.51,
			55: 9.61,
			56: 11.55,
			57: 8.76,
			58: 7.61,
			59: 6.55,
			60: 4.99,
			61: 4.09,
			62: 3.21,
			63: 2.28,
			64: 2.83,
			65: 2.01,
			66: 1.26,
			67: 0,
			68: 1.3,
			69: 2.29,
			70: 3.23,
			71: 4.42,
			72: 5.78,
			73: 8.57,
			74: 7.76,
			75: 6.68,
			76: 5.35,
			77: 3.21,
			78: 3.48,
			79: 2.28,
			80: 1.3,
			81: 2.09,
			82: 1.79,
			83: 1.08,
			84: 1.74,
			85: 3.07,
			86: 4.06,
			87: 4.93,
			88: 6.65,
			89: 7.93,
			90: 8.94,
			91: 10.68,
			92: 12.05,
			93: 13.45,
			94: 3.62,
			95: 4.85,
			96: 5.68,
			97: 6.59,
			98: 7.75,
			99: 16.65,
			100: 14.7,
			101: 13.59,
			102: 12.12,
			103: 10.48,
			104: 9.2,
			105: 8.55,
			106: 7.27,
			107: 6.4,
			108: 3.32,
			109: 2.01,
			110: 0.66,
			111: 1.34,
			112: 2.28,
			113: 3.4,
			114: 4.07,
			115: 4.8,
			116: 5.64,
			117: 6.62,
			118: 7.44,
			119: 8.8,
			120: 10.22,
			121: 11.31,
			122: 8.76,
			123: 10.31,
			124: 9.75,
			125: 8.85,
			126: 7.76,
			127: 9.29,
			128: 9.92,
			129: 10.66,
			130: 9.44,
			131: 8.55,
			132: 7.27,
			133: 7.93,
			134: 9.08,
			135: 10.32
		},
		68: {
			1: 10.55,
			2: 9.87,
			3: 9.35,
			4: 8.21,
			5: 7.45,
			6: 5.85,
			7: 5.03,
			8: 3.9,
			9: 3.15,
			10: 2.26,
			11: 0.99,
			12: 1.92,
			13: 3.4,
			14: 5.99,
			15: 7.32,
			16: 8.6,
			17: 9.43,
			18: 10.44,
			19: 11.57,
			20: 12.43,
			21: 12.71,
			22: 11.86,
			23: 10.82,
			24: 10.17,
			25: 5.87,
			26: 5.14,
			27: 4.14,
			28: 3.15,
			29: 3.01,
			30: 2.35,
			31: 3.58,
			32: 2.59,
			33: 1.96,
			34: 1.3,
			35: 1.85,
			36: 2.38,
			37: 3.41,
			38: 4.93,
			39: 6.02,
			40: 7.12,
			41: 8,
			42: 8.6,
			43: 9.86,
			44: 10.69,
			45: 11.45,
			46: 12.48,
			47: 13.06,
			48: 14.51,
			49: 15.38,
			50: 17.52,
			51: 19.43,
			52: 21.52,
			53: 12.33,
			54: 11.22,
			55: 10.32,
			56: 12.26,
			57: 9.47,
			58: 8.32,
			59: 7.26,
			60: 5.7,
			61: 4.8,
			62: 3.92,
			63: 3.58,
			64: 4.12,
			65: 3.31,
			66: 2.56,
			67: 1.3,
			68: 0,
			69: 0.99,
			70: 1.93,
			71: 3.13,
			72: 4.48,
			73: 9.28,
			74: 8.47,
			75: 7.39,
			76: 6.06,
			77: 3.92,
			78: 2.35,
			79: 1.14,
			80: 0,
			81: 0.8,
			82: 1.75,
			83: 2.38,
			84: 3.04,
			85: 4.37,
			86: 5.36,
			87: 6.23,
			88: 7.95,
			89: 9.22,
			90: 10.24,
			91: 11.98,
			92: 13.35,
			93: 14.75,
			94: 4.91,
			95: 6.15,
			96: 6.98,
			97: 7.88,
			98: 9.05,
			99: 17.94,
			100: 16,
			101: 14.89,
			102: 13.42,
			103: 11.78,
			104: 10.49,
			105: 9.84,
			106: 8.56,
			107: 7.7,
			108: 4.62,
			109: 3.31,
			110: 1.96,
			111: 2.08,
			112: 1.14,
			113: 2.26,
			114: 2.93,
			115: 3.66,
			116: 4.5,
			117: 5.48,
			118: 6.3,
			119: 7.66,
			120: 9.08,
			121: 10.17,
			122: 9.47,
			123: 11.02,
			124: 10.46,
			125: 9.56,
			126: 8.47,
			127: 10,
			128: 10.63,
			129: 11.37,
			130: 10.74,
			131: 9.84,
			132: 8.56,
			133: 9.22,
			134: 10.38,
			135: 11.62
		},
		69: {
			1: 9.56,
			2: 8.88,
			3: 8.36,
			4: 7.22,
			5: 6.46,
			6: 4.86,
			7: 4.04,
			8: 2.91,
			9: 2.16,
			10: 1.27,
			11: 0,
			12: 0.93,
			13: 2.41,
			14: 5,
			15: 6.32,
			16: 7.61,
			17: 8.44,
			18: 9.45,
			19: 10.58,
			20: 11.44,
			21: 11.72,
			22: 10.87,
			23: 9.83,
			24: 9.18,
			25: 4.88,
			26: 4.14,
			27: 3.15,
			28: 2.16,
			29: 2.95,
			30: 3.34,
			31: 4.57,
			32: 3.58,
			33: 2.95,
			34: 2.29,
			35: 2.84,
			36: 3.37,
			37: 4.4,
			38: 5.92,
			39: 7.01,
			40: 8.11,
			41: 8.99,
			42: 9.59,
			43: 10.85,
			44: 11.68,
			45: 12.44,
			46: 13.47,
			47: 14.05,
			48: 15.5,
			49: 16.37,
			50: 18.51,
			51: 20.42,
			52: 22.51,
			53: 13.32,
			54: 12.21,
			55: 11.31,
			56: 13.26,
			57: 10.46,
			58: 9.31,
			59: 8.25,
			60: 6.69,
			61: 5.79,
			62: 4.91,
			63: 4.57,
			64: 5.12,
			65: 4.3,
			66: 3.55,
			67: 2.29,
			68: 0.99,
			69: 0,
			70: 0.94,
			71: 2.14,
			72: 3.49,
			73: 10.27,
			74: 9.46,
			75: 8.38,
			76: 7.05,
			77: 4.91,
			78: 3.34,
			79: 2.14,
			80: 0.99,
			81: 1.79,
			82: 2.74,
			83: 3.37,
			84: 4.03,
			85: 5.36,
			86: 6.35,
			87: 7.22,
			88: 8.94,
			89: 10.21,
			90: 11.23,
			91: 12.97,
			92: 14.34,
			93: 15.74,
			94: 5.91,
			95: 7.14,
			96: 7.97,
			97: 8.87,
			98: 10.04,
			99: 18.93,
			100: 16.99,
			101: 15.88,
			102: 14.41,
			103: 12.77,
			104: 11.49,
			105: 10.83,
			106: 9.56,
			107: 8.69,
			108: 5.61,
			109: 4.3,
			110: 2.95,
			111: 3.07,
			112: 2.14,
			113: 1.27,
			114: 1.94,
			115: 2.66,
			116: 3.51,
			117: 4.49,
			118: 5.31,
			119: 6.67,
			120: 8.09,
			121: 9.18,
			122: 10.46,
			123: 12.01,
			124: 11.45,
			125: 10.55,
			126: 9.46,
			127: 10.99,
			128: 11.62,
			129: 12.36,
			130: 11.73,
			131: 10.83,
			132: 9.56,
			133: 10.21,
			134: 11.37,
			135: 12.61
		},
		70: {
			1: 10.5,
			2: 9.82,
			3: 9.3,
			4: 8.16,
			5: 7.4,
			6: 5.8,
			7: 4.98,
			8: 3.85,
			9: 3.1,
			10: 2.21,
			11: 0.94,
			12: 1.87,
			13: 3.35,
			14: 5.93,
			15: 7.26,
			16: 8.55,
			17: 9.37,
			18: 10.39,
			19: 11.51,
			20: 12.38,
			21: 12.66,
			22: 11.81,
			23: 10.77,
			24: 10.12,
			25: 5.82,
			26: 5.08,
			27: 4.09,
			28: 3.1,
			29: 3.89,
			30: 4.28,
			31: 5.51,
			32: 4.52,
			33: 3.89,
			34: 3.23,
			35: 3.78,
			36: 4.31,
			37: 5.34,
			38: 6.86,
			39: 7.95,
			40: 9.05,
			41: 9.93,
			42: 10.53,
			43: 11.79,
			44: 12.62,
			45: 13.38,
			46: 14.41,
			47: 14.99,
			48: 16.44,
			49: 17.31,
			50: 19.45,
			51: 21.36,
			52: 23.45,
			53: 14.26,
			54: 13.15,
			55: 12.25,
			56: 14.2,
			57: 11.4,
			58: 10.25,
			59: 9.19,
			60: 7.63,
			61: 6.73,
			62: 5.85,
			63: 5.51,
			64: 6.06,
			65: 5.24,
			66: 4.49,
			67: 3.23,
			68: 1.93,
			69: 0.94,
			70: 0,
			71: 1.2,
			72: 2.55,
			73: 11.21,
			74: 10.4,
			75: 9.32,
			76: 7.99,
			77: 5.85,
			78: 4.28,
			79: 3.08,
			80: 1.93,
			81: 2.73,
			82: 3.68,
			83: 4.31,
			84: 4.97,
			85: 6.3,
			86: 7.29,
			87: 8.16,
			88: 9.88,
			89: 11.15,
			90: 12.17,
			91: 13.91,
			92: 15.28,
			93: 16.68,
			94: 6.85,
			95: 8.08,
			96: 8.91,
			97: 9.81,
			98: 10.98,
			99: 19.87,
			100: 17.93,
			101: 16.82,
			102: 15.35,
			103: 13.71,
			104: 12.42,
			105: 11.77,
			106: 10.49,
			107: 9.63,
			108: 6.55,
			109: 5.24,
			110: 3.89,
			111: 4.01,
			112: 3.08,
			113: 2.21,
			114: 2.87,
			115: 3.6,
			116: 4.44,
			117: 5.43,
			118: 6.25,
			119: 7.61,
			120: 9.03,
			121: 10.12,
			122: 11.4,
			123: 12.95,
			124: 12.39,
			125: 11.49,
			126: 10.4,
			127: 11.93,
			128: 12.56,
			129: 13.3,
			130: 12.67,
			131: 11.77,
			132: 10.49,
			133: 11.15,
			134: 12.31,
			135: 13.55
		},
		71: {
			1: 11.69,
			2: 11.01,
			3: 10.5,
			4: 9.36,
			5: 8.59,
			6: 7,
			7: 6.18,
			8: 5.04,
			9: 4.3,
			10: 3.4,
			11: 2.14,
			12: 3.07,
			13: 4.55,
			14: 7.13,
			15: 8.46,
			16: 9.74,
			17: 10.57,
			18: 11.58,
			19: 12.71,
			20: 13.58,
			21: 13.86,
			22: 13,
			23: 11.96,
			24: 11.32,
			25: 7.01,
			26: 6.28,
			27: 5.29,
			28: 4.3,
			29: 5.09,
			30: 5.47,
			31: 6.7,
			32: 5.71,
			33: 5.08,
			34: 4.42,
			35: 4.97,
			36: 5.5,
			37: 6.53,
			38: 8.05,
			39: 9.14,
			40: 10.24,
			41: 11.12,
			42: 11.72,
			43: 12.98,
			44: 13.81,
			45: 14.57,
			46: 15.6,
			47: 16.18,
			48: 17.63,
			49: 18.5,
			50: 20.64,
			51: 22.55,
			52: 24.64,
			53: 15.46,
			54: 14.35,
			55: 13.45,
			56: 15.39,
			57: 12.6,
			58: 11.45,
			59: 10.39,
			60: 8.83,
			61: 7.93,
			62: 7.05,
			63: 6.7,
			64: 7.25,
			65: 6.43,
			66: 5.69,
			67: 4.42,
			68: 3.13,
			69: 2.14,
			70: 1.2,
			71: 0,
			72: 1.35,
			73: 12.41,
			74: 11.6,
			75: 10.52,
			76: 9.19,
			77: 7.05,
			78: 5.47,
			79: 4.27,
			80: 3.13,
			81: 3.93,
			82: 4.87,
			83: 5.5,
			84: 6.17,
			85: 7.5,
			86: 8.49,
			87: 9.35,
			88: 11.08,
			89: 12.35,
			90: 13.37,
			91: 15.11,
			92: 16.48,
			93: 17.88,
			94: 8.04,
			95: 9.28,
			96: 10.11,
			97: 11.01,
			98: 12.18,
			99: 21.07,
			100: 19.12,
			101: 18.01,
			102: 16.55,
			103: 14.9,
			104: 13.62,
			105: 12.97,
			106: 11.69,
			107: 10.83,
			108: 7.75,
			109: 6.43,
			110: 5.08,
			111: 5.21,
			112: 4.27,
			113: 3.4,
			114: 4.07,
			115: 4.8,
			116: 5.64,
			117: 6.63,
			118: 7.44,
			119: 8.8,
			120: 10.23,
			121: 11.32,
			122: 12.6,
			123: 14.15,
			124: 13.59,
			125: 12.68,
			126: 11.6,
			127: 13.13,
			128: 13.76,
			129: 14.49,
			130: 13.86,
			131: 12.97,
			132: 11.69,
			133: 12.35,
			134: 13.51,
			135: 14.75
		},
		72: {
			1: 13.05,
			2: 12.37,
			3: 11.85,
			4: 10.71,
			5: 9.95,
			6: 8.35,
			7: 7.53,
			8: 6.4,
			9: 5.65,
			10: 4.76,
			11: 3.49,
			12: 4.42,
			13: 5.9,
			14: 8.48,
			15: 9.81,
			16: 11.1,
			17: 11.92,
			18: 12.94,
			19: 14.06,
			20: 14.93,
			21: 15.21,
			22: 14.36,
			23: 13.32,
			24: 12.67,
			25: 8.37,
			26: 7.63,
			27: 6.64,
			28: 5.65,
			29: 6.44,
			30: 6.83,
			31: 8.06,
			32: 7.07,
			33: 6.44,
			34: 5.78,
			35: 6.33,
			36: 6.86,
			37: 7.89,
			38: 9.41,
			39: 10.5,
			40: 11.6,
			41: 12.48,
			42: 13.08,
			43: 14.34,
			44: 15.17,
			45: 15.93,
			46: 16.96,
			47: 17.54,
			48: 18.99,
			49: 19.86,
			50: 22,
			51: 23.91,
			52: 26,
			53: 16.81,
			54: 15.7,
			55: 14.8,
			56: 16.75,
			57: 13.95,
			58: 12.8,
			59: 11.74,
			60: 10.18,
			61: 9.28,
			62: 8.4,
			63: 8.06,
			64: 8.61,
			65: 7.79,
			66: 7.04,
			67: 5.78,
			68: 4.48,
			69: 3.49,
			70: 2.55,
			71: 1.35,
			72: 0,
			73: 13.76,
			74: 12.95,
			75: 11.87,
			76: 10.54,
			77: 8.4,
			78: 6.83,
			79: 5.63,
			80: 4.48,
			81: 5.28,
			82: 6.23,
			83: 6.86,
			84: 7.52,
			85: 8.85,
			86: 9.84,
			87: 10.71,
			88: 12.43,
			89: 13.7,
			90: 14.72,
			91: 16.46,
			92: 17.83,
			93: 19.23,
			94: 9.4,
			95: 10.63,
			96: 11.46,
			97: 12.36,
			98: 13.53,
			99: 22.42,
			100: 20.48,
			101: 19.37,
			102: 17.9,
			103: 16.26,
			104: 14.97,
			105: 14.32,
			106: 13.04,
			107: 12.18,
			108: 9.1,
			109: 7.79,
			110: 6.44,
			111: 6.56,
			112: 5.63,
			113: 4.76,
			114: 5.42,
			115: 6.15,
			116: 6.99,
			117: 7.98,
			118: 8.8,
			119: 10.16,
			120: 11.58,
			121: 12.67,
			122: 13.95,
			123: 15.5,
			124: 14.94,
			125: 14.04,
			126: 12.95,
			127: 14.48,
			128: 15.11,
			129: 15.85,
			130: 15.22,
			131: 14.32,
			132: 13.04,
			133: 13.7,
			134: 14.86,
			135: 16.1
		},
		73: {
			1: 15.79,
			2: 15.11,
			3: 14.59,
			4: 13.45,
			5: 12.69,
			6: 11.09,
			7: 10.27,
			8: 9.14,
			9: 8.39,
			10: 9.26,
			11: 10.27,
			12: 11.2,
			13: 12.68,
			14: 15.27,
			15: 16.6,
			16: 17.88,
			17: 18.71,
			18: 19.72,
			19: 20.85,
			20: 21.33,
			21: 19.71,
			22: 18.85,
			23: 17.81,
			24: 17.17,
			25: 11.11,
			26: 10.37,
			27: 9.38,
			28: 8.39,
			29: 7.6,
			30: 6.94,
			31: 6.29,
			32: 7.28,
			33: 7.91,
			34: 8.57,
			35: 9.12,
			36: 9.65,
			37: 10.68,
			38: 12.2,
			39: 13.29,
			40: 14.39,
			41: 15.27,
			42: 15.87,
			43: 17.13,
			44: 17.96,
			45: 18.72,
			46: 19.75,
			47: 20.33,
			48: 21.78,
			49: 22.65,
			50: 24.79,
			51: 26.7,
			52: 28.79,
			53: 8.09,
			54: 6.98,
			55: 6.08,
			56: 8.03,
			57: 5.23,
			58: 6.38,
			59: 7.44,
			60: 7.14,
			61: 6.24,
			62: 5.36,
			63: 6.29,
			64: 7.05,
			65: 7.87,
			66: 8.69,
			67: 8.57,
			68: 9.28,
			69: 10.27,
			70: 11.21,
			71: 12.41,
			72: 13.76,
			73: 0,
			74: 0.81,
			75: 1.89,
			76: 3.22,
			77: 5.36,
			78: 6.94,
			79: 8.14,
			80: 9.28,
			81: 10.08,
			82: 10.36,
			83: 9.65,
			84: 10.31,
			85: 11.64,
			86: 12.63,
			87: 11.91,
			88: 10.19,
			89: 8.92,
			90: 9.94,
			91: 11.67,
			92: 13.04,
			93: 14.44,
			94: 12.19,
			95: 13.42,
			96: 14.25,
			97: 15.16,
			98: 16.32,
			99: 14.11,
			100: 12.16,
			101: 11.05,
			102: 9.58,
			103: 7.94,
			104: 6.66,
			105: 6.01,
			106: 7.28,
			107: 8.15,
			108: 9.19,
			109: 7.87,
			110: 7.91,
			111: 8.59,
			112: 8.14,
			113: 9.26,
			114: 9.92,
			115: 10.65,
			116: 11.49,
			117: 12.48,
			118: 13.29,
			119: 14.66,
			120: 16.08,
			121: 17.17,
			122: 5.23,
			123: 3.68,
			124: 2.8,
			125: 1.9,
			126: 0.81,
			127: 2.34,
			128: 2.97,
			129: 3.71,
			130: 5.11,
			131: 6.01,
			132: 7.28,
			133: 8.92,
			134: 10.07,
			135: 11.31
		},
		74: {
			1: 14.98,
			2: 14.3,
			3: 13.78,
			4: 12.64,
			5: 11.88,
			6: 10.28,
			7: 9.46,
			8: 8.33,
			9: 7.58,
			10: 8.45,
			11: 9.46,
			12: 10.39,
			13: 11.87,
			14: 14.46,
			15: 15.79,
			16: 17.07,
			17: 17.9,
			18: 18.91,
			19: 20.04,
			20: 20.52,
			21: 18.9,
			22: 18.04,
			23: 17.01,
			24: 16.36,
			25: 10.3,
			26: 9.56,
			27: 8.57,
			28: 7.58,
			29: 6.79,
			30: 6.13,
			31: 5.48,
			32: 6.47,
			33: 7.1,
			34: 7.76,
			35: 8.31,
			36: 8.84,
			37: 9.87,
			38: 11.39,
			39: 12.48,
			40: 13.58,
			41: 14.46,
			42: 15.06,
			43: 16.32,
			44: 17.15,
			45: 17.91,
			46: 18.94,
			47: 19.52,
			48: 20.97,
			49: 21.84,
			50: 23.98,
			51: 25.89,
			52: 27.98,
			53: 7.28,
			54: 6.17,
			55: 5.27,
			56: 7.22,
			57: 4.42,
			58: 5.57,
			59: 6.63,
			60: 6.33,
			61: 5.43,
			62: 4.55,
			63: 5.48,
			64: 6.24,
			65: 7.06,
			66: 7.88,
			67: 7.76,
			68: 8.47,
			69: 9.46,
			70: 10.4,
			71: 11.6,
			72: 12.95,
			73: 0.81,
			74: 0,
			75: 1.08,
			76: 2.41,
			77: 4.55,
			78: 6.13,
			79: 7.33,
			80: 8.47,
			81: 9.27,
			82: 9.55,
			83: 8.84,
			84: 9.5,
			85: 10.83,
			86: 11.82,
			87: 11.1,
			88: 9.38,
			89: 8.11,
			90: 9.13,
			91: 10.86,
			92: 12.23,
			93: 13.63,
			94: 11.38,
			95: 12.61,
			96: 13.44,
			97: 14.35,
			98: 15.51,
			99: 13.3,
			100: 11.35,
			101: 10.24,
			102: 8.77,
			103: 7.13,
			104: 5.85,
			105: 5.2,
			106: 6.47,
			107: 7.34,
			108: 8.38,
			109: 7.06,
			110: 7.1,
			111: 7.78,
			112: 7.33,
			113: 8.45,
			114: 9.11,
			115: 9.84,
			116: 10.68,
			117: 11.67,
			118: 12.48,
			119: 13.85,
			120: 15.27,
			121: 16.36,
			122: 4.42,
			123: 2.87,
			124: 1.99,
			125: 1.09,
			126: 0,
			127: 1.53,
			128: 2.16,
			129: 2.9,
			130: 4.3,
			131: 5.2,
			132: 6.47,
			133: 8.11,
			134: 9.26,
			135: 10.5
		},
		75: {
			1: 13.9,
			2: 13.22,
			3: 12.7,
			4: 11.56,
			5: 10.8,
			6: 9.2,
			7: 8.38,
			8: 7.25,
			9: 6.5,
			10: 7.37,
			11: 8.38,
			12: 9.31,
			13: 10.79,
			14: 13.38,
			15: 14.71,
			16: 15.99,
			17: 16.82,
			18: 17.83,
			19: 18.96,
			20: 19.44,
			21: 17.82,
			22: 16.96,
			23: 15.92,
			24: 15.28,
			25: 9.22,
			26: 8.48,
			27: 7.49,
			28: 6.5,
			29: 5.71,
			30: 5.05,
			31: 4.4,
			32: 5.39,
			33: 6.02,
			34: 6.68,
			35: 7.23,
			36: 7.76,
			37: 8.79,
			38: 10.31,
			39: 11.4,
			40: 12.5,
			41: 13.38,
			42: 13.98,
			43: 15.24,
			44: 16.07,
			45: 16.83,
			46: 17.86,
			47: 18.44,
			48: 19.89,
			49: 20.76,
			50: 22.9,
			51: 24.81,
			52: 26.9,
			53: 8.36,
			54: 7.25,
			55: 6.35,
			56: 8.3,
			57: 5.5,
			58: 6.65,
			59: 6.81,
			60: 5.25,
			61: 4.35,
			62: 3.47,
			63: 4.4,
			64: 5.16,
			65: 5.98,
			66: 6.8,
			67: 6.68,
			68: 7.39,
			69: 8.38,
			70: 9.32,
			71: 10.52,
			72: 11.87,
			73: 1.89,
			74: 1.08,
			75: 0,
			76: 1.33,
			77: 3.47,
			78: 5.05,
			79: 6.25,
			80: 7.39,
			81: 8.19,
			82: 8.47,
			83: 7.76,
			84: 8.42,
			85: 9.75,
			86: 10.74,
			87: 11.61,
			88: 10.46,
			89: 9.19,
			90: 10.21,
			91: 11.94,
			92: 13.31,
			93: 14.71,
			94: 10.3,
			95: 11.53,
			96: 12.36,
			97: 13.27,
			98: 14.43,
			99: 14.38,
			100: 12.43,
			101: 11.32,
			102: 9.85,
			103: 8.21,
			104: 6.93,
			105: 6.28,
			106: 7.55,
			107: 8.42,
			108: 7.3,
			109: 5.98,
			110: 6.02,
			111: 6.7,
			112: 6.25,
			113: 7.37,
			114: 8.03,
			115: 8.76,
			116: 9.6,
			117: 10.59,
			118: 11.4,
			119: 12.77,
			120: 14.19,
			121: 15.28,
			122: 5.5,
			123: 3.95,
			124: 3.07,
			125: 2.17,
			126: 1.08,
			127: 2.61,
			128: 3.24,
			129: 3.98,
			130: 5.38,
			131: 6.28,
			132: 7.55,
			133: 9.19,
			134: 10.34,
			135: 11.58
		},
		76: {
			1: 12.57,
			2: 11.89,
			3: 11.37,
			4: 10.23,
			5: 9.47,
			6: 7.87,
			7: 7.05,
			8: 5.92,
			9: 5.17,
			10: 6.04,
			11: 7.05,
			12: 7.98,
			13: 9.46,
			14: 12.05,
			15: 13.38,
			16: 14.66,
			17: 15.49,
			18: 16.5,
			19: 17.63,
			20: 18.11,
			21: 16.49,
			22: 15.63,
			23: 14.59,
			24: 13.95,
			25: 7.89,
			26: 7.15,
			27: 6.16,
			28: 5.17,
			29: 4.38,
			30: 3.72,
			31: 3.07,
			32: 4.06,
			33: 4.69,
			34: 5.35,
			35: 5.9,
			36: 6.43,
			37: 7.46,
			38: 8.98,
			39: 10.07,
			40: 11.17,
			41: 12.05,
			42: 12.65,
			43: 13.91,
			44: 14.74,
			45: 15.5,
			46: 16.53,
			47: 17.11,
			48: 18.56,
			49: 19.43,
			50: 21.57,
			51: 23.48,
			52: 25.57,
			53: 9.69,
			54: 8.58,
			55: 7.68,
			56: 9.63,
			57: 6.83,
			58: 6.54,
			59: 5.48,
			60: 3.92,
			61: 3.02,
			62: 2.14,
			63: 3.07,
			64: 3.83,
			65: 4.65,
			66: 5.47,
			67: 5.35,
			68: 6.06,
			69: 7.05,
			70: 7.99,
			71: 9.19,
			72: 10.54,
			73: 3.22,
			74: 2.41,
			75: 1.33,
			76: 0,
			77: 2.14,
			78: 3.72,
			79: 4.92,
			80: 6.06,
			81: 6.86,
			82: 7.14,
			83: 6.43,
			84: 7.09,
			85: 8.42,
			86: 9.41,
			87: 10.28,
			88: 11.79,
			89: 10.52,
			90: 11.54,
			91: 13.27,
			92: 14.64,
			93: 16.04,
			94: 8.97,
			95: 10.2,
			96: 11.03,
			97: 11.94,
			98: 13.1,
			99: 15.71,
			100: 13.76,
			101: 12.65,
			102: 11.18,
			103: 9.54,
			104: 8.26,
			105: 7.61,
			106: 8.88,
			107: 9.05,
			108: 5.97,
			109: 4.65,
			110: 4.69,
			111: 5.37,
			112: 4.92,
			113: 6.04,
			114: 6.7,
			115: 7.43,
			116: 8.27,
			117: 9.26,
			118: 10.07,
			119: 11.44,
			120: 12.86,
			121: 13.95,
			122: 6.83,
			123: 5.28,
			124: 4.4,
			125: 3.5,
			126: 2.41,
			127: 3.94,
			128: 4.57,
			129: 5.31,
			130: 6.71,
			131: 7.61,
			132: 8.88,
			133: 10.52,
			134: 11.67,
			135: 12.91
		},
		77: {
			1: 10.43,
			2: 9.75,
			3: 9.23,
			4: 8.09,
			5: 7.33,
			6: 5.73,
			7: 4.91,
			8: 3.78,
			9: 3.03,
			10: 3.9,
			11: 4.91,
			12: 5.84,
			13: 7.32,
			14: 9.91,
			15: 11.24,
			16: 12.52,
			17: 13.35,
			18: 14.36,
			19: 15.49,
			20: 15.97,
			21: 14.35,
			22: 13.49,
			23: 12.45,
			24: 11.81,
			25: 5.75,
			26: 5.01,
			27: 4.02,
			28: 3.03,
			29: 2.24,
			30: 1.58,
			31: 0.93,
			32: 1.92,
			33: 2.55,
			34: 3.21,
			35: 3.76,
			36: 4.29,
			37: 5.32,
			38: 6.84,
			39: 7.93,
			40: 9.03,
			41: 9.91,
			42: 10.51,
			43: 11.77,
			44: 12.6,
			45: 13.36,
			46: 14.39,
			47: 14.97,
			48: 16.42,
			49: 17.29,
			50: 19.43,
			51: 21.34,
			52: 23.43,
			53: 8.41,
			54: 7.3,
			55: 6.4,
			56: 8.34,
			57: 5.55,
			58: 4.4,
			59: 3.34,
			60: 1.78,
			61: 0.88,
			62: 0,
			63: 0.93,
			64: 1.69,
			65: 2.51,
			66: 3.33,
			67: 3.21,
			68: 3.92,
			69: 4.91,
			70: 5.85,
			71: 7.05,
			72: 8.4,
			73: 5.36,
			74: 4.55,
			75: 3.47,
			76: 2.14,
			77: 0,
			78: 1.58,
			79: 2.78,
			80: 3.92,
			81: 4.72,
			82: 5.01,
			83: 4.29,
			84: 4.95,
			85: 6.28,
			86: 7.27,
			87: 8.14,
			88: 9.86,
			89: 9.4,
			90: 10.42,
			91: 12.16,
			92: 13.53,
			93: 14.93,
			94: 6.83,
			95: 8.06,
			96: 8.89,
			97: 9.8,
			98: 10.96,
			99: 17.15,
			100: 15.2,
			101: 14.09,
			102: 12.63,
			103: 10.98,
			104: 9.7,
			105: 9.05,
			106: 7.77,
			107: 6.91,
			108: 3.83,
			109: 2.51,
			110: 2.55,
			111: 3.23,
			112: 2.78,
			113: 3.9,
			114: 4.56,
			115: 5.29,
			116: 6.13,
			117: 7.12,
			118: 7.93,
			119: 9.3,
			120: 10.72,
			121: 11.81,
			122: 5.55,
			123: 7.1,
			124: 6.54,
			125: 5.64,
			126: 4.55,
			127: 6.08,
			128: 6.71,
			129: 7.45,
			130: 8.85,
			131: 9.05,
			132: 7.77,
			133: 9.4,
			134: 10.56,
			135: 11.8
		},
		78: {
			1: 8.85,
			2: 8.17,
			3: 7.66,
			4: 6.51,
			5: 5.75,
			6: 4.16,
			7: 3.34,
			8: 2.2,
			9: 1.46,
			10: 2.32,
			11: 3.34,
			12: 4.27,
			13: 5.75,
			14: 8.33,
			15: 9.66,
			16: 10.94,
			17: 11.77,
			18: 12.78,
			19: 13.91,
			20: 14.4,
			21: 12.77,
			22: 11.92,
			23: 10.88,
			24: 10.23,
			25: 4.17,
			26: 3.44,
			27: 2.44,
			28: 1.46,
			29: 0.67,
			30: 0,
			31: 1.56,
			32: 2.55,
			33: 2.82,
			34: 3.48,
			35: 4.03,
			36: 4.56,
			37: 5.59,
			38: 7.11,
			39: 8.2,
			40: 9.3,
			41: 10.18,
			42: 10.78,
			43: 12.04,
			44: 12.87,
			45: 13.63,
			46: 14.66,
			47: 15.24,
			48: 16.69,
			49: 17.56,
			50: 19.7,
			51: 21.61,
			52: 23.7,
			53: 9.99,
			54: 8.88,
			55: 7.98,
			56: 9.92,
			57: 7.13,
			58: 5.98,
			59: 4.92,
			60: 3.36,
			61: 2.46,
			62: 1.58,
			63: 1.56,
			64: 2.32,
			65: 3.14,
			66: 3.96,
			67: 3.48,
			68: 2.35,
			69: 3.34,
			70: 4.28,
			71: 5.47,
			72: 6.83,
			73: 6.94,
			74: 6.13,
			75: 5.05,
			76: 3.72,
			77: 1.58,
			78: 0,
			79: 1.2,
			80: 2.35,
			81: 3.14,
			82: 4.09,
			83: 4.56,
			84: 5.22,
			85: 6.56,
			86: 7.54,
			87: 8.41,
			88: 10.14,
			89: 10.03,
			90: 11.05,
			91: 12.79,
			92: 14.16,
			93: 15.56,
			94: 7.1,
			95: 8.33,
			96: 9.17,
			97: 10.07,
			98: 11.23,
			99: 17.78,
			100: 15.83,
			101: 14.72,
			102: 13.26,
			103: 11.61,
			104: 10.33,
			105: 9.68,
			106: 8.4,
			107: 7.54,
			108: 4.46,
			109: 3.14,
			110: 2.82,
			111: 2.14,
			112: 1.2,
			113: 2.32,
			114: 2.99,
			115: 3.72,
			116: 4.56,
			117: 5.54,
			118: 6.36,
			119: 7.72,
			120: 9.14,
			121: 10.23,
			122: 7.13,
			123: 8.68,
			124: 8.11,
			125: 7.21,
			126: 6.13,
			127: 7.65,
			128: 8.28,
			129: 9.02,
			130: 10.43,
			131: 9.68,
			132: 8.4,
			133: 10.03,
			134: 11.19,
			135: 12.43
		},
		79: {
			1: 9.41,
			2: 8.73,
			3: 8.21,
			4: 7.07,
			5: 6.31,
			6: 4.71,
			7: 3.89,
			8: 2.76,
			9: 2.01,
			10: 1.12,
			11: 2.14,
			12: 3.07,
			13: 4.55,
			14: 7.13,
			15: 8.46,
			16: 9.74,
			17: 10.57,
			18: 11.58,
			19: 12.71,
			20: 13.2,
			21: 11.57,
			22: 10.72,
			23: 9.68,
			24: 9.03,
			25: 4.73,
			26: 3.99,
			27: 3,
			28: 2.01,
			29: 1.87,
			30: 1.2,
			31: 2.76,
			32: 2.25,
			33: 1.62,
			34: 2.28,
			35: 2.83,
			36: 3.36,
			37: 4.39,
			38: 5.91,
			39: 7,
			40: 8.1,
			41: 8.98,
			42: 9.58,
			43: 10.84,
			44: 11.67,
			45: 12.43,
			46: 13.46,
			47: 14.04,
			48: 15.49,
			49: 16.36,
			50: 18.5,
			51: 20.41,
			52: 22.5,
			53: 11.19,
			54: 10.08,
			55: 9.18,
			56: 11.12,
			57: 8.33,
			58: 7.18,
			59: 6.12,
			60: 4.56,
			61: 3.66,
			62: 2.78,
			63: 2.76,
			64: 3.52,
			65: 2.97,
			66: 3.54,
			67: 2.28,
			68: 1.14,
			69: 2.14,
			70: 3.08,
			71: 4.27,
			72: 5.63,
			73: 8.14,
			74: 7.33,
			75: 6.25,
			76: 4.92,
			77: 2.78,
			78: 1.2,
			79: 0,
			80: 1.14,
			81: 1.94,
			82: 2.89,
			83: 3.36,
			84: 4.02,
			85: 5.35,
			86: 6.34,
			87: 7.21,
			88: 8.93,
			89: 9.86,
			90: 10.88,
			91: 12.62,
			92: 13.99,
			93: 15.39,
			94: 5.9,
			95: 7.13,
			96: 7.97,
			97: 8.87,
			98: 10.03,
			99: 17.61,
			100: 15.66,
			101: 14.55,
			102: 13.08,
			103: 11.44,
			104: 10.16,
			105: 9.51,
			106: 8.23,
			107: 7.36,
			108: 4.28,
			109: 2.97,
			110: 1.62,
			111: 0.94,
			112: 0,
			113: 1.12,
			114: 1.79,
			115: 2.51,
			116: 3.36,
			117: 4.34,
			118: 5.16,
			119: 6.52,
			120: 7.94,
			121: 9.03,
			122: 8.33,
			123: 9.88,
			124: 9.31,
			125: 8.41,
			126: 7.33,
			127: 8.85,
			128: 9.48,
			129: 10.22,
			130: 10.4,
			131: 9.51,
			132: 8.23,
			133: 9.86,
			134: 11.02,
			135: 12.26
		},
		80: {
			1: 10.55,
			2: 9.87,
			3: 9.35,
			4: 8.21,
			5: 7.45,
			6: 5.85,
			7: 5.03,
			8: 3.9,
			9: 3.15,
			10: 2.26,
			11: 0.99,
			12: 1.92,
			13: 3.4,
			14: 5.99,
			15: 7.32,
			16: 8.6,
			17: 9.43,
			18: 10.44,
			19: 11.57,
			20: 12.43,
			21: 12.71,
			22: 11.86,
			23: 10.82,
			24: 10.17,
			25: 5.87,
			26: 5.14,
			27: 4.14,
			28: 3.15,
			29: 3.01,
			30: 2.35,
			31: 3.58,
			32: 2.59,
			33: 1.96,
			34: 1.3,
			35: 1.85,
			36: 2.38,
			37: 3.41,
			38: 4.93,
			39: 6.02,
			40: 7.12,
			41: 8,
			42: 8.6,
			43: 9.86,
			44: 10.69,
			45: 11.45,
			46: 12.48,
			47: 13.06,
			48: 14.51,
			49: 15.38,
			50: 17.52,
			51: 19.43,
			52: 21.52,
			53: 12.33,
			54: 11.22,
			55: 10.32,
			56: 12.26,
			57: 9.47,
			58: 8.32,
			59: 7.26,
			60: 5.7,
			61: 4.8,
			62: 3.92,
			63: 3.58,
			64: 4.12,
			65: 3.31,
			66: 2.56,
			67: 1.3,
			68: 0,
			69: 0.99,
			70: 1.93,
			71: 3.13,
			72: 4.48,
			73: 9.28,
			74: 8.47,
			75: 7.39,
			76: 6.06,
			77: 3.92,
			78: 2.35,
			79: 1.14,
			80: 0,
			81: 0.8,
			82: 1.75,
			83: 2.38,
			84: 3.04,
			85: 4.37,
			86: 5.36,
			87: 6.23,
			88: 7.95,
			89: 9.22,
			90: 10.24,
			91: 11.98,
			92: 13.35,
			93: 14.75,
			94: 4.91,
			95: 6.15,
			96: 6.98,
			97: 7.88,
			98: 9.05,
			99: 17.94,
			100: 16,
			101: 14.89,
			102: 13.42,
			103: 11.78,
			104: 10.49,
			105: 9.84,
			106: 8.56,
			107: 7.7,
			108: 4.62,
			109: 3.31,
			110: 1.96,
			111: 2.08,
			112: 1.14,
			113: 2.26,
			114: 2.93,
			115: 3.66,
			116: 4.5,
			117: 5.48,
			118: 6.3,
			119: 7.66,
			120: 9.08,
			121: 10.17,
			122: 9.47,
			123: 11.02,
			124: 10.46,
			125: 9.56,
			126: 8.47,
			127: 10,
			128: 10.63,
			129: 11.37,
			130: 10.74,
			131: 9.84,
			132: 8.56,
			133: 9.22,
			134: 10.38,
			135: 11.62
		},
		81: {
			1: 11.35,
			2: 10.67,
			3: 10.15,
			4: 9.01,
			5: 8.25,
			6: 6.65,
			7: 5.83,
			8: 4.7,
			9: 3.95,
			10: 3.06,
			11: 1.79,
			12: 2.72,
			13: 4.2,
			14: 6.79,
			15: 8.11,
			16: 9.4,
			17: 10.23,
			18: 11.24,
			19: 12.37,
			20: 13.23,
			21: 13.51,
			22: 12.66,
			23: 11.62,
			24: 10.97,
			25: 6.67,
			26: 5.93,
			27: 4.94,
			28: 3.95,
			29: 3.81,
			30: 3.14,
			31: 4.37,
			32: 3.38,
			33: 2.75,
			34: 2.09,
			35: 2.19,
			36: 1.66,
			37: 2.69,
			38: 4.21,
			39: 5.3,
			40: 6.4,
			41: 7.28,
			42: 7.88,
			43: 9.14,
			44: 9.97,
			45: 10.73,
			46: 11.76,
			47: 12.34,
			48: 13.79,
			49: 14.66,
			50: 16.8,
			51: 18.71,
			52: 20.8,
			53: 13.13,
			54: 12.02,
			55: 11.12,
			56: 13.06,
			57: 10.27,
			58: 9.12,
			59: 8.06,
			60: 6.5,
			61: 5.6,
			62: 4.72,
			63: 4.37,
			64: 4.92,
			65: 4.1,
			66: 3.36,
			67: 2.09,
			68: 0.8,
			69: 1.79,
			70: 2.73,
			71: 3.93,
			72: 5.28,
			73: 10.08,
			74: 9.27,
			75: 8.19,
			76: 6.86,
			77: 4.72,
			78: 3.14,
			79: 1.94,
			80: 0.8,
			81: 0,
			82: 0.95,
			83: 1.66,
			84: 2.32,
			85: 3.65,
			86: 4.64,
			87: 5.51,
			88: 7.23,
			89: 8.51,
			90: 9.52,
			91: 11.26,
			92: 12.63,
			93: 14.03,
			94: 4.2,
			95: 5.43,
			96: 6.26,
			97: 7.16,
			98: 8.33,
			99: 18.74,
			100: 16.79,
			101: 15.68,
			102: 14.22,
			103: 12.57,
			104: 11.29,
			105: 10.64,
			106: 9.36,
			107: 8.5,
			108: 5.42,
			109: 4.1,
			110: 2.75,
			111: 2.88,
			112: 1.94,
			113: 3.06,
			114: 3.73,
			115: 4.45,
			116: 5.3,
			117: 6.28,
			118: 7.1,
			119: 8.46,
			120: 9.88,
			121: 10.97,
			122: 10.27,
			123: 11.82,
			124: 11.26,
			125: 10.35,
			126: 9.27,
			127: 10.8,
			128: 11.43,
			129: 12.16,
			130: 11.53,
			131: 10.64,
			132: 9.36,
			133: 8.51,
			134: 9.66,
			135: 10.9
		},
		82: {
			1: 12.3,
			2: 11.61,
			3: 11.1,
			4: 9.96,
			5: 9.2,
			6: 7.6,
			7: 6.78,
			8: 5.64,
			9: 4.9,
			10: 4.01,
			11: 2.74,
			12: 3.67,
			13: 5.15,
			14: 7.73,
			15: 9.06,
			16: 10.35,
			17: 11.17,
			18: 12.18,
			19: 13.31,
			20: 14.18,
			21: 14.46,
			22: 13.6,
			23: 12.57,
			24: 11.92,
			25: 7.62,
			26: 6.88,
			27: 5.89,
			28: 4.9,
			29: 4.76,
			30: 4.09,
			31: 4.07,
			32: 3.08,
			33: 2.45,
			34: 1.79,
			35: 1.24,
			36: 0.71,
			37: 1.74,
			38: 3.26,
			39: 4.35,
			40: 5.45,
			41: 6.33,
			42: 6.93,
			43: 8.19,
			44: 9.02,
			45: 9.78,
			46: 10.81,
			47: 11.39,
			48: 12.84,
			49: 13.71,
			50: 15.85,
			51: 17.76,
			52: 19.85,
			53: 13.41,
			54: 12.3,
			55: 11.4,
			56: 13.35,
			57: 10.55,
			58: 9.4,
			59: 8.34,
			60: 6.78,
			61: 5.88,
			62: 5.01,
			63: 4.07,
			64: 4.62,
			65: 3.8,
			66: 3.05,
			67: 1.79,
			68: 1.75,
			69: 2.74,
			70: 3.68,
			71: 4.87,
			72: 6.23,
			73: 10.36,
			74: 9.55,
			75: 8.47,
			76: 7.14,
			77: 5.01,
			78: 4.09,
			79: 2.89,
			80: 1.75,
			81: 0.95,
			82: 0,
			83: 0.71,
			84: 1.37,
			85: 2.7,
			86: 3.69,
			87: 4.56,
			88: 6.28,
			89: 7.56,
			90: 8.58,
			91: 10.31,
			92: 11.68,
			93: 13.08,
			94: 3.25,
			95: 4.48,
			96: 5.32,
			97: 6.22,
			98: 7.38,
			99: 18.44,
			100: 16.49,
			101: 15.38,
			102: 13.91,
			103: 12.27,
			104: 10.99,
			105: 10.34,
			106: 9.06,
			107: 8.19,
			108: 5.11,
			109: 3.8,
			110: 2.45,
			111: 3.13,
			112: 2.89,
			113: 4.01,
			114: 4.67,
			115: 5.4,
			116: 6.24,
			117: 7.23,
			118: 8.04,
			119: 9.41,
			120: 10.83,
			121: 11.92,
			122: 10.55,
			123: 12.1,
			124: 11.54,
			125: 10.64,
			126: 9.55,
			127: 11.08,
			128: 11.71,
			129: 12.45,
			130: 11.23,
			131: 10.34,
			132: 9.06,
			133: 7.56,
			134: 8.71,
			135: 9.95
		},
		83: {
			1: 12.77,
			2: 12.09,
			3: 11.57,
			4: 10.43,
			5: 9.67,
			6: 8.07,
			7: 7.25,
			8: 6.12,
			9: 5.37,
			10: 4.48,
			11: 3.37,
			12: 4.3,
			13: 5.78,
			14: 8.36,
			15: 9.69,
			16: 10.98,
			17: 11.8,
			18: 12.81,
			19: 13.94,
			20: 14.81,
			21: 14.93,
			22: 14.08,
			23: 13.04,
			24: 12.39,
			25: 8.09,
			26: 7.36,
			27: 6.36,
			28: 5.37,
			29: 5.23,
			30: 4.56,
			31: 3.36,
			32: 2.37,
			33: 1.74,
			34: 1.08,
			35: 0.53,
			36: 0,
			37: 1.03,
			38: 2.55,
			39: 3.64,
			40: 4.74,
			41: 5.62,
			42: 6.22,
			43: 7.48,
			44: 8.31,
			45: 9.07,
			46: 10.1,
			47: 10.68,
			48: 12.13,
			49: 13,
			50: 15.14,
			51: 17.05,
			52: 19.14,
			53: 12.7,
			54: 11.59,
			55: 10.69,
			56: 12.63,
			57: 9.84,
			58: 8.69,
			59: 7.63,
			60: 6.07,
			61: 5.17,
			62: 4.29,
			63: 3.36,
			64: 3.91,
			65: 3.09,
			66: 2.34,
			67: 1.08,
			68: 2.38,
			69: 3.37,
			70: 4.31,
			71: 5.5,
			72: 6.86,
			73: 9.65,
			74: 8.84,
			75: 7.76,
			76: 6.43,
			77: 4.29,
			78: 4.56,
			79: 3.36,
			80: 2.38,
			81: 1.66,
			82: 0.71,
			83: 0,
			84: 0.66,
			85: 1.99,
			86: 2.98,
			87: 3.85,
			88: 5.57,
			89: 6.85,
			90: 7.86,
			91: 9.6,
			92: 10.97,
			93: 12.37,
			94: 2.54,
			95: 3.77,
			96: 4.6,
			97: 5.51,
			98: 6.67,
			99: 17.73,
			100: 15.78,
			101: 14.67,
			102: 13.2,
			103: 11.56,
			104: 10.28,
			105: 9.63,
			106: 8.35,
			107: 7.48,
			108: 4.4,
			109: 3.09,
			110: 1.74,
			111: 2.42,
			112: 3.36,
			113: 4.48,
			114: 5.15,
			115: 5.88,
			116: 6.72,
			117: 7.7,
			118: 8.52,
			119: 9.88,
			120: 11.3,
			121: 12.39,
			122: 9.84,
			123: 11.39,
			124: 10.83,
			125: 9.93,
			126: 8.84,
			127: 10.37,
			128: 11,
			129: 11.74,
			130: 10.52,
			131: 9.63,
			132: 8.35,
			133: 6.85,
			134: 8.01,
			135: 9.24
		},
		84: {
			1: 13.43,
			2: 12.75,
			3: 12.24,
			4: 11.09,
			5: 10.33,
			6: 8.74,
			7: 7.91,
			8: 6.78,
			9: 6.03,
			10: 5.14,
			11: 4.03,
			12: 4.96,
			13: 6.44,
			14: 9.02,
			15: 10.35,
			16: 11.64,
			17: 12.46,
			18: 13.48,
			19: 14.6,
			20: 15.47,
			21: 15.59,
			22: 14.74,
			23: 13.7,
			24: 13.05,
			25: 8.75,
			26: 8.02,
			27: 7.02,
			28: 6.03,
			29: 5.89,
			30: 5.22,
			31: 4.02,
			32: 3.03,
			33: 2.4,
			34: 1.74,
			35: 1.19,
			36: 0.66,
			37: 1.69,
			38: 3.21,
			39: 4.3,
			40: 5.4,
			41: 6.28,
			42: 6.88,
			43: 8.14,
			44: 8.97,
			45: 9.73,
			46: 10.76,
			47: 11.34,
			48: 12.79,
			49: 13.66,
			50: 15.8,
			51: 17.71,
			52: 19.8,
			53: 13.36,
			54: 12.25,
			55: 11.35,
			56: 13.3,
			57: 10.5,
			58: 9.35,
			59: 8.29,
			60: 6.73,
			61: 5.83,
			62: 4.95,
			63: 4.02,
			64: 4.57,
			65: 3.75,
			66: 3,
			67: 1.74,
			68: 3.04,
			69: 4.03,
			70: 4.97,
			71: 6.17,
			72: 7.52,
			73: 10.31,
			74: 9.5,
			75: 8.42,
			76: 7.09,
			77: 4.95,
			78: 5.22,
			79: 4.02,
			80: 3.04,
			81: 2.32,
			82: 1.37,
			83: 0.66,
			84: 0,
			85: 1.33,
			86: 2.32,
			87: 3.19,
			88: 4.91,
			89: 6.19,
			90: 7.2,
			91: 8.94,
			92: 10.31,
			93: 11.71,
			94: 1.88,
			95: 3.11,
			96: 3.94,
			97: 4.84,
			98: 6.01,
			99: 17.2,
			100: 15.25,
			101: 14.14,
			102: 12.67,
			103: 11.03,
			104: 9.75,
			105: 9.1,
			106: 7.82,
			107: 8.14,
			108: 5.06,
			109: 3.75,
			110: 2.4,
			111: 3.08,
			112: 4.02,
			113: 5.14,
			114: 5.81,
			115: 6.54,
			116: 7.38,
			117: 8.36,
			118: 9.18,
			119: 10.54,
			120: 11.97,
			121: 13.05,
			122: 10.5,
			123: 12.05,
			124: 11.49,
			125: 10.59,
			126: 9.5,
			127: 11.03,
			128: 11.66,
			129: 11.4,
			130: 9.99,
			131: 9.1,
			132: 7.82,
			133: 6.19,
			134: 7.34,
			135: 8.58
		},
		85: {
			1: 14.76,
			2: 14.08,
			3: 13.57,
			4: 12.43,
			5: 11.66,
			6: 10.07,
			7: 9.25,
			8: 8.11,
			9: 7.37,
			10: 6.47,
			11: 5.36,
			12: 6.29,
			13: 7.77,
			14: 10.36,
			15: 11.68,
			16: 12.97,
			17: 13.8,
			18: 14.81,
			19: 15.94,
			20: 16.8,
			21: 16.92,
			22: 16.07,
			23: 15.03,
			24: 14.39,
			25: 10.08,
			26: 9.35,
			27: 8.35,
			28: 7.37,
			29: 7.22,
			30: 6.56,
			31: 5.35,
			32: 4.36,
			33: 3.73,
			34: 3.07,
			35: 2.52,
			36: 1.99,
			37: 3.02,
			38: 4.54,
			39: 5.63,
			40: 6.73,
			41: 7.61,
			42: 8.21,
			43: 9.47,
			44: 10.3,
			45: 11.06,
			46: 12.09,
			47: 12.67,
			48: 14.12,
			49: 14.99,
			50: 17.13,
			51: 19.04,
			52: 21.13,
			53: 14.69,
			54: 13.58,
			55: 12.68,
			56: 14.63,
			57: 11.83,
			58: 10.68,
			59: 9.62,
			60: 8.06,
			61: 7.16,
			62: 6.28,
			63: 5.35,
			64: 5.9,
			65: 5.08,
			66: 4.34,
			67: 3.07,
			68: 4.37,
			69: 5.36,
			70: 6.3,
			71: 7.5,
			72: 8.85,
			73: 11.64,
			74: 10.83,
			75: 9.75,
			76: 8.42,
			77: 6.28,
			78: 6.56,
			79: 5.35,
			80: 4.37,
			81: 3.65,
			82: 2.7,
			83: 1.99,
			84: 1.33,
			85: 0,
			86: 0.99,
			87: 1.86,
			88: 3.58,
			89: 4.85,
			90: 5.87,
			91: 7.61,
			92: 8.98,
			93: 10.38,
			94: 3.21,
			95: 4.44,
			96: 5.28,
			97: 6.18,
			98: 7.34,
			99: 15.87,
			100: 13.92,
			101: 12.81,
			102: 11.34,
			103: 9.7,
			104: 8.42,
			105: 7.77,
			106: 6.49,
			107: 7.35,
			108: 6.4,
			109: 5.08,
			110: 3.73,
			111: 4.42,
			112: 5.35,
			113: 6.47,
			114: 7.14,
			115: 7.87,
			116: 8.71,
			117: 9.7,
			118: 10.51,
			119: 11.87,
			120: 13.3,
			121: 14.39,
			122: 11.83,
			123: 13.38,
			124: 12.82,
			125: 11.92,
			126: 10.83,
			127: 11.43,
			128: 10.8,
			129: 10.07,
			130: 8.66,
			131: 7.77,
			132: 6.49,
			133: 4.85,
			134: 6.01,
			135: 7.25
		},
		86: {
			1: 15.75,
			2: 15.07,
			3: 14.56,
			4: 13.41,
			5: 12.65,
			6: 11.06,
			7: 10.23,
			8: 9.1,
			9: 8.35,
			10: 7.46,
			11: 6.35,
			12: 7.28,
			13: 8.76,
			14: 11.34,
			15: 12.67,
			16: 13.96,
			17: 14.78,
			18: 15.8,
			19: 16.92,
			20: 17.79,
			21: 17.91,
			22: 17.06,
			23: 16.02,
			24: 15.37,
			25: 11.07,
			26: 10.34,
			27: 9.34,
			28: 8.35,
			29: 8.21,
			30: 7.54,
			31: 6.34,
			32: 5.35,
			33: 4.72,
			34: 4.06,
			35: 3.51,
			36: 2.98,
			37: 4.01,
			38: 5.53,
			39: 6.62,
			40: 7.72,
			41: 8.6,
			42: 9.2,
			43: 10.46,
			44: 11.29,
			45: 12.05,
			46: 13.08,
			47: 13.66,
			48: 15.11,
			49: 15.98,
			50: 18.12,
			51: 20.03,
			52: 22.12,
			53: 15.68,
			54: 14.57,
			55: 13.67,
			56: 15.62,
			57: 12.82,
			58: 11.67,
			59: 10.61,
			60: 9.05,
			61: 8.15,
			62: 7.27,
			63: 6.34,
			64: 6.89,
			65: 6.07,
			66: 5.32,
			67: 4.06,
			68: 5.36,
			69: 6.35,
			70: 7.29,
			71: 8.49,
			72: 9.84,
			73: 12.63,
			74: 11.82,
			75: 10.74,
			76: 9.41,
			77: 7.27,
			78: 7.54,
			79: 6.34,
			80: 5.36,
			81: 4.64,
			82: 3.69,
			83: 2.98,
			84: 2.32,
			85: 0.99,
			86: 0,
			87: 0.87,
			88: 2.59,
			89: 3.87,
			90: 4.88,
			91: 6.62,
			92: 7.99,
			93: 9.39,
			94: 4.2,
			95: 5.43,
			96: 6.26,
			97: 7.16,
			98: 8.33,
			99: 14.88,
			100: 12.93,
			101: 11.82,
			102: 10.35,
			103: 8.71,
			104: 7.43,
			105: 6.78,
			106: 5.5,
			107: 6.36,
			108: 7.38,
			109: 6.07,
			110: 4.72,
			111: 5.4,
			112: 6.34,
			113: 7.46,
			114: 8.13,
			115: 8.86,
			116: 9.7,
			117: 10.68,
			118: 11.5,
			119: 12.86,
			120: 14.29,
			121: 15.37,
			122: 12.82,
			123: 14.37,
			124: 13.81,
			125: 12.91,
			126: 11.82,
			127: 10.45,
			128: 9.82,
			129: 9.08,
			130: 7.67,
			131: 6.78,
			132: 5.5,
			133: 3.87,
			134: 5.02,
			135: 6.26
		},
		87: {
			1: 16.62,
			2: 15.94,
			3: 15.42,
			4: 14.28,
			5: 13.52,
			6: 11.92,
			7: 11.1,
			8: 9.97,
			9: 9.22,
			10: 8.33,
			11: 7.22,
			12: 8.15,
			13: 9.63,
			14: 12.21,
			15: 13.54,
			16: 14.83,
			17: 15.65,
			18: 16.66,
			19: 17.79,
			20: 18.66,
			21: 18.78,
			22: 17.93,
			23: 16.89,
			24: 16.24,
			25: 11.94,
			26: 11.21,
			27: 10.21,
			28: 9.22,
			29: 9.08,
			30: 8.41,
			31: 7.21,
			32: 6.22,
			33: 5.59,
			34: 4.93,
			35: 4.38,
			36: 3.85,
			37: 4.88,
			38: 6.4,
			39: 7.49,
			40: 8.59,
			41: 9.47,
			42: 10.07,
			43: 11.33,
			44: 12.16,
			45: 12.92,
			46: 13.95,
			47: 14.53,
			48: 15.98,
			49: 16.85,
			50: 18.99,
			51: 20.9,
			52: 22.99,
			53: 16.55,
			54: 15.44,
			55: 14.54,
			56: 16.48,
			57: 13.69,
			58: 12.54,
			59: 11.48,
			60: 9.92,
			61: 9.02,
			62: 8.14,
			63: 7.21,
			64: 7.76,
			65: 6.94,
			66: 6.19,
			67: 4.93,
			68: 6.23,
			69: 7.22,
			70: 8.16,
			71: 9.35,
			72: 10.71,
			73: 11.91,
			74: 11.1,
			75: 11.61,
			76: 10.28,
			77: 8.14,
			78: 8.41,
			79: 7.21,
			80: 6.23,
			81: 5.51,
			82: 4.56,
			83: 3.85,
			84: 3.19,
			85: 1.86,
			86: 0.87,
			87: 0,
			88: 1.72,
			89: 3,
			90: 4.01,
			91: 5.75,
			92: 7.12,
			93: 8.52,
			94: 5.07,
			95: 6.3,
			96: 7.13,
			97: 8.03,
			98: 9.2,
			99: 14.01,
			100: 12.06,
			101: 10.95,
			102: 9.49,
			103: 7.84,
			104: 6.56,
			105: 5.91,
			106: 4.63,
			107: 5.5,
			108: 8.25,
			109: 6.94,
			110: 5.59,
			111: 6.27,
			112: 7.21,
			113: 8.33,
			114: 9,
			115: 9.73,
			116: 10.57,
			117: 11.55,
			118: 12.37,
			119: 13.73,
			120: 15.15,
			121: 16.24,
			122: 13.69,
			123: 13.98,
			124: 13.09,
			125: 12.19,
			126: 11.1,
			127: 9.58,
			128: 8.95,
			129: 8.21,
			130: 6.8,
			131: 5.91,
			132: 4.63,
			133: 3,
			134: 4.15,
			135: 5.39
		},
		88: {
			1: 18.34,
			2: 17.66,
			3: 17.15,
			4: 16.01,
			5: 15.24,
			6: 13.65,
			7: 12.83,
			8: 11.69,
			9: 10.95,
			10: 10.05,
			11: 8.94,
			12: 9.87,
			13: 11.35,
			14: 13.94,
			15: 15.26,
			16: 16.55,
			17: 17.38,
			18: 18.39,
			19: 19.52,
			20: 20.38,
			21: 20.5,
			22: 19.65,
			23: 18.61,
			24: 17.97,
			25: 13.66,
			26: 12.93,
			27: 11.93,
			28: 10.95,
			29: 10.8,
			30: 10.14,
			31: 8.93,
			32: 7.94,
			33: 7.31,
			34: 6.65,
			35: 6.1,
			36: 5.57,
			37: 6.6,
			38: 8.12,
			39: 9.21,
			40: 10.31,
			41: 11.19,
			42: 11.79,
			43: 13.05,
			44: 13.88,
			45: 14.64,
			46: 15.67,
			47: 16.25,
			48: 17.7,
			49: 18.57,
			50: 20.71,
			51: 22.62,
			52: 24.71,
			53: 16.66,
			54: 15.55,
			55: 14.65,
			56: 16.6,
			57: 13.8,
			58: 14.26,
			59: 13.2,
			60: 11.64,
			61: 10.74,
			62: 9.86,
			63: 8.93,
			64: 8.98,
			65: 8.17,
			66: 7.92,
			67: 6.65,
			68: 7.95,
			69: 8.94,
			70: 9.88,
			71: 11.08,
			72: 12.43,
			73: 10.19,
			74: 9.38,
			75: 10.46,
			76: 11.79,
			77: 9.86,
			78: 10.14,
			79: 8.93,
			80: 7.95,
			81: 7.23,
			82: 6.28,
			83: 5.57,
			84: 4.91,
			85: 3.58,
			86: 2.59,
			87: 1.72,
			88: 0,
			89: 1.27,
			90: 2.29,
			91: 4.03,
			92: 5.4,
			93: 6.8,
			94: 6.79,
			95: 8.02,
			96: 8.86,
			97: 9.76,
			98: 10.92,
			99: 12.29,
			100: 10.34,
			101: 9.23,
			102: 7.76,
			103: 6.12,
			104: 4.84,
			105: 4.19,
			106: 2.91,
			107: 3.77,
			108: 6.85,
			109: 8.17,
			110: 7.31,
			111: 8,
			112: 8.93,
			113: 10.05,
			114: 10.72,
			115: 11.45,
			116: 12.29,
			117: 13.28,
			118: 14.09,
			119: 15.45,
			120: 16.88,
			121: 17.97,
			122: 13.8,
			123: 12.25,
			124: 11.37,
			125: 10.47,
			126: 9.38,
			127: 7.85,
			128: 7.22,
			129: 6.49,
			130: 5.08,
			131: 4.19,
			132: 2.91,
			133: 1.27,
			134: 2.43,
			135: 3.67
		},
		89: {
			1: 18.89,
			2: 18.2,
			3: 17.69,
			4: 16.55,
			5: 15.79,
			6: 14.19,
			7: 13.37,
			8: 12.23,
			9: 11.49,
			10: 10.98,
			11: 10.21,
			12: 11.15,
			13: 12.62,
			14: 15.21,
			15: 16.54,
			16: 17.82,
			17: 18.65,
			18: 19.66,
			19: 20.79,
			20: 21.66,
			21: 21.43,
			22: 20.58,
			23: 19.54,
			24: 18.89,
			25: 14.21,
			26: 13.47,
			27: 12.48,
			28: 11.49,
			29: 10.7,
			30: 10.03,
			31: 8.47,
			32: 8.87,
			33: 8.24,
			34: 7.93,
			35: 7.38,
			36: 6.85,
			37: 7.88,
			38: 9.4,
			39: 10.49,
			40: 11.59,
			41: 12.47,
			42: 13.07,
			43: 14.33,
			44: 15.16,
			45: 15.92,
			46: 16.95,
			47: 17.53,
			48: 18.98,
			49: 19.85,
			50: 21.99,
			51: 23.9,
			52: 25.99,
			53: 15.39,
			54: 14.28,
			55: 13.38,
			56: 15.33,
			57: 12.53,
			58: 13.68,
			59: 12.74,
			60: 11.18,
			61: 10.28,
			62: 9.4,
			63: 8.47,
			64: 7.71,
			65: 6.89,
			66: 7.71,
			67: 7.93,
			68: 9.22,
			69: 10.21,
			70: 11.15,
			71: 12.35,
			72: 13.7,
			73: 8.92,
			74: 8.11,
			75: 9.19,
			76: 10.52,
			77: 9.4,
			78: 10.03,
			79: 9.86,
			80: 9.22,
			81: 8.51,
			82: 7.56,
			83: 6.85,
			84: 6.19,
			85: 4.85,
			86: 3.87,
			87: 3,
			88: 1.27,
			89: 0,
			90: 1.02,
			91: 2.76,
			92: 4.13,
			93: 5.53,
			94: 8.06,
			95: 9.3,
			96: 10.13,
			97: 11.03,
			98: 12.2,
			99: 11.01,
			100: 9.07,
			101: 7.96,
			102: 6.49,
			103: 4.85,
			104: 3.56,
			105: 2.91,
			106: 1.63,
			107: 2.5,
			108: 5.58,
			109: 6.89,
			110: 8.24,
			111: 8.92,
			112: 9.86,
			113: 10.98,
			114: 11.65,
			115: 12.38,
			116: 13.22,
			117: 14.2,
			118: 15.02,
			119: 16.38,
			120: 17.81,
			121: 18.89,
			122: 12.53,
			123: 10.98,
			124: 10.09,
			125: 9.19,
			126: 8.11,
			127: 6.58,
			128: 5.95,
			129: 5.21,
			130: 3.81,
			131: 2.91,
			132: 1.63,
			133: 0,
			134: 1.16,
			135: 2.4
		},
		90: {
			1: 19.9,
			2: 19.22,
			3: 18.71,
			4: 17.57,
			5: 16.8,
			6: 15.21,
			7: 14.39,
			8: 13.25,
			9: 12.51,
			10: 12,
			11: 11.23,
			12: 12.16,
			13: 13.64,
			14: 16.23,
			15: 17.56,
			16: 18.84,
			17: 19.67,
			18: 20.68,
			19: 21.81,
			20: 22.67,
			21: 22.45,
			22: 21.6,
			23: 20.56,
			24: 19.91,
			25: 15.22,
			26: 14.49,
			27: 13.5,
			28: 12.51,
			29: 11.72,
			30: 11.05,
			31: 9.49,
			32: 9.89,
			33: 9.26,
			34: 8.94,
			35: 8.39,
			36: 7.86,
			37: 8.89,
			38: 10.41,
			39: 11.5,
			40: 12.6,
			41: 13.48,
			42: 14.08,
			43: 15.34,
			44: 16.17,
			45: 16.93,
			46: 17.96,
			47: 18.54,
			48: 19.99,
			49: 20.86,
			50: 23.01,
			51: 24.91,
			52: 27.01,
			53: 16.41,
			54: 15.3,
			55: 14.4,
			56: 16.34,
			57: 13.55,
			58: 14.7,
			59: 13.76,
			60: 12.2,
			61: 11.3,
			62: 10.42,
			63: 9.49,
			64: 8.73,
			65: 7.91,
			66: 8.72,
			67: 8.94,
			68: 10.24,
			69: 11.23,
			70: 12.17,
			71: 13.37,
			72: 14.72,
			73: 9.94,
			74: 9.13,
			75: 10.21,
			76: 11.54,
			77: 10.42,
			78: 11.05,
			79: 10.88,
			80: 10.24,
			81: 9.52,
			82: 8.58,
			83: 7.86,
			84: 7.2,
			85: 5.87,
			86: 4.88,
			87: 4.01,
			88: 2.29,
			89: 1.02,
			90: 0,
			91: 1.74,
			92: 3.11,
			93: 4.51,
			94: 9.08,
			95: 10.31,
			96: 11.15,
			97: 12.05,
			98: 13.21,
			99: 12.03,
			100: 10.08,
			101: 8.97,
			102: 7.51,
			103: 5.86,
			104: 4.58,
			105: 3.93,
			106: 2.65,
			107: 3.52,
			108: 6.6,
			109: 7.91,
			110: 9.26,
			111: 9.94,
			112: 10.88,
			113: 12,
			114: 12.67,
			115: 13.39,
			116: 14.24,
			117: 15.22,
			118: 16.04,
			119: 17.4,
			120: 18.82,
			121: 19.91,
			122: 13.55,
			123: 12,
			124: 11.11,
			125: 10.21,
			126: 9.13,
			127: 7.6,
			128: 6.97,
			129: 6.23,
			130: 4.82,
			131: 3.93,
			132: 2.65,
			133: 1.02,
			134: 2.17,
			135: 3.42
		},
		91: {
			1: 21.64,
			2: 20.96,
			3: 20.45,
			4: 19.31,
			5: 18.54,
			6: 16.95,
			7: 16.13,
			8: 14.99,
			9: 14.25,
			10: 13.74,
			11: 12.97,
			12: 13.9,
			13: 15.38,
			14: 17.97,
			15: 19.29,
			16: 20.58,
			17: 21.41,
			18: 22.42,
			19: 23.55,
			20: 24.41,
			21: 24.19,
			22: 23.34,
			23: 22.3,
			24: 21.65,
			25: 16.96,
			26: 16.23,
			27: 15.23,
			28: 14.25,
			29: 13.46,
			30: 12.79,
			31: 11.23,
			32: 11.63,
			33: 11,
			34: 10.68,
			35: 10.13,
			36: 9.6,
			37: 10.63,
			38: 12.15,
			39: 13.24,
			40: 14.34,
			41: 15.22,
			42: 15.82,
			43: 17.08,
			44: 17.91,
			45: 18.67,
			46: 19.7,
			47: 20.28,
			48: 21.73,
			49: 22.6,
			50: 24.74,
			51: 26.65,
			52: 28.74,
			53: 18.15,
			54: 17.04,
			55: 16.14,
			56: 18.08,
			57: 15.29,
			58: 16.44,
			59: 15.5,
			60: 13.94,
			61: 13.04,
			62: 12.16,
			63: 11.23,
			64: 10.47,
			65: 9.65,
			66: 10.46,
			67: 10.68,
			68: 11.98,
			69: 12.97,
			70: 13.91,
			71: 15.11,
			72: 16.46,
			73: 11.67,
			74: 10.86,
			75: 11.94,
			76: 13.27,
			77: 12.16,
			78: 12.79,
			79: 12.62,
			80: 11.98,
			81: 11.26,
			82: 10.31,
			83: 9.6,
			84: 8.94,
			85: 7.61,
			86: 6.62,
			87: 5.75,
			88: 4.03,
			89: 2.76,
			90: 1.74,
			91: 0,
			92: 1.37,
			93: 2.77,
			94: 10.82,
			95: 12.05,
			96: 12.89,
			97: 13.79,
			98: 14.95,
			99: 13.77,
			100: 11.82,
			101: 10.71,
			102: 9.25,
			103: 7.6,
			104: 6.32,
			105: 5.67,
			106: 4.39,
			107: 5.26,
			108: 8.34,
			109: 9.65,
			110: 11,
			111: 11.68,
			112: 12.62,
			113: 13.74,
			114: 14.41,
			115: 15.13,
			116: 15.98,
			117: 16.96,
			118: 17.78,
			119: 19.14,
			120: 20.56,
			121: 21.65,
			122: 15.29,
			123: 13.74,
			124: 12.85,
			125: 11.95,
			126: 10.86,
			127: 9.34,
			128: 8.71,
			129: 7.97,
			130: 6.56,
			131: 5.67,
			132: 4.39,
			133: 2.76,
			134: 3.91,
			135: 5.15
		},
		92: {
			1: 23.01,
			2: 22.33,
			3: 21.82,
			4: 20.67,
			5: 19.91,
			6: 18.32,
			7: 17.49,
			8: 16.36,
			9: 15.61,
			10: 15.11,
			11: 14.34,
			12: 15.27,
			13: 16.75,
			14: 19.33,
			15: 20.66,
			16: 21.95,
			17: 22.77,
			18: 23.79,
			19: 24.91,
			20: 25.78,
			21: 25.56,
			22: 24.7,
			23: 23.67,
			24: 23.02,
			25: 18.33,
			26: 17.6,
			27: 16.6,
			28: 15.61,
			29: 14.83,
			30: 14.16,
			31: 12.6,
			32: 13,
			33: 12.37,
			34: 12.05,
			35: 11.5,
			36: 10.97,
			37: 12,
			38: 13.52,
			39: 14.61,
			40: 15.71,
			41: 16.59,
			42: 17.19,
			43: 18.45,
			44: 19.28,
			45: 20.04,
			46: 21.07,
			47: 21.65,
			48: 23.1,
			49: 23.97,
			50: 26.11,
			51: 28.02,
			52: 30.11,
			53: 19.52,
			54: 18.41,
			55: 17.51,
			56: 19.45,
			57: 16.66,
			58: 17.81,
			59: 16.87,
			60: 15.31,
			61: 14.41,
			62: 13.53,
			63: 12.6,
			64: 11.84,
			65: 11.02,
			66: 11.83,
			67: 12.05,
			68: 13.35,
			69: 14.34,
			70: 15.28,
			71: 16.48,
			72: 17.83,
			73: 13.04,
			74: 12.23,
			75: 13.31,
			76: 14.64,
			77: 13.53,
			78: 14.16,
			79: 13.99,
			80: 13.35,
			81: 12.63,
			82: 11.68,
			83: 10.97,
			84: 10.31,
			85: 8.98,
			86: 7.99,
			87: 7.12,
			88: 5.4,
			89: 4.13,
			90: 3.11,
			91: 1.37,
			92: 0,
			93: 1.4,
			94: 12.19,
			95: 13.42,
			96: 14.25,
			97: 15.15,
			98: 16.32,
			99: 15.14,
			100: 13.19,
			101: 12.08,
			102: 10.61,
			103: 8.97,
			104: 7.69,
			105: 7.04,
			106: 5.76,
			107: 6.62,
			108: 9.7,
			109: 11.02,
			110: 12.37,
			111: 13.05,
			112: 13.99,
			113: 15.11,
			114: 15.77,
			115: 16.5,
			116: 17.34,
			117: 18.33,
			118: 19.14,
			119: 20.51,
			120: 21.93,
			121: 23.02,
			122: 16.66,
			123: 15.11,
			124: 14.22,
			125: 13.32,
			126: 12.23,
			127: 10.71,
			128: 10.08,
			129: 9.34,
			130: 7.93,
			131: 7.04,
			132: 5.76,
			133: 4.13,
			134: 5.28,
			135: 6.52
		},
		93: {
			1: 24.41,
			2: 23.73,
			3: 23.22,
			4: 22.07,
			5: 21.31,
			6: 19.72,
			7: 18.9,
			8: 17.76,
			9: 17.02,
			10: 16.51,
			11: 15.74,
			12: 16.67,
			13: 18.15,
			14: 20.74,
			15: 22.06,
			16: 23.35,
			17: 24.18,
			18: 25.19,
			19: 26.32,
			20: 27.18,
			21: 26.96,
			22: 26.11,
			23: 25.07,
			24: 24.42,
			25: 19.73,
			26: 19,
			27: 18,
			28: 17.02,
			29: 16.23,
			30: 15.56,
			31: 14,
			32: 14.4,
			33: 13.77,
			34: 13.45,
			35: 12.9,
			36: 12.37,
			37: 13.4,
			38: 14.92,
			39: 16.01,
			40: 17.11,
			41: 17.99,
			42: 18.59,
			43: 19.85,
			44: 20.68,
			45: 21.44,
			46: 22.47,
			47: 23.05,
			48: 24.5,
			49: 25.37,
			50: 27.51,
			51: 29.42,
			52: 31.51,
			53: 20.92,
			54: 19.81,
			55: 18.91,
			56: 20.85,
			57: 18.06,
			58: 19.21,
			59: 18.27,
			60: 16.71,
			61: 15.81,
			62: 14.93,
			63: 14,
			64: 13.24,
			65: 12.42,
			66: 13.23,
			67: 13.45,
			68: 14.75,
			69: 15.74,
			70: 16.68,
			71: 17.88,
			72: 19.23,
			73: 14.44,
			74: 13.63,
			75: 14.71,
			76: 16.04,
			77: 14.93,
			78: 15.56,
			79: 15.39,
			80: 14.75,
			81: 14.03,
			82: 13.08,
			83: 12.37,
			84: 11.71,
			85: 10.38,
			86: 9.39,
			87: 8.52,
			88: 6.8,
			89: 5.53,
			90: 4.51,
			91: 2.77,
			92: 1.4,
			93: 0,
			94: 13.59,
			95: 14.82,
			96: 15.65,
			97: 16.56,
			98: 17.72,
			99: 16.54,
			100: 14.59,
			101: 13.48,
			102: 12.02,
			103: 10.37,
			104: 9.09,
			105: 8.44,
			106: 7.16,
			107: 8.03,
			108: 11.11,
			109: 12.42,
			110: 13.77,
			111: 14.45,
			112: 15.39,
			113: 16.51,
			114: 17.17,
			115: 17.9,
			116: 18.74,
			117: 19.73,
			118: 20.55,
			119: 21.91,
			120: 23.33,
			121: 24.42,
			122: 18.06,
			123: 16.51,
			124: 15.62,
			125: 14.72,
			126: 13.63,
			127: 12.11,
			128: 11.48,
			129: 10.74,
			130: 9.33,
			131: 8.44,
			132: 7.16,
			133: 5.53,
			134: 6.68,
			135: 7.92
		},
		94: {
			1: 15.31,
			2: 14.63,
			3: 14.11,
			4: 12.97,
			5: 12.21,
			6: 10.61,
			7: 9.79,
			8: 8.66,
			9: 7.91,
			10: 7.02,
			11: 5.91,
			12: 6.84,
			13: 8.32,
			14: 10.9,
			15: 12.23,
			16: 13.51,
			17: 14.34,
			18: 15.35,
			19: 16.48,
			20: 17.35,
			21: 17.47,
			22: 16.62,
			23: 15.58,
			24: 14.93,
			25: 10.63,
			26: 9.89,
			27: 8.9,
			28: 7.91,
			29: 7.77,
			30: 7.1,
			31: 5.9,
			32: 4.91,
			33: 4.28,
			34: 3.62,
			35: 3.07,
			36: 2.54,
			37: 3.57,
			38: 5.09,
			39: 6.18,
			40: 7.28,
			41: 8.16,
			42: 8.76,
			43: 10.02,
			44: 10.85,
			45: 11.61,
			46: 12.64,
			47: 13.22,
			48: 14.67,
			49: 15.54,
			50: 17.68,
			51: 19.59,
			52: 21.68,
			53: 15.24,
			54: 14.13,
			55: 13.23,
			56: 15.17,
			57: 12.38,
			58: 11.23,
			59: 10.17,
			60: 8.61,
			61: 7.71,
			62: 6.83,
			63: 5.9,
			64: 6.45,
			65: 5.63,
			66: 4.88,
			67: 3.62,
			68: 4.91,
			69: 5.91,
			70: 6.85,
			71: 8.04,
			72: 9.4,
			73: 12.19,
			74: 11.38,
			75: 10.3,
			76: 8.97,
			77: 6.83,
			78: 7.1,
			79: 5.9,
			80: 4.91,
			81: 4.2,
			82: 3.25,
			83: 2.54,
			84: 1.88,
			85: 3.21,
			86: 4.2,
			87: 5.07,
			88: 6.79,
			89: 8.06,
			90: 9.08,
			91: 10.82,
			92: 12.19,
			93: 13.59,
			94: 0,
			95: 1.23,
			96: 2.07,
			97: 2.97,
			98: 4.13,
			99: 19.08,
			100: 17.13,
			101: 16.02,
			102: 14.55,
			103: 12.91,
			104: 11.63,
			105: 10.97,
			106: 9.7,
			107: 10.02,
			108: 6.94,
			109: 5.63,
			110: 4.28,
			111: 4.96,
			112: 5.9,
			113: 7.02,
			114: 7.69,
			115: 8.41,
			116: 9.26,
			117: 10.24,
			118: 11.06,
			119: 12.42,
			120: 13.84,
			121: 14.93,
			122: 12.38,
			123: 13.93,
			124: 13.37,
			125: 12.46,
			126: 11.38,
			127: 12.91,
			128: 13.54,
			129: 13.27,
			130: 11.87,
			131: 10.97,
			132: 9.7,
			133: 8.06,
			134: 9.22,
			135: 10.46
		},
		95: {
			1: 16.54,
			2: 15.86,
			3: 15.35,
			4: 14.2,
			5: 13.44,
			6: 11.85,
			7: 11.02,
			8: 9.89,
			9: 9.14,
			10: 8.25,
			11: 7.14,
			12: 8.07,
			13: 9.55,
			14: 12.13,
			15: 13.46,
			16: 14.75,
			17: 15.57,
			18: 16.59,
			19: 17.71,
			20: 18.58,
			21: 18.7,
			22: 17.85,
			23: 16.81,
			24: 16.16,
			25: 11.86,
			26: 11.13,
			27: 10.13,
			28: 9.14,
			29: 9,
			30: 8.33,
			31: 7.13,
			32: 6.14,
			33: 5.51,
			34: 4.85,
			35: 4.3,
			36: 3.77,
			37: 4.8,
			38: 6.32,
			39: 7.41,
			40: 8.51,
			41: 9.39,
			42: 9.99,
			43: 11.25,
			44: 12.08,
			45: 12.84,
			46: 13.87,
			47: 14.45,
			48: 15.9,
			49: 16.77,
			50: 18.91,
			51: 20.82,
			52: 22.91,
			53: 16.47,
			54: 15.36,
			55: 14.46,
			56: 16.41,
			57: 13.61,
			58: 12.46,
			59: 11.4,
			60: 9.84,
			61: 8.94,
			62: 8.06,
			63: 7.13,
			64: 7.68,
			65: 6.86,
			66: 6.11,
			67: 4.85,
			68: 6.15,
			69: 7.14,
			70: 8.08,
			71: 9.28,
			72: 10.63,
			73: 13.42,
			74: 12.61,
			75: 11.53,
			76: 10.2,
			77: 8.06,
			78: 8.33,
			79: 7.13,
			80: 6.15,
			81: 5.43,
			82: 4.48,
			83: 3.77,
			84: 3.11,
			85: 4.44,
			86: 5.43,
			87: 6.3,
			88: 8.02,
			89: 9.3,
			90: 10.31,
			91: 12.05,
			92: 13.42,
			93: 14.82,
			94: 1.23,
			95: 0,
			96: 0.83,
			97: 1.73,
			98: 2.9,
			99: 20.31,
			100: 18.36,
			101: 17.25,
			102: 15.78,
			103: 14.14,
			104: 12.86,
			105: 12.21,
			106: 10.93,
			107: 11.25,
			108: 8.17,
			109: 6.86,
			110: 5.51,
			111: 6.19,
			112: 7.13,
			113: 8.25,
			114: 8.92,
			115: 9.65,
			116: 10.49,
			117: 11.47,
			118: 12.29,
			119: 13.65,
			120: 15.08,
			121: 16.16,
			122: 13.61,
			123: 15.16,
			124: 14.6,
			125: 13.7,
			126: 12.61,
			127: 14.14,
			128: 14.77,
			129: 14.51,
			130: 13.1,
			131: 12.21,
			132: 10.93,
			133: 9.3,
			134: 10.45,
			135: 11.69
		},
		96: {
			1: 17.37,
			2: 16.69,
			3: 16.18,
			4: 15.04,
			5: 14.27,
			6: 12.68,
			7: 11.86,
			8: 10.72,
			9: 9.98,
			10: 9.08,
			11: 7.97,
			12: 8.9,
			13: 10.38,
			14: 12.97,
			15: 14.3,
			16: 15.58,
			17: 16.41,
			18: 17.42,
			19: 18.55,
			20: 19.41,
			21: 19.54,
			22: 18.68,
			23: 17.64,
			24: 17,
			25: 12.69,
			26: 11.96,
			27: 10.97,
			28: 9.98,
			29: 9.83,
			30: 9.17,
			31: 7.96,
			32: 6.97,
			33: 6.34,
			34: 5.68,
			35: 5.13,
			36: 4.6,
			37: 5.63,
			38: 7.15,
			39: 8.24,
			40: 9.34,
			41: 10.22,
			42: 10.82,
			43: 12.08,
			44: 12.91,
			45: 13.67,
			46: 14.7,
			47: 15.28,
			48: 16.73,
			49: 17.6,
			50: 19.74,
			51: 21.65,
			52: 23.74,
			53: 17.3,
			54: 16.19,
			55: 15.29,
			56: 17.24,
			57: 14.44,
			58: 13.29,
			59: 12.23,
			60: 10.67,
			61: 9.77,
			62: 8.89,
			63: 7.96,
			64: 8.51,
			65: 7.69,
			66: 6.95,
			67: 5.68,
			68: 6.98,
			69: 7.97,
			70: 8.91,
			71: 10.11,
			72: 11.46,
			73: 14.25,
			74: 13.44,
			75: 12.36,
			76: 11.03,
			77: 8.89,
			78: 9.17,
			79: 7.97,
			80: 6.98,
			81: 6.26,
			82: 5.32,
			83: 4.6,
			84: 3.94,
			85: 5.28,
			86: 6.26,
			87: 7.13,
			88: 8.86,
			89: 10.13,
			90: 11.15,
			91: 12.89,
			92: 14.25,
			93: 15.65,
			94: 2.07,
			95: 0.83,
			96: 0,
			97: 0.9,
			98: 2.07,
			99: 21.14,
			100: 19.19,
			101: 18.08,
			102: 16.62,
			103: 14.97,
			104: 13.69,
			105: 13.04,
			106: 11.76,
			107: 12.09,
			108: 9.01,
			109: 7.69,
			110: 6.34,
			111: 7.03,
			112: 7.97,
			113: 9.08,
			114: 9.75,
			115: 10.48,
			116: 11.32,
			117: 12.31,
			118: 13.12,
			119: 14.48,
			120: 15.91,
			121: 17,
			122: 14.44,
			123: 16,
			124: 15.43,
			125: 14.53,
			126: 13.44,
			127: 14.97,
			128: 15.6,
			129: 15.34,
			130: 13.93,
			131: 13.04,
			132: 11.76,
			133: 10.13,
			134: 11.28,
			135: 12.53
		},
		97: {
			1: 18.28,
			2: 17.59,
			3: 17.08,
			4: 15.94,
			5: 15.18,
			6: 13.58,
			7: 12.76,
			8: 11.62,
			9: 10.88,
			10: 9.99,
			11: 8.87,
			12: 9.8,
			13: 11.28,
			14: 13.87,
			15: 15.2,
			16: 16.48,
			17: 17.31,
			18: 18.32,
			19: 19.45,
			20: 20.32,
			21: 20.44,
			22: 19.58,
			23: 18.54,
			24: 17.9,
			25: 13.6,
			26: 12.86,
			27: 11.87,
			28: 10.88,
			29: 10.73,
			30: 10.07,
			31: 8.87,
			32: 7.88,
			33: 7.25,
			34: 6.59,
			35: 6.04,
			36: 5.51,
			37: 6.54,
			38: 8.06,
			39: 9.15,
			40: 10.25,
			41: 11.13,
			42: 11.73,
			43: 12.99,
			44: 13.82,
			45: 14.58,
			46: 15.61,
			47: 16.19,
			48: 17.64,
			49: 18.51,
			50: 20.65,
			51: 22.56,
			52: 24.65,
			53: 18.21,
			54: 17.1,
			55: 16.2,
			56: 18.14,
			57: 15.35,
			58: 14.2,
			59: 13.14,
			60: 11.58,
			61: 10.68,
			62: 9.8,
			63: 8.87,
			64: 9.41,
			65: 8.59,
			66: 7.85,
			67: 6.59,
			68: 7.88,
			69: 8.87,
			70: 9.81,
			71: 11.01,
			72: 12.36,
			73: 15.16,
			74: 14.35,
			75: 13.27,
			76: 11.94,
			77: 9.8,
			78: 10.07,
			79: 8.87,
			80: 7.88,
			81: 7.16,
			82: 6.22,
			83: 5.51,
			84: 4.84,
			85: 6.18,
			86: 7.16,
			87: 8.03,
			88: 9.76,
			89: 11.03,
			90: 12.05,
			91: 13.79,
			92: 15.15,
			93: 16.56,
			94: 2.97,
			95: 1.73,
			96: 0.9,
			97: 0,
			98: 1.17,
			99: 22.04,
			100: 20.1,
			101: 18.99,
			102: 17.52,
			103: 15.88,
			104: 14.59,
			105: 13.94,
			106: 12.66,
			107: 12.99,
			108: 9.91,
			109: 8.59,
			110: 7.25,
			111: 7.93,
			112: 8.87,
			113: 9.99,
			114: 10.65,
			115: 11.38,
			116: 12.22,
			117: 13.21,
			118: 14.02,
			119: 15.39,
			120: 16.81,
			121: 17.9,
			122: 15.35,
			123: 16.9,
			124: 16.33,
			125: 15.43,
			126: 14.35,
			127: 15.87,
			128: 16.5,
			129: 16.24,
			130: 14.84,
			131: 13.94,
			132: 12.66,
			133: 11.03,
			134: 12.18,
			135: 13.43
		},
		98: {
			1: 19.44,
			2: 18.76,
			3: 18.25,
			4: 17.1,
			5: 16.34,
			6: 14.75,
			7: 13.93,
			8: 12.79,
			9: 12.05,
			10: 11.15,
			11: 10.04,
			12: 10.97,
			13: 12.45,
			14: 15.04,
			15: 16.36,
			16: 17.65,
			17: 18.48,
			18: 19.49,
			19: 20.62,
			20: 21.48,
			21: 21.6,
			22: 20.75,
			23: 19.71,
			24: 19.07,
			25: 14.76,
			26: 14.03,
			27: 13.03,
			28: 12.05,
			29: 11.9,
			30: 11.23,
			31: 10.03,
			32: 9.04,
			33: 8.41,
			34: 7.75,
			35: 7.2,
			36: 6.67,
			37: 7.7,
			38: 9.22,
			39: 10.31,
			40: 11.41,
			41: 12.29,
			42: 12.89,
			43: 14.15,
			44: 14.98,
			45: 15.74,
			46: 16.77,
			47: 17.35,
			48: 18.8,
			49: 19.67,
			50: 21.81,
			51: 23.72,
			52: 25.81,
			53: 19.37,
			54: 18.26,
			55: 17.36,
			56: 19.31,
			57: 16.51,
			58: 15.36,
			59: 14.3,
			60: 12.74,
			61: 11.84,
			62: 10.96,
			63: 10.03,
			64: 10.58,
			65: 9.76,
			66: 9.02,
			67: 7.75,
			68: 9.05,
			69: 10.04,
			70: 10.98,
			71: 12.18,
			72: 13.53,
			73: 16.32,
			74: 15.51,
			75: 14.43,
			76: 13.1,
			77: 10.96,
			78: 11.23,
			79: 10.03,
			80: 9.05,
			81: 8.33,
			82: 7.38,
			83: 6.67,
			84: 6.01,
			85: 7.34,
			86: 8.33,
			87: 9.2,
			88: 10.92,
			89: 12.2,
			90: 13.21,
			91: 14.95,
			92: 16.32,
			93: 17.72,
			94: 4.13,
			95: 2.9,
			96: 2.07,
			97: 1.17,
			98: 0,
			99: 23.21,
			100: 21.26,
			101: 20.15,
			102: 18.69,
			103: 17.04,
			104: 15.76,
			105: 15.11,
			106: 13.83,
			107: 14.15,
			108: 11.07,
			109: 9.76,
			110: 8.41,
			111: 9.1,
			112: 10.03,
			113: 11.15,
			114: 11.82,
			115: 12.55,
			116: 13.39,
			117: 14.38,
			118: 15.19,
			119: 16.55,
			120: 17.98,
			121: 19.07,
			122: 16.51,
			123: 18.06,
			124: 17.5,
			125: 16.6,
			126: 15.51,
			127: 17.04,
			128: 17.67,
			129: 17.41,
			130: 16,
			131: 15.11,
			132: 13.83,
			133: 12.2,
			134: 13.35,
			135: 14.59
		},
		99: {
			1: 26.63,
			2: 25.95,
			3: 25.44,
			4: 24.29,
			5: 23.53,
			6: 21.94,
			7: 21.11,
			8: 19.98,
			9: 19.23,
			10: 18.73,
			11: 18.93,
			12: 19.87,
			13: 21.34,
			14: 23.93,
			15: 25.26,
			16: 26.54,
			17: 27.37,
			18: 28.38,
			19: 29.51,
			20: 30.38,
			21: 29.18,
			22: 28.32,
			23: 27.29,
			24: 26.64,
			25: 21.95,
			26: 21.22,
			27: 20.22,
			28: 19.23,
			29: 18.45,
			30: 17.78,
			31: 16.22,
			32: 16.62,
			33: 15.99,
			34: 16.65,
			35: 17.2,
			36: 17.73,
			37: 18.76,
			38: 20.28,
			39: 21.37,
			40: 22.47,
			41: 23.35,
			42: 23.95,
			43: 25.21,
			44: 26.04,
			45: 26.8,
			46: 27.83,
			47: 28.41,
			48: 29.86,
			49: 30.73,
			50: 32.87,
			51: 34.78,
			52: 36.87,
			53: 20.58,
			54: 19.47,
			55: 18.57,
			56: 20.51,
			57: 17.72,
			58: 18.87,
			59: 19.93,
			60: 18.93,
			61: 18.03,
			62: 17.15,
			63: 16.22,
			64: 15.46,
			65: 14.64,
			66: 15.45,
			67: 16.65,
			68: 17.94,
			69: 18.93,
			70: 19.87,
			71: 21.07,
			72: 22.42,
			73: 14.11,
			74: 13.3,
			75: 14.38,
			76: 15.71,
			77: 17.15,
			78: 17.78,
			79: 17.61,
			80: 17.94,
			81: 18.74,
			82: 18.44,
			83: 17.73,
			84: 17.2,
			85: 15.87,
			86: 14.88,
			87: 14.01,
			88: 12.29,
			89: 11.01,
			90: 12.03,
			91: 13.77,
			92: 15.14,
			93: 16.54,
			94: 19.08,
			95: 20.31,
			96: 21.14,
			97: 22.04,
			98: 23.21,
			99: 0,
			100: 1.95,
			101: 3.06,
			102: 4.52,
			103: 6.17,
			104: 7.45,
			105: 8.1,
			106: 9.38,
			107: 10.24,
			108: 13.32,
			109: 14.64,
			110: 15.99,
			111: 16.67,
			112: 17.61,
			113: 18.73,
			114: 19.39,
			115: 20.12,
			116: 20.96,
			117: 21.95,
			118: 22.76,
			119: 24.13,
			120: 25.55,
			121: 26.64,
			122: 17.72,
			123: 16.17,
			124: 15.28,
			125: 14.38,
			126: 13.3,
			127: 11.77,
			128: 11.14,
			129: 10.4,
			130: 9,
			131: 8.1,
			132: 9.38,
			133: 11.01,
			134: 12.17,
			135: 13.41
		},
		100: {
			1: 24.68,
			2: 24,
			3: 23.49,
			4: 22.35,
			5: 21.58,
			6: 19.99,
			7: 19.17,
			8: 18.03,
			9: 17.29,
			10: 16.78,
			11: 16.99,
			12: 17.92,
			13: 19.4,
			14: 21.98,
			15: 23.31,
			16: 24.59,
			17: 25.42,
			18: 26.43,
			19: 27.56,
			20: 28.43,
			21: 27.23,
			22: 26.38,
			23: 25.34,
			24: 24.69,
			25: 20.01,
			26: 19.27,
			27: 18.28,
			28: 17.29,
			29: 16.5,
			30: 15.83,
			31: 14.27,
			32: 14.67,
			33: 14.04,
			34: 14.7,
			35: 15.25,
			36: 15.78,
			37: 16.81,
			38: 18.33,
			39: 19.42,
			40: 20.52,
			41: 21.4,
			42: 22,
			43: 23.26,
			44: 24.09,
			45: 24.85,
			46: 25.88,
			47: 26.46,
			48: 27.91,
			49: 28.78,
			50: 30.92,
			51: 32.83,
			52: 34.92,
			53: 18.63,
			54: 17.52,
			55: 16.62,
			56: 18.57,
			57: 15.77,
			58: 16.92,
			59: 17.98,
			60: 16.98,
			61: 16.08,
			62: 15.2,
			63: 14.27,
			64: 13.51,
			65: 12.69,
			66: 13.5,
			67: 14.7,
			68: 16,
			69: 16.99,
			70: 17.93,
			71: 19.12,
			72: 20.48,
			73: 12.16,
			74: 11.35,
			75: 12.43,
			76: 13.76,
			77: 15.2,
			78: 15.83,
			79: 15.66,
			80: 16,
			81: 16.79,
			82: 16.49,
			83: 15.78,
			84: 15.25,
			85: 13.92,
			86: 12.93,
			87: 12.06,
			88: 10.34,
			89: 9.07,
			90: 10.08,
			91: 11.82,
			92: 13.19,
			93: 14.59,
			94: 17.13,
			95: 18.36,
			96: 19.19,
			97: 20.1,
			98: 21.26,
			99: 1.95,
			100: 0,
			101: 1.11,
			102: 2.58,
			103: 4.22,
			104: 5.5,
			105: 6.15,
			106: 7.43,
			107: 8.3,
			108: 11.38,
			109: 12.69,
			110: 14.04,
			111: 14.72,
			112: 15.66,
			113: 16.78,
			114: 17.45,
			115: 18.17,
			116: 19.02,
			117: 20.01,
			118: 20.82,
			119: 22.18,
			120: 23.6,
			121: 24.69,
			122: 15.77,
			123: 14.22,
			124: 13.34,
			125: 12.43,
			126: 11.35,
			127: 9.82,
			128: 9.19,
			129: 8.45,
			130: 7.05,
			131: 6.15,
			132: 7.43,
			133: 9.07,
			134: 10.22,
			135: 11.46
		},
		101: {
			1: 23.57,
			2: 22.89,
			3: 22.38,
			4: 21.24,
			5: 20.47,
			6: 18.88,
			7: 18.06,
			8: 16.92,
			9: 16.18,
			10: 15.67,
			11: 15.88,
			12: 16.81,
			13: 18.29,
			14: 20.87,
			15: 22.2,
			16: 23.48,
			17: 24.31,
			18: 25.32,
			19: 26.45,
			20: 27.32,
			21: 26.12,
			22: 25.27,
			23: 24.23,
			24: 23.58,
			25: 18.89,
			26: 18.16,
			27: 17.17,
			28: 16.18,
			29: 15.39,
			30: 14.72,
			31: 13.16,
			32: 13.56,
			33: 12.93,
			34: 13.59,
			35: 14.14,
			36: 14.67,
			37: 15.7,
			38: 17.22,
			39: 18.31,
			40: 19.41,
			41: 20.29,
			42: 20.89,
			43: 22.15,
			44: 22.98,
			45: 23.74,
			46: 24.77,
			47: 25.35,
			48: 26.8,
			49: 27.67,
			50: 29.81,
			51: 31.72,
			52: 33.81,
			53: 17.52,
			54: 16.41,
			55: 15.51,
			56: 17.46,
			57: 14.66,
			58: 15.81,
			59: 16.87,
			60: 15.87,
			61: 14.97,
			62: 14.09,
			63: 13.16,
			64: 12.4,
			65: 11.58,
			66: 12.39,
			67: 13.59,
			68: 14.89,
			69: 15.88,
			70: 16.82,
			71: 18.01,
			72: 19.37,
			73: 11.05,
			74: 10.24,
			75: 11.32,
			76: 12.65,
			77: 14.09,
			78: 14.72,
			79: 14.55,
			80: 14.89,
			81: 15.68,
			82: 15.38,
			83: 14.67,
			84: 14.14,
			85: 12.81,
			86: 11.82,
			87: 10.95,
			88: 9.23,
			89: 7.96,
			90: 8.97,
			91: 10.71,
			92: 12.08,
			93: 13.48,
			94: 16.02,
			95: 17.25,
			96: 18.08,
			97: 18.99,
			98: 20.15,
			99: 3.06,
			100: 1.11,
			101: 0,
			102: 1.47,
			103: 3.11,
			104: 4.39,
			105: 5.04,
			106: 6.32,
			107: 7.19,
			108: 10.27,
			109: 11.58,
			110: 12.93,
			111: 13.61,
			112: 14.55,
			113: 15.67,
			114: 16.34,
			115: 17.06,
			116: 17.91,
			117: 18.89,
			118: 19.71,
			119: 21.07,
			120: 22.49,
			121: 23.58,
			122: 14.66,
			123: 13.11,
			124: 12.23,
			125: 11.32,
			126: 10.24,
			127: 8.71,
			128: 8.08,
			129: 7.34,
			130: 5.94,
			131: 5.04,
			132: 6.32,
			133: 7.96,
			134: 9.11,
			135: 10.35
		},
		102: {
			1: 22.11,
			2: 21.43,
			3: 20.91,
			4: 19.77,
			5: 19.01,
			6: 17.41,
			7: 16.59,
			8: 15.46,
			9: 14.71,
			10: 14.2,
			11: 14.41,
			12: 15.34,
			13: 16.82,
			14: 19.41,
			15: 20.73,
			16: 22.02,
			17: 22.85,
			18: 23.86,
			19: 24.99,
			20: 25.85,
			21: 24.65,
			22: 23.8,
			23: 22.76,
			24: 22.12,
			25: 17.43,
			26: 16.69,
			27: 15.7,
			28: 14.71,
			29: 13.92,
			30: 13.26,
			31: 11.7,
			32: 12.09,
			33: 11.46,
			34: 12.12,
			35: 12.67,
			36: 13.2,
			37: 14.23,
			38: 15.75,
			39: 16.84,
			40: 17.94,
			41: 18.82,
			42: 19.42,
			43: 20.68,
			44: 21.51,
			45: 22.27,
			46: 23.3,
			47: 23.88,
			48: 25.33,
			49: 26.2,
			50: 28.34,
			51: 30.25,
			52: 32.34,
			53: 16.06,
			54: 14.95,
			55: 14.05,
			56: 15.99,
			57: 13.2,
			58: 14.35,
			59: 15.41,
			60: 14.41,
			61: 13.51,
			62: 12.63,
			63: 11.7,
			64: 10.93,
			65: 10.11,
			66: 10.93,
			67: 12.12,
			68: 13.42,
			69: 14.41,
			70: 15.35,
			71: 16.55,
			72: 17.9,
			73: 9.58,
			74: 8.77,
			75: 9.85,
			76: 11.18,
			77: 12.63,
			78: 13.26,
			79: 13.08,
			80: 13.42,
			81: 14.22,
			82: 13.91,
			83: 13.2,
			84: 12.67,
			85: 11.34,
			86: 10.35,
			87: 9.49,
			88: 7.76,
			89: 6.49,
			90: 7.51,
			91: 9.25,
			92: 10.61,
			93: 12.02,
			94: 14.55,
			95: 15.78,
			96: 16.62,
			97: 17.52,
			98: 18.69,
			99: 4.52,
			100: 2.58,
			101: 1.47,
			102: 0,
			103: 1.64,
			104: 2.93,
			105: 3.58,
			106: 4.86,
			107: 5.72,
			108: 8.8,
			109: 10.11,
			110: 11.46,
			111: 12.15,
			112: 13.08,
			113: 14.2,
			114: 14.87,
			115: 15.6,
			116: 16.44,
			117: 17.43,
			118: 18.24,
			119: 19.6,
			120: 21.03,
			121: 22.12,
			122: 13.2,
			123: 11.65,
			124: 10.76,
			125: 9.86,
			126: 8.77,
			127: 7.25,
			128: 6.62,
			129: 5.88,
			130: 4.47,
			131: 3.58,
			132: 4.86,
			133: 6.49,
			134: 7.64,
			135: 8.89
		},
		103: {
			1: 20.46,
			2: 19.78,
			3: 19.27,
			4: 18.13,
			5: 17.36,
			6: 15.77,
			7: 14.95,
			8: 13.81,
			9: 13.07,
			10: 12.56,
			11: 12.77,
			12: 13.7,
			13: 15.18,
			14: 17.76,
			15: 19.09,
			16: 20.37,
			17: 21.2,
			18: 22.21,
			19: 23.34,
			20: 24.21,
			21: 23.01,
			22: 22.16,
			23: 21.12,
			24: 20.47,
			25: 15.78,
			26: 15.05,
			27: 14.06,
			28: 13.07,
			29: 12.28,
			30: 11.61,
			31: 10.05,
			32: 10.45,
			33: 9.82,
			34: 10.48,
			35: 11.03,
			36: 11.56,
			37: 12.59,
			38: 14.11,
			39: 15.2,
			40: 16.3,
			41: 17.18,
			42: 17.78,
			43: 19.04,
			44: 19.87,
			45: 20.63,
			46: 21.66,
			47: 22.24,
			48: 23.69,
			49: 24.56,
			50: 26.7,
			51: 28.61,
			52: 30.7,
			53: 14.41,
			54: 13.3,
			55: 12.4,
			56: 14.35,
			57: 11.55,
			58: 12.7,
			59: 13.76,
			60: 12.76,
			61: 11.86,
			62: 10.98,
			63: 10.05,
			64: 9.29,
			65: 8.47,
			66: 9.28,
			67: 10.48,
			68: 11.78,
			69: 12.77,
			70: 13.71,
			71: 14.9,
			72: 16.26,
			73: 7.94,
			74: 7.13,
			75: 8.21,
			76: 9.54,
			77: 10.98,
			78: 11.61,
			79: 11.44,
			80: 11.78,
			81: 12.57,
			82: 12.27,
			83: 11.56,
			84: 11.03,
			85: 9.7,
			86: 8.71,
			87: 7.84,
			88: 6.12,
			89: 4.85,
			90: 5.86,
			91: 7.6,
			92: 8.97,
			93: 10.37,
			94: 12.91,
			95: 14.14,
			96: 14.97,
			97: 15.88,
			98: 17.04,
			99: 6.17,
			100: 4.22,
			101: 3.11,
			102: 1.64,
			103: 0,
			104: 1.28,
			105: 1.93,
			106: 3.21,
			107: 4.08,
			108: 7.16,
			109: 8.47,
			110: 9.82,
			111: 10.5,
			112: 11.44,
			113: 12.56,
			114: 13.23,
			115: 13.95,
			116: 14.8,
			117: 15.78,
			118: 16.6,
			119: 17.96,
			120: 19.38,
			121: 20.47,
			122: 11.55,
			123: 10,
			124: 9.12,
			125: 8.21,
			126: 7.13,
			127: 5.6,
			128: 4.97,
			129: 4.23,
			130: 2.83,
			131: 1.93,
			132: 3.21,
			133: 4.85,
			134: 6,
			135: 7.24
		},
		104: {
			1: 19.18,
			2: 18.5,
			3: 17.99,
			4: 16.84,
			5: 16.08,
			6: 14.49,
			7: 13.67,
			8: 12.53,
			9: 11.79,
			10: 11.28,
			11: 11.49,
			12: 12.42,
			13: 13.89,
			14: 16.48,
			15: 17.81,
			16: 19.09,
			17: 19.92,
			18: 20.93,
			19: 22.06,
			20: 22.93,
			21: 21.73,
			22: 20.88,
			23: 19.84,
			24: 19.19,
			25: 14.5,
			26: 13.77,
			27: 12.77,
			28: 11.79,
			29: 11,
			30: 10.33,
			31: 8.77,
			32: 9.17,
			33: 8.54,
			34: 9.2,
			35: 9.75,
			36: 10.28,
			37: 11.31,
			38: 12.83,
			39: 13.92,
			40: 15.02,
			41: 15.9,
			42: 16.5,
			43: 17.76,
			44: 18.59,
			45: 19.35,
			46: 20.38,
			47: 20.96,
			48: 22.41,
			49: 23.28,
			50: 25.42,
			51: 27.33,
			52: 29.42,
			53: 13.13,
			54: 12.02,
			55: 11.12,
			56: 13.07,
			57: 10.27,
			58: 11.42,
			59: 12.48,
			60: 11.48,
			61: 10.58,
			62: 9.7,
			63: 8.77,
			64: 8.01,
			65: 7.19,
			66: 8.01,
			67: 9.2,
			68: 10.49,
			69: 11.49,
			70: 12.42,
			71: 13.62,
			72: 14.97,
			73: 6.66,
			74: 5.85,
			75: 6.93,
			76: 8.26,
			77: 9.7,
			78: 10.33,
			79: 10.16,
			80: 10.49,
			81: 11.29,
			82: 10.99,
			83: 10.28,
			84: 9.75,
			85: 8.42,
			86: 7.43,
			87: 6.56,
			88: 4.84,
			89: 3.56,
			90: 4.58,
			91: 6.32,
			92: 7.69,
			93: 9.09,
			94: 11.63,
			95: 12.86,
			96: 13.69,
			97: 14.59,
			98: 15.76,
			99: 7.45,
			100: 5.5,
			101: 4.39,
			102: 2.93,
			103: 1.28,
			104: 0,
			105: 0.65,
			106: 1.93,
			107: 2.8,
			108: 5.88,
			109: 7.19,
			110: 8.54,
			111: 9.22,
			112: 10.16,
			113: 11.28,
			114: 11.94,
			115: 12.67,
			116: 13.51,
			117: 14.5,
			118: 15.32,
			119: 16.68,
			120: 18.1,
			121: 19.19,
			122: 10.27,
			123: 8.72,
			124: 7.83,
			125: 6.93,
			126: 5.85,
			127: 4.32,
			128: 3.69,
			129: 2.95,
			130: 1.55,
			131: 0.65,
			132: 1.93,
			133: 3.56,
			134: 4.72,
			135: 5.96
		},
		105: {
			1: 18.53,
			2: 17.85,
			3: 17.33,
			4: 16.19,
			5: 15.43,
			6: 13.83,
			7: 13.01,
			8: 11.88,
			9: 11.13,
			10: 10.63,
			11: 10.83,
			12: 11.76,
			13: 13.24,
			14: 15.83,
			15: 17.16,
			16: 18.44,
			17: 19.27,
			18: 20.28,
			19: 21.41,
			20: 22.28,
			21: 21.08,
			22: 20.22,
			23: 19.18,
			24: 18.54,
			25: 13.85,
			26: 13.12,
			27: 12.12,
			28: 11.13,
			29: 10.35,
			30: 9.68,
			31: 8.12,
			32: 8.52,
			33: 7.89,
			34: 8.55,
			35: 9.1,
			36: 9.63,
			37: 10.66,
			38: 12.18,
			39: 13.27,
			40: 14.37,
			41: 15.25,
			42: 15.85,
			43: 17.11,
			44: 17.94,
			45: 18.7,
			46: 19.73,
			47: 20.31,
			48: 21.76,
			49: 22.63,
			50: 24.77,
			51: 26.68,
			52: 28.77,
			53: 12.48,
			54: 11.37,
			55: 10.47,
			56: 12.41,
			57: 9.62,
			58: 10.77,
			59: 11.83,
			60: 10.83,
			61: 9.93,
			62: 9.05,
			63: 8.12,
			64: 7.36,
			65: 6.54,
			66: 7.35,
			67: 8.55,
			68: 9.84,
			69: 10.83,
			70: 11.77,
			71: 12.97,
			72: 14.32,
			73: 6.01,
			74: 5.2,
			75: 6.28,
			76: 7.61,
			77: 9.05,
			78: 9.68,
			79: 9.51,
			80: 9.84,
			81: 10.64,
			82: 10.34,
			83: 9.63,
			84: 9.1,
			85: 7.77,
			86: 6.78,
			87: 5.91,
			88: 4.19,
			89: 2.91,
			90: 3.93,
			91: 5.67,
			92: 7.04,
			93: 8.44,
			94: 10.97,
			95: 12.21,
			96: 13.04,
			97: 13.94,
			98: 15.11,
			99: 8.1,
			100: 6.15,
			101: 5.04,
			102: 3.58,
			103: 1.93,
			104: 0.65,
			105: 0,
			106: 1.28,
			107: 2.14,
			108: 5.22,
			109: 6.54,
			110: 7.89,
			111: 8.57,
			112: 9.51,
			113: 10.63,
			114: 11.29,
			115: 12.02,
			116: 12.86,
			117: 13.85,
			118: 14.66,
			119: 16.03,
			120: 17.45,
			121: 18.54,
			122: 9.62,
			123: 8.07,
			124: 7.18,
			125: 6.28,
			126: 5.2,
			127: 3.67,
			128: 3.04,
			129: 2.3,
			130: 0.89,
			131: 0,
			132: 1.28,
			133: 2.91,
			134: 4.07,
			135: 5.31
		},
		106: {
			1: 17.25,
			2: 16.57,
			3: 16.06,
			4: 14.91,
			5: 14.15,
			6: 12.56,
			7: 11.74,
			8: 10.6,
			9: 9.86,
			10: 9.35,
			11: 9.56,
			12: 10.49,
			13: 11.96,
			14: 14.55,
			15: 15.88,
			16: 17.16,
			17: 17.99,
			18: 19,
			19: 20.13,
			20: 21,
			21: 19.8,
			22: 18.95,
			23: 17.91,
			24: 17.26,
			25: 12.57,
			26: 11.84,
			27: 10.84,
			28: 9.86,
			29: 9.07,
			30: 8.4,
			31: 6.84,
			32: 7.24,
			33: 6.61,
			34: 7.27,
			35: 7.82,
			36: 8.35,
			37: 9.38,
			38: 10.9,
			39: 11.99,
			40: 13.09,
			41: 13.97,
			42: 14.57,
			43: 15.83,
			44: 16.66,
			45: 17.42,
			46: 18.45,
			47: 19.03,
			48: 20.48,
			49: 21.35,
			50: 23.49,
			51: 25.4,
			52: 27.49,
			53: 13.76,
			54: 12.65,
			55: 11.75,
			56: 13.69,
			57: 10.9,
			58: 12.05,
			59: 11.11,
			60: 9.55,
			61: 8.65,
			62: 7.77,
			63: 6.84,
			64: 6.08,
			65: 5.26,
			66: 6.07,
			67: 7.27,
			68: 8.56,
			69: 9.56,
			70: 10.49,
			71: 11.69,
			72: 13.04,
			73: 7.28,
			74: 6.47,
			75: 7.55,
			76: 8.88,
			77: 7.77,
			78: 8.4,
			79: 8.23,
			80: 8.56,
			81: 9.36,
			82: 9.06,
			83: 8.35,
			84: 7.82,
			85: 6.49,
			86: 5.5,
			87: 4.63,
			88: 2.91,
			89: 1.63,
			90: 2.65,
			91: 4.39,
			92: 5.76,
			93: 7.16,
			94: 9.7,
			95: 10.93,
			96: 11.76,
			97: 12.66,
			98: 13.83,
			99: 9.38,
			100: 7.43,
			101: 6.32,
			102: 4.86,
			103: 3.21,
			104: 1.93,
			105: 1.28,
			106: 0,
			107: 0.87,
			108: 3.95,
			109: 5.26,
			110: 6.61,
			111: 7.29,
			112: 8.23,
			113: 9.35,
			114: 10.01,
			115: 10.74,
			116: 11.58,
			117: 12.57,
			118: 13.39,
			119: 14.75,
			120: 16.17,
			121: 17.26,
			122: 10.9,
			123: 9.35,
			124: 8.46,
			125: 7.56,
			126: 6.47,
			127: 4.95,
			128: 4.32,
			129: 3.58,
			130: 2.17,
			131: 1.28,
			132: 0,
			133: 1.63,
			134: 2.79,
			135: 4.03
		},
		107: {
			1: 16.39,
			2: 15.71,
			3: 15.19,
			4: 14.05,
			5: 13.29,
			6: 11.69,
			7: 10.87,
			8: 9.74,
			9: 8.99,
			10: 8.48,
			11: 8.69,
			12: 9.62,
			13: 11.1,
			14: 13.69,
			15: 15.01,
			16: 16.3,
			17: 17.13,
			18: 18.14,
			19: 19.27,
			20: 20.13,
			21: 18.93,
			22: 18.08,
			23: 17.04,
			24: 16.4,
			25: 11.71,
			26: 10.97,
			27: 9.98,
			28: 8.99,
			29: 8.2,
			30: 7.54,
			31: 5.98,
			32: 6.37,
			33: 5.74,
			34: 6.4,
			35: 6.95,
			36: 7.48,
			37: 8.51,
			38: 10.03,
			39: 11.12,
			40: 12.22,
			41: 13.1,
			42: 13.7,
			43: 14.96,
			44: 15.79,
			45: 16.55,
			46: 17.58,
			47: 18.16,
			48: 19.61,
			49: 20.48,
			50: 22.62,
			51: 24.53,
			52: 26.62,
			53: 14.62,
			54: 13.51,
			55: 12.61,
			56: 14.56,
			57: 11.76,
			58: 11.31,
			59: 10.25,
			60: 8.69,
			61: 7.79,
			62: 6.91,
			63: 5.98,
			64: 5.21,
			65: 4.39,
			66: 5.21,
			67: 6.4,
			68: 7.7,
			69: 8.69,
			70: 9.63,
			71: 10.83,
			72: 12.18,
			73: 8.15,
			74: 7.34,
			75: 8.42,
			76: 9.05,
			77: 6.91,
			78: 7.54,
			79: 7.36,
			80: 7.7,
			81: 8.5,
			82: 8.19,
			83: 7.48,
			84: 8.14,
			85: 7.35,
			86: 6.36,
			87: 5.5,
			88: 3.77,
			89: 2.5,
			90: 3.52,
			91: 5.26,
			92: 6.62,
			93: 8.03,
			94: 10.02,
			95: 11.25,
			96: 12.09,
			97: 12.99,
			98: 14.15,
			99: 10.24,
			100: 8.3,
			101: 7.19,
			102: 5.72,
			103: 4.08,
			104: 2.8,
			105: 2.14,
			106: 0.87,
			107: 0,
			108: 3.08,
			109: 4.39,
			110: 5.74,
			111: 6.43,
			112: 7.36,
			113: 8.48,
			114: 9.15,
			115: 9.88,
			116: 10.72,
			117: 11.71,
			118: 12.52,
			119: 13.88,
			120: 15.31,
			121: 16.4,
			122: 11.76,
			123: 10.21,
			124: 9.33,
			125: 8.42,
			126: 7.34,
			127: 5.81,
			128: 5.18,
			129: 4.44,
			130: 3.04,
			131: 2.14,
			132: 0.87,
			133: 2.5,
			134: 3.65,
			135: 4.9
		},
		108: {
			1: 13.31,
			2: 12.63,
			3: 12.11,
			4: 10.97,
			5: 10.21,
			6: 8.61,
			7: 7.79,
			8: 6.66,
			9: 5.91,
			10: 5.4,
			11: 5.61,
			12: 6.54,
			13: 8.02,
			14: 10.61,
			15: 11.93,
			16: 13.22,
			17: 14.05,
			18: 15.06,
			19: 16.19,
			20: 17.05,
			21: 15.85,
			22: 15,
			23: 13.96,
			24: 13.32,
			25: 8.63,
			26: 7.89,
			27: 6.9,
			28: 5.91,
			29: 5.12,
			30: 4.46,
			31: 2.9,
			32: 3.29,
			33: 2.66,
			34: 3.32,
			35: 3.87,
			36: 4.4,
			37: 5.43,
			38: 6.95,
			39: 8.04,
			40: 9.14,
			41: 10.02,
			42: 10.62,
			43: 11.88,
			44: 12.71,
			45: 13.47,
			46: 14.5,
			47: 15.08,
			48: 16.53,
			49: 17.4,
			50: 19.54,
			51: 21.45,
			52: 23.54,
			53: 12.24,
			54: 11.13,
			55: 10.23,
			56: 12.17,
			57: 9.38,
			58: 8.23,
			59: 7.17,
			60: 5.61,
			61: 4.71,
			62: 3.83,
			63: 2.9,
			64: 2.13,
			65: 1.31,
			66: 2.13,
			67: 3.32,
			68: 4.62,
			69: 5.61,
			70: 6.55,
			71: 7.75,
			72: 9.1,
			73: 9.19,
			74: 8.38,
			75: 7.3,
			76: 5.97,
			77: 3.83,
			78: 4.46,
			79: 4.28,
			80: 4.62,
			81: 5.42,
			82: 5.11,
			83: 4.4,
			84: 5.06,
			85: 6.4,
			86: 7.38,
			87: 8.25,
			88: 6.85,
			89: 5.58,
			90: 6.6,
			91: 8.34,
			92: 9.7,
			93: 11.11,
			94: 6.94,
			95: 8.17,
			96: 9.01,
			97: 9.91,
			98: 11.07,
			99: 13.32,
			100: 11.38,
			101: 10.27,
			102: 8.8,
			103: 7.16,
			104: 5.88,
			105: 5.22,
			106: 3.95,
			107: 3.08,
			108: 0,
			109: 1.31,
			110: 2.66,
			111: 3.35,
			112: 4.28,
			113: 5.4,
			114: 6.07,
			115: 6.8,
			116: 7.64,
			117: 8.63,
			118: 9.44,
			119: 10.8,
			120: 12.23,
			121: 13.32,
			122: 9.38,
			123: 10.93,
			124: 10.36,
			125: 9.46,
			126: 8.38,
			127: 8.89,
			128: 8.26,
			129: 7.52,
			130: 6.12,
			131: 5.22,
			132: 3.95,
			133: 5.58,
			134: 6.73,
			135: 7.98
		},
		109: {
			1: 11.99,
			2: 11.31,
			3: 10.8,
			4: 9.66,
			5: 8.89,
			6: 7.3,
			7: 6.48,
			8: 5.34,
			9: 4.6,
			10: 4.09,
			11: 4.3,
			12: 5.23,
			13: 6.71,
			14: 9.29,
			15: 10.62,
			16: 11.9,
			17: 12.73,
			18: 13.74,
			19: 14.87,
			20: 15.74,
			21: 14.54,
			22: 13.69,
			23: 12.65,
			24: 12,
			25: 7.31,
			26: 6.58,
			27: 5.59,
			28: 4.6,
			29: 3.81,
			30: 3.14,
			31: 1.58,
			32: 1.98,
			33: 1.35,
			34: 2.01,
			35: 2.56,
			36: 3.09,
			37: 4.12,
			38: 5.64,
			39: 6.73,
			40: 7.83,
			41: 8.71,
			42: 9.31,
			43: 10.57,
			44: 11.4,
			45: 12.16,
			46: 13.19,
			47: 13.77,
			48: 15.22,
			49: 16.09,
			50: 18.23,
			51: 20.14,
			52: 22.23,
			53: 10.92,
			54: 9.81,
			55: 8.91,
			56: 10.86,
			57: 8.06,
			58: 6.91,
			59: 5.85,
			60: 4.29,
			61: 3.39,
			62: 2.51,
			63: 1.58,
			64: 0.82,
			65: 0,
			66: 0.81,
			67: 2.01,
			68: 3.31,
			69: 4.3,
			70: 5.24,
			71: 6.43,
			72: 7.79,
			73: 7.87,
			74: 7.06,
			75: 5.98,
			76: 4.65,
			77: 2.51,
			78: 3.14,
			79: 2.97,
			80: 3.31,
			81: 4.1,
			82: 3.8,
			83: 3.09,
			84: 3.75,
			85: 5.08,
			86: 6.07,
			87: 6.94,
			88: 8.17,
			89: 6.89,
			90: 7.91,
			91: 9.65,
			92: 11.02,
			93: 12.42,
			94: 5.63,
			95: 6.86,
			96: 7.69,
			97: 8.59,
			98: 9.76,
			99: 14.64,
			100: 12.69,
			101: 11.58,
			102: 10.11,
			103: 8.47,
			104: 7.19,
			105: 6.54,
			106: 5.26,
			107: 4.39,
			108: 1.31,
			109: 0,
			110: 1.35,
			111: 2.03,
			112: 2.97,
			113: 4.09,
			114: 4.76,
			115: 5.48,
			116: 6.33,
			117: 7.31,
			118: 8.13,
			119: 9.49,
			120: 10.91,
			121: 12,
			122: 8.06,
			123: 9.61,
			124: 9.05,
			125: 8.15,
			126: 7.06,
			127: 8.59,
			128: 9.22,
			129: 8.84,
			130: 7.43,
			131: 6.54,
			132: 5.26,
			133: 6.89,
			134: 8.05,
			135: 9.29
		},
		110: {
			1: 11.03,
			2: 10.35,
			3: 9.83,
			4: 8.69,
			5: 7.93,
			6: 6.33,
			7: 5.51,
			8: 4.38,
			9: 3.63,
			10: 2.74,
			11: 2.95,
			12: 3.88,
			13: 5.36,
			14: 7.94,
			15: 9.27,
			16: 10.56,
			17: 11.38,
			18: 12.39,
			19: 13.52,
			20: 14.39,
			21: 13.19,
			22: 12.34,
			23: 11.3,
			24: 10.65,
			25: 6.35,
			26: 5.62,
			27: 4.62,
			28: 3.63,
			29: 3.49,
			30: 2.82,
			31: 1.62,
			32: 0.63,
			33: 0,
			34: 0.66,
			35: 1.21,
			36: 1.74,
			37: 2.77,
			38: 4.29,
			39: 5.38,
			40: 6.48,
			41: 7.36,
			42: 7.96,
			43: 9.22,
			44: 10.05,
			45: 10.81,
			46: 11.84,
			47: 12.42,
			48: 13.87,
			49: 14.74,
			50: 16.88,
			51: 18.79,
			52: 20.88,
			53: 10.96,
			54: 9.85,
			55: 8.95,
			56: 10.89,
			57: 8.1,
			58: 6.95,
			59: 5.89,
			60: 4.33,
			61: 3.43,
			62: 2.55,
			63: 1.62,
			64: 2.17,
			65: 1.35,
			66: 1.92,
			67: 0.66,
			68: 1.96,
			69: 2.95,
			70: 3.89,
			71: 5.08,
			72: 6.44,
			73: 7.91,
			74: 7.1,
			75: 6.02,
			76: 4.69,
			77: 2.55,
			78: 2.82,
			79: 1.62,
			80: 1.96,
			81: 2.75,
			82: 2.45,
			83: 1.74,
			84: 2.4,
			85: 3.73,
			86: 4.72,
			87: 5.59,
			88: 7.31,
			89: 8.24,
			90: 9.26,
			91: 11,
			92: 12.37,
			93: 13.77,
			94: 4.28,
			95: 5.51,
			96: 6.34,
			97: 7.25,
			98: 8.41,
			99: 15.99,
			100: 14.04,
			101: 12.93,
			102: 11.46,
			103: 9.82,
			104: 8.54,
			105: 7.89,
			106: 6.61,
			107: 5.74,
			108: 2.66,
			109: 1.35,
			110: 0,
			111: 0.68,
			112: 1.62,
			113: 2.74,
			114: 3.41,
			115: 4.14,
			116: 4.98,
			117: 5.96,
			118: 6.78,
			119: 8.14,
			120: 9.56,
			121: 10.65,
			122: 8.1,
			123: 9.65,
			124: 9.09,
			125: 8.19,
			126: 7.1,
			127: 8.63,
			128: 9.26,
			129: 10,
			130: 8.78,
			131: 7.89,
			132: 6.61,
			133: 8.24,
			134: 9.4,
			135: 10.64
		},
		111: {
			1: 10.35,
			2: 9.67,
			3: 9.15,
			4: 8.01,
			5: 7.25,
			6: 5.65,
			7: 4.83,
			8: 3.7,
			9: 2.95,
			10: 2.06,
			11: 3.07,
			12: 4.01,
			13: 5.48,
			14: 8.07,
			15: 9.4,
			16: 10.68,
			17: 11.51,
			18: 12.52,
			19: 13.65,
			20: 14.14,
			21: 12.51,
			22: 11.66,
			23: 10.62,
			24: 9.97,
			25: 5.67,
			26: 4.93,
			27: 3.94,
			28: 2.95,
			29: 2.81,
			30: 2.14,
			31: 2.3,
			32: 1.31,
			33: 0.68,
			34: 1.34,
			35: 1.89,
			36: 2.42,
			37: 3.45,
			38: 4.97,
			39: 6.06,
			40: 7.16,
			41: 8.04,
			42: 8.64,
			43: 9.9,
			44: 10.73,
			45: 11.49,
			46: 12.52,
			47: 13.1,
			48: 14.55,
			49: 15.42,
			50: 17.56,
			51: 19.47,
			52: 21.56,
			53: 11.64,
			54: 10.53,
			55: 9.63,
			56: 11.58,
			57: 8.78,
			58: 7.63,
			59: 6.57,
			60: 5.01,
			61: 4.11,
			62: 3.23,
			63: 2.3,
			64: 2.85,
			65: 2.03,
			66: 2.61,
			67: 1.34,
			68: 2.08,
			69: 3.07,
			70: 4.01,
			71: 5.21,
			72: 6.56,
			73: 8.59,
			74: 7.78,
			75: 6.7,
			76: 5.37,
			77: 3.23,
			78: 2.14,
			79: 0.94,
			80: 2.08,
			81: 2.88,
			82: 3.13,
			83: 2.42,
			84: 3.08,
			85: 4.42,
			86: 5.4,
			87: 6.27,
			88: 8,
			89: 8.92,
			90: 9.94,
			91: 11.68,
			92: 13.05,
			93: 14.45,
			94: 4.96,
			95: 6.19,
			96: 7.03,
			97: 7.93,
			98: 9.1,
			99: 16.67,
			100: 14.72,
			101: 13.61,
			102: 12.15,
			103: 10.5,
			104: 9.22,
			105: 8.57,
			106: 7.29,
			107: 6.43,
			108: 3.35,
			109: 2.03,
			110: 0.68,
			111: 0,
			112: 0.94,
			113: 2.06,
			114: 2.72,
			115: 3.45,
			116: 4.29,
			117: 5.28,
			118: 6.1,
			119: 7.46,
			120: 8.88,
			121: 9.97,
			122: 8.78,
			123: 10.33,
			124: 9.77,
			125: 8.87,
			126: 7.78,
			127: 9.31,
			128: 9.94,
			129: 10.68,
			130: 9.46,
			131: 8.57,
			132: 7.29,
			133: 8.92,
			134: 10.08,
			135: 11.32
		},
		112: {
			1: 9.41,
			2: 8.73,
			3: 8.21,
			4: 7.07,
			5: 6.31,
			6: 4.71,
			7: 3.89,
			8: 2.76,
			9: 2.01,
			10: 1.12,
			11: 2.14,
			12: 3.07,
			13: 4.55,
			14: 7.13,
			15: 8.46,
			16: 9.74,
			17: 10.57,
			18: 11.58,
			19: 12.71,
			20: 13.2,
			21: 11.57,
			22: 10.72,
			23: 9.68,
			24: 9.03,
			25: 4.73,
			26: 3.99,
			27: 3,
			28: 2.01,
			29: 1.87,
			30: 1.2,
			31: 2.76,
			32: 2.25,
			33: 1.62,
			34: 2.28,
			35: 2.83,
			36: 3.36,
			37: 4.39,
			38: 5.91,
			39: 7,
			40: 8.1,
			41: 8.98,
			42: 9.58,
			43: 10.84,
			44: 11.67,
			45: 12.43,
			46: 13.46,
			47: 14.04,
			48: 15.49,
			49: 16.36,
			50: 18.5,
			51: 20.41,
			52: 22.5,
			53: 11.19,
			54: 10.08,
			55: 9.18,
			56: 11.12,
			57: 8.33,
			58: 7.18,
			59: 6.12,
			60: 4.56,
			61: 3.66,
			62: 2.78,
			63: 2.76,
			64: 3.52,
			65: 2.97,
			66: 3.54,
			67: 2.28,
			68: 1.14,
			69: 2.14,
			70: 3.08,
			71: 4.27,
			72: 5.63,
			73: 8.14,
			74: 7.33,
			75: 6.25,
			76: 4.92,
			77: 2.78,
			78: 1.2,
			79: 0,
			80: 1.14,
			81: 1.94,
			82: 2.89,
			83: 3.36,
			84: 4.02,
			85: 5.35,
			86: 6.34,
			87: 7.21,
			88: 8.93,
			89: 9.86,
			90: 10.88,
			91: 12.62,
			92: 13.99,
			93: 15.39,
			94: 5.9,
			95: 7.13,
			96: 7.97,
			97: 8.87,
			98: 10.03,
			99: 17.61,
			100: 15.66,
			101: 14.55,
			102: 13.08,
			103: 11.44,
			104: 10.16,
			105: 9.51,
			106: 8.23,
			107: 7.36,
			108: 4.28,
			109: 2.97,
			110: 1.62,
			111: 0.94,
			112: 0,
			113: 1.12,
			114: 1.79,
			115: 2.51,
			116: 3.36,
			117: 4.34,
			118: 5.16,
			119: 6.52,
			120: 7.94,
			121: 9.03,
			122: 8.33,
			123: 9.88,
			124: 9.31,
			125: 8.41,
			126: 7.33,
			127: 8.85,
			128: 9.48,
			129: 10.22,
			130: 10.4,
			131: 9.51,
			132: 8.23,
			133: 9.86,
			134: 11.02,
			135: 12.26
		},
		113: {
			1: 8.29,
			2: 7.61,
			3: 7.09,
			4: 5.95,
			5: 5.19,
			6: 3.59,
			7: 2.77,
			8: 1.64,
			9: 0.89,
			10: 0,
			11: 1.27,
			12: 2.2,
			13: 3.68,
			14: 6.26,
			15: 7.59,
			16: 8.88,
			17: 9.7,
			18: 10.71,
			19: 11.84,
			20: 12.08,
			21: 10.45,
			22: 9.6,
			23: 8.56,
			24: 7.91,
			25: 3.61,
			26: 2.88,
			27: 1.88,
			28: 0.89,
			29: 1.68,
			30: 2.32,
			31: 3.88,
			32: 3.37,
			33: 2.74,
			34: 3.4,
			35: 3.95,
			36: 4.48,
			37: 5.51,
			38: 7.03,
			39: 8.12,
			40: 9.22,
			41: 10.1,
			42: 10.7,
			43: 11.96,
			44: 12.79,
			45: 13.55,
			46: 14.58,
			47: 15.16,
			48: 16.61,
			49: 17.48,
			50: 19.62,
			51: 21.53,
			52: 23.62,
			53: 12.31,
			54: 11.2,
			55: 10.3,
			56: 12.24,
			57: 9.45,
			58: 8.3,
			59: 7.24,
			60: 5.68,
			61: 4.78,
			62: 3.9,
			63: 3.88,
			64: 4.64,
			65: 4.09,
			66: 4.66,
			67: 3.4,
			68: 2.26,
			69: 1.27,
			70: 2.21,
			71: 3.4,
			72: 4.76,
			73: 9.26,
			74: 8.45,
			75: 7.37,
			76: 6.04,
			77: 3.9,
			78: 2.32,
			79: 1.12,
			80: 2.26,
			81: 3.06,
			82: 4.01,
			83: 4.48,
			84: 5.14,
			85: 6.47,
			86: 7.46,
			87: 8.33,
			88: 10.05,
			89: 10.98,
			90: 12,
			91: 13.74,
			92: 15.11,
			93: 16.51,
			94: 7.02,
			95: 8.25,
			96: 9.08,
			97: 9.99,
			98: 11.15,
			99: 18.73,
			100: 16.78,
			101: 15.67,
			102: 14.2,
			103: 12.56,
			104: 11.28,
			105: 10.63,
			106: 9.35,
			107: 8.48,
			108: 5.4,
			109: 4.09,
			110: 2.74,
			111: 2.06,
			112: 1.12,
			113: 0,
			114: 0.67,
			115: 1.4,
			116: 2.24,
			117: 3.22,
			118: 4.04,
			119: 5.4,
			120: 6.82,
			121: 7.91,
			122: 9.45,
			123: 11,
			124: 10.43,
			125: 9.53,
			126: 8.45,
			127: 9.97,
			128: 10.6,
			129: 11.34,
			130: 11.52,
			131: 10.63,
			132: 9.35,
			133: 10.98,
			134: 12.14,
			135: 13.38
		},
		114: {
			1: 8.96,
			2: 8.28,
			3: 7.76,
			4: 6.62,
			5: 5.86,
			6: 4.26,
			7: 3.44,
			8: 2.31,
			9: 1.56,
			10: 0.67,
			11: 1.94,
			12: 2.87,
			13: 4.34,
			14: 6.93,
			15: 8.26,
			16: 9.54,
			17: 10.37,
			18: 11.38,
			19: 12.28,
			20: 11.41,
			21: 9.78,
			22: 8.93,
			23: 7.89,
			24: 7.25,
			25: 4.28,
			26: 3.54,
			27: 2.55,
			28: 1.56,
			29: 2.35,
			30: 2.99,
			31: 4.55,
			32: 4.04,
			33: 3.41,
			34: 4.07,
			35: 4.62,
			36: 5.15,
			37: 6.18,
			38: 7.7,
			39: 8.79,
			40: 9.89,
			41: 10.77,
			42: 11.37,
			43: 12.63,
			44: 13.46,
			45: 14.22,
			46: 15.25,
			47: 15.83,
			48: 17.28,
			49: 18.15,
			50: 20.29,
			51: 22.2,
			52: 24.29,
			53: 12.97,
			54: 11.86,
			55: 10.96,
			56: 12.91,
			57: 10.11,
			58: 8.96,
			59: 7.9,
			60: 6.34,
			61: 5.44,
			62: 4.56,
			63: 4.55,
			64: 5.31,
			65: 4.76,
			66: 5.33,
			67: 4.07,
			68: 2.93,
			69: 1.94,
			70: 2.87,
			71: 4.07,
			72: 5.42,
			73: 9.92,
			74: 9.11,
			75: 8.03,
			76: 6.7,
			77: 4.56,
			78: 2.99,
			79: 1.79,
			80: 2.93,
			81: 3.73,
			82: 4.67,
			83: 5.15,
			84: 5.81,
			85: 7.14,
			86: 8.13,
			87: 9,
			88: 10.72,
			89: 11.65,
			90: 12.67,
			91: 14.41,
			92: 15.77,
			93: 17.17,
			94: 7.69,
			95: 8.92,
			96: 9.75,
			97: 10.65,
			98: 11.82,
			99: 19.39,
			100: 17.45,
			101: 16.34,
			102: 14.87,
			103: 13.23,
			104: 11.94,
			105: 11.29,
			106: 10.01,
			107: 9.15,
			108: 6.07,
			109: 4.76,
			110: 3.41,
			111: 2.72,
			112: 1.79,
			113: 0.67,
			114: 0,
			115: 0.73,
			116: 1.57,
			117: 2.56,
			118: 3.37,
			119: 4.73,
			120: 6.16,
			121: 7.25,
			122: 10.11,
			123: 11.66,
			124: 11.1,
			125: 10.2,
			126: 9.11,
			127: 10.64,
			128: 11.27,
			129: 12.01,
			130: 12.19,
			131: 11.29,
			132: 10.01,
			133: 11.65,
			134: 12.8,
			135: 14.05
		},
		115: {
			1: 9.69,
			2: 9,
			3: 8.49,
			4: 7.35,
			5: 6.59,
			6: 4.99,
			7: 4.17,
			8: 3.03,
			9: 2.29,
			10: 1.4,
			11: 2.66,
			12: 3.59,
			13: 5.07,
			14: 7.66,
			15: 8.99,
			16: 10.27,
			17: 11.1,
			18: 12.11,
			19: 11.55,
			20: 10.68,
			21: 9.06,
			22: 8.2,
			23: 7.16,
			24: 6.52,
			25: 5.01,
			26: 4.27,
			27: 3.28,
			28: 2.29,
			29: 3.08,
			30: 3.72,
			31: 5.28,
			32: 4.77,
			33: 4.14,
			34: 4.8,
			35: 5.35,
			36: 5.88,
			37: 6.91,
			38: 8.43,
			39: 9.52,
			40: 10.62,
			41: 11.5,
			42: 12.1,
			43: 13.36,
			44: 14.19,
			45: 14.95,
			46: 15.98,
			47: 16.56,
			48: 18.01,
			49: 18.88,
			50: 21.02,
			51: 22.93,
			52: 25.02,
			53: 13.7,
			54: 12.59,
			55: 11.69,
			56: 13.63,
			57: 10.84,
			58: 9.69,
			59: 8.63,
			60: 7.07,
			61: 6.17,
			62: 5.29,
			63: 5.28,
			64: 6.04,
			65: 5.48,
			66: 6.06,
			67: 4.8,
			68: 3.66,
			69: 2.66,
			70: 3.6,
			71: 4.8,
			72: 6.15,
			73: 10.65,
			74: 9.84,
			75: 8.76,
			76: 7.43,
			77: 5.29,
			78: 3.72,
			79: 2.51,
			80: 3.66,
			81: 4.45,
			82: 5.4,
			83: 5.88,
			84: 6.54,
			85: 7.87,
			86: 8.86,
			87: 9.73,
			88: 11.45,
			89: 12.38,
			90: 13.39,
			91: 15.13,
			92: 16.5,
			93: 17.9,
			94: 8.41,
			95: 9.65,
			96: 10.48,
			97: 11.38,
			98: 12.55,
			99: 20.12,
			100: 18.17,
			101: 17.06,
			102: 15.6,
			103: 13.95,
			104: 12.67,
			105: 12.02,
			106: 10.74,
			107: 9.88,
			108: 6.8,
			109: 5.48,
			110: 4.14,
			111: 3.45,
			112: 2.51,
			113: 1.4,
			114: 0.73,
			115: 0,
			116: 0.84,
			117: 1.83,
			118: 2.64,
			119: 4.01,
			120: 5.43,
			121: 6.52,
			122: 10.84,
			123: 12.39,
			124: 11.83,
			125: 10.93,
			126: 9.84,
			127: 11.37,
			128: 12,
			129: 12.74,
			130: 12.91,
			131: 12.02,
			132: 10.74,
			133: 12.38,
			134: 13.53,
			135: 14.77
		},
		116: {
			1: 10.53,
			2: 9.85,
			3: 9.33,
			4: 8.19,
			5: 7.43,
			6: 5.83,
			7: 5.01,
			8: 3.88,
			9: 3.13,
			10: 2.24,
			11: 3.51,
			12: 4.44,
			13: 5.91,
			14: 8.5,
			15: 9.83,
			16: 11.11,
			17: 11.94,
			18: 11.84,
			19: 10.71,
			20: 9.84,
			21: 8.21,
			22: 7.36,
			23: 6.32,
			24: 5.68,
			25: 5.85,
			26: 5.11,
			27: 4.12,
			28: 3.13,
			29: 3.92,
			30: 4.56,
			31: 6.12,
			32: 5.61,
			33: 4.98,
			34: 5.64,
			35: 6.19,
			36: 6.72,
			37: 7.75,
			38: 9.27,
			39: 10.36,
			40: 11.46,
			41: 12.34,
			42: 12.94,
			43: 14.2,
			44: 15.03,
			45: 15.79,
			46: 16.82,
			47: 17.4,
			48: 18.85,
			49: 19.72,
			50: 21.86,
			51: 23.77,
			52: 25.86,
			53: 14.54,
			54: 13.43,
			55: 12.53,
			56: 14.48,
			57: 11.68,
			58: 10.53,
			59: 9.47,
			60: 7.91,
			61: 7.01,
			62: 6.13,
			63: 6.12,
			64: 6.88,
			65: 6.33,
			66: 6.9,
			67: 5.64,
			68: 4.5,
			69: 3.51,
			70: 4.44,
			71: 5.64,
			72: 6.99,
			73: 11.49,
			74: 10.68,
			75: 9.6,
			76: 8.27,
			77: 6.13,
			78: 4.56,
			79: 3.36,
			80: 4.5,
			81: 5.3,
			82: 6.24,
			83: 6.72,
			84: 7.38,
			85: 8.71,
			86: 9.7,
			87: 10.57,
			88: 12.29,
			89: 13.22,
			90: 14.24,
			91: 15.98,
			92: 17.34,
			93: 18.74,
			94: 9.26,
			95: 10.49,
			96: 11.32,
			97: 12.22,
			98: 13.39,
			99: 20.96,
			100: 19.02,
			101: 17.91,
			102: 16.44,
			103: 14.8,
			104: 13.51,
			105: 12.86,
			106: 11.58,
			107: 10.72,
			108: 7.64,
			109: 6.33,
			110: 4.98,
			111: 4.29,
			112: 3.36,
			113: 2.24,
			114: 1.57,
			115: 0.84,
			116: 0,
			117: 0.99,
			118: 1.8,
			119: 3.16,
			120: 4.59,
			121: 5.68,
			122: 11.68,
			123: 13.23,
			124: 12.67,
			125: 11.77,
			126: 10.68,
			127: 12.21,
			128: 12.84,
			129: 13.58,
			130: 13.76,
			131: 12.86,
			132: 11.58,
			133: 13.22,
			134: 14.37,
			135: 15.62
		},
		117: {
			1: 11.51,
			2: 10.83,
			3: 10.32,
			4: 9.18,
			5: 8.41,
			6: 6.82,
			7: 6,
			8: 4.86,
			9: 4.12,
			10: 3.22,
			11: 4.49,
			12: 5.42,
			13: 6.9,
			14: 9.49,
			15: 10.81,
			16: 12.1,
			17: 11.86,
			18: 10.85,
			19: 9.72,
			20: 8.86,
			21: 7.23,
			22: 6.38,
			23: 5.34,
			24: 4.69,
			25: 6.83,
			26: 6.1,
			27: 5.1,
			28: 4.12,
			29: 4.9,
			30: 5.54,
			31: 7.1,
			32: 6.59,
			33: 5.96,
			34: 6.62,
			35: 7.17,
			36: 7.7,
			37: 8.73,
			38: 10.25,
			39: 11.34,
			40: 12.44,
			41: 13.32,
			42: 13.92,
			43: 15.18,
			44: 16.01,
			45: 16.77,
			46: 17.8,
			47: 18.38,
			48: 19.83,
			49: 20.7,
			50: 22.84,
			51: 24.75,
			52: 26.84,
			53: 15.53,
			54: 14.42,
			55: 13.52,
			56: 15.46,
			57: 12.67,
			58: 11.52,
			59: 10.46,
			60: 8.9,
			61: 8,
			62: 7.12,
			63: 7.1,
			64: 7.87,
			65: 7.31,
			66: 7.89,
			67: 6.62,
			68: 5.48,
			69: 4.49,
			70: 5.43,
			71: 6.63,
			72: 7.98,
			73: 12.48,
			74: 11.67,
			75: 10.59,
			76: 9.26,
			77: 7.12,
			78: 5.54,
			79: 4.34,
			80: 5.48,
			81: 6.28,
			82: 7.23,
			83: 7.7,
			84: 8.36,
			85: 9.7,
			86: 10.68,
			87: 11.55,
			88: 13.28,
			89: 14.2,
			90: 15.22,
			91: 16.96,
			92: 18.33,
			93: 19.73,
			94: 10.24,
			95: 11.47,
			96: 12.31,
			97: 13.21,
			98: 14.38,
			99: 21.95,
			100: 20.01,
			101: 18.89,
			102: 17.43,
			103: 15.78,
			104: 14.5,
			105: 13.85,
			106: 12.57,
			107: 11.71,
			108: 8.63,
			109: 7.31,
			110: 5.96,
			111: 5.28,
			112: 4.34,
			113: 3.22,
			114: 2.56,
			115: 1.83,
			116: 0.99,
			117: 0,
			118: 0.82,
			119: 2.18,
			120: 3.6,
			121: 4.69,
			122: 12.67,
			123: 14.22,
			124: 13.66,
			125: 12.75,
			126: 11.67,
			127: 13.2,
			128: 13.83,
			129: 14.56,
			130: 14.74,
			131: 13.85,
			132: 12.57,
			133: 14.2,
			134: 15.36,
			135: 16.6
		},
		118: {
			1: 12.33,
			2: 11.65,
			3: 11.13,
			4: 9.99,
			5: 9.23,
			6: 7.63,
			7: 6.81,
			8: 5.68,
			9: 4.93,
			10: 4.04,
			11: 5.31,
			12: 6.24,
			13: 7.72,
			14: 10.3,
			15: 11.63,
			16: 11.88,
			17: 11.05,
			18: 10.04,
			19: 8.91,
			20: 8.04,
			21: 6.41,
			22: 5.56,
			23: 4.52,
			24: 3.88,
			25: 7.65,
			26: 6.91,
			27: 5.92,
			28: 4.93,
			29: 5.72,
			30: 6.36,
			31: 7.92,
			32: 7.41,
			33: 6.78,
			34: 7.44,
			35: 7.99,
			36: 8.52,
			37: 9.55,
			38: 11.07,
			39: 12.16,
			40: 13.26,
			41: 14.14,
			42: 14.74,
			43: 16,
			44: 16.83,
			45: 17.59,
			46: 18.62,
			47: 19.2,
			48: 20.65,
			49: 21.52,
			50: 23.66,
			51: 25.57,
			52: 27.66,
			53: 16.34,
			54: 15.23,
			55: 14.33,
			56: 16.28,
			57: 13.48,
			58: 12.33,
			59: 11.27,
			60: 9.71,
			61: 8.81,
			62: 7.93,
			63: 7.92,
			64: 8.68,
			65: 8.13,
			66: 8.7,
			67: 7.44,
			68: 6.3,
			69: 5.31,
			70: 6.25,
			71: 7.44,
			72: 8.8,
			73: 13.29,
			74: 12.48,
			75: 11.4,
			76: 10.07,
			77: 7.93,
			78: 6.36,
			79: 5.16,
			80: 6.3,
			81: 7.1,
			82: 8.04,
			83: 8.52,
			84: 9.18,
			85: 10.51,
			86: 11.5,
			87: 12.37,
			88: 14.09,
			89: 15.02,
			90: 16.04,
			91: 17.78,
			92: 19.14,
			93: 20.55,
			94: 11.06,
			95: 12.29,
			96: 13.12,
			97: 14.02,
			98: 15.19,
			99: 22.76,
			100: 20.82,
			101: 19.71,
			102: 18.24,
			103: 16.6,
			104: 15.32,
			105: 14.66,
			106: 13.39,
			107: 12.52,
			108: 9.44,
			109: 8.13,
			110: 6.78,
			111: 6.1,
			112: 5.16,
			113: 4.04,
			114: 3.37,
			115: 2.64,
			116: 1.8,
			117: 0.82,
			118: 0,
			119: 1.36,
			120: 2.79,
			121: 3.88,
			122: 13.48,
			123: 15.03,
			124: 14.47,
			125: 13.57,
			126: 12.48,
			127: 14.01,
			128: 14.64,
			129: 15.38,
			130: 15.56,
			131: 14.66,
			132: 13.39,
			133: 15.02,
			134: 16.17,
			135: 17.42
		},
		119: {
			1: 13.69,
			2: 13.01,
			3: 12.49,
			4: 11.35,
			5: 10.59,
			6: 8.99,
			7: 8.17,
			8: 7.04,
			9: 6.29,
			10: 5.4,
			11: 6.67,
			12: 7.6,
			13: 9.08,
			14: 11.66,
			15: 11.8,
			16: 10.51,
			17: 9.69,
			18: 8.67,
			19: 7.55,
			20: 6.68,
			21: 5.05,
			22: 4.2,
			23: 3.16,
			24: 2.51,
			25: 9.01,
			26: 8.28,
			27: 7.28,
			28: 6.29,
			29: 7.08,
			30: 7.72,
			31: 9.28,
			32: 8.77,
			33: 8.14,
			34: 8.8,
			35: 9.35,
			36: 9.88,
			37: 10.91,
			38: 12.43,
			39: 13.52,
			40: 14.62,
			41: 15.5,
			42: 16.1,
			43: 17.36,
			44: 18.19,
			45: 18.95,
			46: 19.98,
			47: 20.56,
			48: 22.01,
			49: 22.88,
			50: 25.02,
			51: 26.93,
			52: 29.02,
			53: 17.71,
			54: 16.6,
			55: 15.7,
			56: 17.64,
			57: 14.85,
			58: 13.7,
			59: 12.64,
			60: 11.08,
			61: 10.18,
			62: 9.3,
			63: 9.28,
			64: 10.04,
			65: 9.49,
			66: 10.06,
			67: 8.8,
			68: 7.66,
			69: 6.67,
			70: 7.61,
			71: 8.8,
			72: 10.16,
			73: 14.66,
			74: 13.85,
			75: 12.77,
			76: 11.44,
			77: 9.3,
			78: 7.72,
			79: 6.52,
			80: 7.66,
			81: 8.46,
			82: 9.41,
			83: 9.88,
			84: 10.54,
			85: 11.87,
			86: 12.86,
			87: 13.73,
			88: 15.45,
			89: 16.38,
			90: 17.4,
			91: 19.14,
			92: 20.51,
			93: 21.91,
			94: 12.42,
			95: 13.65,
			96: 14.48,
			97: 15.39,
			98: 16.55,
			99: 24.13,
			100: 22.18,
			101: 21.07,
			102: 19.6,
			103: 17.96,
			104: 16.68,
			105: 16.03,
			106: 14.75,
			107: 13.88,
			108: 10.8,
			109: 9.49,
			110: 8.14,
			111: 7.46,
			112: 6.52,
			113: 5.4,
			114: 4.73,
			115: 4.01,
			116: 3.16,
			117: 2.18,
			118: 1.36,
			119: 0,
			120: 1.42,
			121: 2.51,
			122: 14.85,
			123: 16.4,
			124: 15.83,
			125: 14.93,
			126: 13.85,
			127: 15.37,
			128: 16,
			129: 16.74,
			130: 16.92,
			131: 16.03,
			132: 14.75,
			133: 16.38,
			134: 17.54,
			135: 18.78
		},
		120: {
			1: 15.11,
			2: 14.43,
			3: 13.92,
			4: 12.78,
			5: 12.01,
			6: 10.42,
			7: 9.6,
			8: 8.46,
			9: 7.72,
			10: 6.82,
			11: 8.09,
			12: 9.02,
			13: 10.5,
			14: 11.7,
			15: 10.37,
			16: 9.09,
			17: 8.26,
			18: 7.25,
			19: 6.12,
			20: 5.25,
			21: 3.63,
			22: 2.77,
			23: 1.74,
			24: 1.09,
			25: 10.43,
			26: 9.7,
			27: 8.71,
			28: 7.72,
			29: 8.51,
			30: 9.14,
			31: 10.7,
			32: 10.19,
			33: 9.56,
			34: 10.22,
			35: 10.77,
			36: 11.3,
			37: 12.33,
			38: 13.85,
			39: 14.94,
			40: 16.04,
			41: 16.92,
			42: 17.52,
			43: 18.78,
			44: 19.61,
			45: 20.37,
			46: 21.4,
			47: 21.98,
			48: 23.43,
			49: 24.3,
			50: 26.44,
			51: 28.35,
			52: 30.44,
			53: 19.13,
			54: 18.02,
			55: 17.12,
			56: 19.06,
			57: 16.27,
			58: 15.12,
			59: 14.06,
			60: 12.5,
			61: 11.6,
			62: 10.72,
			63: 10.7,
			64: 11.47,
			65: 10.91,
			66: 11.49,
			67: 10.22,
			68: 9.08,
			69: 8.09,
			70: 9.03,
			71: 10.23,
			72: 11.58,
			73: 16.08,
			74: 15.27,
			75: 14.19,
			76: 12.86,
			77: 10.72,
			78: 9.14,
			79: 7.94,
			80: 9.08,
			81: 9.88,
			82: 10.83,
			83: 11.3,
			84: 11.97,
			85: 13.3,
			86: 14.29,
			87: 15.15,
			88: 16.88,
			89: 17.81,
			90: 18.82,
			91: 20.56,
			92: 21.93,
			93: 23.33,
			94: 13.84,
			95: 15.08,
			96: 15.91,
			97: 16.81,
			98: 17.98,
			99: 25.55,
			100: 23.6,
			101: 22.49,
			102: 21.03,
			103: 19.38,
			104: 18.1,
			105: 17.45,
			106: 16.17,
			107: 15.31,
			108: 12.23,
			109: 10.91,
			110: 9.56,
			111: 8.88,
			112: 7.94,
			113: 6.82,
			114: 6.16,
			115: 5.43,
			116: 4.59,
			117: 3.6,
			118: 2.79,
			119: 1.42,
			120: 0,
			121: 1.09,
			122: 16.27,
			123: 17.82,
			124: 17.26,
			125: 16.35,
			126: 15.27,
			127: 16.8,
			128: 17.43,
			129: 18.16,
			130: 18.34,
			131: 17.45,
			132: 16.17,
			133: 17.81,
			134: 18.96,
			135: 20.2
		},
		121: {
			1: 16.2,
			2: 15.52,
			3: 15.01,
			4: 13.87,
			5: 13.1,
			6: 11.51,
			7: 10.69,
			8: 9.55,
			9: 8.81,
			10: 7.91,
			11: 9.18,
			12: 10.11,
			13: 11.59,
			14: 10.61,
			15: 9.28,
			16: 8,
			17: 7.17,
			18: 6.16,
			19: 5.03,
			20: 4.17,
			21: 2.54,
			22: 1.69,
			23: 0.65,
			24: 0,
			25: 11.52,
			26: 10.79,
			27: 9.79,
			28: 8.81,
			29: 9.59,
			30: 10.23,
			31: 11.79,
			32: 11.28,
			33: 10.65,
			34: 11.31,
			35: 11.86,
			36: 12.39,
			37: 13.42,
			38: 14.94,
			39: 16.03,
			40: 17.13,
			41: 18.01,
			42: 18.61,
			43: 19.87,
			44: 20.7,
			45: 21.46,
			46: 22.49,
			47: 23.07,
			48: 24.52,
			49: 25.39,
			50: 27.53,
			51: 29.44,
			52: 31.53,
			53: 20.22,
			54: 19.11,
			55: 18.21,
			56: 20.15,
			57: 17.36,
			58: 16.21,
			59: 15.15,
			60: 13.59,
			61: 12.69,
			62: 11.81,
			63: 11.79,
			64: 12.56,
			65: 12,
			66: 12.58,
			67: 11.31,
			68: 10.17,
			69: 9.18,
			70: 10.12,
			71: 11.32,
			72: 12.67,
			73: 17.17,
			74: 16.36,
			75: 15.28,
			76: 13.95,
			77: 11.81,
			78: 10.23,
			79: 9.03,
			80: 10.17,
			81: 10.97,
			82: 11.92,
			83: 12.39,
			84: 13.05,
			85: 14.39,
			86: 15.37,
			87: 16.24,
			88: 17.97,
			89: 18.89,
			90: 19.91,
			91: 21.65,
			92: 23.02,
			93: 24.42,
			94: 14.93,
			95: 16.16,
			96: 17,
			97: 17.9,
			98: 19.07,
			99: 26.64,
			100: 24.69,
			101: 23.58,
			102: 22.12,
			103: 20.47,
			104: 19.19,
			105: 18.54,
			106: 17.26,
			107: 16.4,
			108: 13.32,
			109: 12,
			110: 10.65,
			111: 9.97,
			112: 9.03,
			113: 7.91,
			114: 7.25,
			115: 6.52,
			116: 5.68,
			117: 4.69,
			118: 3.88,
			119: 2.51,
			120: 1.09,
			121: 0,
			122: 17.36,
			123: 18.91,
			124: 18.35,
			125: 17.44,
			126: 16.36,
			127: 17.89,
			128: 18.52,
			129: 19.25,
			130: 19.43,
			131: 18.54,
			132: 17.26,
			133: 18.89,
			134: 20.05,
			135: 21.29
		},
		122: {
			1: 15.98,
			2: 15.3,
			3: 14.78,
			4: 13.64,
			5: 12.88,
			6: 11.28,
			7: 10.46,
			8: 9.33,
			9: 8.58,
			10: 9.45,
			11: 10.46,
			12: 11.39,
			13: 12.87,
			14: 15.46,
			15: 16.79,
			16: 18.07,
			17: 18.9,
			18: 19.91,
			19: 21.04,
			20: 21.52,
			21: 19.9,
			22: 19.04,
			23: 18,
			24: 17.36,
			25: 11.3,
			26: 10.56,
			27: 9.57,
			28: 8.58,
			29: 7.79,
			30: 7.13,
			31: 6.48,
			32: 7.47,
			33: 8.1,
			34: 8.76,
			35: 9.31,
			36: 9.84,
			37: 10.87,
			38: 12.39,
			39: 13.48,
			40: 14.58,
			41: 15.46,
			42: 16.06,
			43: 17.32,
			44: 18.15,
			45: 18.91,
			46: 19.94,
			47: 20.52,
			48: 21.97,
			49: 22.84,
			50: 24.98,
			51: 26.89,
			52: 28.98,
			53: 2.86,
			54: 1.75,
			55: 0.85,
			56: 2.79,
			57: 0,
			58: 1.15,
			59: 2.21,
			60: 3.77,
			61: 4.67,
			62: 5.55,
			63: 6.48,
			64: 7.24,
			65: 8.06,
			66: 8.88,
			67: 8.76,
			68: 9.47,
			69: 10.46,
			70: 11.4,
			71: 12.6,
			72: 13.95,
			73: 5.23,
			74: 4.42,
			75: 5.5,
			76: 6.83,
			77: 5.55,
			78: 7.13,
			79: 8.33,
			80: 9.47,
			81: 10.27,
			82: 10.55,
			83: 9.84,
			84: 10.5,
			85: 11.83,
			86: 12.82,
			87: 13.69,
			88: 13.8,
			89: 12.53,
			90: 13.55,
			91: 15.29,
			92: 16.66,
			93: 18.06,
			94: 12.38,
			95: 13.61,
			96: 14.44,
			97: 15.35,
			98: 16.51,
			99: 17.72,
			100: 15.77,
			101: 14.66,
			102: 13.2,
			103: 11.55,
			104: 10.27,
			105: 9.62,
			106: 10.9,
			107: 11.76,
			108: 9.38,
			109: 8.06,
			110: 8.1,
			111: 8.78,
			112: 8.33,
			113: 9.45,
			114: 10.11,
			115: 10.84,
			116: 11.68,
			117: 12.67,
			118: 13.48,
			119: 14.85,
			120: 16.27,
			121: 17.36,
			122: 0,
			123: 1.55,
			124: 2.44,
			125: 3.34,
			126: 4.42,
			127: 5.95,
			128: 6.58,
			129: 7.32,
			130: 8.73,
			131: 9.62,
			132: 10.9,
			133: 12.53,
			134: 13.69,
			135: 14.93
		},
		123: {
			1: 17.53,
			2: 16.85,
			3: 16.33,
			4: 15.19,
			5: 14.43,
			6: 12.83,
			7: 12.01,
			8: 10.88,
			9: 10.13,
			10: 11,
			11: 12.01,
			12: 12.94,
			13: 14.42,
			14: 17.01,
			15: 18.34,
			16: 19.62,
			17: 20.45,
			18: 21.46,
			19: 22.59,
			20: 23.07,
			21: 21.45,
			22: 20.59,
			23: 19.56,
			24: 18.91,
			25: 12.85,
			26: 12.11,
			27: 11.12,
			28: 10.13,
			29: 9.34,
			30: 8.68,
			31: 8.03,
			32: 9.02,
			33: 9.65,
			34: 10.31,
			35: 10.86,
			36: 11.39,
			37: 12.42,
			38: 13.94,
			39: 15.03,
			40: 16.13,
			41: 17.01,
			42: 17.61,
			43: 18.87,
			44: 19.7,
			45: 20.46,
			46: 21.49,
			47: 22.07,
			48: 23.52,
			49: 24.39,
			50: 26.53,
			51: 28.44,
			52: 30.53,
			53: 4.41,
			54: 3.3,
			55: 2.4,
			56: 4.35,
			57: 1.55,
			58: 2.7,
			59: 3.76,
			60: 5.32,
			61: 6.22,
			62: 7.1,
			63: 8.03,
			64: 8.79,
			65: 9.61,
			66: 10.43,
			67: 10.31,
			68: 11.02,
			69: 12.01,
			70: 12.95,
			71: 14.15,
			72: 15.5,
			73: 3.68,
			74: 2.87,
			75: 3.95,
			76: 5.28,
			77: 7.1,
			78: 8.68,
			79: 9.88,
			80: 11.02,
			81: 11.82,
			82: 12.1,
			83: 11.39,
			84: 12.05,
			85: 13.38,
			86: 14.37,
			87: 13.98,
			88: 12.25,
			89: 10.98,
			90: 12,
			91: 13.74,
			92: 15.11,
			93: 16.51,
			94: 13.93,
			95: 15.16,
			96: 16,
			97: 16.9,
			98: 18.06,
			99: 16.17,
			100: 14.22,
			101: 13.11,
			102: 11.65,
			103: 10,
			104: 8.72,
			105: 8.07,
			106: 9.35,
			107: 10.21,
			108: 10.93,
			109: 9.61,
			110: 9.65,
			111: 10.33,
			112: 9.88,
			113: 11,
			114: 11.66,
			115: 12.39,
			116: 13.23,
			117: 14.22,
			118: 15.03,
			119: 16.4,
			120: 17.82,
			121: 18.91,
			122: 1.55,
			123: 0,
			124: 0.89,
			125: 1.79,
			126: 2.87,
			127: 4.4,
			128: 5.03,
			129: 5.77,
			130: 7.17,
			131: 8.07,
			132: 9.35,
			133: 10.98,
			134: 12.14,
			135: 13.38
		},
		124: {
			1: 16.96,
			2: 16.28,
			3: 15.77,
			4: 14.63,
			5: 13.86,
			6: 12.27,
			7: 11.45,
			8: 10.31,
			9: 9.57,
			10: 10.43,
			11: 11.45,
			12: 12.38,
			13: 13.86,
			14: 16.44,
			15: 17.77,
			16: 19.06,
			17: 19.88,
			18: 20.9,
			19: 22.02,
			20: 22.51,
			21: 20.88,
			22: 20.03,
			23: 18.99,
			24: 18.35,
			25: 12.28,
			26: 11.55,
			27: 10.56,
			28: 9.57,
			29: 8.78,
			30: 8.11,
			31: 7.47,
			32: 8.46,
			33: 9.09,
			34: 9.75,
			35: 10.3,
			36: 10.83,
			37: 11.86,
			38: 13.38,
			39: 14.47,
			40: 15.57,
			41: 16.45,
			42: 17.05,
			43: 18.31,
			44: 19.14,
			45: 19.9,
			46: 20.93,
			47: 21.51,
			48: 22.96,
			49: 23.83,
			50: 25.97,
			51: 27.88,
			52: 29.97,
			53: 5.3,
			54: 4.19,
			55: 3.29,
			56: 5.23,
			57: 2.44,
			58: 3.59,
			59: 4.65,
			60: 6.21,
			61: 7.11,
			62: 6.54,
			63: 7.47,
			64: 8.23,
			65: 9.05,
			66: 9.86,
			67: 9.75,
			68: 10.46,
			69: 11.45,
			70: 12.39,
			71: 13.59,
			72: 14.94,
			73: 2.8,
			74: 1.99,
			75: 3.07,
			76: 4.4,
			77: 6.54,
			78: 8.11,
			79: 9.31,
            80: 10.46,
			81: 11.26,
			82: 11.54,
			83: 10.83,
			84: 11.49,
			85: 12.82,
			86: 13.81,
			87: 13.09,
			88: 11.37,
			89: 10.09,
			90: 11.11,
			91: 12.85,
			92: 14.22,
			93: 15.62,
			94: 13.37,
			95: 14.6,
			96: 15.43,
			97: 16.33,
			98: 17.5,
			99: 15.28,
			100: 13.34,
			101: 12.23,
			102: 10.76,
			103: 9.12,
			104: 7.83,
			105: 7.18,
			106: 8.46,
			107: 9.33,
			108: 10.36,
			109: 9.05,
			110: 9.09,
			111: 9.77,
			112: 9.31,
			113: 10.43,
			114: 11.1,
			115: 11.83,
			116: 12.67,
			117: 13.66,
			118: 14.47,
			119: 15.83,
			120: 17.26,
			121: 18.35,
			122: 2.44,
			123: 0.89,
			124: 0,
			125: 0.9,
			126: 1.99,
			127: 3.51,
			128: 4.14,
			129: 4.88,
			130: 6.29,
			131: 7.18,
			132: 8.46,
			133: 10.09,
			134: 11.25,
			135: 12.49
		},
		125: {
			1: 16.06,
			2: 15.38,
			3: 14.87,
			4: 13.72,
			5: 12.96,
			6: 11.37,
			7: 10.55,
			8: 9.41,
			9: 8.67,
			10: 9.53,
			11: 10.55,
			12: 11.48,
			13: 12.96,
			14: 15.54,
			15: 16.87,
			16: 18.15,
			17: 18.98,
			18: 19.99,
			19: 21.12,
			20: 21.61,
			21: 19.98,
			22: 19.13,
			23: 18.09,
			24: 17.44,
			25: 11.38,
			26: 10.65,
			27: 9.65,
			28: 8.67,
			29: 7.88,
			30: 7.21,
			31: 6.57,
			32: 7.56,
			33: 8.19,
			34: 8.85,
			35: 9.4,
			36: 9.93,
			37: 10.96,
			38: 12.48,
			39: 13.57,
			40: 14.67,
			41: 15.55,
			42: 16.15,
			43: 17.41,
			44: 18.24,
			45: 19,
			46: 20.03,
			47: 20.61,
			48: 22.06,
			49: 22.93,
			50: 25.07,
			51: 26.98,
			52: 29.07,
			53: 6.2,
			54: 5.09,
			55: 4.19,
			56: 6.13,
			57: 3.34,
			58: 4.49,
			59: 5.55,
			60: 7.11,
			61: 6.52,
			62: 5.64,
			63: 6.57,
			64: 7.33,
			65: 8.15,
			66: 8.96,
			67: 8.85,
			68: 9.56,
			69: 10.55,
			70: 11.49,
			71: 12.68,
			72: 14.04,
			73: 1.9,
			74: 1.09,
			75: 2.17,
			76: 3.5,
			77: 5.64,
			78: 7.21,
			79: 8.41,
			80: 9.56,
			81: 10.35,
			82: 10.64,
			83: 9.93,
			84: 10.59,
			85: 11.92,
			86: 12.91,
			87: 12.19,
			88: 10.47,
			89: 9.19,
			90: 10.21,
			91: 11.95,
			92: 13.32,
			93: 14.72,
			94: 12.46,
			95: 13.7,
			96: 14.53,
			97: 15.43,
			98: 16.6,
			99: 14.38,
			100: 12.43,
			101: 11.32,
			102: 9.86,
			103: 8.21,
			104: 6.93,
			105: 6.28,
			106: 7.56,
			107: 8.42,
			108: 9.46,
			109: 8.15,
			110: 8.19,
			111: 8.87,
			112: 8.41,
			113: 9.53,
			114: 10.2,
			115: 10.93,
			116: 11.77,
			117: 12.75,
			118: 13.57,
			119: 14.93,
			120: 16.35,
			121: 17.44,
			122: 3.34,
			123: 1.79,
			124: 0.9,
			125: 0,
			126: 1.09,
			127: 2.61,
			128: 3.24,
			129: 3.98,
			130: 5.39,
			131: 6.28,
			132: 7.56,
			133: 9.19,
			134: 10.35,
			135: 11.59
		},
		126: {
			1: 14.98,
			2: 14.3,
			3: 13.78,
			4: 12.64,
			5: 11.88,
			6: 10.28,
			7: 9.46,
			8: 8.33,
			9: 7.58,
			10: 8.45,
			11: 9.46,
			12: 10.39,
			13: 11.87,
			14: 14.46,
			15: 15.79,
			16: 17.07,
			17: 17.9,
			18: 18.91,
			19: 20.04,
			20: 20.52,
			21: 18.9,
			22: 18.04,
			23: 17.01,
			24: 16.36,
			25: 10.3,
			26: 9.56,
			27: 8.57,
			28: 7.58,
			29: 6.79,
			30: 6.13,
			31: 5.48,
			32: 6.47,
			33: 7.1,
			34: 7.76,
			35: 8.31,
			36: 8.84,
			37: 9.87,
			38: 11.39,
			39: 12.48,
			40: 13.58,
			41: 14.46,
			42: 15.06,
			43: 16.32,
			44: 17.15,
			45: 17.91,
			46: 18.94,
			47: 19.52,
			48: 20.97,
			49: 21.84,
			50: 23.98,
			51: 25.89,
			52: 27.98,
			53: 7.28,
			54: 6.17,
			55: 5.27,
			56: 7.22,
			57: 4.42,
			58: 5.57,
			59: 6.63,
			60: 6.33,
			61: 5.43,
			62: 4.55,
			63: 5.48,
			64: 6.24,
			65: 7.06,
			66: 7.88,
			67: 7.76,
			68: 8.47,
			69: 9.46,
			70: 10.4,
			71: 11.6,
			72: 12.95,
			73: 0.81,
			74: 0,
			75: 1.08,
			76: 2.41,
			77: 4.55,
			78: 6.13,
			79: 7.33,
            80: 8.47,
			81: 9.27,
			82: 9.55,
			83: 8.84,
			84: 9.5,
			85: 10.83,
			86: 11.82,
			87: 11.1,
			88: 9.38,
			89: 8.11,
			90: 9.13,
			91: 10.86,
			92: 12.23,
			93: 13.63,
			94: 11.38,
			95: 12.61,
			96: 13.44,
			97: 14.35,
			98: 15.51,
			99: 13.3,
			100: 11.35,
			101: 10.24,
			102: 8.77,
			103: 7.13,
			104: 5.85,
			105: 5.2,
			106: 6.47,
			107: 7.34,
			108: 8.38,
			109: 7.06,
			110: 7.1,
			111: 7.78,
			112: 7.33,
			113: 8.45,
			114: 9.11,
			115: 9.84,
			116: 10.68,
			117: 11.67,
			118: 12.48,
			119: 13.85,
			120: 15.27,
			121: 16.36,
			122: 4.42,
			123: 2.87,
			124: 1.99,
			125: 1.09,
			126: 0,
			127: 1.53,
			128: 2.16,
			129: 2.9,
			130: 4.3,
			131: 5.2,
			132: 6.47,
			133: 8.11,
			134: 9.26,
			135: 10.5
		},
		127: {
			1: 16.5,
			2: 15.82,
			3: 15.31,
			4: 14.17,
			5: 13.4,
			6: 11.81,
			7: 10.99,
			8: 9.85,
			9: 9.11,
			10: 9.97,
			11: 10.99,
			12: 11.92,
			13: 13.4,
			14: 15.98,
			15: 17.31,
			16: 18.6,
			17: 19.42,
			18: 20.44,
			19: 21.56,
			20: 22.05,
			21: 20.42,
			22: 19.57,
			23: 18.53,
			24: 17.89,
			25: 11.82,
			26: 11.09,
			27: 10.1,
			28: 9.11,
			29: 8.32,
			30: 7.65,
			31: 7.01,
			32: 8,
			33: 8.63,
			34: 9.29,
			35: 9.84,
			36: 10.37,
			37: 11.4,
			38: 12.92,
			39: 14.01,
			40: 15.11,
			41: 15.99,
			42: 16.59,
			43: 17.85,
			44: 18.68,
			45: 19.44,
			46: 20.47,
			47: 21.05,
			48: 22.5,
			49: 23.37,
			50: 25.51,
			51: 27.42,
			52: 29.51,
			53: 8.81,
			54: 7.7,
			55: 6.8,
			56: 8.75,
			57: 5.95,
			58: 7.1,
			59: 8.16,
			60: 7.86,
			61: 6.96,
			62: 6.08,
			63: 7.01,
			64: 7.77,
			65: 8.59,
			66: 9.4,
			67: 9.29,
			68: 10,
			69: 10.99,
			70: 11.93,
			71: 13.13,
			72: 14.48,
			73: 2.34,
			74: 1.53,
			75: 2.61,
			76: 3.94,
			77: 6.08,
			78: 7.65,
			79: 8.85,
			80: 10,
			81: 10.8,
			82: 11.08,
			83: 10.37,
			84: 11.03,
			85: 11.43,
			86: 10.45,
			87: 9.58,
			88: 7.85,
			89: 6.58,
			90: 7.6,
			91: 9.34,
			92: 10.71,
			93: 12.11,
			94: 12.91,
			95: 14.14,
			96: 14.97,
			97: 15.87,
			98: 17.04,
			99: 11.77,
			100: 9.82,
			101: 8.71,
			102: 7.25,
			103: 5.6,
			104: 4.32,
			105: 3.67,
			106: 4.95,
			107: 5.81,
			108: 8.89,
			109: 8.59,
			110: 8.63,
			111: 9.31,
			112: 8.85,
			113: 9.97,
			114: 10.64,
			115: 11.37,
			116: 12.21,
			117: 13.2,
			118: 14.01,
			119: 15.37,
			120: 16.8,
			121: 17.89,
			122: 5.95,
			123: 4.4,
			124: 3.51,
			125: 2.61,
			126: 1.53,
			127: 0,
			128: 0.63,
			129: 1.37,
			130: 2.77,
			131: 3.67,
			132: 4.95,
			133: 6.58,
			134: 7.74,
			135: 8.98
		},
		128: {
			1: 17.13,
			2: 16.45,
			3: 15.94,
			4: 14.8,
			5: 14.03,
			6: 12.44,
			7: 11.62,
			8: 10.48,
			9: 9.74,
			10: 10.6,
			11: 11.62,
			12: 12.55,
			13: 14.03,
			14: 16.61,
			15: 17.94,
			16: 19.23,
			17: 20.05,
			18: 21.07,
			19: 22.19,
			20: 22.68,
			21: 21.05,
			22: 20.2,
			23: 19.16,
			24: 18.52,
			25: 12.45,
			26: 11.72,
			27: 10.73,
			28: 9.74,
			29: 8.95,
			30: 8.28,
			31: 7.64,
			32: 8.63,
			33: 9.26,
			34: 9.92,
			35: 10.47,
			36: 11,
			37: 12.03,
			38: 13.55,
			39: 14.64,
			40: 15.74,
			41: 16.62,
			42: 17.22,
			43: 18.48,
			44: 19.31,
			45: 20.07,
			46: 21.1,
			47: 21.68,
			48: 23.13,
			49: 24,
			50: 26.14,
			51: 28.05,
			52: 30.14,
			53: 9.44,
			54: 8.33,
			55: 7.43,
			56: 9.38,
			57: 6.58,
			58: 7.73,
			59: 8.79,
			60: 8.49,
			61: 7.59,
			62: 6.71,
			63: 7.64,
			64: 8.4,
			65: 9.22,
			66: 10.03,
			67: 9.92,
			68: 10.63,
			69: 11.62,
			70: 12.56,
			71: 13.76,
			72: 15.11,
			73: 2.97,
			74: 2.16,
			75: 3.24,
			76: 4.57,
			77: 6.71,
			78: 8.28,
			79: 9.48,
			80: 10.63,
			81: 11.43,
			82: 11.71,
			83: 11,
			84: 11.66,
			85: 10.8,
			86: 9.82,
			87: 8.95,
			88: 7.22,
			89: 5.95,
			90: 6.97,
			91: 8.71,
			92: 10.08,
			93: 11.48,
			94: 13.54,
			95: 14.77,
			96: 15.6,
			97: 16.5,
			98: 17.67,
			99: 11.14,
			100: 9.19,
			101: 8.08,
			102: 6.62,
			103: 4.97,
			104: 3.69,
			105: 3.04,
			106: 4.32,
			107: 5.18,
			108: 8.26,
			109: 9.22,
            110: 9.26,
			111: 9.94,
			112: 9.48,
			113: 10.6,
			114: 11.27,
			115: 12,
			116: 12.84,
			117: 13.83,
			118: 14.64,
			119: 16,
			120: 17.43,
			121: 18.52,
			122: 6.58,
			123: 5.03,
			124: 4.14,
			125: 3.24,
			126: 2.16,
			127: 0.63,
			128: 0,
			129: 0.74,
			130: 2.14,
			131: 3.04,
			132: 4.32,
			133: 5.95,
			134: 7.11,
			135: 8.35
		},
		129: {
			1: 17.87,
			2: 17.19,
			3: 16.68,
			4: 15.53,
			5: 14.77,
			6: 13.18,
			7: 12.36,
			8: 11.22,
			9: 10.48,
			10: 11.34,
			11: 12.36,
			12: 13.29,
			13: 14.77,
			14: 17.35,
			15: 18.68,
			16: 19.96,
			17: 20.79,
			18: 21.8,
			19: 22.93,
			20: 23.42,
			21: 21.79,
			22: 20.94,
			23: 19.9,
			24: 19.25,
			25: 13.19,
			26: 12.46,
			27: 11.46,
			28: 10.48,
			29: 9.69,
			30: 9.02,
			31: 8.38,
			32: 9.37,
			33: 10,
			34: 10.66,
			35: 11.21,
			36: 11.74,
			37: 12.77,
			38: 14.29,
			39: 15.38,
			40: 16.48,
			41: 17.36,
			42: 17.96,
			43: 19.22,
			44: 20.05,
			45: 20.81,
			46: 21.84,
			47: 22.42,
			48: 23.87,
			49: 24.74,
			50: 26.88,
			51: 28.79,
			52: 30.88,
			53: 10.18,
			54: 9.07,
			55: 8.17,
			56: 10.11,
			57: 7.32,
			58: 8.47,
			59: 9.53,
			60: 9.23,
			61: 8.33,
			62: 7.45,
			63: 8.38,
			64: 9.14,
			65: 8.84,
			66: 9.65,
			67: 10.66,
			68: 11.37,
			69: 12.36,
			70: 13.3,
			71: 14.49,
			72: 15.85,
			73: 3.71,
			74: 2.9,
			75: 3.98,
			76: 5.31,
			77: 7.45,
			78: 9.02,
			79: 10.22,
            80: 11.37,
			81: 12.16,
			82: 12.45,
			83: 11.74,
			84: 11.4,
			85: 10.07,
			86: 9.08,
			87: 8.21,
			88: 6.49,
			89: 5.21,
			90: 6.23,
			91: 7.97,
			92: 9.34,
			93: 10.74,
			94: 13.27,
			95: 14.51,
			96: 15.34,
			97: 16.24,
			98: 17.41,
			99: 10.4,
			100: 8.45,
			101: 7.34,
			102: 5.88,
			103: 4.23,
			104: 2.95,
			105: 2.3,
			106: 3.58,
			107: 4.44,
			108: 7.52,
			109: 8.84,
			110: 10,
			111: 10.68,
			112: 10.22,
			113: 11.34,
			114: 12.01,
			115: 12.74,
			116: 13.58,
			117: 14.56,
			118: 15.38,
			119: 16.74,
			120: 18.16,
			121: 19.25,
			122: 7.32,
			123: 5.77,
			124: 4.88,
			125: 3.98,
			126: 2.9,
			127: 1.37,
			128: 0.74,
			129: 0,
			130: 1.41,
			131: 2.3,
			132: 3.58,
			133: 5.21,
			134: 6.37,
			135: 7.61
		},
		130: {
			1: 19.28,
			2: 18.6,
			3: 18.08,
			4: 16.94,
			5: 16.18,
			6: 14.58,
			7: 13.76,
			8: 12.63,
			9: 11.88,
			10: 11.52,
			11: 11.73,
			12: 12.66,
			13: 14.14,
			14: 16.72,
			15: 18.05,
			16: 19.33,
			17: 20.16,
			18: 21.17,
			19: 22.3,
			20: 23.17,
			21: 21.97,
			22: 21.12,
			23: 20.08,
			24: 19.43,
			25: 14.6,
			26: 13.86,
			27: 12.87,
			28: 11.88,
			29: 11.09,
			30: 10.43,
			31: 9.01,
			32: 9.41,
			33: 8.78,
			34: 9.44,
			35: 9.99,
			36: 10.52,
			37: 11.55,
			38: 13.07,
			39: 14.16,
			40: 15.26,
			41: 16.14,
			42: 16.74,
			43: 18,
			44: 18.83,
			45: 19.59,
			46: 20.62,
			47: 21.2,
			48: 22.65,
			49: 23.52,
			50: 25.66,
			51: 27.57,
			52: 29.66,
			53: 11.59,
			54: 10.48,
			55: 9.58,
			56: 11.52,
			57: 8.73,
			58: 9.88,
			59: 10.94,
			60: 10.63,
			61: 9.73,
			62: 8.85,
			63: 9.01,
			64: 8.25,
			65: 7.43,
			66: 8.24,
			67: 9.44,
			68: 10.74,
			69: 11.73,
			70: 12.67,
			71: 13.86,
			72: 15.22,
			73: 5.11,
			74: 4.3,
			75: 5.38,
			76: 6.71,
			77: 8.85,
			78: 10.43,
			79: 10.4,
			80: 10.74,
			81: 11.53,
			82: 11.23,
			83: 10.52,
			84: 9.99,
			85: 8.66,
			86: 7.67,
			87: 6.8,
			88: 5.08,
			89: 3.81,
			90: 4.82,
			91: 6.56,
			92: 7.93,
			93: 9.33,
			94: 11.87,
			95: 13.1,
			96: 13.93,
			97: 14.84,
			98: 16,
			99: 9,
			100: 7.05,
			101: 5.94,
			102: 4.47,
			103: 2.83,
			104: 1.55,
			105: 0.89,
			106: 2.17,
			107: 3.04,
			108: 6.12,
			109: 7.43,
            110: 8.78,
			111: 9.46,
			112: 10.4,
			113: 11.52,
			114: 12.19,
			115: 12.91,
			116: 13.76,
			117: 14.74,
			118: 15.56,
			119: 16.92,
			120: 18.34,
			121: 19.43,
			122: 8.73,
			123: 7.17,
			124: 6.29,
			125: 5.39,
			126: 4.3,
			127: 2.77,
			128: 2.14,
			129: 1.41,
			130: 0,
			131: 0.89,
			132: 2.17,
			133: 3.81,
			134: 4.96,
			135: 6.2
		},
		131: {
			1: 18.53,
			2: 17.85,
			3: 17.33,
			4: 16.19,
			5: 15.43,
			6: 13.83,
			7: 13.01,
			8: 11.88,
			9: 11.13,
			10: 10.63,
			11: 10.83,
			12: 11.76,
			13: 13.24,
			14: 15.83,
			15: 17.16,
			16: 18.44,
			17: 19.27,
			18: 20.28,
			19: 21.41,
			20: 22.28,
			21: 21.08,
			22: 20.22,
			23: 19.18,
			24: 18.54,
			25: 13.85,
			26: 13.12,
			27: 12.12,
			28: 11.13,
			29: 10.35,
			30: 9.68,
			31: 8.12,
			32: 8.52,
			33: 7.89,
			34: 8.55,
			35: 9.1,
			36: 9.63,
			37: 10.66,
			38: 12.18,
			39: 13.27,
			40: 14.37,
			41: 15.25,
			42: 15.85,
			43: 17.11,
			44: 17.94,
			45: 18.7,
			46: 19.73,
			47: 20.31,
			48: 21.76,
			49: 22.63,
			50: 24.77,
			51: 26.68,
			52: 28.77,
			53: 12.48,
			54: 11.37,
			55: 10.47,
			56: 12.41,
			57: 9.62,
			58: 10.77,
			59: 11.83,
			60: 10.83,
			61: 9.93,
			62: 9.05,
			63: 8.12,
			64: 7.36,
			65: 6.54,
			66: 7.35,
			67: 8.55,
			68: 9.84,
			69: 10.83,
			70: 11.77,
			71: 12.97,
			72: 14.32,
			73: 6.01,
			74: 5.2,
			75: 6.28,
			76: 7.61,
			77: 9.05,
			78: 9.68,
			79: 9.51,
			80: 9.84,
			81: 10.64,
			82: 10.34,
			83: 9.63,
			84: 9.1,
			85: 7.77,
			86: 6.78,
			87: 5.91,
			88: 4.19,
			89: 2.91,
			90: 3.93,
			91: 5.67,
			92: 7.04,
			93: 8.44,
			94: 10.97,
			95: 12.21,
			96: 13.04,
			97: 13.94,
			98: 15.11,
			99: 8.1,
			100: 6.15,
			101: 5.04,
			102: 3.58,
			103: 1.93,
			104: 0.65,
			105: 0,
			106: 1.28,
			107: 2.14,
			108: 5.22,
			109: 6.54,
            110: 7.89,
			111: 8.57,
			112: 9.51,
			113: 10.63,
			114: 11.29,
			115: 12.02,
			116: 12.86,
			117: 13.85,
			118: 14.66,
			119: 16.03,
			120: 17.45,
			121: 18.54,
			122: 9.62,
			123: 8.07,
			124: 7.18,
			125: 6.28,
			126: 5.2,
			127: 3.67,
			128: 3.04,
			129: 2.3,
			130: 0.89,
			131: 0,
			132: 1.28,
			133: 2.91,
			134: 4.07,
			135: 5.31
		},
		132: {
			1: 17.25,
			2: 16.57,
			3: 16.06,
			4: 14.91,
			5: 14.15,
			6: 12.56,
			7: 11.74,
			8: 10.6,
			9: 9.86,
			10: 9.35,
			11: 9.56,
			12: 10.49,
			13: 11.96,
			14: 14.55,
			15: 15.88,
			16: 17.16,
			17: 17.99,
			18: 19,
			19: 20.13,
			20: 21,
			21: 19.8,
			22: 18.95,
			23: 17.91,
			24: 17.26,
			25: 12.57,
			26: 11.84,
			27: 10.84,
			28: 9.86,
			29: 9.07,
			30: 8.4,
			31: 6.84,
			32: 7.24,
			33: 6.61,
			34: 7.27,
			35: 7.82,
			36: 8.35,
			37: 9.38,
			38: 10.9,
			39: 11.99,
			40: 13.09,
			41: 13.97,
			42: 14.57,
			43: 15.83,
			44: 16.66,
			45: 17.42,
			46: 18.45,
			47: 19.03,
			48: 20.48,
			49: 21.35,
			50: 23.49,
			51: 25.4,
			52: 27.49,
			53: 13.76,
			54: 12.65,
			55: 11.75,
			56: 13.69,
			57: 10.9,
			58: 12.05,
			59: 11.11,
			60: 9.55,
			61: 8.65,
			62: 7.77,
			63: 6.84,
			64: 6.08,
			65: 5.26,
			66: 6.07,
			67: 7.27,
			68: 8.56,
			69: 9.56,
			70: 10.49,
			71: 11.69,
			72: 13.04,
			73: 7.28,
			74: 6.47,
			75: 7.55,
			76: 8.88,
			77: 7.77,
			78: 8.4,
			79: 8.23,
			80: 8.56,
			81: 9.36,
			82: 9.06,
			83: 8.35,
			84: 7.82,
			85: 6.49,
			86: 5.5,
			87: 4.63,
			88: 2.91,
			89: 1.63,
			90: 2.65,
			91: 4.39,
			92: 5.76,
			93: 7.16,
			94: 9.7,
			95: 10.93,
			96: 11.76,
			97: 12.66,
			98: 13.83,
			99: 9.38,
			100: 7.43,
			101: 6.32,
			102: 4.86,
			103: 3.21,
			104: 1.93,
			105: 1.28,
			106: 0,
			107: 0.87,
			108: 3.95,
			109: 5.26,
			110: 6.61,
			111: 7.29,
			112: 8.23,
			113: 9.35,
			114: 10.01,
			115: 10.74,
			116: 11.58,
			117: 12.57,
			118: 13.39,
			119: 14.75,
			120: 16.17,
			121: 17.26,
			122: 10.9,
			123: 9.35,
			124: 8.46,
			125: 7.56,
			126: 6.47,
			127: 4.95,
			128: 4.32,
			129: 3.58,
			130: 2.17,
			131: 1.28,
			132: 0,
			133: 1.63,
			134: 2.79,
			135: 4.03
		},
		133: {
			1: 18.89,
			2: 18.2,
			3: 17.69,
			4: 16.55,
			5: 15.79,
			6: 14.19,
			7: 13.37,
			8: 12.23,
			9: 11.49,
			10: 10.98,
			11: 10.21,
			12: 11.15,
			13: 12.62,
			14: 15.21,
			15: 16.54,
			16: 17.82,
			17: 18.65,
			18: 19.66,
			19: 20.79,
			20: 21.66,
			21: 21.43,
			22: 20.58,
			23: 19.54,
			24: 18.89,
			25: 14.21,
			26: 13.47,
			27: 12.48,
			28: 11.49,
			29: 10.7,
			30: 10.03,
			31: 8.47,
			32: 8.87,
			33: 8.24,
			34: 7.93,
			35: 7.38,
			36: 6.85,
			37: 7.88,
			38: 9.4,
			39: 10.49,
			40: 11.59,
			41: 12.47,
			42: 13.07,
			43: 14.33,
			44: 15.16,
			45: 15.92,
			46: 16.95,
			47: 17.53,
			48: 18.98,
			49: 19.85,
			50: 21.99,
			51: 23.9,
			52: 25.99,
			53: 15.39,
			54: 14.28,
			55: 13.38,
			56: 15.33,
			57: 12.53,
			58: 13.68,
			59: 12.74,
			60: 11.18,
			61: 10.28,
			62: 9.4,
			63: 8.47,
			64: 7.71,
			65: 6.89,
			66: 7.71,
			67: 7.93,
			68: 9.22,
			69: 10.21,
			70: 11.15,
			71: 12.35,
			72: 13.7,
			73: 8.92,
			74: 8.11,
			75: 9.19,
			76: 10.52,
			77: 9.4,
			78: 10.03,
			79: 9.86,
			80: 9.22,
			81: 8.51,
			82: 7.56,
			83: 6.85,
			84: 6.19,
			85: 4.85,
			86: 3.87,
			87: 3,
			88: 1.27,
			89: 0,
			90: 1.02,
			91: 2.76,
			92: 4.13,
			93: 5.53,
			94: 8.06,
			95: 9.3,
			96: 10.13,
			97: 11.03,
			98: 12.2,
			99: 11.01,
			100: 9.07,
			101: 7.96,
			102: 6.49,
			103: 4.85,
			104: 3.56,
			105: 2.91,
			106: 1.63,
			107: 2.5,
			108: 5.58,
			109: 6.89,
			110: 8.24,
			111: 8.92,
			112: 9.86,
			113: 10.98,
			114: 11.65,
			115: 12.38,
			116: 13.22,
			117: 14.2,
			118: 15.02,
			119: 16.38,
			120: 17.81,
			121: 18.89,
			122: 12.53,
			123: 10.98,
			124: 10.09,
			125: 9.19,
			126: 8.11,
			127: 6.58,
			128: 5.95,
			129: 5.21,
			130: 3.81,
			131: 2.91,
			132: 1.63,
			133: 0,
			134: 1.16,
			135: 2.4
		},
		134: {
			1: 20.04,
			2: 19.36,
			3: 18.85,
			4: 17.7,
			5: 16.94,
			6: 15.35,
			7: 14.52,
			8: 13.39,
			9: 12.64,
			10: 12.14,
			11: 11.37,
			12: 12.3,
			13: 13.78,
			14: 16.36,
			15: 17.69,
			16: 18.98,
			17: 19.8,
			18: 20.82,
			19: 21.94,
			20: 22.81,
			21: 22.59,
			22: 21.73,
			23: 20.7,
			24: 20.05,
			25: 15.36,
			26: 14.63,
			27: 13.63,
			28: 12.64,
			29: 11.86,
			30: 11.19,
			31: 9.63,
			32: 10.03,
			33: 9.4,
			34: 9.08,
			35: 8.53,
			36: 8.01,
			37: 9.03,
			38: 10.55,
			39: 11.64,
			40: 12.74,
			41: 13.62,
			42: 14.22,
			43: 15.48,
			44: 16.31,
			45: 17.07,
			46: 18.1,
			47: 18.68,
			48: 20.13,
			49: 21,
			50: 23.14,
			51: 25.05,
			52: 27.14,
			53: 16.55,
			54: 15.44,
			55: 14.54,
			56: 16.48,
			57: 13.69,
			58: 14.84,
			59: 13.9,
			60: 12.34,
			61: 11.44,
			62: 10.56,
			63: 9.63,
			64: 8.87,
			65: 8.05,
			66: 8.86,
			67: 9.08,
			68: 10.38,
			69: 11.37,
			70: 12.31,
			71: 13.51,
			72: 14.86,
			73: 10.07,
			74: 9.26,
			75: 10.34,
			76: 11.67,
			77: 10.56,
			78: 11.19,
			79: 11.02,
			80: 10.38,
			81: 9.66,
			82: 8.71,
			83: 8.01,
			84: 7.34,
			85: 6.01,
			86: 5.02,
			87: 4.15,
			88: 2.43,
			89: 1.16,
			90: 2.17,
			91: 3.91,
			92: 5.28,
			93: 6.68,
			94: 9.22,
			95: 10.45,
			96: 11.28,
			97: 12.18,
			98: 13.35,
			99: 12.17,
			100: 10.22,
			101: 9.11,
			102: 7.64,
			103: 6,
			104: 4.72,
			105: 4.07,
			106: 2.79,
			107: 3.65,
			108: 6.73,
			109: 8.05,
			110: 9.4,
			111: 10.08,
			112: 11.02,
			113: 12.14,
			114: 12.8,
			115: 13.53,
			116: 14.37,
			117: 15.36,
			118: 16.17,
			119: 17.54,
			120: 18.96,
			121: 20.05,
			122: 13.69,
			123: 12.14,
			124: 11.25,
			125: 10.35,
			126: 9.26,
			127: 7.74,
			128: 7.11,
			129: 6.37,
			130: 4.96,
			131: 4.07,
			132: 2.79,
			133: 1.16,
			134: 0,
			135: 1.24
		},
		135: {
			1: 21.28,
			2: 20.6,
			3: 20.09,
			4: 18.95,
			5: 18.18,
			6: 16.59,
			7: 15.77,
			8: 14.63,
			9: 13.89,
			10: 13.38,
			11: 12.61,
			12: 13.54,
			13: 15.02,
			14: 17.61,
			15: 18.93,
			16: 20.22,
			17: 21.05,
			18: 22.06,
			19: 23.19,
			20: 24.05,
			21: 23.83,
			22: 22.98,
			23: 21.94,
			24: 21.29,
			25: 16.6,
			26: 15.87,
			27: 14.87,
			28: 13.89,
			29: 13.1,
			30: 12.43,
			31: 10.87,
			32: 11.27,
			33: 10.64,
			34: 10.32,
			35: 9.77,
			36: 9.24,
			37: 10.27,
			38: 11.79,
			39: 12.88,
			40: 13.98,
			41: 14.86,
			42: 15.46,
			43: 16.72,
			44: 17.55,
			45: 18.31,
			46: 19.34,
			47: 19.92,
			48: 21.37,
			49: 22.24,
			50: 24.38,
			51: 26.29,
			52: 28.38,
			53: 17.79,
			54: 16.68,
			55: 15.78,
			56: 17.72,
			57: 14.93,
			58: 16.08,
			59: 15.14,
			60: 13.58,
			61: 12.68,
			62: 11.8,
			63: 10.87,
			64: 10.11,
			65: 9.29,
			66: 10.1,
			67: 10.32,
			68: 11.62,
			69: 12.61,
			70: 13.55,
			71: 14.75,
			72: 16.1,
			73: 11.31,
			74: 10.5,
			75: 11.58,
			76: 12.91,
			77: 11.8,
			78: 12.43,
			79: 12.26,
			80: 11.62,
			81: 10.9,
			82: 9.95,
			83: 9.24,
			84: 8.58,
			85: 7.25,
			86: 6.26,
			87: 5.39,
			88: 3.67,
			89: 2.4,
			90: 3.42,
			91: 5.15,
			92: 6.52,
			93: 7.92,
			94: 10.46,
			95: 11.69,
			96: 12.53,
			97: 13.43,
			98: 14.59,
			99: 13.41,
			100: 11.46,
			101: 10.35,
			102: 8.89,
			103: 7.24,
			104: 5.96,
			105: 5.31,
			106: 4.03,
			107: 4.9,
			108: 7.98,
			109: 9.29,
			110: 10.64,
			111: 11.32,
			112: 12.26,
			113: 13.38,
			114: 14.05,
			115: 14.77,
			116: 15.62,
			117: 16.6,
			118: 17.42,
			119: 18.78,
			120: 20.2,
			121: 21.29,
			122: 14.93,
			123: 13.38,
			124: 12.49,
			125: 11.59,
			126: 10.5,
			127: 8.98,
			128: 8.35,
			129: 7.61,
			130: 6.2,
			131: 5.31,
			132: 4.03,
			133: 2.4,
			134: 1.24,
			135: 0
		}
	},

	'taoyuanMetroMile': {
		136: {
			136: 0,
			137: 4.236,
			138: 7.729,
			139: 9.098,
			140: 10.029,
			141: 12.833,
			142: 17.403,
			143: 20.145,
			144: 21.35,
			145: 29.745,
			146: 31.721,
			147: 34.876,
			148: 35.896,
			150: 37.232,
			151: 39.13,
			152: 41.38,
			153: 42.96,
			154: 44.57,
			155: 46.31,
			156: 49.27,
			157: 50.81,
			158: 51.76
		},
		137: {
			136: 4.236,
			137: 0,
			138: 3.493,
			139: 4.862,
			140: 5.793,
			141: 8.597,
			142: 13.167,
			143: 15.909,
			144: 17.114,
			145: 25.509,
			146: 27.485,
			147: 30.64,
			148: 31.66,
			150: 32.996,
			151: 34.894,
			152: 37.144,
			153: 38.724,
			154: 40.334,
			155: 42.074,
			156: 45.034,
			157: 46.574,
			158: 47.524
		},
		138: {
			136: 7.729,
			137: 3.493,
			138: 0,
			139: 1.369,
			140: 2.3,
			141: 5.104,
			142: 9.674,
			143: 12.416,
			144: 13.621,
			145: 22.016,
			146: 23.992,
			147: 27.147,
			148: 28.167,
			150: 29.503,
			151: 31.401,
			152: 33.651,
			153: 35.231,
			154: 36.841,
			155: 38.581,
			156: 41.541,
			157: 43.081,
			158: 44.031
		},
		139: {
			136: 9.098,
			137: 4.862,
			138: 1.369,
			139: 0,
			140: 0.931,
			141: 3.735,
			142: 8.305,
			143: 11.047,
			144: 12.252,
			145: 20.647,
			146: 22.623,
			147: 25.778,
			148: 26.798,
			150: 28.134,
			151: 30.032,
			152: 32.282,
			153: 33.862,
			154: 35.472,
			155: 37.212,
			156: 40.172,
			157: 41.712,
			158: 42.662
		},
		140: {
			136: 10.029,
			137: 5.793,
			138: 2.3,
			139: 0.931,
			140: 0,
			141: 2.804,
			142: 7.374,
			143: 10.116,
			144: 11.321,
			145: 19.716,
			146: 21.692,
			147: 24.847,
			148: 25.867,
			150: 27.203,
			151: 29.101,
			152: 31.351,
			153: 32.931,
			154: 34.541,
			155: 36.281,
			156: 39.241,
			157: 40.781,
			158: 41.731
		},
		141: {
			136: 12.833,
			137: 8.597,
			138: 5.104,
			139: 3.735,
			140: 2.804,
			141: 0,
			142: 4.57,
			143: 7.312,
			144: 8.517,
			145: 16.912,
			146: 18.888,
			147: 22.043,
			148: 23.063,
			150: 24.399,
			151: 26.297,
			152: 28.547,
			153: 30.127,
			154: 31.737,
			155: 33.477,
			156: 36.437,
			157: 37.977,
			158: 38.927
		},
		142: {
			136: 17.403,
			137: 13.167,
			138: 9.674,
			139: 8.305,
			140: 7.374,
			141: 4.57,
			142: 0,
			143: 2.742,
			144: 3.947,
			145: 12.342,
			146: 14.318,
			147: 17.473,
			148: 18.493,
			150: 19.829,
			151: 21.727,
			152: 23.977,
			153: 25.557,
			154: 27.167,
			155: 28.907,
			156: 31.867,
			157: 33.407,
			158: 34.357
		},
		143: {
			136: 20.145,
			137: 15.909,
			138: 12.416,
			139: 11.047,
			140: 10.116,
			141: 7.312,
			142: 2.742,
			143: 0,
			144: 1.205,
			145: 9.6,
			146: 11.576,
			147: 14.731,
			148: 15.751,
			150: 17.087,
			151: 18.985,
			152: 21.235,
			153: 22.815,
			154: 24.425,
			155: 26.165,
			156: 29.125,
			157: 30.665,
			158: 31.615
		},
		144: {
			136: 21.35,
			137: 17.114,
			138: 13.621,
			139: 12.252,
			140: 11.321,
			141: 8.517,
			142: 3.947,
			143: 1.205,
			144: 0,
			145: 8.395,
			146: 10.371,
			147: 13.526,
			148: 14.546,
			150: 15.882,
			151: 17.78,
			152: 20.03,
			153: 21.61,
			154: 23.22,
			155: 24.96,
			156: 27.92,
			157: 29.46,
			158: 30.41
		},
		145: {
			136: 29.745,
			137: 25.509,
			138: 22.016,
			139: 20.647,
			140: 19.716,
			141: 16.912,
			142: 12.342,
			143: 9.6,
			144: 8.395,
			145: 0,
			146: 1.976,
			147: 5.131,
			148: 6.151,
			150: 7.487,
			151: 9.385,
			152: 11.635,
			153: 13.215,
			154: 14.825,
			155: 16.565,
			156: 19.525,
			157: 21.065,
			158: 22.015
		},
		146: {
			136: 31.721,
			137: 27.485,
			138: 23.992,
			139: 22.623,
			140: 21.692,
			141: 18.888,
			142: 14.318,
			143: 11.576,
			144: 10.371,
			145: 1.976,
			146: 0,
			147: 3.155,
			148: 4.175,
			150: 5.511,
			151: 7.409,
			152: 9.659,
			153: 11.239,
			154: 12.849,
			155: 14.589,
			156: 17.549,
			157: 19.089,
			158: 20.039
		},
		147: {
			136: 34.876,
			137: 30.64,
			138: 27.147,
			139: 25.778,
			140: 24.847,
			141: 22.043,
			142: 17.473,
			143: 14.731,
			144: 13.526,
			145: 5.131,
			146: 3.155,
			147: 0,
			148: 1.02,
			150: 2.356,
			151: 4.254,
			152: 6.504,
			153: 8.084,
			154: 9.694,
			155: 11.434,
			156: 14.394,
			157: 15.934,
			158: 16.884
		},
		148: {
			136: 35.896,
			137: 31.66,
			138: 28.167,
			139: 26.798,
			140: 25.867,
			141: 23.063,
			142: 18.493,
			143: 15.751,
			144: 14.546,
			145: 6.151,
			146: 4.175,
			147: 1.02,
			148: 0,
			150: 1.336,
			151: 3.234,
			152: 5.484,
			153: 7.064,
			154: 8.674,
			155: 10.414,
			156: 13.374,
			157: 14.914,
			158: 15.864
		},
		150: {
			136: 37.232,
			137: 32.996,
			138: 29.503,
			139: 28.134,
			140: 27.203,
			141: 24.399,
			142: 19.829,
			143: 17.087,
			144: 15.882,
			145: 7.487,
			146: 5.511,
			147: 2.356,
			148: 1.336,
			150: 0,
			151: 1.898,
			152: 4.148,
			153: 5.728,
			154: 7.338,
			155: 9.078,
			156: 12.038,
			157: 13.578,
			158: 14.528
		},
		151: {
			136: 39.13,
			137: 34.894,
			138: 31.401,
			139: 30.032,
			140: 29.101,
			141: 26.297,
			142: 21.727,
			143: 18.985,
			144: 17.78,
			145: 9.385,
			146: 7.409,
			147: 4.254,
			148: 3.234,
			150: 1.898,
			151: 0,
			152: 2.25,
			153: 3.83,
			154: 5.44,
			155: 7.18,
			156: 10.14,
			157: 11.68,
			158: 12.63
		},
		152: {
			136: 41.38,
			137: 37.144,
			138: 33.651,
			139: 32.282,
			140: 31.351,
			141: 28.547,
			142: 23.977,
			143: 21.235,
			144: 20.03,
			145: 11.635,
			146: 9.659,
			147: 6.504,
			148: 5.484,
			150: 4.148,
			151: 2.25,
			152: 0,
			153: 1.58,
			154: 3.19,
			155: 4.93,
			156: 7.89,
			157: 9.43,
			158: 10.38
		},
		153: {
			136: 42.96,
			137: 38.724,
			138: 35.231,
			139: 33.862,
			140: 32.931,
			141: 30.127,
			142: 25.557,
			143: 22.815,
			144: 21.61,
			145: 13.215,
			146: 11.239,
			147: 8.084,
			148: 7.064,
			150: 5.728,
			151: 3.83,
			152: 1.58,
			153: 0,
			154: 1.61,
			155: 3.35,
			156: 6.31,
			157: 7.85,
			158: 8.8
		},
		154: {
			136: 44.57,
			137: 40.334,
			138: 36.841,
			139: 35.472,
			140: 34.541,
			141: 31.737,
			142: 27.167,
			143: 24.425,
			144: 23.22,
			145: 14.825,
			146: 12.849,
			147: 9.694,
			148: 8.674,
			150: 7.338,
			151: 5.44,
			152: 3.19,
			153: 1.61,
			154: 0,
			155: 1.74,
			156: 4.7,
			157: 6.24,
			158: 7.19
		},
		155: {
			136: 46.31,
			137: 42.074,
			138: 38.581,
			139: 37.212,
			140: 36.281,
			141: 33.477,
			142: 28.907,
			143: 26.165,
			144: 24.96,
			145: 16.565,
			146: 14.589,
			147: 11.434,
			148: 10.414,
			150: 9.078,
			151: 7.18,
			152: 4.93,
			153: 3.35,
			154: 1.74,
			155: 0,
			156: 2.96,
			157: 4.5,
			158: 5.45
		},
		156: {
			136: 49.27,
			137: 45.034,
			138: 41.541,
			139: 40.172,
			140: 39.241,
			141: 36.437,
			142: 31.867,
			143: 29.125,
			144: 27.92,
			145: 19.525,
			146: 17.549,
			147: 14.394,
			148: 13.374,
			150: 12.038,
			151: 10.14,
			152: 7.89,
			153: 6.31,
			154: 4.7,
			155: 2.96,
			156: 0,
			157: 1.54,
			158: 2.49
		},
		157: {
			136: 50.81,
			137: 46.574,
			138: 43.081,
			139: 41.712,
			140: 40.781,
			141: 37.977,
			142: 33.407,
			143: 30.665,
			144: 29.46,
			145: 21.065,
			146: 19.089,
			147: 15.934,
			148: 14.914,
			150: 13.578,
			151: 11.68,
			152: 9.43,
			153: 7.85,
			154: 6.24,
			155: 4.5,
			156: 1.54,
			157: 0,
			158: 0.95
		},
		158: {
			136: 51.76,
			137: 47.524,
			138: 44.031,
			139: 42.662,
			140: 41.731,
			141: 38.927,
			142: 34.357,
			143: 31.615,
			144: 30.41,
			145: 22.015,
			146: 20.039,
			147: 16.884,
			148: 15.864,
			150: 14.528,
			151: 12.63,
			152: 10.38,
			153: 8.8,
			154: 7.19,
			155: 5.45,
			156: 2.49,
			157: 0.95,
			158: 0
		}
	},

	'taichungMetroMile': {
		160: {
			160: 0,
			161: 1.027,
			162: 1.705,
			163: 3.357,
			164: 4.22,
			165: 5.692,
			166: 6.755,
			167: 7.571,
			168: 8.375,
			169: 9.395,
			170: 10.251,
			171: 10.792,
			172: 11.67,
			173: 13.277,
			174: 14.198,
			175: 14.888,
			176: 15.92,
			177: 16.986
		},
		161: {
			160: 1.027,
			161: 0,
			162: 0.678,
			163: 2.33,
			164: 3.193,
			165: 4.665,
			166: 5.728,
			167: 6.544,
			168: 7.348,
			169: 8.368,
			170: 9.224,
			171: 9.765,
			172: 10.643,
			173: 12.25,
			174: 13.171,
			175: 13.861,
			176: 14.893,
			177: 15.959
		},
		162: {
			160: 1.705,
			161: 0.678,
			162: 0,
			163: 1.652,
			164: 2.515,
			165: 3.987,
			166: 5.05,
			167: 5.866,
			168: 6.67,
			169: 7.69,
			170: 8.546,
			171: 9.087,
			172: 9.965,
			173: 11.572,
			174: 12.493,
			175: 13.183,
			176: 14.215,
			177: 15.281
		},
		163: {
			160: 3.357,
			161: 2.33,
			162: 1.652,
			163: 0,
			164: 0.863,
			165: 2.335,
			166: 3.398,
			167: 4.214,
			168: 5.018,
			169: 6.038,
			170: 6.894,
			171: 7.435,
			172: 8.313,
			173: 9.92,
			174: 10.841,
			175: 11.531,
			176: 12.563,
			177: 13.629
		},
		164: {
			160: 4.22,
			161: 3.193,
			162: 2.515,
			163: 0.863,
			164: 0,
			165: 1.472,
			166: 2.535,
			167: 3.351,
			168: 4.155,
			169: 5.175,
			170: 6.031,
			171: 6.572,
			172: 7.45,
			173: 9.057,
			174: 9.978,
			175: 10.668,
			176: 11.7,
			177: 12.766
		},
		165: {
			160: 5.692,
			161: 4.665,
			162: 3.987,
			163: 2.335,
			164: 1.472,
			165: 0,
			166: 1.063,
			167: 1.879,
			168: 2.683,
			169: 3.703,
			170: 4.559,
			171: 5.1,
			172: 5.978,
			173: 7.585,
			174: 8.506,
			175: 9.196,
			176: 10.228,
			177: 11.294
		},
		166: {
			160: 6.755,
			161: 5.728,
			162: 5.05,
			163: 3.398,
			164: 2.535,
			165: 1.063,
			166: 0,
			167: 0.816,
			168: 1.62,
			169: 2.64,
			170: 3.496,
			171: 4.037,
			172: 4.915,
			173: 6.522,
			174: 7.443,
			175: 8.133,
			176: 9.165,
			177: 10.231
		},
		167: {
			160: 7.571,
			161: 6.544,
			162: 5.866,
			163: 4.214,
			164: 3.351,
			165: 1.879,
			166: 0.816,
			167: 0,
			168: 0.804,
			169: 1.824,
			170: 2.68,
			171: 3.221,
			172: 4.099,
			173: 5.706,
			174: 6.627,
			175: 7.317,
			176: 8.349,
			177: 9.415
		},
		168: {
			160: 8.375,
			161: 7.348,
			162: 6.67,
			163: 5.018,
			164: 4.155,
			165: 2.683,
			166: 1.62,
			167: 0.804,
			168: 0,
			169: 1.02,
			170: 1.876,
			171: 2.417,
			172: 3.295,
			173: 4.902,
			174: 5.823,
			175: 6.513,
			176: 7.545,
			177: 8.611
		},
		169: {
			160: 9.395,
			161: 8.368,
			162: 7.69,
			163: 6.038,
			164: 5.175,
			165: 3.703,
			166: 2.64,
			167: 1.824,
			168: 1.02,
			169: 0,
			170: 0.856,
			171: 1.397,
			172: 2.275,
			173: 3.882,
			174: 4.803,
			175: 5.493,
			176: 6.525,
			177: 7.591
		},
		170: {
			160: 10.251,
			161: 9.224,
			162: 8.546,
			163: 6.894,
			164: 6.031,
			165: 4.559,
			166: 3.496,
			167: 2.68,
			168: 1.876,
			169: 0.856,
			170: 0,
			171: 0.541,
			172: 1.419,
			173: 3.026,
			174: 3.947,
			175: 4.637,
			176: 5.669,
			177: 6.735
		},
		171: {
			160: 10.792,
			161: 9.765,
			162: 9.087,
			163: 7.435,
			164: 6.572,
			165: 5.1,
			166: 4.037,
			167: 3.221,
			168: 2.417,
			169: 1.397,
			170: 0.541,
			171: 0,
			172: 0.878,
			173: 2.485,
			174: 3.406,
			175: 4.096,
			176: 5.128,
			177: 6.194
		},
		172: {
			160: 11.67,
			161: 10.643,
			162: 9.965,
			163: 8.313,
			164: 7.45,
			165: 5.978,
			166: 4.915,
			167: 4.099,
			168: 3.295,
			169: 2.275,
			170: 1.419,
			171: 0.878,
			172: 0,
			173: 1.607,
			174: 2.528,
			175: 3.218,
			176: 4.25,
			177: 5.316
		},
		173: {
			160: 13.277,
			161: 12.25,
			162: 11.572,
			163: 9.92,
			164: 9.057,
			165: 7.585,
			166: 6.522,
			167: 5.706,
			168: 4.902,
			169: 3.882,
			170: 3.026,
			171: 2.485,
			172: 1.607,
			173: 0,
			174: 0.921,
			175: 1.611,
			176: 2.643,
			177: 3.709
		},
		174: {
			160: 14.198,
			161: 13.171,
			162: 12.493,
			163: 10.841,
			164: 9.978,
			165: 8.506,
			166: 7.443,
			167: 6.627,
			168: 5.823,
			169: 4.803,
			170: 3.947,
			171: 3.406,
			172: 2.528,
			173: 0.921,
			174: 0,
			175: 0.69,
			176: 1.722,
			177: 2.788
		},
		175: {
			160: 14.888,
			161: 13.861,
			162: 13.183,
			163: 11.531,
			164: 10.668,
			165: 9.196,
			166: 8.133,
			167: 7.317,
			168: 6.513,
			169: 5.493,
			170: 4.637,
			171: 4.096,
			172: 3.218,
			173: 1.611,
			174: 0.69,
			175: 0,
			176: 1.032,
			177: 2.098
		},
		176: {
			160: 15.92,
			161: 14.893,
			162: 14.215,
			163: 12.563,
			164: 11.7,
			165: 10.228,
			166: 9.165,
			167: 8.349,
			168: 7.545,
			169: 6.525,
			170: 5.669,
			171: 5.128,
			172: 4.25,
			173: 2.643,
			174: 1.722,
			175: 1.032,
			176: 0,
			177: 1.066
		},
		177: {
			160: 16.986,
			161: 15.959,
			162: 15.281,
			163: 13.629,
			164: 12.766,
			165: 11.294,
			166: 10.231,
			167: 9.415,
			168: 8.611,
			169: 7.591,
			170: 6.735,
			171: 6.194,
			172: 5.316,
			173: 3.709,
			174: 2.788,
			175: 2.098,
			176: 1.066,
			177: 0
		}
	},

	/**
	 * 碳排 重複車站 對應
	 */
	'duplicateStation': {
		1: [1],
		2: [2],
		3: [3],
		4: [4],
		5: [5],
		6: [6],
		7: [7],
		8: [8],
		9: [9,28],
		10: [10,113],
		11: [11,69],
		12: [12],
		13: [13],
		14: [14],
		15: [15],
		16: [16],
		17: [17],
		18: [18],
		19: [19],
		20: [20],
		21: [21],
		22: [22],
		23: [23],
		24: [24,121],
		25: [25],
		26: [26],
		27: [27],
		28: [9,28],
		29: [29],
		30: [30,78],
		31: [31,63],
		32: [32],
		33: [33, 110],
		34: [34,67],
		35: [35],
		36: [36,83],
		37: [37],
		38: [38],
		39: [39],
		40: [40],
		41: [41],
		42: [42],
		43: [43],
		44: [44],
		45: [45],
		46: [46],
		47: [47],
		48: [48],
		49: [49],
		50: [50],
		51: [51],
		52: [52],
		53: [53],
		54: [54],
		55: [55],
		56: [56],
		57: [57,122],
		58: [58],
		59: [59],
		60: [60],
		61: [61],
		62: [62,77],
		63: [31,63],
		64: [64],
		65: [65,109],
		66: [66],
		67: [34,67],
		68: [68, 80],
		69: [11,69],
		70: [70],
		71: [71],
		72: [72],
		73: [73],
		74: [74,126],
		75: [75],
		76: [76],
		77: [62,77],
		78: [30,78],
		79: [79,112],
		80: [68, 80],
		81: [81],
		82: [82],
		83: [36,83],
		84: [84],
		85: [85],
		86: [86],
		87: [87],
		88: [88],
		89: [89,133],
		90: [90],
		91: [91],
		92: [92],
		93: [93],
		94: [94],
		95: [95],
		96: [96],
		97: [97],
		98: [98],
		99: [99],
		100: [100],
		101: [101],
		102: [102],
		103: [103],
		104: [104],
		105: [105,131],
		106: [106, 132],
		107: [107],
		108: [108],
		109: [65,109],
		110: [33, 110],
		111: [111],
		112: [79,112],
		113: [10,113],
		114: [114],
		115: [115],
		116: [116],
		117: [117],
		118: [118],
		119: [119],
		120: [120],
		121: [24,121],
		122: [57, 122],
		123: [123],
		124: [124],
		125: [125],
		126: [74, 126],
		127: [127],
		128: [128],
		129: [129],
		130: [130],
		131: [105,131],
		132: [106, 132],
		133: [89,133],
		134: [134],
		135: [135],
		136: [ 136 ],
		137: [ 137 ],
		138: [ 138 ],
		139: [ 139 ],
		140: [ 140 ],
		141: [ 141 ],
		142: [ 142 ],
		143: [ 143 ],
		144: [ 144 ],
		145: [ 145 ],
		146: [ 146 ],
		147: [ 147 ],
		148: [ 148 ],
		149: [ 149 ],
		150: [ 150 ],
		151: [ 151 ],
		152: [ 152 ],
		153: [ 153 ],
		154: [ 154 ],
		155: [ 155 ],
		156: [ 156 ],
		157: [ 157 ],
		158: [ 158 ],
		159: [ 159 ],
		160: [ 160 ],
		161: [ 161 ],
		162: [ 162 ],
		163: [ 163 ],
		164: [ 164 ],
		165: [ 165 ],
		166: [ 166 ],
		167: [ 167 ],
		168: [ 168 ],
		169: [ 169 ],
		170: [ 170 ],
		171: [ 171 ],
		172: [ 172 ],
		173: [ 173 ],
		174: [ 174 ],
		175: [ 175 ],
		176: [ 176 ],
		177: [ 177 ],
		178: [ 178 ],
		179: [ 179 ],
		180: [ 180 ],
		181: [ 181 ],
		182: [ 182 ],
		183: [ 183 ],
		184: [ 184 ],
		185: [ 185 ],
		186: [ 186 ],
		187: [ 187 ],
		188: [ 188 ],
		189: [ 189 ]
	},
	/**
	 * 碳盤查里程 end
	 */
	// PERF_SCORE,IS_PASS,PERF_RATING_RULE_ID,PERF_RATING_ID,PERF_COMMENT,FILE_UUID,PERF_NOTE
	'ep.performanceRecords.customAllFields': {
		'PERF_SCORE': ['評核分數', 'Score', '评核分数'],
		'IS_PASS': ['是否通過', 'Pass', '是否通过'],
		'PERF_RATING_RULE_ID': ['評核等級規則', 'Level rule', '评核等级规则'],
		'PERF_RATING_ID': ['評核等級', 'Level', '评核等级'],
		'PERF_COMMENT': ['評語', 'Comment', '评语'],
		'FILE_UUID': ['附件', 'Attachment', '附件'],
		'PERF_NOTE': ['備註', 'Remark', '备注']
	},
	// 評語,附件,備註,主管姓名,考核人員,階段分數,階段評核等級規則,階段評核等級
	// PLAN_COMMENT,FILE_UUID,PLAN_NOTE,LEADER_ID,EXAM_ID,PLAN_SCORE,PERF_RATING_RULE_ID,PLAN_RATING_ID
	'ep.performanceRecords.customStageFields': {
		'LEADER_ID': ['主管姓名', 'Manager name', '主管姓名'],
		'EXAM_ID': ['考核人員', 'Assessor', '考核人员'],
		'PLAN_SCORE': ['階段分數', 'Stage score', '阶段分数'],
		'PERF_RATING_RULE_ID': ['階段評核等級規則', 'Stage level rule', '阶段评核等级规则'],
		'PLAN_RATING_ID': ['階段評核等級', 'Stage level', '阶段评核等级'],
		'PLAN_COMMENT': ['評語', 'Comment', '评语'],
		'FILE_UUID': ['附件', 'Attachment', '附件'],
		'PLAN_NOTE': ['備註', 'Remark', '备注']
	},
};

const custOptions = require('../customize/constants/options');
const i18n = require('./i18n/index');

let custI18n = {};
const sno = (typeof window === 'undefined') ? process.env.SNO : window.sno;
if (sno) {
	try {
		custI18n = require(`../customize/${sno}/constants/i18n/index.js`);
	} catch (err) {}
}

module.exports = Object.freeze({ ...options, ...custOptions, ...i18n, ...custI18n });
